
export const customerCityOptions = [
  { value: "1GB-A(CT)", label: "1GB-A(CT)" },
  { value: "24AS-C(CT)", label: "24AS-C(CT)" },
  { value: "3eVillage(CT)", label: "3eVillage(CT)" },
  { value: "8LLGLALGARH", label: "8LLGLALGARH" },
  { value: "8PSD-B(CT)", label: "8PSD-B(CT)" },
  { value: "A G CLASSIC COLONY", label: "A G CLASSIC COLONY" },
  { value: "AAKASH NAGAR", label: "AAKASH NAGAR" },
  { value: "AALIVILLAGE", label: "AALIVILLAGE" },
  { value: "AALO", label: "AALO" },
  { value: "AANDHI", label: "AANDHI" },
  { value: "ABASANA", label: "ABASANA" },
  { value: "ABBIGERI", label: "ABBIGERI" },
  { value: "ABHANPUR", label: "ABHANPUR" },
  { value: "ABHIRAMPUR", label: "ABHIRAMPUR" },
  { value: "ABICHERLA", label: "ABICHERLA" },
  { value: "ABOHAR", label: "ABOHAR" },
  { value: "ABUROAD", label: "ABUROAD" },
  { value: "ACHABAL", label: "ACHABAL" },
  { value: "ACHALDA", label: "ACHALDA" },
  { value: "ACHAMBUR", label: "ACHAMBUR" },
  { value: "ACHAMPET", label: "ACHAMPET" },
  { value: "ACHROL", label: "ACHROL" },
  { value: "AD COLONY", label: "AD COLONY" },
  { value: "ADALSAR", label: "ADALSAR" },
  { value: "ADAMPUR", label: "ADAMPUR" },
  { value: "ADARIYANA", label: "ADARIYANA" },
  { value: "ADARSH COLONY", label: "ADARSH COLONY" },
  { value: "ADARSHAPALLI", label: "ADARSHAPALLI" },
  { value: "ADATT", label: "ADATT" },
  { value: "ADBD1", label: "ADBD1" },
  { value: "ADDANKI", label: "ADDANKI" },
  { value: "ADDUR", label: "ADDUR" },
  { value: "ADHANA", label: "ADHANA" },
  { value: "ADHYARU NO DELO", label: "ADHYARU NO DELO" },
  { value: "ADILABAD", label: "ADILABAD" },
  { value: "ADIMALI", label: "ADIMALI" },
  { value: "ADIVADA", label: "ADIVADA" },
  { value: "ADONI", label: "ADONI" },
  { value: "ADOOR", label: "ADOOR" },
  { value: "AFZALGARH", label: "AFZALGARH" },
  { value: "AFZALPUR TAKKE", label: "AFZALPUR TAKKE" },
  { value: "AGAR", label: "AGAR" },
  { value: "AGAR MALWA", label: "AGAR MALWA" },
  { value: "AGARTALA", label: "AGARTALA" },
  { value: "AGARTALA ", label: "AGARTALA " },
  { value: "AGAYA", label: "AGAYA" },
  { value: "AGRA", label: "AGRA" },
  { value: "AGRACANTT", label: "AGRACANTT" },
  { value: "AHAMADPUR TAKROLI", label: "AHAMADPUR TAKROLI" },
  { value: "AHERI", label: "AHERI" },
  { value: "AHILYANAGAR", label: "AHILYANAGAR" },
  { value: "AHIYAPUR", label: "AHIYAPUR" },
  { value: "AHMED NAGAR", label: "AHMED NAGAR" },
  { value: "AHMEDABAD", label: "AHMEDABAD" },
  { value: "AHMEDNAGAR", label: "AHMEDNAGAR" },
  { value: "AHMEDPUR", label: "AHMEDPUR" },
  { value: "AHORE", label: "AHORE" },
  { value: "AHWA", label: "AHWA" },
  { value: "AIBULON", label: "AIBULON" },
  { value: "AILTA", label: "AILTA" },
  { value: "AILUM", label: "AILUM" },
  { value: "AISHMUQAM", label: "AISHMUQAM" },
  { value: "AITH TSUBA", label: "AITH TSUBA" },
  { value: "AIZAWL", label: "AIZAWL" },
  { value: "AJAB", label: "AJAB" },
  { value: "AJARA", label: "AJARA" },
  { value: "AJEETGARH", label: "AJEETGARH" },
  { value: "AJITMAL", label: "AJITMAL" },
  { value: "AJMER", label: "AJMER" },
  { value: "AJNALA", label: "AJNALA" },
  { value: "AKALPAUSH", label: "AKALPAUSH" },
  { value: "AKALTARA", label: "AKALTARA" },
  { value: "AKBARPUR", label: "AKBARPUR" },
  { value: "AKBARPUR-ANAGAR", label: "AKBARPUR-ANAGAR" },
  { value: "AKEDADOONGAR", label: "AKEDADOONGAR" },
  { value: "AKHAJ", label: "AKHAJ" },
  { value: "AKHIYANA", label: "AKHIYANA" },
  { value: "AKHNOOR", label: "AKHNOOR" },
  { value: "AKHTA (PART IN BAIRGANIA) *", label: "AKHTA (PART IN BAIRGANIA) *" },
  { value: "AKKIALUR", label: "AKKIALUR" },
  { value: "AKLERA", label: "AKLERA" },
  { value: "AKLUJ", label: "AKLUJ" },
  { value: "AKOLA", label: "AKOLA" },
  { value: "AKOLE", label: "AKOLE" },
  { value: "AKOT", label: "AKOT" },
  { value: "AKRI MOTI", label: "AKRI MOTI" },
  { value: "AKUK MHAYAN (UR)", label: "AKUK MHAYAN (UR)" },
  { value: "ALAKODE", label: "ALAKODE" },
  { value: "ALAMPUR", label: "ALAMPUR" },
  { value: "ALAMPURA", label: "ALAMPURA" },
  { value: "ALAMPURPETH ", label: "ALAMPURPETH " },
  { value: "ALANALLUR", label: "ALANALLUR" },
  { value: "ALANDI", label: "ALANDI" },
  { value: "ALANG", label: "ALANG" },
  { value: "ALANGUDI", label: "ALANGUDI" },
  { value: "ALANGULAM", label: "ALANGULAM" },
  { value: "ALANTHURAI", label: "ALANTHURAI" },
  { value: "ALAPPUZHA", label: "ALAPPUZHA" },
  { value: "ALARPUR", label: "ALARPUR" },
  { value: "ALATHIYOOR", label: "ALATHIYOOR" },
  { value: "ALATHUR", label: "ALATHUR" },
  { value: "ALE", label: "ALE" },
  { value: "ALEFNAGAR", label: "ALEFNAGAR" },
  { value: "ALEHALLI", label: "ALEHALLI" },
  { value: "ALEWA", label: "ALEWA" },
  { value: "ALGAPUR", label: "ALGAPUR" },
  { value: "ALIBAG", label: "ALIBAG" },
  { value: "ALIGANJ", label: "ALIGANJ" },
  { value: "ALIGARH", label: "ALIGARH" },
  { value: "ALIPUR", label: "ALIPUR" },
  { value: "ALIPURDUAR", label: "ALIPURDUAR" },
  { value: "ALIRAJPUR", label: "ALIRAJPUR" },
  { value: "ALKAPURI COLONY", label: "ALKAPURI COLONY" },
  { value: "ALLAGANJ", label: "ALLAGANJ" },
  { value: "ALLAPALLI", label: "ALLAPALLI" },
  { value: "ALLEPEY", label: "ALLEPEY" },
  { value: "ALLURIGEDDA", label: "ALLURIGEDDA" },
  { value: "ALMASPUR", label: "ALMASPUR" },
  { value: "ALMORA", label: "ALMORA" },
  { value: "ALOKCITY", label: "ALOKCITY" },
  { value: "ALOTE", label: "ALOTE" },
  { value: "ALUVA", label: "ALUVA" },
  { value: "ALWAR", label: "ALWAR" },
  { value: "AMADAGUR", label: "AMADAGUR" },
  { value: "AMALAPURAM", label: "AMALAPURAM" },
  { value: "AMALNER", label: "AMALNER" },
  { value: "AMANGAL", label: "AMANGAL" },
  { value: "AMARATPUR", label: "AMARATPUR" },
  { value: "AMARAVATI", label: "AMARAVATI" },
  { value: "AMARPUR", label: "AMARPUR" },
  { value: "AMB", label: "AMB" },
  { value: "AMBA \"A\"", label: "AMBA \"A\"" },
  { value: "AMBAD", label: "AMBAD" },
  { value: "AMBADI", label: "AMBADI" },
  { value: "AMBAGARHCHOWKI", label: "AMBAGARHCHOWKI" },
  { value: "AMBAI", label: "AMBAI" },
  { value: "AMBAJI", label: "AMBAJI" },
  { value: "AMBAJOGAI", label: "AMBAJOGAI" },
  { value: "AMBALA", label: "AMBALA" },
  { value: "AMBALACANTT", label: "AMBALACANTT" },
  { value: "AMBALLUR", label: "AMBALLUR" },
  { value: "AMBASAMUDRAM", label: "AMBASAMUDRAM" },
  { value: "AMBASSA", label: "AMBASSA" },
  { value: "AMBATTUR", label: "AMBATTUR" },
  { value: "AMBEDKAR NAGAR", label: "AMBEDKAR NAGAR" },
  { value: "AMBEDKARNAGAR", label: "AMBEDKARNAGAR" },
  { value: "AMBERA", label: "AMBERA" },
  { value: "AMBERNATH", label: "AMBERNATH" },
  { value: "AMBHETA", label: "AMBHETA" },
  { value: "AMBIKAPUR", label: "AMBIKAPUR" },
  { value: "AMBIVALITARFWANKHAL", label: "AMBIVALITARFWANKHAL" },
  { value: "AMBUR", label: "AMBUR" },
  { value: "AMET", label: "AMET" },
  { value: "AMETHI", label: "AMETHI" },
  { value: "AMGAON", label: "AMGAON" },
  { value: "AMGURI", label: "AMGURI" },
  { value: "AMINGAD", label: "AMINGAD" },
  { value: "AMJHURI", label: "AMJHURI" },
  { value: "AMJOR", label: "AMJOR" },
  { value: "AMLAHA", label: "AMLAHA" },
  { value: "AMLAICTPART", label: "AMLAICTPART" },
  { value: "AMLOH", label: "AMLOH" },
  { value: "AMOD", label: "AMOD" },
  { value: "AMRABATI", label: "AMRABATI" },
  { value: "AMRARGAR", label: "AMRARGAR" },
  { value: "AMRAVATI", label: "AMRAVATI" },
  { value: "AMRELI", label: "AMRELI" },
  { value: "AMRITPUR", label: "AMRITPUR" },
  { value: "AMRITSAR", label: "AMRITSAR" },
  { value: "AMROHA", label: "AMROHA" },
  { value: "AMTA", label: "AMTA" },
  { value: "AMTALA", label: "AMTALA" },
  { value: "AMUR", label: "AMUR" },
  { value: "ANAIMALAI", label: "ANAIMALAI" },
  { value: "ANAKAPALLE", label: "ANAKAPALLE" },
  { value: "ANAND", label: "ANAND" },
  { value: "ANAND BAGH", label: "ANAND BAGH" },
  { value: "ANAND BAZAR", label: "ANAND BAZAR" },
  { value: "ANANDANAGAR", label: "ANANDANAGAR" },
  { value: "ANANDAPUR", label: "ANANDAPUR" },
  { value: "ANANDNAGAR", label: "ANANDNAGAR" },
  { value: "ANANDPUR", label: "ANANDPUR" },
  { value: "ANANDPURA", label: "ANANDPURA" },
  { value: "ANANDPURSAHIB", label: "ANANDPURSAHIB" },
  { value: "ANANTAPUR", label: "ANANTAPUR" },
  { value: "ANANTHAPUR", label: "ANANTHAPUR" },
  { value: "ANANTHNAG", label: "ANANTHNAG" },
  { value: "ANANTNAG", label: "ANANTNAG" },
  { value: "ANARBATI", label: "ANARBATI" },
  { value: "ANAVAL", label: "ANAVAL" },
  { value: "ANAWARIYIA", label: "ANAWARIYIA" },
  { value: "ANCHAL", label: "ANCHAL" },
  { value: "ANDALGRAM", label: "ANDALGRAM" },
  { value: "ANDANKOILEAST", label: "ANDANKOILEAST" },
  { value: "ANDHARIA", label: "ANDHARIA" },
  { value: "ANDIPPATTI", label: "ANDIPPATTI" },
  { value: "ANDUL", label: "ANDUL" },
  { value: "ANEKAL", label: "ANEKAL" },
  { value: "ANGAMALY", label: "ANGAMALY" },
  { value: "ANGUL", label: "ANGUL" },
  { value: "ANI", label: "ANI" },
  { value: "ANIASHU", label: "ANIASHU" },
  { value: "ANJAD", label: "ANJAD" },
  { value: "ANJAR", label: "ANJAR" },
  { value: "ANJUGRAMAM", label: "ANJUGRAMAM" },
  { value: "ANKLAV", label: "ANKLAV" },
  { value: "ANKLESHWAR", label: "ANKLESHWAR" },
  { value: "ANKOLA", label: "ANKOLA" },
  { value: "ANNAVARAM", label: "ANNAVARAM" },
  { value: "ANNI", label: "ANNI" },
  { value: "ANNUR", label: "ANNUR" },
  { value: "ANPARA", label: "ANPARA" },
  { value: "ANTA", label: "ANTA" },
  { value: "ANTARI", label: "ANTARI" },
  { value: "ANTHIYUR", label: "ANTHIYUR" },
  { value: "ANUPGARH", label: "ANUPGARH" },
  { value: "ANUPPUR", label: "ANUPPUR" },
  { value: "ANUPSHAHAR", label: "ANUPSHAHAR" },
  { value: "ANURUDHPUR", label: "ANURUDHPUR" },
  { value: "AONLA", label: "AONLA" },
  { value: "AORAS", label: "AORAS" },
  { value: "APRA", label: "APRA" },
  { value: "ARA", label: "ARA" },
  { value: "ARACHALUR", label: "ARACHALUR" },
  { value: "ARADURAH HILL", label: "ARADURAH HILL" },
  { value: "ARAG", label: "ARAG" },
  { value: "ARAKKONAM", label: "ARAKKONAM" },
  { value: "ARAKUVALLEY", label: "ARAKUVALLEY" },
  { value: "ARALBANSHI", label: "ARALBANSHI" },
  { value: "ARAMBAG", label: "ARAMBAG" },
  { value: "ARANATTUKARA", label: "ARANATTUKARA" },
  { value: "ARANG", label: "ARANG" },
  { value: "ARANI", label: "ARANI" },
  { value: "ARANTHANGI", label: "ARANTHANGI" },
  { value: "ARAPUR", label: "ARAPUR" },
  { value: "ARARIA", label: "ARARIA" },
  { value: "ARAVAKURICHI", label: "ARAVAKURICHI" },
  { value: "ARAVALLI", label: "ARAVALLI" },
  { value: "ARCOT", label: "ARCOT" },
  { value: "AREEKODE", label: "AREEKODE" },
  { value: "ARGARA", label: "ARGARA" },
  { value: "ARIYALUR", label: "ARIYALUR" },
  { value: "ARKALGUD", label: "ARKALGUD" },
  { value: "ARKI", label: "ARKI" },
  { value: "ARMORI", label: "ARMORI" },
  { value: "ARMUR", label: "ARMUR" },
  { value: "ARNOD", label: "ARNOD" },
  { value: "AROORGRAMPANCHAYAT", label: "AROORGRAMPANCHAYAT" },
  { value: "ARRAH", label: "ARRAH" },
  { value: "ARSIKERE", label: "ARSIKERE" },
  { value: "ARUPPUKKOTTAI", label: "ARUPPUKKOTTAI" },
  { value: "ARVI", label: "ARVI" },
  { value: "ARWAL", label: "ARWAL" },
  { value: "ASAFPUR", label: "ASAFPUR" },
  { value: "ASANBANI", label: "ASANBANI" },
  { value: "ASANSOL", label: "ASANSOL" },
  { value: "ASHAPUR", label: "ASHAPUR" },
  { value: "ASHIYANA ENCLAVE", label: "ASHIYANA ENCLAVE" },
  { value: "ASHMUJI", label: "ASHMUJI" },
  { value: "ASHNAPUR (GERITA)", label: "ASHNAPUR (GERITA)" },
  { value: "ASHOK NAGAR", label: "ASHOK NAGAR" },
  { value: "ASHOKNAGAR", label: "ASHOKNAGAR" },
  { value: "ASHOKNAGAR(WB)", label: "ASHOKNAGAR(WB)" },
  { value: "ASHOKNAGARKALYANGARH", label: "ASHOKNAGARKALYANGARH" },
  { value: "ASHTA", label: "ASHTA" },
  { value: "ASHTI", label: "ASHTI" },
  { value: "ASIFABAD", label: "ASIFABAD" },
  { value: "ASIND", label: "ASIND" },
  { value: "ASKA", label: "ASKA" },
  { value: "ASMOLI", label: "ASMOLI" },
  { value: "ASODA", label: "ASODA" },
  { value: "ASOP", label: "ASOP" },
  { value: "ASPUR", label: "ASPUR" },
  { value: "ASSAM", label: "ASSAM" },
  { value: "ASSANDH", label: "ASSANDH" },
  { value: "ATARRA", label: "ATARRA" },
  { value: "ATELI", label: "ATELI" },
  { value: "ATHAGARH", label: "ATHAGARH" },
  { value: "ATHANI", label: "ATHANI" },
  { value: "ATHIPATTI", label: "ATHIPATTI" },
  { value: "ATHIPATTTU", label: "ATHIPATTTU" },
  { value: "ATHOLI", label: "ATHOLI" },
  { value: "ATHRADY", label: "ATHRADY" },
  { value: "ATMAKUR", label: "ATMAKUR" },
  { value: "ATPADI", label: "ATPADI" },
  { value: "ATRAULIA", label: "ATRAULIA" },
  { value: "ATRU", label: "ATRU" },
  { value: "ATSU", label: "ATSU" },
  { value: "ATTABIRA", label: "ATTABIRA" },
  { value: "ATTAYAMPATTI", label: "ATTAYAMPATTI" },
  { value: "ATTIBELE", label: "ATTIBELE" },
  { value: "ATTILI", label: "ATTILI" },
  { value: "ATTINGAL", label: "ATTINGAL" },
  { value: "ATTUR", label: "ATTUR" },
  { value: "AUR", label: "AUR" },
  { value: "AURAI", label: "AURAI" },
  { value: "AURAIYA", label: "AURAIYA" },
  { value: "AURANGABAD", label: "AURANGABAD" },
  { value: "AVADI", label: "AVADI" },
  { value: "AVANIYAPURAM", label: "AVANIYAPURAM" },
  { value: "AVAS VIKAS COLONY", label: "AVAS VIKAS COLONY" },
  { value: "AVINASHI", label: "AVINASHI" },
  { value: "AVUDAIRKOIL", label: "AVUDAIRKOIL" },
  { value: "AWALPUR", label: "AWALPUR" },
  { value: "AWANTIPORA", label: "AWANTIPORA" },
  { value: "AYIROOPARA", label: "AYIROOPARA" },
  { value: "AYOOR", label: "AYOOR" },
  { value: "AZAD NAGAR", label: "AZAD NAGAR" },
  { value: "AZAMGARH", label: "AZAMGARH" },
  { value: "AZARA", label: "AZARA" },
  { value: "Achalganj(CT)", label: "Achalganj(CT)" },
  { value: "Achhnera(NPP)", label: "Achhnera(NPP)" },
  { value: "Adampur(MCl)", label: "Adampur(MCl)" },
  { value: "Adari(NP)", label: "Adari(NP)" },
  { value: "Adityapur(NagarParishad)", label: "Adityapur(NagarParishad)" },
  { value: "Afzalgarh(NPP)", label: "Afzalgarh(NPP)" },
  { value: "Aheri(CT)", label: "Aheri(CT)" },
  { value: "Ahilynagar", label: "Ahilynagar" },
  { value: "Ahirkhedi(CT)", label: "Ahirkhedi(CT)" },
  { value: "Ahore(CT)", label: "Ahore(CT)" },
  { value: "AhrauliShekh(CT)", label: "AhrauliShekh(CT)" },
  { value: "Ahraura(NPP)", label: "Ahraura(NPP)" },
  { value: "AirForceArea(CT)", label: "AirForceArea(CT)" },
  { value: "Aizawal", label: "Aizawal" },
  { value: "Ajhuwa(NP)", label: "Ajhuwa(NP)" },
  { value: "Ajitgarh", label: "Ajitgarh" },
  { value: "Ajitpur(CT)", label: "Ajitpur(CT)" },
  { value: "Akalgarh(CT)", label: "Akalgarh(CT)" },
  { value: "Akaltara(M)", label: "Akaltara(M)" },
  { value: "AkdoniKhurd(CT)", label: "AkdoniKhurd(CT)" },
  { value: "Aklera(M)", label: "Aklera(M)" },
  { value: "Akoda(NP)", label: "Akoda(NP)" },
  { value: "Akodia(NP)", label: "Akodia(NP)" },
  { value: "Alagdiha(CT)", label: "Alagdiha(CT)" },
  { value: "Alampur(NP)", label: "Alampur(NP)" },
  { value: "Alang(CT)", label: "Alang(CT)" },
  { value: "Alappuzha ", label: "Alappuzha " },
  { value: "Alhaipur(CT)", label: "Alhaipur(CT)" },
  { value: "Aliganj(NPP)", label: "Aliganj(NPP)" },
  { value: "Aligarh(CT)", label: "Aligarh(CT)" },
  { value: "Alipukur(CT)", label: "Alipukur(CT)" },
  { value: "Alipurduar(M)", label: "Alipurduar(M)" },
  { value: "AlipurduarRly.Jnc.(CT)", label: "AlipurduarRly.Jnc.(CT)" },
  { value: "Allahabad", label: "Allahabad" },
  { value: "Allapur(NP)", label: "Allapur(NP)" },
  { value: "Amanganj(CT)", label: "Amanganj(CT)" },
  { value: "Amanpur(NP)", label: "Amanpur(NP)" },
  { value: "AmaraKhairaChak(CT)", label: "AmaraKhairaChak(CT)" },
  { value: "Amarkantak(NP)", label: "Amarkantak(NP)" },
  { value: "Amarpur(NP)", label: "Amarpur(NP)" },
  { value: "Ambah(M)", label: "Ambah(M)" },
  { value: "Amballur(CT)", label: "Amballur(CT)" },
  { value: "Ambattur(M)", label: "Ambattur(M)" },
  { value: "Ambepur(CT)", label: "Ambepur(CT)" },
  { value: "AmbicapurPtVIII(CT)", label: "AmbicapurPtVIII(CT)" },
  { value: "AmehraAdipur(CT)", label: "AmehraAdipur(CT)" },
  { value: "Amet(M)", label: "Amet(M)" },
  { value: "Amgaonkh.(CT)", label: "Amgaonkh.(CT)" },
  { value: "Amila(NP)", label: "Amila(NP)" },
  { value: "Amilo(CT)", label: "Amilo(CT)" },
  { value: "AminagarSarai(NP)", label: "AminagarSarai(NP)" },
  { value: "AminagarUrfBhurbaral(CT)", label: "AminagarUrfBhurbaral(CT)" },
  { value: "Amkhera(CT)", label: "Amkhera(CT)" },
  { value: "Amkula(CT)", label: "Amkula(CT)" },
  { value: "Ammanabrolu", label: "Ammanabrolu" },
  { value: "Ammanur(CT)", label: "Ammanur(CT)" },
  { value: "Amraudha(NP)", label: "Amraudha(NP)" },
  { value: "Amroha(NPP)", label: "Amroha(NPP)" },
  { value: "Anaiyur(M)", label: "Anaiyur(M)" },
  { value: "AnandNagar(CT)", label: "AnandNagar(CT)" },
  { value: "Anandpar(CT)", label: "Anandpar(CT)" },
  { value: "AnandpurSahib(MCl)", label: "AnandpurSahib(MCl)" },
  { value: "Anantpur(CT)", label: "Anantpur(CT)" },
  { value: "Andipalayam(CT)", label: "Andipalayam(CT)" },
  { value: "AndipattiJakkampatti(TP)", label: "AndipattiJakkampatti(TP)" },
  { value: "Andul(CT)", label: "Andul(CT)" },
  { value: "Ankurhati(CT)", label: "Ankurhati(CT)" },
  { value: "Annur(TP)", label: "Annur(TP)" },
  { value: "Antu(NP)", label: "Antu(NP)" },
  { value: "Anuppankulam(CT)", label: "Anuppankulam(CT)" },
  { value: "Apra(CT)", label: "Apra(CT)" },
  { value: "ArailUparhar(CT)", label: "ArailUparhar(CT)" },
  { value: "Aralgoria(CT)", label: "Aralgoria(CT)" },
  { value: "Arasur(CT)", label: "Arasur(CT)" },
  { value: "Areraj(NP)", label: "Areraj(NP)" },
  { value: "ArmapurEstate(CT)", label: "ArmapurEstate(CT)" },
  { value: "Armur(M)", label: "Armur(M)" },
  { value: "Aron(NP)", label: "Aron(NP)" },
  { value: "Arrah(MCorp.)", label: "Arrah(MCorp.)" },
  { value: "Artauni(CT)", label: "Artauni(CT)" },
  { value: "Arvi(CT)", label: "Arvi(CT)" },
  { value: "Arwani(MC)", label: "Arwani(MC)" },
  { value: "AsanKhurd(CT)", label: "AsanKhurd(CT)" },
  { value: "Asapur(CT)", label: "Asapur(CT)" },
  { value: "Asarganj(CT)", label: "Asarganj(CT)" },
  { value: "Ashoknagar(M)", label: "Ashoknagar(M)" },
  { value: "AshrafpurJalal(CT)", label: "AshrafpurJalal(CT)" },
  { value: "Ashti(CT)", label: "Ashti(CT)" },
  { value: "Asind(M)", label: "Asind(M)" },
  { value: "Asola(CT)", label: "Asola(CT)" },
  { value: "Atarra(NPP)", label: "Atarra(NPP)" },
  { value: "Ateli(MC)", label: "Ateli(MC)" },
  { value: "Athirampuzha(CT)", label: "Athirampuzha(CT)" },
  { value: "Athur(TP)", label: "Athur(TP)" },
  { value: "Atrari(CT)", label: "Atrari(CT)" },
  { value: "Atrauli(NPP)", label: "Atrauli(NPP)" },
  { value: "Aurangabad(NP)", label: "Aurangabad(NP)" },
  { value: "AurangabadGadana(CT)", label: "AurangabadGadana(CT)" },
  { value: "Avalapalli(CT)", label: "Avalapalli(CT)" },
  { value: "Avinissery(CT)", label: "Avinissery(CT)" },
  { value: "Awadhan(CT)", label: "Awadhan(CT)" },
  { value: "Awagarh(NP)", label: "Awagarh(NP)" },
  { value: "Ayothiapattinam(TP)", label: "Ayothiapattinam(TP)" },
  { value: "AzhikodeSouth(CT)", label: "AzhikodeSouth(CT)" },
  { value: "Azizpur(CT)", label: "Azizpur(CT)" },
  { value: "Azmatgarh(NP)", label: "Azmatgarh(NP)" },
  { value: "B.Meenakshipuram(TP)", label: "B.Meenakshipuram(TP)" },
  { value: "BABARPUR", label: "BABARPUR" },
  { value: "BABARPURVILLAGE", label: "BABARPURVILLAGE" },
  { value: "BABHANPURA", label: "BABHANPURA" },
  { value: "BABHNAN BAZAR", label: "BABHNAN BAZAR" },
  { value: "BABRA", label: "BABRA" },
  { value: "BABRALA", label: "BABRALA" },
  { value: "BABUAKALAN", label: "BABUAKALAN" },
  { value: "BABUGARH", label: "BABUGARH" },
  { value: "BABUISOL", label: "BABUISOL" },
  { value: "BABYAL", label: "BABYAL" },
  { value: "BACHHRAWAN", label: "BACHHRAWAN" },
  { value: "BADABANGARDA", label: "BADABANGARDA" },
  { value: "BADALPURA", label: "BADALPURA" },
  { value: "BADAMI", label: "BADAMI" },
  { value: "BADAMIBAGHCANTONMENT", label: "BADAMIBAGHCANTONMENT" },
  { value: "BADANGPET", label: "BADANGPET" },
  { value: "BADARPUR", label: "BADARPUR" },
  { value: "BADARWAS", label: "BADARWAS" },
  { value: "BADDI", label: "BADDI" },
  { value: "BADHAL", label: "BADHAL" },
  { value: "BADHIMAJRA", label: "BADHIMAJRA" },
  { value: "BADHRA", label: "BADHRA" },
  { value: "BADIYADKA", label: "BADIYADKA" },
  { value: "BADKALI", label: "BADKALI" },
  { value: "BADLAPUR", label: "BADLAPUR" },
  { value: "BADLYA", label: "BADLYA" },
  { value: "BADNAWAR", label: "BADNAWAR" },
  { value: "BADRA", label: "BADRA" },
  { value: "BADRINATH", label: "BADRINATH" },
  { value: "BADSHAHPUR", label: "BADSHAHPUR" },
  { value: "BADURIA", label: "BADURIA" },
  { value: "BADWEL", label: "BADWEL" },
  { value: "BAGAHA", label: "BAGAHA" },
  { value: "BAGALKOT", label: "BAGALKOT" },
  { value: "BAGALKOTE", label: "BAGALKOTE" },
  { value: "BAGANALA", label: "BAGANALA" },
  { value: "BAGAR", label: "BAGAR" },
  { value: "BAGBAHARA", label: "BAGBAHARA" },
  { value: "BAGDAH", label: "BAGDAH" },
  { value: "BAGDIHA", label: "BAGDIHA" },
  { value: "BAGEPALLI", label: "BAGEPALLI" },
  { value: "BAGESHWAR", label: "BAGESHWAR" },
  { value: "BAGH", label: "BAGH" },
  { value: "BAGHADABAR", label: "BAGHADABAR" },
  { value: "BAGHAPURANA", label: "BAGHAPURANA" },
  { value: "BAGHATI", label: "BAGHATI" },
  { value: "BAGHEL COLONY", label: "BAGHEL COLONY" },
  { value: "BAGHERI KALAN", label: "BAGHERI KALAN" },
  { value: "BAGHPAT", label: "BAGHPAT" },
  { value: "BAGJATA", label: "BAGJATA" },
  { value: "BAGODAR", label: "BAGODAR" },
  { value: "BAGODARA", label: "BAGODARA" },
  { value: "BAGPAT", label: "BAGPAT" },
  { value: "BAGRU", label: "BAGRU" },
  { value: "BAGULA", label: "BAGULA" },
  { value: "BAH", label: "BAH" },
  { value: "BAHADARABAD", label: "BAHADARABAD" },
  { value: "BAHADURGARH", label: "BAHADURGARH" },
  { value: "BAHALIMPUR", label: "BAHALIMPUR" },
  { value: "BAHARAGORA", label: "BAHARAGORA" },
  { value: "BAHARI", label: "BAHARI" },
  { value: "BAHERI", label: "BAHERI" },
  { value: "BAHIRSARBAMANGALAP", label: "BAHIRSARBAMANGALAP" },
  { value: "BAHJOI", label: "BAHJOI" },
  { value: "BAHORIBAND", label: "BAHORIBAND" },
  { value: "BAHRAICH", label: "BAHRAICH" },
  { value: "BAHUWARURAL", label: "BAHUWARURAL" },
  { value: "BAIHATACHARIALI", label: "BAIHATACHARIALI" },
  { value: "BAIJNATH", label: "BAIJNATH" },
  { value: "BAIKUNTHPUR", label: "BAIKUNTHPUR" },
  { value: "BAILHONGAL", label: "BAILHONGAL" },
  { value: "BAINDUR", label: "BAINDUR" },
  { value: "BAITIPARA", label: "BAITIPARA" },
  { value: "BAJARGAON", label: "BAJARGAON" },
  { value: "BAJARI", label: "BAJARI" },
  { value: "BAJEISORA", label: "BAJEISORA" },
  { value: "BAJJU", label: "BAJJU" },
  { value: "BAJJUTEJPURA", label: "BAJJUTEJPURA" },
  { value: "BAJKUL", label: "BAJKUL" },
  { value: "BAJPEPROPER", label: "BAJPEPROPER" },
  { value: "BAJUWALA", label: "BAJUWALA" },
  { value: "BAKANI", label: "BAKANI" },
  { value: "BAKCHANCH", label: "BAKCHANCH" },
  { value: "BAKEWAR", label: "BAKEWAR" },
  { value: "BAKHIRAURFBAGHNAGAR", label: "BAKHIRAURFBAGHNAGAR" },
  { value: "BAKSA", label: "BAKSA" },
  { value: "BAKSHIKATALAB", label: "BAKSHIKATALAB" },
  { value: "BAKSHIRHAT", label: "BAKSHIRHAT" },
  { value: "BALACHAUR", label: "BALACHAUR" },
  { value: "BALAGARH", label: "BALAGARH" },
  { value: "BALAGHAT", label: "BALAGHAT" },
  { value: "BALANGIR", label: "BALANGIR" },
  { value: "BALANIVAV", label: "BALANIVAV" },
  { value: "BALARAMAPURAM", label: "BALARAMAPURAM" },
  { value: "BALASINOR", label: "BALASINOR" },
  { value: "BALASORE", label: "BALASORE" },
  { value: "BALAT", label: "BALAT" },
  { value: "BALBALIA", label: "BALBALIA" },
  { value: "BALBEHRA", label: "BALBEHRA" },
  { value: "BALDEO", label: "BALDEO" },
  { value: "BALDEVGARH", label: "BALDEVGARH" },
  { value: "BALEHONNUR", label: "BALEHONNUR" },
  { value: "BALESAR", label: "BALESAR" },
  { value: "BALESWAR", label: "BALESWAR" },
  { value: "BALIAPAL", label: "BALIAPAL" },
  { value: "BALIAPUR", label: "BALIAPUR" },
  { value: "BALIKUDA", label: "BALIKUDA" },
  { value: "BALLABHGARH", label: "BALLABHGARH" },
  { value: "BALLARI", label: "BALLARI" },
  { value: "BALLARPUR", label: "BALLARPUR" },
  { value: "BALLIA", label: "BALLIA" },
  { value: "BALLIGUDA", label: "BALLIGUDA" },
  { value: "BALOD", label: "BALOD" },
  { value: "BALOD BAZER", label: "BALOD BAZER" },
  { value: "BALODABAZAR", label: "BALODABAZAR" },
  { value: "BALOTRA", label: "BALOTRA" },
  { value: "BALRAMPUR", label: "BALRAMPUR" },
  { value: "BALUGAON", label: "BALUGAON" },
  { value: "BALURGHAT", label: "BALURGHAT" },
  { value: "BALUSSERY", label: "BALUSSERY" },
  { value: "BAMANGRAM", label: "BAMANGRAM" },
  { value: "BAMBOLIM", label: "BAMBOLIM" },
  { value: "BAMRA", label: "BAMRA" },
  { value: "BAMUNARI", label: "BAMUNARI" },
  { value: "BAN ASHURIA", label: "BAN ASHURIA" },
  { value: "BANAGRAM", label: "BANAGRAM" },
  { value: "BANASKANTHA", label: "BANASKANTHA" },
  { value: "BANBASA", label: "BANBASA" },
  { value: "BAND", label: "BAND" },
  { value: "BANDA", label: "BANDA" },
  { value: "BANDALLI", label: "BANDALLI" },
  { value: "BANDANWARA", label: "BANDANWARA" },
  { value: "BANDARGACH", label: "BANDARGACH" },
  { value: "BANDEL", label: "BANDEL" },
  { value: "BANDERDAWA", label: "BANDERDAWA" },
  { value: "BANDIKUI", label: "BANDIKUI" },
  { value: "BANDIPORE", label: "BANDIPORE" },
  { value: "BANDIYA", label: "BANDIYA" },
  { value: "BANDIYOD", label: "BANDIYOD" },
  { value: "BANDLAGUDAJAGIR", label: "BANDLAGUDAJAGIR" },
  { value: "BANDODA", label: "BANDODA" },
  { value: "BANDRA", label: "BANDRA" },
  { value: "BANEI", label: "BANEI" },
  { value: "BANGA", label: "BANGA" },
  { value: "BANGALIPARA", label: "BANGALIPARA" },
  { value: "BANGALORE", label: "BANGALORE" },
  { value: "BANGANA", label: "BANGANA" },
  { value: "BANGAON", label: "BANGAON" },
  { value: "BANGARAPET", label: "BANGARAPET" },
  { value: "BANGARMAU", label: "BANGARMAU" },
  { value: "BANGARPET", label: "BANGARPET" },
  { value: "BANIHAL", label: "BANIHAL" },
  { value: "BANIKHET", label: "BANIKHET" },
  { value: "BANJAR", label: "BANJAR" },
  { value: "BANKA", label: "BANKA" },
  { value: "BANKAPURA", label: "BANKAPURA" },
  { value: "BANKIMNAGAR", label: "BANKIMNAGAR" },
  { value: "BANKNER", label: "BANKNER" },
  { value: "BANKURA", label: "BANKURA" },
  { value: "BANMORE", label: "BANMORE" },
  { value: "BANNERUGHATTA", label: "BANNERUGHATTA" },
  { value: "BANNIKOPPA", label: "BANNIKOPPA" },
  { value: "BANNURU", label: "BANNURU" },
  { value: "BANOI", label: "BANOI" },
  { value: "BANSAWADA", label: "BANSAWADA" },
  { value: "BANSGAONCHAKLA", label: "BANSGAONCHAKLA" },
  { value: "BANSI", label: "BANSI" },
  { value: "BANSKHO", label: "BANSKHO" },
  { value: "BANSUR", label: "BANSUR" },
  { value: "BANSWARA", label: "BANSWARA" },
  { value: "BANTHARA", label: "BANTHARA" },
  { value: "BANTHRA", label: "BANTHRA" },
  { value: "BANTWAL", label: "BANTWAL" },
  { value: "BANUR", label: "BANUR" },
  { value: "BAORI", label: "BAORI" },
  { value: "BARA BELUN", label: "BARA BELUN" },
  { value: "BARA KURPA", label: "BARA KURPA" },
  { value: "BARABANKI", label: "BARABANKI" },
  { value: "BARABAZAR", label: "BARABAZAR" },
  { value: "BARADHEMO", label: "BARADHEMO" },
  { value: "BARAHATILJAGDISHPUR", label: "BARAHATILJAGDISHPUR" },
  { value: "BARAMA", label: "BARAMA" },
  { value: "BARAMARA", label: "BARAMARA" },
  { value: "BARAMATI", label: "BARAMATI" },
  { value: "BARAMKELA", label: "BARAMKELA" },
  { value: "BARAMPUR", label: "BARAMPUR" },
  { value: "BARAMULLA", label: "BARAMULLA" },
  { value: "BARAN", label: "BARAN" },
  { value: "BARAPALASHAN", label: "BARAPALASHAN" },
  { value: "BARARA", label: "BARARA" },
  { value: "BARASAT", label: "BARASAT" },
  { value: "BARAT KAMDEBPUR", label: "BARAT KAMDEBPUR" },
  { value: "BARAUT", label: "BARAUT" },
  { value: "BARBARI", label: "BARBARI" },
  { value: "BARBIL", label: "BARBIL" },
  { value: "BARDHAMAN", label: "BARDHAMAN" },
  { value: "BARDOLI", label: "BARDOLI" },
  { value: "BAREILLY", label: "BAREILLY" },
  { value: "BAREJA", label: "BAREJA" },
  { value: "BARELI", label: "BARELI" },
  { value: "BARGACHIA", label: "BARGACHIA" },
  { value: "BARGAHI", label: "BARGAHI" },
  { value: "BARGAONRURAL", label: "BARGAONRURAL" },
  { value: "BARGARH", label: "BARGARH" },
  { value: "BARHA", label: "BARHA" },
  { value: "BARHAJ", label: "BARHAJ" },
  { value: "BARHALGANJ", label: "BARHALGANJ" },
  { value: "BARHAN", label: "BARHAN" },
  { value: "BARHARWA", label: "BARHARWA" },
  { value: "BARHI", label: "BARHI" },
  { value: "BARI", label: "BARI" },
  { value: "BARIAR", label: "BARIAR" },
  { value: "BARIJHATI", label: "BARIJHATI" },
  { value: "BARIPADA", label: "BARIPADA" },
  { value: "BARISADRI", label: "BARISADRI" },
  { value: "BARJORA", label: "BARJORA" },
  { value: "BARKOT", label: "BARKOT" },
  { value: "BARMANA", label: "BARMANA" },
  { value: "BARMER", label: "BARMER" },
  { value: "BARNAGAR", label: "BARNAGAR" },
  { value: "BARNALA", label: "BARNALA" },
  { value: "BARNESBEG TEA GARDEN", label: "BARNESBEG TEA GARDEN" },
  { value: "BAROBISHA", label: "BAROBISHA" },
  { value: "BAROD", label: "BAROD" },
  { value: "BARPATHAR", label: "BARPATHAR" },
  { value: "BARPETA", label: "BARPETA" },
  { value: "BARSAR", label: "BARSAR" },
  { value: "BARSHI", label: "BARSHI" },
  { value: "BARSUNDRA", label: "BARSUNDRA" },
  { value: "BARUIPARA", label: "BARUIPARA" },
  { value: "BARUIPUR", label: "BARUIPUR" },
  { value: "BARURAJ", label: "BARURAJ" },
  { value: "BARUT", label: "BARUT" },
  { value: "BARWAHA", label: "BARWAHA" },
  { value: "BARWALA", label: "BARWALA" },
  { value: "BARWANI", label: "BARWANI" },
  { value: "BASAR", label: "BASAR" },
  { value: "BASARIA", label: "BASARIA" },
  { value: "BASAVAKALYAN", label: "BASAVAKALYAN" },
  { value: "BASHATTIHALLI", label: "BASHATTIHALLI" },
  { value: "BASIRHAT", label: "BASIRHAT" },
  { value: "BASKHARI", label: "BASKHARI" },
  { value: "BASNA", label: "BASNA" },
  { value: "BASNI", label: "BASNI" },
  { value: "BASOHLI", label: "BASOHLI" },
  { value: "BASSI", label: "BASSI" },
  { value: "BASTAR", label: "BASTAR" },
  { value: "BASTI", label: "BASTI" },
  { value: "BASUDEBPUR", label: "BASUDEBPUR" },
  { value: "BATAGRAM", label: "BATAGRAM" },
  { value: "BATALA", label: "BATALA" },
  { value: "BATAURA", label: "BATAURA" },
  { value: "BATHINDA", label: "BATHINDA" },
  { value: "BATLAGUNDU", label: "BATLAGUNDU" },
  { value: "BATTISSHIRALA", label: "BATTISSHIRALA" },
  { value: "BAUDHGARH", label: "BAUDHGARH" },
  { value: "BAVADA", label: "BAVADA" },
  { value: "BAVI DHOKI", label: "BAVI DHOKI" },
  { value: "BAVLA", label: "BAVLA" },
  { value: "BAWADA", label: "BAWADA" },
  { value: "BAWAL", label: "BAWAL" },
  { value: "BAY", label: "BAY" },
  { value: "BAYAD", label: "BAYAD" },
  { value: "BAYANA", label: "BAYANA" },
  { value: "BAYANPUR", label: "BAYANPUR" },
  { value: "BAYTU", label: "BAYTU" },
  { value: "BAYYARAM", label: "BAYYARAM" },
  { value: "BAZPUR", label: "BAZPUR" },
  { value: "BEAWAR", label: "BEAWAR" },
  { value: "BECHARAJI", label: "BECHARAJI" },
  { value: "BEED", label: "BEED" },
  { value: "BEGOWAL", label: "BEGOWAL" },
  { value: "BEGUMGANJ", label: "BEGUMGANJ" },
  { value: "BEGUN", label: "BEGUN" },
  { value: "BEGUSARAI", label: "BEGUSARAI" },
  { value: "BEHATA", label: "BEHATA" },
  { value: "BEHRAMPUR", label: "BEHRAMPUR" },
  { value: "BEHROR", label: "BEHROR" },
  { value: "BEHSUMA", label: "BEHSUMA" },
  { value: "BEJRA", label: "BEJRA" },
  { value: "BELA", label: "BELA" },
  { value: "BELACOBA", label: "BELACOBA" },
  { value: "BELAGALAPETH", label: "BELAGALAPETH" },
  { value: "BELAGALI", label: "BELAGALI" },
  { value: "BELAGAVI", label: "BELAGAVI" },
  { value: "BELAGAVICANTONMENT", label: "BELAGAVICANTONMENT" },
  { value: "BELARMATH", label: "BELARMATH" },
  { value: "BELAVANAKI", label: "BELAVANAKI" },
  { value: "BELDA", label: "BELDA" },
  { value: "BELGAUM", label: "BELGAUM" },
  { value: "BELIARA", label: "BELIARA" },
  { value: "BELIATORE", label: "BELIATORE" },
  { value: "BELLAMPALLE", label: "BELLAMPALLE" },
  { value: "BELLARE", label: "BELLARE" },
  { value: "BELLARY", label: "BELLARY" },
  { value: "BELLATTI", label: "BELLATTI" },
  { value: "BELLURCROSS", label: "BELLURCROSS" },
  { value: "BELMURI", label: "BELMURI" },
  { value: "BELONIA", label: "BELONIA" },
  { value: "BELPAHAR", label: "BELPAHAR" },
  { value: "BELTHANGADY", label: "BELTHANGADY" },
  { value: "BELUNIA", label: "BELUNIA" },
  { value: "BELUR", label: "BELUR" },
  { value: "BELWAT", label: "BELWAT" },
  { value: "BEMETARA", label: "BEMETARA" },
  { value: "BENGALURU", label: "BENGALURU" },
  { value: "BEOHARI", label: "BEOHARI" },
  { value: "BERACHAMPA", label: "BERACHAMPA" },
  { value: "BERASIA", label: "BERASIA" },
  { value: "BERHAMPORE", label: "BERHAMPORE" },
  { value: "BERHAMPUR", label: "BERHAMPUR" },
  { value: "BERI", label: "BERI" },
  { value: "BERINAG", label: "BERINAG" },
  { value: "BERLA", label: "BERLA" },
  { value: "BERO", label: "BERO" },
  { value: "BETMA", label: "BETMA" },
  { value: "BETTADAPURA", label: "BETTADAPURA" },
  { value: "BETTIAH", label: "BETTIAH" },
  { value: "BETUL", label: "BETUL" },
  { value: "BEWAR", label: "BEWAR" },
  { value: "BEYPORE", label: "BEYPORE" },
  { value: "BHABHAR", label: "BHABHAR" },
  { value: "BHADA", label: "BHADA" },
  { value: "BHADERWAH", label: "BHADERWAH" },
  { value: "BHADESAR", label: "BHADESAR" },
  { value: "BHADOHI", label: "BHADOHI" },
  { value: "BHADRA", label: "BHADRA" },
  { value: "BHADRACHALAM", label: "BHADRACHALAM" },
  { value: "BHADRAK", label: "BHADRAK" },
  { value: "BHADRAVATHI", label: "BHADRAVATHI" },
  { value: "BHADSON", label: "BHADSON" },
  { value: "BHAGABAZAR", label: "BHAGABAZAR" },
  { value: "BHAGALPUR", label: "BHAGALPUR" },
  { value: "BHAGTABHAIKA", label: "BHAGTABHAIKA" },
  { value: "BHAGWANPUR", label: "BHAGWANPUR" },
  { value: "BHAGWANTNAGAR", label: "BHAGWANTNAGAR" },
  { value: "BHAINSA", label: "BHAINSA" },
  { value: "BHAITBARINEW", label: "BHAITBARINEW" },
  { value: "BHAKTA BALLABHPUR", label: "BHAKTA BALLABHPUR" },
  { value: "BHALGAM", label: "BHALGAM" },
  { value: "BHALGAMDA", label: "BHALGAMDA" },
  { value: "BHALKI", label: "BHALKI" },
  { value: "BHALPARAPART", label: "BHALPARAPART" },
  { value: "BHALSWAJAHANGIRVILLAGE", label: "BHALSWAJAHANGIRVILLAGE" },
  { value: "BHALUKHOP FOREST", label: "BHALUKHOP FOREST" },
  { value: "BHALUKPONG", label: "BHALUKPONG" },
  { value: "BHAMBLA", label: "BHAMBLA" },
  { value: "BHAMIAKALAN", label: "BHAMIAKALAN" },
  { value: "BHAMRAGARH", label: "BHAMRAGARH" },
  { value: "BHANDARA", label: "BHANDARA" },
  { value: "BHANDARPUR", label: "BHANDARPUR" },
  { value: "BHANJANAGAR", label: "BHANJANAGAR" },
  { value: "BHANPURA", label: "BHANPURA" },
  { value: "BHANVAD", label: "BHANVAD" },
  { value: "BHARANIKKAVU", label: "BHARANIKKAVU" },
  { value: "BHARARIGHAT", label: "BHARARIGHAT" },
  { value: "BHARATPUR", label: "BHARATPUR" },
  { value: "BHARTHANA", label: "BHARTHANA" },
  { value: "BHARUCH", label: "BHARUCH" },
  { value: "BHAT", label: "BHAT" },
  { value: "BHATAPARA", label: "BHATAPARA" },
  { value: "BHATEWAR", label: "BHATEWAR" },
  { value: "BHATI", label: "BHATI" },
  { value: "BHATIYA", label: "BHATIYA" },
  { value: "BHATKAL", label: "BHATKAL" },
  { value: "BHATOD", label: "BHATOD" },
  { value: "BHATROG (20)", label: "BHATROG (20)" },
  { value: "BHAVANI", label: "BHAVANI" },
  { value: "BHAVNAGAR", label: "BHAVNAGAR" },
  { value: "BHAVRA", label: "BHAVRA" },
  { value: "BHAWANBAHADURNAGAR", label: "BHAWANBAHADURNAGAR" },
  { value: "BHAWANIGARH", label: "BHAWANIGARH" },
  { value: "BHAWANIMANDI", label: "BHAWANIMANDI" },
  { value: "BHAWANIPATNA", label: "BHAWANIPATNA" },
  { value: "BHAYAVADAR", label: "BHAYAVADAR" },
  { value: "BHEEMGAL", label: "BHEEMGAL" },
  { value: "BHEEMUNIPATNAM", label: "BHEEMUNIPATNAM" },
  { value: "BHESLAY", label: "BHESLAY" },
  { value: "BHETKAKHALI", label: "BHETKAKHALI" },
  { value: "BHIGWAN", label: "BHIGWAN" },
  { value: "BHIKHIWIND", label: "BHIKHIWIND" },
  { value: "BHILAI", label: "BHILAI" },
  { value: "BHILAWADI", label: "BHILAWADI" },
  { value: "BHILODA", label: "BHILODA" },
  { value: "BHILWARA", label: "BHILWARA" },
  { value: "BHIM", label: "BHIM" },
  { value: "BHIMARAMRURAL", label: "BHIMARAMRURAL" },
  { value: "BHIMAVARAM", label: "BHIMAVARAM" },
  { value: "BHIND", label: "BHIND" },
  { value: "BHINDER", label: "BHINDER" },
  { value: "BHINGA", label: "BHINGA" },
  { value: "BHINMAL", label: "BHINMAL" },
  { value: "BHITARWAR", label: "BHITARWAR" },
  { value: "BHIWADI", label: "BHIWADI" },
  { value: "BHIWANDI", label: "BHIWANDI" },
  { value: "BHIWANI", label: "BHIWANI" },
  { value: "BHOGNIPUR", label: "BHOGNIPUR" },
  { value: "BHOGPUR", label: "BHOGPUR" },
  { value: "BHOIRYMBONG", label: "BHOIRYMBONG" },
  { value: "BHOJPUR", label: "BHOJPUR" },
  { value: "BHOLATH", label: "BHOLATH" },
  { value: "BHONGIR", label: "BHONGIR" },
  { value: "BHOPAL", label: "BHOPAL" },
  { value: "BHOPALGARH", label: "BHOPALGARH" },
  { value: "BHOPALI", label: "BHOPALI" },
  { value: "BHOR", label: "BHOR" },
  { value: "BHORANJ", label: "BHORANJ" },
  { value: "BHORGARH", label: "BHORGARH" },
  { value: "BHOWALI", label: "BHOWALI" },
  { value: "BHUBAN", label: "BHUBAN" },
  { value: "BHUBANESWAR", label: "BHUBANESWAR" },
  { value: "BHUINDHARA", label: "BHUINDHARA" },
  { value: "BHUJ", label: "BHUJ" },
  { value: "BHUJ SOHAR", label: "BHUJ SOHAR" },
  { value: "BHUNA", label: "BHUNA" },
  { value: "BHUNTAR", label: "BHUNTAR" },
  { value: "BHUPALPALLY", label: "BHUPALPALLY" },
  { value: "BHUSAWAL", label: "BHUSAWAL" },
  { value: "BHUVANAGIRI", label: "BHUVANAGIRI" },
  { value: "BIAORA", label: "BIAORA" },
  { value: "BIBARDA", label: "BIBARDA" },
  { value: "BICHHADI", label: "BICHHADI" },
  { value: "BICHHIYA", label: "BICHHIYA" },
  { value: "BICHOLIHAPSI", label: "BICHOLIHAPSI" },
  { value: "BICHOLIM", label: "BICHOLIM" },
  { value: "BIDADI", label: "BIDADI" },
  { value: "BIDAR", label: "BIDAR" },
  { value: "BIDASAR", label: "BIDASAR" },
  { value: "BIDHANNAGAR", label: "BIDHANNAGAR" },
  { value: "BIDHUNA", label: "BIDHUNA" },
  { value: "BIHARSHARIF", label: "BIHARSHARIF" },
  { value: "BIHAT-IV", label: "BIHAT-IV" },
  { value: "BIHTA", label: "BIHTA" },
  { value: "BIJAINAGAR", label: "BIJAINAGAR" },
  { value: "BIJANBARI", label: "BIJANBARI" },
  { value: "BIJAPUR", label: "BIJAPUR" },
  { value: "BIJAPUR(KAR)", label: "BIJAPUR(KAR)" },
  { value: "BIJNOR", label: "BIJNOR" },
  { value: "BIJOLIA", label: "BIJOLIA" },
  { value: "BIJOLIYA", label: "BIJOLIYA" },
  { value: "BIJOYNAGAR", label: "BIJOYNAGAR" },
  { value: "BIJPUR", label: "BIJPUR" },
  { value: "BIJURI", label: "BIJURI" },
  { value: "BIJYAPUR", label: "BIJYAPUR" },
  { value: "BIKANER", label: "BIKANER" },
  { value: "BIKRAM", label: "BIKRAM" },
  { value: "BILARA", label: "BILARA" },
  { value: "BILARI", label: "BILARI" },
  { value: "BILARIYAGANJ", label: "BILARIYAGANJ" },
  { value: "BILASIPARA", label: "BILASIPARA" },
  { value: "BILASPUR", label: "BILASPUR" },
  { value: "BILASPUR HP", label: "BILASPUR HP" },
  { value: "BILGA", label: "BILGA" },
  { value: "BILGI", label: "BILGI" },
  { value: "BILHAUR", label: "BILHAUR" },
  { value: "BILIMORA", label: "BILIMORA" },
  { value: "BILLOWA", label: "BILLOWA" },
  { value: "BINA", label: "BINA" },
  { value: "BINARAILWAYCOLONY", label: "BINARAILWAYCOLONY" },
  { value: "BINDKI", label: "BINDKI" },
  { value: "BIRBHUM", label: "BIRBHUM" },
  { value: "BIRCHHUCHHAKWAS", label: "BIRCHHUCHHAKWAS" },
  { value: "BIRGHAGHAR", label: "BIRGHAGHAR" },
  { value: "BIRGOAN", label: "BIRGOAN" },
  { value: "BIRLOK", label: "BIRLOK" },
  { value: "BIRPARA", label: "BIRPARA" },
  { value: "BISALPUR", label: "BISALPUR" },
  { value: "BISAULI", label: "BISAULI" },
  { value: "BISHALGARH", label: "BISHALGARH" },
  { value: "BISHANPURA", label: "BISHANPURA" },
  { value: "BISHKODAR", label: "BISHKODAR" },
  { value: "BISHNUPUR", label: "BISHNUPUR" },
  { value: "BISHRAMPUR", label: "BISHRAMPUR" },
  { value: "BISWAN", label: "BISWAN" },
  { value: "BISWANATHCHARALI", label: "BISWANATHCHARALI" },
  { value: "BOBBILI", label: "BOBBILI" },
  { value: "BODDUGUDEM", label: "BODDUGUDEM" },
  { value: "BODELI", label: "BODELI" },
  { value: "BODHGAYA", label: "BODHGAYA" },
  { value: "BODINAYAKANUR", label: "BODINAYAKANUR" },
  { value: "BODRA", label: "BODRA" },
  { value: "BOH", label: "BOH" },
  { value: "BOHAR", label: "BOHAR" },
  { value: "BOISAR", label: "BOISAR" },
  { value: "BOJJIGUPPA", label: "BOJJIGUPPA" },
  { value: "BOKAJAN", label: "BOKAJAN" },
  { value: "BOKAKHAT", label: "BOKAKHAT" },
  { value: "BOKARO", label: "BOKARO" },
  { value: "BOKARO STEEL CITY", label: "BOKARO STEEL CITY" },
  { value: "BOKAROSTEELCITY", label: "BOKAROSTEELCITY" },
  { value: "BOKAROTHERMAL", label: "BOKAROTHERMAL" },
  { value: "BOKO", label: "BOKO" },
  { value: "BOLPUR", label: "BOLPUR" },
  { value: "BOMDILA", label: "BOMDILA" },
  { value: "BOMMANAHAL", label: "BOMMANAHAL" },
  { value: "BOMMANAHALLI", label: "BOMMANAHALLI" },
  { value: "BONDAGAON", label: "BONDAGAON" },
  { value: "BONGAIGAON", label: "BONGAIGAON" },
  { value: "BONGSHAR", label: "BONGSHAR" },
  { value: "BONLI", label: "BONLI" },
  { value: "BORAJ", label: "BORAJ" },
  { value: "BORDEVI", label: "BORDEVI" },
  { value: "BORKA", label: "BORKA" },
  { value: "BORLIPANCHATAN", label: "BORLIPANCHATAN" },
  { value: "BORSAD", label: "BORSAD" },
  { value: "BORUNDA", label: "BORUNDA" },
  { value: "BOTAB", label: "BOTAB" },
  { value: "BOTAD", label: "BOTAD" },
  { value: "BOUDH", label: "BOUDH" },
  { value: "BRAHMANVADA", label: "BRAHMANVADA" },
  { value: "BRAHMAPUR", label: "BRAHMAPUR" },
  { value: "BRAHMAPURI", label: "BRAHMAPURI" },
  { value: "BRAJRAJNAGAR", label: "BRAJRAJNAGAR" },
  { value: "BRAMHANGRAM", label: "BRAMHANGRAM" },
  { value: "BROADWAY", label: "BROADWAY" },
  { value: "BUDAUN", label: "BUDAUN" },
  { value: "BUDGAM", label: "BUDGAM" },
  { value: "BUDGEBUDGE", label: "BUDGEBUDGE" },
  { value: "BUDHAL", label: "BUDHAL" },
  { value: "BUDHANA", label: "BUDHANA" },
  { value: "BUDHLADA", label: "BUDHLADA" },
  { value: "BUDHNI", label: "BUDHNI" },
  { value: "BUDIGERECROSS", label: "BUDIGERECROSS" },
  { value: "BUJABUJANELLORE", label: "BUJABUJANELLORE" },
  { value: "BULANDSHAHR", label: "BULANDSHAHR" },
  { value: "BULDHANA", label: "BULDHANA" },
  { value: "BULLOWAL", label: "BULLOWAL" },
  { value: "BUNDI", label: "BUNDI" },
  { value: "BUNDU", label: "BUNDU" },
  { value: "BURHANPUR", label: "BURHANPUR" },
  { value: "BUTIBORI", label: "BUTIBORI" },
  { value: "BUXAR", label: "BUXAR" },
  { value: "BYADAGI", label: "BYADAGI" },
  { value: "BYASANAGAR", label: "BYASANAGAR" },
  { value: "Babai(CT)", label: "Babai(CT)" },
  { value: "BabarpurAjitmal(NP)", label: "BabarpurAjitmal(NP)" },
  { value: "Baben(CT)", label: "Baben(CT)" },
  { value: "Baberu(NP)", label: "Baberu(NP)" },
  { value: "Babina(CB)", label: "Babina(CB)" },
  { value: "Babra(M)", label: "Babra(M)" },
  { value: "Babrala(NP)", label: "Babrala(NP)" },
  { value: "Babugarh(NP)", label: "Babugarh(NP)" },
  { value: "Bachhraon(NPP)", label: "Bachhraon(NPP)" },
  { value: "Bachhrawan(NP)", label: "Bachhrawan(NP)" },
  { value: "BadaMalhera(NP)", label: "BadaMalhera(NP)" },
  { value: "Badagaon(NP)", label: "Badagaon(NP)" },
  { value: "Badarwas(NP)", label: "Badarwas(NP)" },
  { value: "Badawada(NP)", label: "Badawada(NP)" },
  { value: "Baddowal(CT)", label: "Baddowal(CT)" },
  { value: "BadhniKalan(NP)", label: "BadhniKalan(NP)" },
  { value: "Badmal(CT)", label: "Badmal(CT)" },
  { value: "Badoni(NP)", label: "Badoni(NP)" },
  { value: "Badra(CT)", label: "Badra(CT)" },
  { value: "Badshahpur(87)(CT)", label: "Badshahpur(87)(CT)" },
  { value: "Badwa", label: "Badwa" },
  { value: "Bagasara(M)", label: "Bagasara(M)" },
  { value: "Bagh(CT)", label: "Bagh(CT)" },
  { value: "BaghaPurana(MCl)", label: "BaghaPurana(MCl)" },
  { value: "Baghola(44)(CT)", label: "Baghola(44)(CT)" },
  { value: "Bagrana(CT)", label: "Bagrana(CT)" },
  { value: "Bah(NPP)", label: "Bah(NPP)" },
  { value: "Bahadurganj(NP)", label: "Bahadurganj(NP)" },
  { value: "Bahadurpur(CT)", label: "Bahadurpur(CT)" },
  { value: "BahbariGaon(CT)", label: "BahbariGaon(CT)" },
  { value: "Bahjoi(NPP)", label: "Bahjoi(NPP)" },
  { value: "Baikunthpur(M)", label: "Baikunthpur(M)" },
  { value: "Baikunthpur(NP)", label: "Baikunthpur(NP)" },
  { value: "Bairgania(NP)", label: "Bairgania(NP)" },
  { value: "Bajna(NP)", label: "Bajna(NP)" },
  { value: "BakalpurMathura(CT)", label: "BakalpurMathura(CT)" },
  { value: "Bakani(CT)", label: "Bakani(CT)" },
  { value: "BakshiKaTalab(NP)", label: "BakshiKaTalab(NP)" },
  { value: "Baktarnagar(CT)", label: "Baktarnagar(CT)" },
  { value: "Balapur(MCl)", label: "Balapur(MCl)" },
  { value: "Baldeo(NP)", label: "Baldeo(NP)" },
  { value: "Bali(M)", label: "Bali(M)" },
  { value: "Balia(NP)", label: "Balia(NP)" },
  { value: "Baliapur(CT)", label: "Baliapur(CT)" },
  { value: "Balihati(CT)", label: "Balihati(CT)" },
  { value: "Balirampur(CT)", label: "Balirampur(CT)" },
  { value: "Balitha(CT)", label: "Balitha(CT)" },
  { value: "Ballarpur(MCl)", label: "Ballarpur(MCl)" },
  { value: "Ballepalle(CT)", label: "Ballepalle(CT)" },
  { value: "Bally(CT)", label: "Bally(CT)" },
  { value: "Bally(M)", label: "Bally(M)" },
  { value: "Balongi(CT)", label: "Balongi(CT)" },
  { value: "Bamhani(NP)", label: "Bamhani(NP)" },
  { value: "Bamora(CT)", label: "Bamora(CT)" },
  { value: "Banat(NP)", label: "Banat(NP)" },
  { value: "Banda(NP)", label: "Banda(NP)" },
  { value: "Bandhail(CT)", label: "Bandhail(CT)" },
  { value: "Bandhgora(CT)", label: "Bandhgora(CT)" },
  { value: "Bandipur", label: "Bandipur" },
  { value: "Bangaon(CT)", label: "Bangaon(CT)" },
  { value: "Bangarmau(NPP)", label: "Bangarmau(NPP)" },
  { value: "Bangawan(CT)", label: "Bangawan(CT)" },
  { value: "Bangherimahabatpur(Must)(CT)", label: "Bangherimahabatpur(Must)(CT)" },
  { value: "Banglore", label: "Banglore" },
  { value: "BanguwanKalan(CT)", label: "BanguwanKalan(CT)" },
  { value: "Baniban(CT)", label: "Baniban(CT)" },
  { value: "BanibanJagadishpur(CT)", label: "BanibanJagadishpur(CT)" },
  { value: "Banjarepur(CT)", label: "Banjarepur(CT)" },
  { value: "Banjetia(CT)", label: "Banjetia(CT)" },
  { value: "Bank(CT)", label: "Bank(CT)" },
  { value: "Bankra(CT)", label: "Bankra(CT)" },
  { value: "BansatarKheda(CT)", label: "BansatarKheda(CT)" },
  { value: "Bansdih(NP)", label: "Bansdih(NP)" },
  { value: "Bansgaon(NP)", label: "Bansgaon(NP)" },
  { value: "Banshra(CT)", label: "Banshra(CT)" },
  { value: "Bansi(NPP)", label: "Bansi(NPP)" },
  { value: "Banur(MCl)", label: "Banur(MCl)" },
  { value: "Bapatla", label: "Bapatla" },
  { value: "Bapatla(M)", label: "Bapatla(M)" },
  { value: "Bapauli", label: "Bapauli" },
  { value: "Baqiabad(CT)", label: "Baqiabad(CT)" },
  { value: "Baragaon(CT)", label: "Baragaon(CT)" },
  { value: "Baragaon(NP)", label: "Baragaon(NP)" },
  { value: "Barajamda(CT)", label: "Barajamda(CT)" },
  { value: "Baral(CT)", label: "Baral(CT)" },
  { value: "Baranagar(M)", label: "Baranagar(M)" },
  { value: "Barauli(NP)", label: "Barauli(NP)" },
  { value: "Bargo(CT)", label: "Bargo(CT)" },
  { value: "Barhalganj(NP)", label: "Barhalganj(NP)" },
  { value: "BarhaniBazar(NP)", label: "BarhaniBazar(NP)" },
  { value: "Bari(M)", label: "Bari(M)" },
  { value: "BariSadri(M)", label: "BariSadri(M)" },
  { value: "Barigarh(NP)", label: "Barigarh(NP)" },
  { value: "BarikaChuburi(CT)", label: "BarikaChuburi(CT)" },
  { value: "Barkhera(NP)", label: "Barkhera(NP)" },
  { value: "Barkot(NP)", label: "Barkot(NP)" },
  { value: "BarmanKalan(CT)", label: "BarmanKalan(CT)" },
  { value: "Baroun(CT)", label: "Baroun(CT)" },
  { value: "Barpathar(TC)", label: "Barpathar(TC)" },
  { value: "BarrackpurCantonment", label: "BarrackpurCantonment" },
  { value: "Barsana(NP)", label: "Barsana(NP)" },
  { value: "BaruaBariGaon(CT)", label: "BaruaBariGaon(CT)" },
  { value: "BaruaSagar(NPP)", label: "BaruaSagar(NPP)" },
  { value: "Barwar(NP)", label: "Barwar(NP)" },
  { value: "BarwaraMazra(CT)", label: "BarwaraMazra(CT)" },
  { value: "Basta(CT)", label: "Basta(CT)" },
  { value: "Bastar", label: "Bastar" },
  { value: "Basudebpur(CT)", label: "Basudebpur(CT)" },
  { value: "Basugaon(TC)", label: "Basugaon(TC)" },
  { value: "Baswar(CT)", label: "Baswar(CT)" },
  { value: "Batarashi(CT)", label: "Batarashi(CT)" },
  { value: "Bawal(MC)", label: "Bawal(MC)" },
  { value: "Bawanikhera(MC)", label: "Bawanikhera(MC)" },
  { value: "Bedla(CT)", label: "Bedla(CT)" },
  { value: "Beelna(CT)", label: "Beelna(CT)" },
  { value: "Beerwah(MC)", label: "Beerwah(MC)" },
  { value: "BegumabadBudhana(CT)", label: "BegumabadBudhana(CT)" },
  { value: "BegunKodar(CT)", label: "BegunKodar(CT)" },
  { value: "Behat(NP)", label: "Behat(NP)" },
  { value: "BelaPratapgarh(NPP)", label: "BelaPratapgarh(NPP)" },
  { value: "Belagachhia(CT)", label: "Belagachhia(CT)" },
  { value: "Belebathan(CT)", label: "Belebathan(CT)" },
  { value: "Belma(CT)", label: "Belma(CT)" },
  { value: "Belsand(NP)", label: "Belsand(NP)" },
  { value: "BeltharaRoad(NP)", label: "BeltharaRoad(NP)" },
  { value: "Belvata(CT)", label: "Belvata(CT)" },
  { value: "Benakanahalli(CT)", label: "Benakanahalli(CT)" },
  { value: "Benipur(CT)", label: "Benipur(CT)" },
  { value: "Berasia(M)", label: "Berasia(M)" },
  { value: "Beriyawali(CT)", label: "Beriyawali(CT)" },
  { value: "Bermo(CT)", label: "Bermo(CT)" },
  { value: "Beswan(NP)", label: "Beswan(NP)" },
  { value: "Bewar(NP)", label: "Bewar(NP)" },
  { value: "BhabnanBazar(NP)", label: "BhabnanBazar(NP)" },
  { value: "Bhadauni(CT)", label: "Bhadauni(CT)" },
  { value: "Bhadaur(MCl)", label: "Bhadaur(MCl)" },
  { value: "Bhadravati(CMC)", label: "Bhadravati(CMC)" },
  { value: "Bhadravati(MCl)", label: "Bhadravati(MCl)" },
  { value: "Bhadreswar(M)", label: "Bhadreswar(M)" },
  { value: "Bhagdawada(CT)", label: "Bhagdawada(CT)" },
  { value: "Bhagipur(CT)", label: "Bhagipur(CT)" },
  { value: "Bhagwanpur(CT)", label: "Bhagwanpur(CT)" },
  { value: "Bhainsa(CT)", label: "Bhainsa(CT)" },
  { value: "Bhakhara(NP)", label: "Bhakhara(NP)" },
  { value: "Bhalariya(CT)", label: "Bhalariya(CT)" },
  { value: "Bhandardaha(CT)", label: "Bhandardaha(CT)" },
  { value: "Bhander(NP)", label: "Bhander(NP)" },
  { value: "Bhankharpur(CT)", label: "Bhankharpur(CT)" },
  { value: "Bhanpura(NP)", label: "Bhanpura(NP)" },
  { value: "Bhanur(CT)", label: "Bhanur(CT)" },
  { value: "Bharatganj(NP)", label: "Bharatganj(NP)" },
  { value: "Bhargain(NP)", label: "Bhargain(NP)" },
  { value: "Bharthana(NPP)", label: "Bharthana(NPP)" },
  { value: "Bharuhana(CT)", label: "Bharuhana(CT)" },
  { value: "Bharveli(CT)", label: "Bharveli(CT)" },
  { value: "Bhatinda", label: "Bhatinda" },
  { value: "BhatniBazar(NP)", label: "BhatniBazar(NP)" },
  { value: "BhatparRani(NP)", label: "BhatparRani(NP)" },
  { value: "Bhatpara(M+OG)", label: "Bhatpara(M+OG)" },
  { value: "Bhattian(CT)", label: "Bhattian(CT)" },
  { value: "Bhaurasa(NP)", label: "Bhaurasa(NP)" },
  { value: "Bhavra(NP)", label: "Bhavra(NP)" },
  { value: "Bhavri(CT)", label: "Bhavri(CT)" },
  { value: "BhawanBahadurNagar(NP)", label: "BhawanBahadurNagar(NP)" },
  { value: "Bhilakhedi(CT)", label: "Bhilakhedi(CT)" },
  { value: "Bhim(CT)", label: "Bhim(CT)" },
  { value: "Bhimtal(NP)", label: "Bhimtal(NP)" },
  { value: "Bhinder(M)", label: "Bhinder(M)" },
  { value: "Bhinmal(M)", label: "Bhinmal(M)" },
  { value: "Bhisiana(CT)", label: "Bhisiana(CT)" },
  { value: "Bhitarwar(NP)", label: "Bhitarwar(NP)" },
  { value: "Bhogadi(CT)", label: "Bhogadi(CT)" },
  { value: "Bhogaon(NP)", label: "Bhogaon(NP)" },
  { value: "BhojpurDharampur(NP)", label: "BhojpurDharampur(NP)" },
  { value: "Bhokarhedi(NP)", label: "Bhokarhedi(NP)" },
  { value: "BholarDabri(CT)", label: "BholarDabri(CT)" },
  { value: "Bholav(CT)", label: "Bholav(CT)" },
  { value: "Bhondsi(168)(CT)", label: "Bhondsi(168)(CT)" },
  { value: "Bhoogar(CT)", label: "Bhoogar(CT)" },
  { value: "Bhulepur(CT)", label: "Bhulepur(CT)" },
  { value: "Bhuragaon(Rev.)Town(CT)", label: "Bhuragaon(Rev.)Town(CT)" },
  { value: "Bhuran(16)(CT)", label: "Bhuran(16)(CT)" },
  { value: "Bhusawal(MCl)", label: "Bhusawal(MCl)" },
  { value: "Bhusawar(M)", label: "Bhusawar(M)" },
  { value: "Bhuwana(CT)", label: "Bhuwana(CT)" },
  { value: "Bidasar(M)", label: "Bidasar(M)" },
  { value: "Bidhannagar(M)", label: "Bidhannagar(M)" },
  { value: "Bidhuna(NP)", label: "Bidhuna(NP)" },
  { value: "Bidyadharpur(CT)", label: "Bidyadharpur(CT)" },
  { value: "Bighapur(NP)", label: "Bighapur(NP)" },
  { value: "Bihar", label: "Bihar" },
  { value: "Bihpuria(TC)", label: "Bihpuria(TC)" },
  { value: "Bijapur(CGH)", label: "Bijapur(CGH)" },
  { value: "Bijawar(NP)", label: "Bijawar(NP)" },
  { value: "Bijbehara(MC)", label: "Bijbehara(MC)" },
  { value: "Bijni(TC)", label: "Bijni(TC)" },
  { value: "Bilara(M)", label: "Bilara(M)" },
  { value: "Bilaspur(NP)", label: "Bilaspur(NP)" },
  { value: "Bilhaur(NPP)", label: "Bilhaur(NPP)" },
  { value: "Bilpura(CT)", label: "Bilpura(CT)" },
  { value: "Bilram(NP)", label: "Bilram(NP)" },
  { value: "Bilsanda(NP)", label: "Bilsanda(NP)" },
  { value: "Bilsi(NPP)", label: "Bilsi(NPP)" },
  { value: "Birbhanpur(CT)", label: "Birbhanpur(CT)" },
  { value: "Birjapur(CT)", label: "Birjapur(CT)" },
  { value: "Bisalpur(NPP)", label: "Bisalpur(NPP)" },
  { value: "BisandaBuzurg(NP)", label: "BisandaBuzurg(NP)" },
  { value: "Bisauli(NPP)", label: "Bisauli(NPP)" },
  { value: "Bishnugarh(CT)", label: "Bishnugarh(CT)" },
  { value: "Bishrampur(NP)", label: "Bishrampur(NP)" },
  { value: "Bishunipur(CT)", label: "Bishunipur(CT)" },
  { value: "Bisokhar(CT)", label: "Bisokhar(CT)" },
  { value: "Bissau(M)", label: "Bissau(M)" },
  { value: "Biswan(NPP)", label: "Biswan(NPP)" },
  { value: "BiswanathChariali(TC)", label: "BiswanathChariali(TC)" },
  { value: "Boda(NP)", label: "Boda(NP)" },
  { value: "BodhGaya(NP)", label: "BodhGaya(NP)" },
  { value: "Bodla(NP)", label: "Bodla(NP)" },
  { value: "Boduppal(CT)", label: "Boduppal(CT)" },
  { value: "Bohari(CT)", label: "Bohari(CT)" },
  { value: "Bomdila", label: "Bomdila" },
  { value: "Bommasandra(CT)", label: "Bommasandra(CT)" },
  { value: "Bondathila(CT)", label: "Bondathila(CT)" },
  { value: "Boothipuram(TP)", label: "Boothipuram(TP)" },
  { value: "Bopal(CT)", label: "Bopal(CT)" },
  { value: "Boraj-Kazipura(CT)", label: "Boraj-Kazipura(CT)" },
  { value: "Borawar(CT)", label: "Borawar(CT)" },
  { value: "Bori(CT)", label: "Bori(CT)" },
  { value: "Borim(CT)", label: "Borim(CT)" },
  { value: "BorivaliTarfRahur(CT)", label: "BorivaliTarfRahur(CT)" },
  { value: "Borkhedi(CT)", label: "Borkhedi(CT)" },
  { value: "Borsad(M)", label: "Borsad(M)" },
  { value: "Brahmapur(MCorp.)", label: "Brahmapur(MCorp.)" },
  { value: "Briddhanagar(CT)", label: "Briddhanagar(CT)" },
  { value: "Brindabanpur(CT)", label: "Brindabanpur(CT)" },
  { value: "Budhana(NP)", label: "Budhana(NP)" },
  { value: "Budhpura(CT)", label: "Budhpura(CT)" },
  { value: "Bugrasi(NP)", label: "Bugrasi(NP)" },
  { value: "Bundia(CT)", label: "Bundia(CT)" },
  { value: "Bungal(CT)", label: "Bungal(CT)" },
  { value: "Burari(CT)", label: "Burari(CT)" },
  { value: "Burhanagar(CT)", label: "Burhanagar(CT)" },
  { value: "Burhar(NP)", label: "Burhar(NP)" },
  { value: "Buria(CT)", label: "Buria(CT)" },
  { value: "Burla(NAC)", label: "Burla(NAC)" },
  { value: "Buxer(CT)", label: "Buxer(CT)" },
  { value: "Buxwaha(NP)", label: "Buxwaha(NP)" },
  { value: "Buzurg(CT)", label: "Buzurg(CT)" },
  { value: "CACHAR", label: "CACHAR" },
  { value: "CALICUT", label: "CALICUT" },
  { value: "CALICUT ", label: "CALICUT " },
  { value: "CANACONA", label: "CANACONA" },
  { value: "CANNING", label: "CANNING" },
  { value: "CARNICOBAR", label: "CARNICOBAR" },
  { value: "CBDBELAPUR", label: "CBDBELAPUR" },
  { value: "CENTRAL DELHI", label: "CENTRAL DELHI" },
  { value: "CENTRAL INDUSTRIAL SECURITY FORCE QUARTERS", label: "CENTRAL INDUSTRIAL SECURITY FORCE QUARTERS" },
  { value: "CHABBEWAL", label: "CHABBEWAL" },
  { value: "CHACHAURA-BINAGANJ", label: "CHACHAURA-BINAGANJ" },
  { value: "CHACHOKI", label: "CHACHOKI" },
  { value: "CHADOORA", label: "CHADOORA" },
  { value: "CHAHAL", label: "CHAHAL" },
  { value: "CHAIBASA", label: "CHAIBASA" },
  { value: "CHAIL", label: "CHAIL" },
  { value: "CHAKARNAGAR", label: "CHAKARNAGAR" },
  { value: "CHAKDAHA", label: "CHAKDAHA" },
  { value: "CHAKDAYALA", label: "CHAKDAYALA" },
  { value: "CHAKDHOYAKURE", label: "CHAKDHOYAKURE" },
  { value: "CHAKGHAT", label: "CHAKGHAT" },
  { value: "CHAKIA", label: "CHAKIA" },
  { value: "CHAKPARA", label: "CHAKPARA" },
  { value: "CHAKRA", label: "CHAKRA" },
  { value: "CHAKRADHARPUR", label: "CHAKRADHARPUR" },
  { value: "CHAKSU", label: "CHAKSU" },
  { value: "CHAKURTHA (1/2)", label: "CHAKURTHA (1/2)" },
  { value: "CHALAKUDY", label: "CHALAKUDY" },
  { value: "CHALAPARAMBU", label: "CHALAPARAMBU" },
  { value: "CHALISGAON", label: "CHALISGAON" },
  { value: "CHALLAKERE", label: "CHALLAKERE" },
  { value: "CHALLAPALLI", label: "CHALLAPALLI" },
  { value: "CHAMARAJANAGAR", label: "CHAMARAJANAGAR" },
  { value: "CHAMATA", label: "CHAMATA" },
  { value: "CHAMBA", label: "CHAMBA" },
  { value: "CHAMOLI", label: "CHAMOLI" },
  { value: "CHAMORSHI", label: "CHAMORSHI" },
  { value: "CHAMPA", label: "CHAMPA" },
  { value: "CHAMPAKNAGAR", label: "CHAMPAKNAGAR" },
  { value: "CHAMPAWAT", label: "CHAMPAWAT" },
  { value: "CHAMPHAI", label: "CHAMPHAI" },
  { value: "CHANASMA", label: "CHANASMA" },
  { value: "CHANCHAL", label: "CHANCHAL" },
  { value: "CHANDAN", label: "CHANDAN" },
  { value: "CHANDANHOLA", label: "CHANDANHOLA" },
  { value: "CHANDANKIYARI", label: "CHANDANKIYARI" },
  { value: "CHANDAULI", label: "CHANDAULI" },
  { value: "CHANDAUSI", label: "CHANDAUSI" },
  { value: "CHANDEL", label: "CHANDEL" },
  { value: "CHANDERI", label: "CHANDERI" },
  { value: "CHANDERWADI (SESSIONAL)", label: "CHANDERWADI (SESSIONAL)" },
  { value: "CHANDGAD", label: "CHANDGAD" },
  { value: "CHANDIAL", label: "CHANDIAL" },
  { value: "CHANDIGARH", label: "CHANDIGARH" },
  { value: "CHANDIKHOL", label: "CHANDIKHOL" },
  { value: "CHANDIPUR", label: "CHANDIPUR" },
  { value: "CHANDITALA", label: "CHANDITALA" },
  { value: "CHANDKHERA", label: "CHANDKHERA" },
  { value: "CHANDOL", label: "CHANDOL" },
  { value: "CHANDPARA", label: "CHANDPARA" },
  { value: "CHANDPUR", label: "CHANDPUR" },
  { value: "CHANDRAKONA", label: "CHANDRAKONA" },
  { value: "CHANDRAKONA(C.K.TOWN)", label: "CHANDRAKONA(C.K.TOWN)" },
  { value: "CHANDRALA", label: "CHANDRALA" },
  { value: "CHANDRALOKE", label: "CHANDRALOKE" },
  { value: "CHANDRAPUR", label: "CHANDRAPUR" },
  { value: "CHANDRAPURI", label: "CHANDRAPURI" },
  { value: "CHANDRUGONDA", label: "CHANDRUGONDA" },
  { value: "CHANDU", label: "CHANDU" },
  { value: "CHANDUVAV", label: "CHANDUVAV" },
  { value: "CHANDWA", label: "CHANDWA" },
  { value: "CHANDWAD", label: "CHANDWAD" },
  { value: "CHANGANACHERRY", label: "CHANGANACHERRY" },
  { value: "CHANGANASSERY", label: "CHANGANASSERY" },
  { value: "CHANGARAMKULAM", label: "CHANGARAMKULAM" },
  { value: "CHANGOD", label: "CHANGOD" },
  { value: "CHANGODAR", label: "CHANGODAR" },
  { value: "CHANGSARI", label: "CHANGSARI" },
  { value: "CHANNAGIRI", label: "CHANNAGIRI" },
  { value: "CHANNAPATNA", label: "CHANNAPATNA" },
  { value: "CHANNARAYAPATNA", label: "CHANNARAYAPATNA" },
  { value: "CHAPRA", label: "CHAPRA" },
  { value: "CHARADVA", label: "CHARADVA" },
  { value: "CHARKHIDADRI", label: "CHARKHIDADRI" },
  { value: "CHARODA", label: "CHARODA" },
  { value: "CHATHA", label: "CHATHA" },
  { value: "CHATRA", label: "CHATRA" },
  { value: "CHATRAPATTI", label: "CHATRAPATTI" },
  { value: "CHATRAREDDIAPATTI", label: "CHATRAREDDIAPATTI" },
  { value: "CHATTARPUR", label: "CHATTARPUR" },
  { value: "CHAUBEPUR", label: "CHAUBEPUR" },
  { value: "CHAUKHUTIYA", label: "CHAUKHUTIYA" },
  { value: "CHAUKICHAURA", label: "CHAUKICHAURA" },
  { value: "CHAUREBAZAR", label: "CHAUREBAZAR" },
  { value: "CHAURICHAURA", label: "CHAURICHAURA" },
  { value: "CHAVAKKAD", label: "CHAVAKKAD" },
  { value: "CHAVARA", label: "CHAVARA" },
  { value: "CHAWAND", label: "CHAWAND" },
  { value: "CHEEKA", label: "CHEEKA" },
  { value: "CHEEMA", label: "CHEEMA" },
  { value: "CHEEPURUPALLI", label: "CHEEPURUPALLI" },
  { value: "CHEGUNTA", label: "CHEGUNTA" },
  { value: "CHELUR", label: "CHELUR" },
  { value: "CHEMBUR", label: "CHEMBUR" },
  { value: "CHEMMAD", label: "CHEMMAD" },
  { value: "CHEMNAD", label: "CHEMNAD" },
  { value: "CHENANI", label: "CHENANI" },
  { value: "CHENAR", label: "CHENAR" },
  { value: "CHENGALPATTU", label: "CHENGALPATTU" },
  { value: "CHENGAM", label: "CHENGAM" },
  { value: "CHENGANNUR", label: "CHENGANNUR" },
  { value: "CHENNAI", label: "CHENNAI" },
  { value: "CHENNIMALAI", label: "CHENNIMALAI" },
  { value: "CHEPET", label: "CHEPET" },
  { value: "CHERPULASSERY", label: "CHERPULASSERY" },
  { value: "CHERTHALA", label: "CHERTHALA" },
  { value: "CHERUPUZHA", label: "CHERUPUZHA" },
  { value: "CHERUVATHUR", label: "CHERUVATHUR" },
  { value: "CHETTINAYAKANPATTI", label: "CHETTINAYAKANPATTI" },
  { value: "CHETTIPALAYAM", label: "CHETTIPALAYAM" },
  { value: "CHEVELLA", label: "CHEVELLA" },
  { value: "CHEYYAR", label: "CHEYYAR" },
  { value: "CHHABRA", label: "CHHABRA" },
  { value: "CHHACHHRAULI", label: "CHHACHHRAULI" },
  { value: "CHHANERA", label: "CHHANERA" },
  { value: "CHHAPER", label: "CHHAPER" },
  { value: "CHHATARPUR", label: "CHHATARPUR" },
  { value: "CHHATNA", label: "CHHATNA" },
  { value: "CHHATRISH GANDA", label: "CHHATRISH GANDA" },
  { value: "CHHATTISGARH", label: "CHHATTISGARH" },
  { value: "CHHAYGAON", label: "CHHAYGAON" },
  { value: "CHHER MOTI", label: "CHHER MOTI" },
  { value: "CHHIBRAMAU", label: "CHHIBRAMAU" },
  { value: "CHHINDWARA", label: "CHHINDWARA" },
  { value: "CHHOTA UDEPUR", label: "CHHOTA UDEPUR" },
  { value: "CHHOTAUDEPUR", label: "CHHOTAUDEPUR" },
  { value: "CHHOTISADRI", label: "CHHOTISADRI" },
  { value: "CHHURIYA", label: "CHHURIYA" },
  { value: "CHHUTMALPUR", label: "CHHUTMALPUR" },
  { value: "CHIBRAMAU", label: "CHIBRAMAU" },
  { value: "CHICKMAGALUR", label: "CHICKMAGALUR" },
  { value: "CHIDAMBARAM", label: "CHIDAMBARAM" },
  { value: "CHIKHLI", label: "CHIKHLI" },
  { value: "CHIKKABALLAPUR", label: "CHIKKABALLAPUR" },
  { value: "CHIKKAMAGALURU", label: "CHIKKAMAGALURU" },
  { value: "CHIKKATIRUPATHI", label: "CHIKKATIRUPATHI" },
  { value: "CHIKODI", label: "CHIKODI" },
  { value: "CHILAKALURIPET", label: "CHILAKALURIPET" },
  { value: "CHILLASARDABANGER", label: "CHILLASARDABANGER" },
  { value: "CHILODA", label: "CHILODA" },
  { value: "CHIMUR", label: "CHIMUR" },
  { value: "CHINCHANI", label: "CHINCHANI" },
  { value: "CHINGAVANAM", label: "CHINGAVANAM" },
  { value: "CHINNAMANUR", label: "CHINNAMANUR" },
  { value: "CHINNAMPALAYAM", label: "CHINNAMPALAYAM" },
  { value: "CHINSURAH", label: "CHINSURAH" },
  { value: "CHINTALAPUDI", label: "CHINTALAPUDI" },
  { value: "CHINTAMANI", label: "CHINTAMANI" },
  { value: "CHINYALISOUR", label: "CHINYALISOUR" },
  { value: "CHIPIYANABUZURG", label: "CHIPIYANABUZURG" },
  { value: "CHIPLUN", label: "CHIPLUN" },
  { value: "CHIRALA", label: "CHIRALA" },
  { value: "CHIRAWA", label: "CHIRAWA" },
  { value: "CHIRKUNDA", label: "CHIRKUNDA" },
  { value: "CHITARPUR", label: "CHITARPUR" },
  { value: "CHITBARAGAON", label: "CHITBARAGAON" },
  { value: "CHITILAPPILLY", label: "CHITILAPPILLY" },
  { value: "CHITRADURGA", label: "CHITRADURGA" },
  { value: "CHITRAKOOT", label: "CHITRAKOOT" },
  { value: "CHITRASENPUR", label: "CHITRASENPUR" },
  { value: "CHITTEGAON", label: "CHITTEGAON" },
  { value: "CHITTOOR", label: "CHITTOOR" },
  { value: "CHITTORGARH", label: "CHITTORGARH" },
  { value: "CHITTUR-THATHAMANGALAM", label: "CHITTUR-THATHAMANGALAM" },
  { value: "CHODAVARAM", label: "CHODAVARAM" },
  { value: "CHOGAWAN", label: "CHOGAWAN" },
  { value: "CHOGLAMSAR", label: "CHOGLAMSAR" },
  { value: "CHOMU", label: "CHOMU" },
  { value: "CHOPAL", label: "CHOPAL" },
  { value: "CHOTABANGARDA", label: "CHOTABANGARDA" },
  { value: "CHOTILA", label: "CHOTILA" },
  { value: "CHOUK", label: "CHOUK" },
  { value: "CHOUTUPPAL", label: "CHOUTUPPAL" },
  { value: "CHOWKA", label: "CHOWKA" },
  { value: "CHUARIKHAS", label: "CHUARIKHAS" },
  { value: "CHUDA", label: "CHUDA" },
  { value: "CHULLIMANOOR", label: "CHULLIMANOOR" },
  { value: "CHUMANG FOREST", label: "CHUMANG FOREST" },
  { value: "CHUMOUKEDIMA", label: "CHUMOUKEDIMA" },
  { value: "CHUNAWADH", label: "CHUNAWADH" },
  { value: "CHUNNIKALAN", label: "CHUNNIKALAN" },
  { value: "CHURACHANDPUR", label: "CHURACHANDPUR" },
  { value: "CHURU", label: "CHURU" },
  { value: "CISF UNIT", label: "CISF UNIT" },
  { value: "COCHIN", label: "COCHIN" },
  { value: "COIMBATORE", label: "COIMBATORE" },
  { value: "COLONELGANJ", label: "COLONELGANJ" },
  { value: "CONTAI", label: "CONTAI" },
  { value: "COOCH BEHAR", label: "COOCH BEHAR" },
  { value: "COOCHBEHAR", label: "COOCHBEHAR" },
  { value: "COONOOR", label: "COONOOR" },
  { value: "CUDDALORE", label: "CUDDALORE" },
  { value: "CUDDAPAH", label: "CUDDAPAH" },
  { value: "CUMBUM", label: "CUMBUM" },
  { value: "CUNCOLIM", label: "CUNCOLIM" },
  { value: "CURTI", label: "CURTI" },
  { value: "CUTTACK", label: "CUTTACK" },
  { value: "CentralHopeTown(CT)", label: "CentralHopeTown(CT)" },
  { value: "Chaibasa(NagarParishad)", label: "Chaibasa(NagarParishad)" },
  { value: "ChakBaburaAlimabad(CT)", label: "ChakBaburaAlimabad(CT)" },
  { value: "ChakImamAli(CT)", label: "ChakImamAli(CT)" },
  { value: "ChakSikari(CT)", label: "ChakSikari(CT)" },
  { value: "Chakeri(CT)", label: "Chakeri(CT)" },
  { value: "Chakia(NP)", label: "Chakia(NP)" },
  { value: "ChakmanoUrfDargah(CT)", label: "ChakmanoUrfDargah(CT)" },
  { value: "Chakrata(CB)", label: "Chakrata(CB)" },
  { value: "Chakulia(NP)", label: "Chakulia(NP)" },
  { value: "Chalala(M)", label: "Chalala(M)" },
  { value: "Chaltia(CT)", label: "Chaltia(CT)" },
  { value: "Chamba(MCl)", label: "Chamba(MCl)" },
  { value: "Chamba(NP)", label: "Chamba(NP)" },
  { value: "ChamkaurSahib(NP)", label: "ChamkaurSahib(NP)" },
  { value: "Chamrail(CT)", label: "Chamrail(CT)" },
  { value: "Chamrajnagar", label: "Chamrajnagar" },
  { value: "Chanderi(M)", label: "Chanderi(M)" },
  { value: "ChandiMandir(391)(CT)", label: "ChandiMandir(391)(CT)" },
  { value: "Chandia(NP)", label: "Chandia(NP)" },
  { value: "Chandil(CT)", label: "Chandil(CT)" },
  { value: "Chandipur(CT)", label: "Chandipur(CT)" },
  { value: "Chandla(NP)", label: "Chandla(NP)" },
  { value: "Chandpur(CT)", label: "Chandpur(CT)" },
  { value: "Chandpur(NPP)", label: "Chandpur(NPP)" },
  { value: "Chandrapur(NP)", label: "Chandrapur(NP)" },
  { value: "Chandur(CT)", label: "Chandur(CT)" },
  { value: "ChandurRailway(MCl)", label: "ChandurRailway(MCl)" },
  { value: "Changlang", label: "Changlang" },
  { value: "Changtongya(TC)", label: "Changtongya(TC)" },
  { value: "Chanje(CT)", label: "Chanje(CT)" },
  { value: "Chanpatia(NP)", label: "Chanpatia(NP)" },
  { value: "ChapakhowaTown(CT)", label: "ChapakhowaTown(CT)" },
  { value: "Chapui(CT)", label: "Chapui(CT)" },
  { value: "Charar-i-Sharief(MC)", label: "Charar-i-Sharief(MC)" },
  { value: "Charipara(CT)", label: "Charipara(CT)" },
  { value: "Charkhari(NPP)", label: "Charkhari(NPP)" },
  { value: "Charthawal(NP)", label: "Charthawal(NP)" },
  { value: "Chas(NagarParishad)", label: "Chas(NagarParishad)" },
  { value: "ChatiborGaon(CT)", label: "ChatiborGaon(CT)" },
  { value: "Chaumuhan(NP)", label: "Chaumuhan(NP)" },
  { value: "Chaurhat(CT)", label: "Chaurhat(CT)" },
  { value: "Chechakhata(CT)", label: "Chechakhata(CT)" },
  { value: "Chekonidhara(CT)", label: "Chekonidhara(CT)" },
  { value: "Chelad(CT)", label: "Chelad(CT)" },
  { value: "Chelannur(CT)", label: "Chelannur(CT)" },
  { value: "Chendhare(CT)", label: "Chendhare(CT)" },
  { value: "ChengalamSouth(CT)", label: "ChengalamSouth(CT)" },
  { value: "Chennai ", label: "Chennai " },
  { value: "Cherra(CT)", label: "Cherra(CT)" },
  { value: "Cherukavu(CT)", label: "Cherukavu(CT)" },
  { value: "Cheruthazham(CT)", label: "Cheruthazham(CT)" },
  { value: "Cheruvannur(CT)", label: "Cheruvannur(CT)" },
  { value: "Chhachhrauli(CT)", label: "Chhachhrauli(CT)" },
  { value: "Chhapar(M)", label: "Chhapar(M)" },
  { value: "Chhapraula(CT)", label: "Chhapraula(CT)" },
  { value: "ChharraRafatpur(NP)", label: "ChharraRafatpur(NP)" },
  { value: "Chhata(NP)", label: "Chhata(NP)" },
  { value: "Chhatari(NP)", label: "Chhatari(NP)" },
  { value: "Chhiri(CT)", label: "Chhiri(CT)" },
  { value: "Chhitauni(CT)", label: "Chhitauni(CT)" },
  { value: "Chhitpur(CT)", label: "Chhitpur(CT)" },
  { value: "ChhotaGobindpur(CT)", label: "ChhotaGobindpur(CT)" },
  { value: "Chhurikala(NP)", label: "Chhurikala(NP)" },
  { value: "Chichli(CT)", label: "Chichli(CT)" },
  { value: "Chikhala(CT)", label: "Chikhala(CT)" },
  { value: "Chikhli(MCl)", label: "Chikhli(MCl)" },
  { value: "Chikkabanavara(CT)", label: "Chikkabanavara(CT)" },
  { value: "Chikkabidarakallu(CT)", label: "Chikkabidarakallu(CT)" },
  { value: "Chilakaluripet(M)", label: "Chilakaluripet(M)" },
  { value: "ChilkanaSultanpur(NP)", label: "ChilkanaSultanpur(NP)" },
  { value: "Chiloda(Naroda)(CT)", label: "Chiloda(Naroda)(CT)" },
  { value: "ChinnaAnuppanadi(CT)", label: "ChinnaAnuppanadi(CT)" },
  { value: "Chinnamanur(M)", label: "Chinnamanur(M)" },
  { value: "Chinnavedampatti(TP)", label: "Chinnavedampatti(TP)" },
  { value: "Chintalavalasa(CT)", label: "Chintalavalasa(CT)" },
  { value: "Chirakkal(CT)", label: "Chirakkal(CT)" },
  { value: "Chirgaon(NPP)", label: "Chirgaon(NPP)" },
  { value: "Chittaranjan(CT)", label: "Chittaranjan(CT)" },
  { value: "Chohal(CT)", label: "Chohal(CT)" },
  { value: "Chomon(CT)", label: "Chomon(CT)" },
  { value: "ChongtongTeaGarden(CT)", label: "ChongtongTeaGarden(CT)" },
  { value: "Chopan(NP)", label: "Chopan(NP)" },
  { value: "ChotaHaibor(CT)", label: "ChotaHaibor(CT)" },
  { value: "Chunar(NPP)", label: "Chunar(NPP)" },
  { value: "ChurkGhurma(NP)", label: "ChurkGhurma(NP)" },
  { value: "ClementTown(CB)", label: "ClementTown(CB)" },
  { value: "Colonelganj(NPP)", label: "Colonelganj(NPP)" },
  { value: "Cuttack ", label: "Cuttack " },
  { value: "DABHALA", label: "DABHALA" },
  { value: "DABHOI", label: "DABHOI" },
  { value: "DABI", label: "DABI" },
  { value: "DABLIRATHAN", label: "DABLIRATHAN" },
  { value: "DABRA", label: "DABRA" },
  { value: "DABRI", label: "DABRI" },
  { value: "DABWALI", label: "DABWALI" },
  { value: "DADRA AND NAGAR HAVELI", label: "DADRA AND NAGAR HAVELI" },
  { value: "DADRI", label: "DADRI" },
  { value: "DADRITOYE", label: "DADRITOYE" },
  { value: "DAHANU", label: "DAHANU" },
  { value: "DAHEJ", label: "DAHEJ" },
  { value: "DAHI", label: "DAHI" },
  { value: "DAHINA", label: "DAHINA" },
  { value: "DAHIWADI", label: "DAHIWADI" },
  { value: "DAHOD", label: "DAHOD" },
  { value: "DAKSHINAKANNADA", label: "DAKSHINAKANNADA" },
  { value: "DAKUWAKHANA", label: "DAKUWAKHANA" },
  { value: "DALGAON", label: "DALGAON" },
  { value: "DALHOUSIE", label: "DALHOUSIE" },
  { value: "DALIMGARYA", label: "DALIMGARYA" },
  { value: "DALLIRAJHARA", label: "DALLIRAJHARA" },
  { value: "DALLUPURA", label: "DALLUPURA" },
  { value: "DALMAU", label: "DALMAU" },
  { value: "DALTONGANJ", label: "DALTONGANJ" },
  { value: "DAMAN", label: "DAMAN" },
  { value: "DAMBAL", label: "DAMBAL" },
  { value: "DAMCHERRA", label: "DAMCHERRA" },
  { value: "DAMMAPETA", label: "DAMMAPETA" },
  { value: "DAMOH", label: "DAMOH" },
  { value: "DAMRO", label: "DAMRO" },
  { value: "DAMTAL", label: "DAMTAL" },
  { value: "DANAPUR", label: "DANAPUR" },
  { value: "DANG", label: "DANG" },
  { value: "DANGS", label: "DANGS" },
  { value: "DANGUWAPOSI", label: "DANGUWAPOSI" },
  { value: "DANKAUR", label: "DANKAUR" },
  { value: "DANKUNI", label: "DANKUNI" },
  { value: "DANSAL", label: "DANSAL" },
  { value: "DANTA", label: "DANTA" },
  { value: "DANTEWADA", label: "DANTEWADA" },
  { value: "DANTIWADA", label: "DANTIWADA" },
  { value: "DAPOLI", label: "DAPOLI" },
  { value: "DARBHANGA", label: "DARBHANGA" },
  { value: "DARIYABAD", label: "DARIYABAD" },
  { value: "DARJEELING", label: "DARJEELING" },
  { value: "DARJILING", label: "DARJILING" },
  { value: "DARLAGHAT", label: "DARLAGHAT" },
  { value: "DARRANG", label: "DARRANG" },
  { value: "DARSI", label: "DARSI" },
  { value: "DARWHA", label: "DARWHA" },
  { value: "DARYAPUR", label: "DARYAPUR" },
  { value: "DASUYA", label: "DASUYA" },
  { value: "DATAGANJ", label: "DATAGANJ" },
  { value: "DATIA", label: "DATIA" },
  { value: "DAUND", label: "DAUND" },
  { value: "DAUSA", label: "DAUSA" },
  { value: "DAVANAGERE", label: "DAVANAGERE" },
  { value: "DAVANGERE", label: "DAVANGERE" },
  { value: "DAYANGMUKH", label: "DAYANGMUKH" },
  { value: "DEBAGARH", label: "DEBAGARH" },
  { value: "DEBAI", label: "DEBAI" },
  { value: "DEBRA", label: "DEBRA" },
  { value: "DECHU", label: "DECHU" },
  { value: "DEDIAPADA", label: "DEDIAPADA" },
  { value: "DEEG", label: "DEEG" },
  { value: "DEESA", label: "DEESA" },
  { value: "DEGANA", label: "DEGANA" },
  { value: "DEGLOOR", label: "DEGLOOR" },
  { value: "DEHRADUN", label: "DEHRADUN" },
  { value: "DEHRAGOPIPUR", label: "DEHRAGOPIPUR" },
  { value: "DEHRI", label: "DEHRI" },
  { value: "DEHRI-ON-SONE", label: "DEHRI-ON-SONE" },
  { value: "DEHRISARAY", label: "DEHRISARAY" },
  { value: "DEHU", label: "DEHU" },
  { value: "DEHUROAD", label: "DEHUROAD" },
  { value: "DELHI", label: "DELHI" },
  { value: "DELHICANTONMENT", label: "DELHICANTONMENT" },
  { value: "DELWARA", label: "DELWARA" },
  { value: "DEMOW", label: "DEMOW" },
  { value: "DENKANIKOTTAI", label: "DENKANIKOTTAI" },
  { value: "DEOBAND", label: "DEOBAND" },
  { value: "DEOGARH", label: "DEOGARH" },
  { value: "DEOGHAR", label: "DEOGHAR" },
  { value: "DEOKAR", label: "DEOKAR" },
  { value: "DEOLA", label: "DEOLA" },
  { value: "DEOLALI", label: "DEOLALI" },
  { value: "DEOLI", label: "DEOLI" },
  { value: "DEOMALI", label: "DEOMALI" },
  { value: "DEOPUR", label: "DEOPUR" },
  { value: "DEORETHA", label: "DEORETHA" },
  { value: "DEORI", label: "DEORI" },
  { value: "DEORIA", label: "DEORIA" },
  { value: "DEPALPUR", label: "DEPALPUR" },
  { value: "DERABASSI", label: "DERABASSI" },
  { value: "DERAMANDI", label: "DERAMANDI" },
  { value: "DERAPUR", label: "DERAPUR" },
  { value: "DERGAON", label: "DERGAON" },
  { value: "DESHNOK", label: "DESHNOK" },
  { value: "DESURI", label: "DESURI" },
  { value: "DETROJ", label: "DETROJ" },
  { value: "DEVAKOTTAI", label: "DEVAKOTTAI" },
  { value: "DEVALKI", label: "DEVALKI" },
  { value: "DEVANAHALLI", label: "DEVANAHALLI" },
  { value: "DEVBHOG", label: "DEVBHOG" },
  { value: "DEVBHOOMI DWERKA", label: "DEVBHOOMI DWERKA" },
  { value: "DEVENDRANAGAR", label: "DEVENDRANAGAR" },
  { value: "DEVGADHBARIA", label: "DEVGADHBARIA" },
  { value: "DEVGARH", label: "DEVGARH" },
  { value: "DEVIPATTINAM", label: "DEVIPATTINAM" },
  { value: "DEVPRAYAG", label: "DEVPRAYAG" },
  { value: "DEWAS", label: "DEWAS" },
  { value: "DHALAVAIPURAM", label: "DHALAVAIPURAM" },
  { value: "DHALIGAONURBAN", label: "DHALIGAONURBAN" },
  { value: "DHALWALA", label: "DHALWALA" },
  { value: "DHAMANGAON", label: "DHAMANGAON" },
  { value: "DHAMDAMA", label: "DHAMDAMA" },
  { value: "DHAMNOD", label: "DHAMNOD" },
  { value: "DHAMPUR", label: "DHAMPUR" },
  { value: "DHAMTARI", label: "DHAMTARI" },
  { value: "DHANBAD", label: "DHANBAD" },
  { value: "DHAND", label: "DHAND" },
  { value: "DHANDHUKA", label: "DHANDHUKA" },
  { value: "DHANERA", label: "DHANERA" },
  { value: "DHANIAKHALI", label: "DHANIAKHALI" },
  { value: "DHANKAWADI", label: "DHANKAWADI" },
  { value: "DHANORA", label: "DHANORA" },
  { value: "DHAR", label: "DHAR" },
  { value: "DHARAMBAHAL", label: "DHARAMBAHAL" },
  { value: "DHARAMKOT", label: "DHARAMKOT" },
  { value: "DHARAMPUR", label: "DHARAMPUR" },
  { value: "DHARAMPURI", label: "DHARAMPURI" },
  { value: "DHARAMSHALA", label: "DHARAMSHALA" },
  { value: "DHARAPURAM", label: "DHARAPURAM" },
  { value: "DHARASHIV ", label: "DHARASHIV " },
  { value: "DHARI", label: "DHARI" },
  { value: "DHARIYAWAD", label: "DHARIYAWAD" },
  { value: "DHARMANAGAR", label: "DHARMANAGAR" },
  { value: "DHARMAPURI", label: "DHARMAPURI" },
  { value: "DHARMATALA", label: "DHARMATALA" },
  { value: "DHARMAVARAM", label: "DHARMAVARAM" },
  { value: "DHARUHERA", label: "DHARUHERA" },
  { value: "DHARWAD", label: "DHARWAD" },
  { value: "DHATAV", label: "DHATAV" },
  { value: "DHAUREHRA", label: "DHAUREHRA" },
  { value: "DHEKIAJULI", label: "DHEKIAJULI" },
  { value: "DHEMAJI", label: "DHEMAJI" },
  { value: "DHENKANAL", label: "DHENKANAL" },
  { value: "DHILWAN", label: "DHILWAN" },
  { value: "DHINA", label: "DHINA" },
  { value: "DHING", label: "DHING" },
  { value: "DHIROWAL", label: "DHIROWAL" },
  { value: "DHODRAMOHAR", label: "DHODRAMOHAR" },
  { value: "DHOLERA", label: "DHOLERA" },
  { value: "DHOLIPAL", label: "DHOLIPAL" },
  { value: "DHOLKA", label: "DHOLKA" },
  { value: "DHOLPUR", label: "DHOLPUR" },
  { value: "DHONE", label: "DHONE" },
  { value: "DHORAJI", label: "DHORAJI" },
  { value: "DHORAJI(GJ)", label: "DHORAJI(GJ)" },
  { value: "DHORIMANA", label: "DHORIMANA" },
  { value: "DHRANGADHRA", label: "DHRANGADHRA" },
  { value: "DHUBRI", label: "DHUBRI" },
  { value: "DHUDASHIYA", label: "DHUDASHIYA" },
  { value: "DHULE", label: "DHULE" },
  { value: "DHUPGURI", label: "DHUPGURI" },
  { value: "DHURI", label: "DHURI" },
  { value: "DHUSRI", label: "DHUSRI" },
  { value: "DIAMONDHARBOUR", label: "DIAMONDHARBOUR" },
  { value: "DIBANGVALLEY", label: "DIBANGVALLEY" },
  { value: "DIBIYAPUR", label: "DIBIYAPUR" },
  { value: "DIBRUGARH", label: "DIBRUGARH" },
  { value: "DICHOLI", label: "DICHOLI" },
  { value: "DIDIHAT", label: "DIDIHAT" },
  { value: "DIDWANA", label: "DIDWANA" },
  { value: "DIGARU", label: "DIGARU" },
  { value: "DIGBOI", label: "DIGBOI" },
  { value: "DIGDOH", label: "DIGDOH" },
  { value: "DIGHA", label: "DIGHA" },
  { value: "DIGHNALA", label: "DIGHNALA" },
  { value: "DIGLIPUR", label: "DIGLIPUR" },
  { value: "DIGRAS", label: "DIGRAS" },
  { value: "DILDARNAGAR", label: "DILDARNAGAR" },
  { value: "DIMA HASSO - NORTH CACHAR HILL", label: "DIMA HASSO - NORTH CACHAR HILL" },
  { value: "DIMAHASAO", label: "DIMAHASAO" },
  { value: "DIMAKUCHI", label: "DIMAKUCHI" },
  { value: "DIMAPUR", label: "DIMAPUR" },
  { value: "DINANAGAR", label: "DINANAGAR" },
  { value: "DINDIGUL", label: "DINDIGUL" },
  { value: "DINDORI", label: "DINDORI" },
  { value: "DINESHPUR", label: "DINESHPUR" },
  { value: "DINHATA", label: "DINHATA" },
  { value: "DIPHU", label: "DIPHU" },
  { value: "DIPKA", label: "DIPKA" },
  { value: "DIRANG", label: "DIRANG" },
  { value: "DIRBA", label: "DIRBA" },
  { value: "DISPUR", label: "DISPUR" },
  { value: "DIU", label: "DIU" },
  { value: "DIYODAR", label: "DIYODAR" },
  { value: "DOBBASPET", label: "DOBBASPET" },
  { value: "DOBOKATOWN", label: "DOBOKATOWN" },
  { value: "DODA", label: "DODA" },
  { value: "DODDABALLAPURA", label: "DODDABALLAPURA" },
  { value: "DODDABELAVAGI", label: "DODDABELAVAGI" },
  { value: "DODDADUNNASANDRA", label: "DODDADUNNASANDRA" },
  { value: "DOGHATRURAL", label: "DOGHATRURAL" },
  { value: "DOIWALA", label: "DOIWALA" },
  { value: "DOLAVALI", label: "DOLAVALI" },
  { value: "DOMARIYAGANJ", label: "DOMARIYAGANJ" },
  { value: "DOMBIVLI", label: "DOMBIVLI" },
  { value: "DOMBIVLI(E)", label: "DOMBIVLI(E)" },
  { value: "DOMBIVLI(W)", label: "DOMBIVLI(W)" },
  { value: "DOMKAL", label: "DOMKAL" },
  { value: "DONAJE", label: "DONAJE" },
  { value: "DONDAICHA", label: "DONDAICHA" },
  { value: "DONDI", label: "DONDI" },
  { value: "DONDILOHARA", label: "DONDILOHARA" },
  { value: "DONGARGAON", label: "DONGARGAON" },
  { value: "DONGARGARH", label: "DONGARGARH" },
  { value: "DOOMDOOMA", label: "DOOMDOOMA" },
  { value: "DOONI", label: "DOONI" },
  { value: "DORAHA", label: "DORAHA" },
  { value: "DORNAKAL", label: "DORNAKAL" },
  { value: "DOSARKA", label: "DOSARKA" },
  { value: "DRAKSHARAMAM", label: "DRAKSHARAMAM" },
  { value: "DUBBAKA", label: "DUBBAKA" },
  { value: "DUBRAJPUR", label: "DUBRAJPUR" },
  { value: "DUBURI", label: "DUBURI" },
  { value: "DUDHIA", label: "DUDHIA" },
  { value: "DUDHINAGAR", label: "DUDHINAGAR" },
  { value: "DUDHKALMI", label: "DUDHKALMI" },
  { value: "DUDHNOI", label: "DUDHNOI" },
  { value: "DUDU", label: "DUDU" },
  { value: "DUGADDA", label: "DUGADDA" },
  { value: "DUGRIYA", label: "DUGRIYA" },
  { value: "DUILLYA", label: "DUILLYA" },
  { value: "DUKLI", label: "DUKLI" },
  { value: "DULHARA", label: "DULHARA" },
  { value: "DULIAJAN", label: "DULIAJAN" },
  { value: "DUMKA", label: "DUMKA" },
  { value: "DUMRI", label: "DUMRI" },
  { value: "DUNDIGAL", label: "DUNDIGAL" },
  { value: "DUNGARPUR", label: "DUNGARPUR" },
  { value: "DUNGLA", label: "DUNGLA" },
  { value: "DUNGURIPALI", label: "DUNGURIPALI" },
  { value: "DURG", label: "DURG" },
  { value: "DURGAPUR", label: "DURGAPUR" },
  { value: "DURLAVPUR", label: "DURLAVPUR" },
  { value: "DURU-VERINAG", label: "DURU-VERINAG" },
  { value: "DWARKA", label: "DWARKA" },
  { value: "DZULHAMI", label: "DZULHAMI" },
  { value: "Dabgram(P)(CT)", label: "Dabgram(P)(CT)" },
  { value: "Daboh(NP)", label: "Daboh(NP)" },
  { value: "Dadar(CT)", label: "Dadar(CT)" },
  { value: "Dadhapatna(CT)", label: "Dadhapatna(CT)" },
  { value: "Dadhel(CT)", label: "Dadhel(CT)" },
  { value: "Dahali(CT)", label: "Dahali(CT)" },
  { value: "Dahi(NP)", label: "Dahi(NP)" },
  { value: "Dahilamau(CT)", label: "Dahilamau(CT)" },
  { value: "Daitari(CT)", label: "Daitari(CT)" },
  { value: "DakshinKhanda(CT)", label: "DakshinKhanda(CT)" },
  { value: "Dakshina Kannada", label: "Dakshina Kannada" },
  { value: "Dakshinpara", label: "Dakshinpara" },
  { value: "Dalavaipatti(CT)", label: "Dalavaipatti(CT)" },
  { value: "Dalmau(NP)", label: "Dalmau(NP)" },
  { value: "Damnagar(M)", label: "Damnagar(M)" },
  { value: "Dandidih(CT)", label: "Dandidih(CT)" },
  { value: "Dankaur(NP)", label: "Dankaur(NP)" },
  { value: "Dankuni(M)", label: "Dankuni(M)" },
  { value: "Danta(CT)", label: "Danta(CT)" },
  { value: "Darappur(CT)", label: "Darappur(CT)" },
  { value: "Darbandora", label: "Darbandora" },
  { value: "Darewadi(CT)", label: "Darewadi(CT)" },
  { value: "Dariapur(CT)", label: "Dariapur(CT)" },
  { value: "Dariyabad(NP)", label: "Dariyabad(NP)" },
  { value: "Dasna(NP)", label: "Dasna(NP)" },
  { value: "Dasnapur(CT)", label: "Dasnapur(CT)" },
  { value: "Dataganj(NP)", label: "Dataganj(NP)" },
  { value: "Daudnagar(NP)", label: "Daudnagar(NP)" },
  { value: "Daulatpur(CT)", label: "Daulatpur(CT)" },
  { value: "Daulatpur(NP)", label: "Daulatpur(NP)" },
  { value: "Daurala(NP)", label: "Daurala(NP)" },
  { value: "Dayalbagh(NP)", label: "Dayalbagh(NP)" },
  { value: "Dehtora(CT)", label: "Dehtora(CT)" },
  { value: "Deidihi", label: "Deidihi" },
  { value: "DelhiCantonment(CB)(Part)", label: "DelhiCantonment(CB)(Part)" },
  { value: "Delhi ", label: "Delhi " },
  { value: "Deoband(NPP)", label: "Deoband(NPP)" },
  { value: "Deodara(CT)", label: "Deodara(CT)" },
  { value: "Deogarh(M)", label: "Deogarh(M)" },
  { value: "DeolaliPravara(MCl)", label: "DeolaliPravara(MCl)" },
  { value: "Deoli(CT)", label: "Deoli(CT)" },
  { value: "Deoranian(NP)", label: "Deoranian(NP)" },
  { value: "Deori(CT)", label: "Deori(CT)" },
  { value: "DeoriSinghpura(CT)", label: "DeoriSinghpura(CT)" },
  { value: "Deosaini(CT)", label: "Deosaini(CT)" },
  { value: "Dergaon(MB)", label: "Dergaon(MB)" },
  { value: "Desaiganj(MCl)", label: "Desaiganj(MCl)" },
  { value: "Desoola(CT)", label: "Desoola(CT)" },
  { value: "Devakottai(M)", label: "Devakottai(M)" },
  { value: "Devinagar(CT)", label: "Devinagar(CT)" },
  { value: "Devsar(MC)", label: "Devsar(MC)" },
  { value: "Dewa(NP)", label: "Dewa(NP)" },
  { value: "Dhaka(NP)", label: "Dhaka(NP)" },
  { value: "Dhakauli(CT)", label: "Dhakauli(CT)" },
  { value: "Dhaki(CT)", label: "Dhaki(CT)" },
  { value: "Dhalai", label: "Dhalai" },
  { value: "Dhaliyur(TP)", label: "Dhaliyur(TP)" },
  { value: "Dhampur(NPP)", label: "Dhampur(NPP)" },
  { value: "DhampurHusainpur(CT)", label: "DhampurHusainpur(CT)" },
  { value: "Dhana(CT)", label: "Dhana(CT)" },
  { value: "Dhanauha(CT)", label: "Dhanauha(CT)" },
  { value: "Dhanauli(CT)", label: "Dhanauli(CT)" },
  { value: "Dhanaura(NPP)", label: "Dhanaura(NPP)" },
  { value: "Dhandera(CT)", label: "Dhandera(CT)" },
  { value: "Dhanegaon(CT)", label: "Dhanegaon(CT)" },
  { value: "Dhanipur(CT)", label: "Dhanipur(CT)" },
  { value: "Dhanpuri(NargadaHariDafai)(M)", label: "Dhanpuri(NargadaHariDafai)(M)" },
  { value: "Dharamapuram(CT)", label: "Dharamapuram(CT)" },
  { value: "Dharamkot(MCl)", label: "Dharamkot(MCl)" },
  { value: "Dharampur(CT)", label: "Dharampur(CT)" },
  { value: "Dharampuri(NP)", label: "Dharampuri(NP)" },
  { value: "Dharapur(CT)", label: "Dharapur(CT)" },
  { value: "Dharchula(NP)", label: "Dharchula(NP)" },
  { value: "Dharuhera(MC)", label: "Dharuhera(MC)" },
  { value: "Dharur(MCl)", label: "Dharur(MCl)" },
  { value: "DhauraTanda(NP)", label: "DhauraTanda(NP)" },
  { value: "Dhaurehra(NP)", label: "Dhaurehra(NP)" },
  { value: "DhaurraMafi(CT)", label: "DhaurraMafi(CT)" },
  { value: "Dhekorgorha(CT)", label: "Dhekorgorha(CT)" },
  { value: "Dholka(M)", label: "Dholka(M)" },
  { value: "Dhopatala(CT)", label: "Dhopatala(CT)" },
  { value: "Dhulagari(CT)", label: "Dhulagari(CT)" },
  { value: "Dibai(NPP)", label: "Dibai(NPP)" },
  { value: "Dibang Valley", label: "Dibang Valley" },
  { value: "Dighwara(NP)", label: "Dighwara(NP)" },
  { value: "Digvijaygram(CT)", label: "Digvijaygram(CT)" },
  { value: "Diken(NP)", label: "Diken(NP)" },
  { value: "Dindaspur(CT)", label: "Dindaspur(CT)" },
  { value: "Dindugul", label: "Dindugul" },
  { value: "DiphuparA(CT)", label: "DiphuparA(CT)" },
  { value: "Diwakari(CT)", label: "Diwakari(CT)" },
  { value: "Doboka(TC)", label: "Doboka(TC)" },
  { value: "Dohrighat(NP)", label: "Dohrighat(NP)" },
  { value: "Dokmoka(TC)", label: "Dokmoka(TC)" },
  { value: "Dola(CT)", label: "Dola(CT)" },
  { value: "Dongargaon", label: "Dongargaon" },
  { value: "Dongargarh(M)", label: "Dongargarh(M)" },
  { value: "Donkamokam(TC)", label: "Donkamokam(TC)" },
  { value: "Doraha(MCl)", label: "Doraha(MCl)" },
  { value: "Dostpur(NP)", label: "Dostpur(NP)" },
  { value: "Dudhani(MCl)", label: "Dudhani(MCl)" },
  { value: "DudhpatilPtV(CT)", label: "DudhpatilPtV(CT)" },
  { value: "Dulhipur(CT)", label: "Dulhipur(CT)" },
  { value: "DumarKachhar(CT)", label: "DumarKachhar(CT)" },
  { value: "Dumra(NP)", label: "Dumra(NP)" },
  { value: "Durgapur(CT)", label: "Durgapur(CT)" },
  { value: "EAST CHAMPARAN", label: "EAST CHAMPARAN" },
  { value: "EAST DELHI", label: "EAST DELHI" },
  { value: "EAST MIDNAPORE", label: "EAST MIDNAPORE" },
  { value: "EAST SIKKIM", label: "EAST SIKKIM" },
  { value: "EAST SINGHBHUM", label: "EAST SINGHBHUM" },
  { value: "EASTCHAMPARAN", label: "EASTCHAMPARAN" },
  { value: "EASTGODAVARI", label: "EASTGODAVARI" },
  { value: "EASTKAMENG", label: "EASTKAMENG" },
  { value: "EASTSINGHBHUM", label: "EASTSINGHBHUM" },
  { value: "EDACKODE", label: "EDACKODE" },
  { value: "EDAKKARA", label: "EDAKKARA" },
  { value: "EDAKKAZHIYUR", label: "EDAKKAZHIYUR" },
  { value: "EDAPPADI", label: "EDAPPADI" },
  { value: "EDAPPAL", label: "EDAPPAL" },
  { value: "EDAVANNAPPARA", label: "EDAVANNAPPARA" },
  { value: "EDAYARPALAYAM", label: "EDAYARPALAYAM" },
  { value: "EGRA", label: "EGRA" },
  { value: "ELAMANCHILI", label: "ELAMANCHILI" },
  { value: "ELAMPILLAI", label: "ELAMPILLAI" },
  { value: "ELLAKUDY", label: "ELLAKUDY" },
  { value: "ELLENABAD", label: "ELLENABAD" },
  { value: "ELUMALAI", label: "ELUMALAI" },
  { value: "ELURU", label: "ELURU" },
  { value: "ERACH", label: "ERACH" },
  { value: "ERAL", label: "ERAL" },
  { value: "ERATTUPETTA", label: "ERATTUPETTA" },
  { value: "ERNAKULAM", label: "ERNAKULAM" },
  { value: "ERODE", label: "ERODE" },
  { value: "ERUVATTY", label: "ERUVATTY" },
  { value: "ETAH", label: "ETAH" },
  { value: "ETAWAH", label: "ETAWAH" },
  { value: "ETTAIYAPURAM", label: "ETTAIYAPURAM" },
  { value: "ETTUMANOOR", label: "ETTUMANOOR" },
  { value: "ETUMANOOR", label: "ETUMANOOR" },
  { value: "ETURNAGARAM", label: "ETURNAGARAM" },
  { value: "East Garo Hills", label: "East Garo Hills" },
  { value: "East Godavari", label: "East Godavari" },
  { value: "East Kameng", label: "East Kameng" },
  { value: "East Khasi Hills", label: "East Khasi Hills" },
  { value: "East Medinipur", label: "East Medinipur" },
  { value: "East Siang", label: "East Siang" },
  { value: "Edathala(CT)", label: "Edathala(CT)" },
  { value: "Ekabbarpur(CT)", label: "Ekabbarpur(CT)" },
  { value: "Ekdil(NP)", label: "Ekdil(NP)" },
  { value: "Eklahare(CT)", label: "Eklahare(CT)" },
  { value: "Eksara(CT)", label: "Eksara(CT)" },
  { value: "Elayavoor(CT)", label: "Elayavoor(CT)" },
  { value: "Emri(CT)", label: "Emri(CT)" },
  { value: "Enumamula(CT)", label: "Enumamula(CT)" },
  { value: "Eranholi(CT)", label: "Eranholi(CT)" },
  { value: "Eraniel(TP)", label: "Eraniel(TP)" },
  { value: "Erattupetta(CT)", label: "Erattupetta(CT)" },
  { value: "Erumapalayam(CT)", label: "Erumapalayam(CT)" },
  { value: "Etmadpur(NPP)", label: "Etmadpur(NPP)" },
  { value: "FAIZABAD", label: "FAIZABAD" },
  { value: "FAKHARPUR", label: "FAKHARPUR" },
  { value: "FALAKATA", label: "FALAKATA" },
  { value: "FALNA", label: "FALNA" },
  { value: "FALTA", label: "FALTA" },
  { value: "FARAKKA", label: "FARAKKA" },
  { value: "FARIDABAD", label: "FARIDABAD" },
  { value: "FARIDKOT", label: "FARIDKOT" },
  { value: "FARIDPUR", label: "FARIDPUR" },
  { value: "FARMANA", label: "FARMANA" },
  { value: "FARMVILLE", label: "FARMVILLE" },
  { value: "FARRUKHABAD", label: "FARRUKHABAD" },
  { value: "FARUKHNAGAR", label: "FARUKHNAGAR" },
  { value: "FATEHABAD", label: "FATEHABAD" },
  { value: "FATEHGARH", label: "FATEHGARH" },
  { value: "FATEHGARH SAHIB", label: "FATEHGARH SAHIB" },
  { value: "FATEHGARHCHURIAN", label: "FATEHGARHCHURIAN" },
  { value: "FATEHGARHSAHIB", label: "FATEHGARHSAHIB" },
  { value: "FATEHNAGAR", label: "FATEHNAGAR" },
  { value: "FATEHPUR", label: "FATEHPUR" },
  { value: "FATEHPUR(LUCKNOW)", label: "FATEHPUR(LUCKNOW)" },
  { value: "FATEHPURBERI", label: "FATEHPURBERI" },
  { value: "FATEHPURCHAORASI", label: "FATEHPURCHAORASI" },
  { value: "FATEHPURSIKRI", label: "FATEHPURSIKRI" },
  { value: "FATWAH", label: "FATWAH" },
  { value: "FAZALPUR", label: "FAZALPUR" },
  { value: "FAZILKA", label: "FAZILKA" },
  { value: "FAZILNAGAR", label: "FAZILNAGAR" },
  { value: "FEROZPUR", label: "FEROZPUR" },
  { value: "FIROZABAD", label: "FIROZABAD" },
  { value: "FIROZPUR", label: "FIROZPUR" },
  { value: "FIROZPURJHIRKA", label: "FIROZPURJHIRKA" },
  { value: "FORTKOCHI", label: "FORTKOCHI" },
  { value: "Faizganj(NP)", label: "Faizganj(NP)" },
  { value: "Faizpur(MCl)", label: "Faizpur(MCl)" },
  { value: "Falna(M)", label: "Falna(M)" },
  { value: "Farah(NP)", label: "Farah(NP)" },
  { value: "Farakhpur(CT)", label: "Farakhpur(CT)" },
  { value: "Faridnagar(NP)", label: "Faridnagar(NP)" },
  { value: "Faridpur(NP)", label: "Faridpur(NP)" },
  { value: "Faridpur(NPP)", label: "Faridpur(NPP)" },
  { value: "Fariha(NP)", label: "Fariha(NP)" },
  { value: "FatehganjPashchimi(NP)", label: "FatehganjPashchimi(NP)" },
  { value: "FatehganjPurvi(NP)", label: "FatehganjPurvi(NP)" },
  { value: "Fatehgarh(CB)", label: "Fatehgarh(CB)" },
  { value: "FatehgarhChurian(MCl)", label: "FatehgarhChurian(MCl)" },
  { value: "Fatehnagar(M)", label: "Fatehnagar(M)" },
  { value: "Fatehpur(M)", label: "Fatehpur(M)" },
  { value: "FatehpurRange(DhamuaDungaArea)(CT)", label: "FatehpurRange(DhamuaDungaArea)(CT)" },
  { value: "FatehpurSikri(NPP)", label: "FatehpurSikri(NPP)" },
  { value: "Feroke(CT)", label: "Feroke(CT)" },
  { value: "G.Udayagiri(NAC)", label: "G.Udayagiri(NAC)" },
  { value: "GAADHI", label: "GAADHI" },
  { value: "GADAG", label: "GADAG" },
  { value: "GADAG-BETAGERI", label: "GADAG-BETAGERI" },
  { value: "GADAGBETAGIRI", label: "GADAGBETAGIRI" },
  { value: "GADARPUR", label: "GADARPUR" },
  { value: "GADARWARA", label: "GADARWARA" },
  { value: "GADCHANDUR", label: "GADCHANDUR" },
  { value: "GADCHIROLI", label: "GADCHIROLI" },
  { value: "GADHINGLAJ", label: "GADHINGLAJ" },
  { value: "GADWAL", label: "GADWAL" },
  { value: "GAGGAL", label: "GAGGAL" },
  { value: "GAGRET", label: "GAGRET" },
  { value: "GAIRATGANJ", label: "GAIRATGANJ" },
  { value: "GAIRSAIN", label: "GAIRSAIN" },
  { value: "GAJAPATI", label: "GAJAPATI" },
  { value: "GAJAPATINAGARAM", label: "GAJAPATINAGARAM" },
  { value: "GAJENDRAGAD", label: "GAJENDRAGAD" },
  { value: "GAJRAULA", label: "GAJRAULA" },
  { value: "GAJWEL", label: "GAJWEL" },
  { value: "GALAGALI", label: "GALAGALI" },
  { value: "GAMBHIRAM", label: "GAMBHIRAM" },
  { value: "GAMBHIRIASAGAR", label: "GAMBHIRIASAGAR" },
  { value: "GAMHARIA", label: "GAMHARIA" },
  { value: "GAMPALAGUDEM", label: "GAMPALAGUDEM" },
  { value: "GANAUR", label: "GANAUR" },
  { value: "GANDAI", label: "GANDAI" },
  { value: "GANDARVAKKOTTAI", label: "GANDARVAKKOTTAI" },
  { value: "GANDERBAL", label: "GANDERBAL" },
  { value: "GANDHI NAGAR", label: "GANDHI NAGAR" },
  { value: "GANDHIDHAM", label: "GANDHIDHAM" },
  { value: "GANDHIGRAM", label: "GANDHIGRAM" },
  { value: "GANDHINAGAR", label: "GANDHINAGAR" },
  { value: "GANDHISAGAR", label: "GANDHISAGAR" },
  { value: "GANDHWANI", label: "GANDHWANI" },
  { value: "GANESHGARH", label: "GANESHGARH" },
  { value: "GANGADHARPUR", label: "GANGADHARPUR" },
  { value: "GANGAPUR", label: "GANGAPUR" },
  { value: "GANGARAR", label: "GANGARAR" },
  { value: "GANGASAGAR", label: "GANGASAGAR" },
  { value: "GANGASHAHAR", label: "GANGASHAHAR" },
  { value: "GANGAVALLI", label: "GANGAVALLI" },
  { value: "GANGAVATHI", label: "GANGAVATHI" },
  { value: "GANGHO", label: "GANGHO" },
  { value: "GANGIRI", label: "GANGIRI" },
  { value: "GANGOLIHAT", label: "GANGOLIHAT" },
  { value: "GANGOTRI", label: "GANGOTRI" },
  { value: "GANGTOK", label: "GANGTOK" },
  { value: "GANGUWALA", label: "GANGUWALA" },
  { value: "GANJ", label: "GANJ" },
  { value: "GANJAM", label: "GANJAM" },
  { value: "GANJBASODA", label: "GANJBASODA" },
  { value: "GANJDUNDWARA", label: "GANJDUNDWARA" },
  { value: "GARALGACHA", label: "GARALGACHA" },
  { value: "GARAULI", label: "GARAULI" },
  { value: "GARGOTI", label: "GARGOTI" },
  { value: "GARHBETA", label: "GARHBETA" },
  { value: "GARHDIWALA", label: "GARHDIWALA" },
  { value: "GARHIHARSARU", label: "GARHIHARSARU" },
  { value: "GARHISWAIRAM", label: "GARHISWAIRAM" },
  { value: "GARHMUKTESHWAR", label: "GARHMUKTESHWAR" },
  { value: "GARHSHANKAR", label: "GARHSHANKAR" },
  { value: "GARHWA", label: "GARHWA" },
  { value: "GARIABAND", label: "GARIABAND" },
  { value: "GARIYABAND", label: "GARIYABAND" },
  { value: "GARMUR", label: "GARMUR" },
  { value: "GARRA", label: "GARRA" },
  { value: "GAUCHAR", label: "GAUCHAR" },
  { value: "GAURA", label: "GAURA" },
  { value: "GAURIBIDANUR", label: "GAURIBIDANUR" },
  { value: "GAURIGANJ", label: "GAURIGANJ" },
  { value: "GAUTAM BUDDHA NAGAR", label: "GAUTAM BUDDHA NAGAR" },
  { value: "GAUTAMBUDDHANAGAR", label: "GAUTAMBUDDHANAGAR" },
  { value: "GAUTAMPURA", label: "GAUTAMPURA" },
  { value: "GAYA", label: "GAYA" },
  { value: "GAYESHPUR", label: "GAYESHPUR" },
  { value: "GAZOLE", label: "GAZOLE" },
  { value: "GCFJabalpur(CT)", label: "GCFJabalpur(CT)" },
  { value: "GENGUVARPATTI", label: "GENGUVARPATTI" },
  { value: "GEORAI", label: "GEORAI" },
  { value: "GEYZING", label: "GEYZING" },
  { value: "GHAGGA", label: "GHAGGA" },
  { value: "GHAGRA", label: "GHAGRA" },
  { value: "GHANAUR", label: "GHANAUR" },
  { value: "GHANSALI", label: "GHANSALI" },
  { value: "GHANTESHWER", label: "GHANTESHWER" },
  { value: "GHARAUNDA", label: "GHARAUNDA" },
  { value: "GHARGHODA", label: "GHARGHODA" },
  { value: "GHAROLI", label: "GHAROLI" },
  { value: "GHAROTAKALAN", label: "GHAROTAKALAN" },
  { value: "GHARSANA", label: "GHARSANA" },
  { value: "GHATAKPUKUR", label: "GHATAKPUKUR" },
  { value: "GHATAL", label: "GHATAL" },
  { value: "GHATAMPUR", label: "GHATAMPUR" },
  { value: "GHATBAKULTALA", label: "GHATBAKULTALA" },
  { value: "GHATIYA", label: "GHATIYA" },
  { value: "GHATKESAR", label: "GHATKESAR" },
  { value: "GHATSHILA", label: "GHATSHILA" },
  { value: "GHAZIABAD", label: "GHAZIABAD" },
  { value: "GHAZIPUR", label: "GHAZIPUR" },
  { value: "GHIROR", label: "GHIROR" },
  { value: "GHODEGAON", label: "GHODEGAON" },
  { value: "GHOMAN", label: "GHOMAN" },
  { value: "GHORAMARI", label: "GHORAMARI" },
  { value: "GHOUMANHASAN", label: "GHOUMANHASAN" },
  { value: "GHUGUS", label: "GHUGUS" },
  { value: "GHULEWADI", label: "GHULEWADI" },
  { value: "GHUMARWAIN", label: "GHUMARWAIN" },
  { value: "GHUMARWIN", label: "GHUMARWIN" },
  { value: "GHUTGARYA", label: "GHUTGARYA" },
  { value: "GHUTGORIA", label: "GHUTGORIA" },
  { value: "GIDDALUR", label: "GIDDALUR" },
  { value: "GIDDERBAHA", label: "GIDDERBAHA" },
  { value: "GIDERBAHA", label: "GIDERBAHA" },
  { value: "GIMS GADAG", label: "GIMS GADAG" },
  { value: "GINIKALLU", label: "GINIKALLU" },
  { value: "GIR SOMNATH", label: "GIR SOMNATH" },
  { value: "GIRIDH", label: "GIRIDH" },
  { value: "GIRIDIH", label: "GIRIDIH" },
  { value: "GOA", label: "GOA" },
  { value: "GOALPARA", label: "GOALPARA" },
  { value: "GOBICHETTIPALAYAM", label: "GOBICHETTIPALAYAM" },
  { value: "GODA", label: "GODA" },
  { value: "GODDA", label: "GODDA" },
  { value: "GODHRA", label: "GODHRA" },
  { value: "GOGAMUKH", label: "GOGAMUKH" },
  { value: "GOGUNDA", label: "GOGUNDA" },
  { value: "GOHAD", label: "GOHAD" },
  { value: "GOHANA", label: "GOHANA" },
  { value: "GOHPUR", label: "GOHPUR" },
  { value: "GOINDWAL", label: "GOINDWAL" },
  { value: "GOJHARIYA", label: "GOJHARIYA" },
  { value: "GOKAK", label: "GOKAK" },
  { value: "GOKALPURI", label: "GOKALPURI" },
  { value: "GOLA", label: "GOLA" },
  { value: "GOLAGHAT", label: "GOLAGHAT" },
  { value: "GOLPARA", label: "GOLPARA" },
  { value: "GOLUWALA", label: "GOLUWALA" },
  { value: "GOMOH", label: "GOMOH" },
  { value: "GONDA", label: "GONDA" },
  { value: "GONDAL", label: "GONDAL" },
  { value: "GONDIA", label: "GONDIA" },
  { value: "GONDPIPARI", label: "GONDPIPARI" },
  { value: "GONDPIPRI", label: "GONDPIPRI" },
  { value: "GONIANA", label: "GONIANA" },
  { value: "GONIKOPPA", label: "GONIKOPPA" },
  { value: "GOOTY", label: "GOOTY" },
  { value: "GOPALGANJ", label: "GOPALGANJ" },
  { value: "GOPALNAGAR", label: "GOPALNAGAR" },
  { value: "GOPESHWAR", label: "GOPESHWAR" },
  { value: "GOPIBALLABPUR", label: "GOPIBALLABPUR" },
  { value: "GORAKHPUR", label: "GORAKHPUR" },
  { value: "GORAUL", label: "GORAUL" },
  { value: "GORAYA", label: "GORAYA" },
  { value: "GORESWAR", label: "GORESWAR" },
  { value: "GOSAINGANJ ", label: "GOSAINGANJ " },
  { value: "GOSSAIGAON", label: "GOSSAIGAON" },
  { value: "GOT", label: "GOT" },
  { value: "GOTAGODI", label: "GOTAGODI" },
  { value: "GOTAN", label: "GOTAN" },
  { value: "GOTEGAON", label: "GOTEGAON" },
  { value: "GOTHAPATNA", label: "GOTHAPATNA" },
  { value: "GOTHARA", label: "GOTHARA" },
  { value: "GOVERDHAN", label: "GOVERDHAN" },
  { value: "GOVINDGARH", label: "GOVINDGARH" },
  { value: "GOWRIBIDNUR", label: "GOWRIBIDNUR" },
  { value: "GOYALI", label: "GOYALI" },
  { value: "GOZARIA", label: "GOZARIA" },
  { value: "GREATER NOIDA", label: "GREATER NOIDA" },
  { value: "GREATERNOIDA", label: "GREATERNOIDA" },
  { value: "GSFCComplex(INA)", label: "GSFCComplex(INA)" },
  { value: "GUBBI", label: "GUBBI" },
  { value: "GUDALUR", label: "GUDALUR" },
  { value: "GUDAMALANI", label: "GUDAMALANI" },
  { value: "GUDHAGORJI", label: "GUDHAGORJI" },
  { value: "GUDIBANDA", label: "GUDIBANDA" },
  { value: "GUDIMANGALAM", label: "GUDIMANGALAM" },
  { value: "GUDIVADA", label: "GUDIVADA" },
  { value: "GUDIYATHAM", label: "GUDIYATHAM" },
  { value: "GUDLAVALLERU", label: "GUDLAVALLERU" },
  { value: "GUDUR", label: "GUDUR" },
  { value: "GUDUVANCHERY", label: "GUDUVANCHERY" },
  { value: "GUHAGAR", label: "GUHAGAR" },
  { value: "GULARIABHINDARA", label: "GULARIABHINDARA" },
  { value: "GULEDAGUDDA", label: "GULEDAGUDDA" },
  { value: "GUMA", label: "GUMA" },
  { value: "GUMIA", label: "GUMIA" },
  { value: "GUMLA", label: "GUMLA" },
  { value: "GUMMA", label: "GUMMA" },
  { value: "GUMMIDIPOONDI", label: "GUMMIDIPOONDI" },
  { value: "GUNA", label: "GUNA" },
  { value: "GUND MULRAJ", label: "GUND MULRAJ" },
  { value: "GUNDERDEHI", label: "GUNDERDEHI" },
  { value: "GUNDLAVAI", label: "GUNDLAVAI" },
  { value: "GUNDLUPETE", label: "GUNDLUPETE" },
  { value: "GUNTAKAL", label: "GUNTAKAL" },
  { value: "GUNTUR", label: "GUNTUR" },
  { value: "GUNUPUR", label: "GUNUPUR" },
  { value: "GUPTIPUR", label: "GUPTIPUR" },
  { value: "GUPTKASHI", label: "GUPTKASHI" },
  { value: "GURAZALA", label: "GURAZALA" },
  { value: "GURDASPUR", label: "GURDASPUR" },
  { value: "GURGAON", label: "GURGAON" },
  { value: "GURSAHAIGANJ", label: "GURSAHAIGANJ" },
  { value: "GURSARAI", label: "GURSARAI" },
  { value: "GURU HARKRISHAN NAGAR", label: "GURU HARKRISHAN NAGAR" },
  { value: "GURUGRAM", label: "GURUGRAM" },
  { value: "GURUVAYUR", label: "GURUVAYUR" },
  { value: "GUSKHARA", label: "GUSKHARA" },
  { value: "GUTTAL", label: "GUTTAL" },
  { value: "GUWAHATI", label: "GUWAHATI" },
  { value: "GWALIOR", label: "GWALIOR" },
  { value: "Gabhana(CT)", label: "Gabhana(CT)" },
  { value: "GagalhediMust.(CT)", label: "GagalhediMust.(CT)" },
  { value: "Gairatganj(NP)", label: "Gairatganj(NP)" },
  { value: "Gajsinghpur(M)", label: "Gajsinghpur(M)" },
  { value: "Galiakot(CT)", label: "Galiakot(CT)" },
  { value: "Gandhigram(CT)", label: "Gandhigram(CT)" },
  { value: "Gandhinagar(CT)", label: "Gandhinagar(CT)" },
  { value: "Gandhinagar(TP)", label: "Gandhinagar(TP)" },
  { value: "Gangaghat(NPP)", label: "Gangaghat(NPP)" },
  { value: "Gangapur(MCl)", label: "Gangapur(MCl)" },
  { value: "Gangapur(NP)", label: "Gangapur(NP)" },
  { value: "Gangoh(NPP)", label: "Gangoh(NPP)" },
  { value: "Gangwa(166)(CT)", label: "Gangwa(166)(CT)" },
  { value: "GanjMuradabad(NP)", label: "GanjMuradabad(NP)" },
  { value: "GanwariaTulsipur(Dehat)(CT)", label: "GanwariaTulsipur(Dehat)(CT)" },
  { value: "Garhi(CT)", label: "Garhi(CT)" },
  { value: "GarhiPukhta(NP)", label: "GarhiPukhta(NP)" },
  { value: "GarhiTamana(CT)", label: "GarhiTamana(CT)" },
  { value: "Gariyaband(NP)", label: "Gariyaband(NP)" },
  { value: "Garoth(NP)", label: "Garoth(NP)" },
  { value: "GaurDaha(CT)", label: "GaurDaha(CT)" },
  { value: "GauraKala(CT)", label: "GauraKala(CT)" },
  { value: "GauriBazar(NP)", label: "GauriBazar(NP)" },
  { value: "Gausganj(CT)", label: "Gausganj(CT)" },
  { value: "Gawan(NP)", label: "Gawan(NP)" },
  { value: "Georai(MCl)", label: "Georai(MCl)" },
  { value: "GerimariChapori(CT)", label: "GerimariChapori(CT)" },
  { value: "Ghanauli(CT)", label: "Ghanauli(CT)" },
  { value: "GhodaDongriRyt(CT)", label: "GhodaDongriRyt(CT)" },
  { value: "Ghorabandha(CT)", label: "Ghorabandha(CT)" },
  { value: "Ghorawal(NP)", label: "Ghorawal(NP)" },
  { value: "Ghosi(NP)", label: "Ghosi(NP)" },
  { value: "GhosiaBazar(NP)", label: "GhosiaBazar(NP)" },
  { value: "Ghughuli(NP)", label: "Ghughuli(NP)" },
  { value: "Ghugus(CT)", label: "Ghugus(CT)" },
  { value: "Ghuni(CT)", label: "Ghuni(CT)" },
  { value: "Ghuwara(NP)", label: "Ghuwara(NP)" },
  { value: "Gill(CT)", label: "Gill(CT)" },
  { value: "GirdBaragaon(CT)", label: "GirdBaragaon(CT)" },
  { value: "GirdGonda(CT)", label: "GirdGonda(CT)" },
  { value: "Gobindapur(CT)", label: "Gobindapur(CT)" },
  { value: "Godda(NP)", label: "Godda(NP)" },
  { value: "Godoli(CT)", label: "Godoli(CT)" },
  { value: "Gogapur(CT)", label: "Gogapur(CT)" },
  { value: "Gogunda(CT)", label: "Gogunda(CT)" },
  { value: "Gohand(NP)", label: "Gohand(NP)" },
  { value: "Gokul(NP)", label: "Gokul(NP)" },
  { value: "Gokunda(CT)", label: "Gokunda(CT)" },
  { value: "GolaBazar(NP)", label: "GolaBazar(NP)" },
  { value: "GolaGokaranNath(NPP)", label: "GolaGokaranNath(NPP)" },
  { value: "Gomati", label: "Gomati" },
  { value: "Gondalpara(CT)", label: "Gondalpara(CT)" },
  { value: "Goniana(MCl)", label: "Goniana(MCl)" },
  { value: "Gopalasamudram(TP)", label: "Gopalasamudram(TP)" },
  { value: "Gopiganj(NPP)", label: "Gopiganj(NPP)" },
  { value: "Goraiya(CT)", label: "Goraiya(CT)" },
  { value: "GorediChancha(CT)", label: "GorediChancha(CT)" },
  { value: "Gormi(NP)", label: "Gormi(NP)" },
  { value: "Gorrekunta(CT)", label: "Gorrekunta(CT)" },
  { value: "Gosainganj(NP)", label: "Gosainganj(NP)" },
  { value: "Govardhan(NP)", label: "Govardhan(NP)" },
  { value: "Govindgarh(NP)", label: "Govindgarh(NP)" },
  { value: "Gua(CT)", label: "Gua(CT)" },
  { value: "Guhala(CT)", label: "Guhala(CT)" },
  { value: "Guirim(CT)", label: "Guirim(CT)" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Gulabpura(M)", label: "Gulabpura(M)" },
  { value: "Gulaothi(NPP)", label: "Gulaothi(NPP)" },
  { value: "Gulariya(NP)", label: "Gulariya(NP)" },
  { value: "Gulmarg(MC)", label: "Gulmarg(MC)" },
  { value: "Gumaniwala(CT)", label: "Gumaniwala(CT)" },
  { value: "Gunghasa(CT)", label: "Gunghasa(CT)" },
  { value: "Gunnaur(NP)", label: "Gunnaur(NP)" },
  { value: "Guriahati(CT)", label: "Guriahati(CT)" },
  { value: "Gursahaiganj(NPP)", label: "Gursahaiganj(NPP)" },
  { value: "Gursarai(NPP)", label: "Gursarai(NPP)" },
  { value: "GuruHarSahai(MCl)", label: "GuruHarSahai(MCl)" },
  { value: "Gyanpur(NP)", label: "Gyanpur(NP)" },
  { value: "HABRA", label: "HABRA" },
  { value: "HAFLONG", label: "HAFLONG" },
  { value: "HAGARIBOMMANAHALLI", label: "HAGARIBOMMANAHALLI" },
  { value: "HAIDARGARH", label: "HAIDARGARH" },
  { value: "HAILAKANDI", label: "HAILAKANDI" },
  { value: "HAILEYMANDI", label: "HAILEYMANDI" },
  { value: "HAJIPUR", label: "HAJIPUR" },
  { value: "HAJO", label: "HAJO" },
  { value: "HALDAURRURAL", label: "HALDAURRURAL" },
  { value: "HALDIA", label: "HALDIA" },
  { value: "HALDIBARI", label: "HALDIBARI" },
  { value: "HALDWANI", label: "HALDWANI" },
  { value: "HALIYAL", label: "HALIYAL" },
  { value: "HALOL", label: "HALOL" },
  { value: "HALUDBANI", label: "HALUDBANI" },
  { value: "HALVAD", label: "HALVAD" },
  { value: "HALWARA", label: "HALWARA" },
  { value: "HAMIRGARH", label: "HAMIRGARH" },
  { value: "HAMIRPUR", label: "HAMIRPUR" },
  { value: "HAMIRPUR(HP)", label: "HAMIRPUR(HP)" },
  { value: "HAMIRPURHP", label: "HAMIRPURHP" },
  { value: "HAMIRPUR ", label: "HAMIRPUR " },
  { value: "HANDIA", label: "HANDIA" },
  { value: "HANDWARA", label: "HANDWARA" },
  { value: "HANGAL", label: "HANGAL" },
  { value: "HANJIWERA", label: "HANJIWERA" },
  { value: "HANSAKHEDI", label: "HANSAKHEDI" },
  { value: "HANSI", label: "HANSI" },
  { value: "HANSOT", label: "HANSOT" },
  { value: "HANUMANGARH", label: "HANUMANGARH" },
  { value: "HANUMANGARHJUNCTION", label: "HANUMANGARHJUNCTION" },
  { value: "HANUMANJUNCTION", label: "HANUMANJUNCTION" },
  { value: "HAPUR", label: "HAPUR" },
  { value: "HARAPANAHALLI", label: "HARAPANAHALLI" },
  { value: "HARDA", label: "HARDA" },
  { value: "HARDOI", label: "HARDOI" },
  { value: "HAREKALAJHC", label: "HAREKALAJHC" },
  { value: "HARGAON", label: "HARGAON" },
  { value: "HARIANA", label: "HARIANA" },
  { value: "HARIDWAR", label: "HARIDWAR" },
  { value: "HARIPAL", label: "HARIPAL" },
  { value: "HAROHALLI", label: "HAROHALLI" },
  { value: "HARRAIYA", label: "HARRAIYA" },
  { value: "HARSUL", label: "HARSUL" },
  { value: "HARUGERI", label: "HARUGERI" },
  { value: "HARUR", label: "HARUR" },
  { value: "HARYANA", label: "HARYANA" },
  { value: "HASANPUR", label: "HASANPUR" },
  { value: "HASNABAD", label: "HASNABAD" },
  { value: "HASPURA", label: "HASPURA" },
  { value: "HASSAN", label: "HASSAN" },
  { value: "HASTINAPUR", label: "HASTINAPUR" },
  { value: "HATHGAON", label: "HATHGAON" },
  { value: "HATHIN", label: "HATHIN" },
  { value: "HATHKHAMBA", label: "HATHKHAMBA" },
  { value: "HATHRAS", label: "HATHRAS" },
  { value: "HATHUA", label: "HATHUA" },
  { value: "HATHUR", label: "HATHUR" },
  { value: "HATOD", label: "HATOD" },
  { value: "HATPIPLIYA", label: "HATPIPLIYA" },
  { value: "HATTA", label: "HATTA" },
  { value: "HAUNSBHAVI", label: "HAUNSBHAVI" },
  { value: "Havelock Island", label: "Havelock Island" },
  { value: "HAVERI", label: "HAVERI" },
  { value: "HAZARIBAGH", label: "HAZARIBAGH" },
  { value: "HAZIRA", label: "HAZIRA" },
  { value: "HCROSS", label: "HCROSS" },
  { value: "HEBRI", label: "HEBRI" },
  { value: "HEGGADADEVANKOTE", label: "HEGGADADEVANKOTE" },
  { value: "HEINGANG", label: "HEINGANG" },
  { value: "HEMAMBIKANAGAR", label: "HEMAMBIKANAGAR" },
  { value: "HEMATPUR", label: "HEMATPUR" },
  { value: "HEMGIR", label: "HEMGIR" },
  { value: "HESARAGHATTA", label: "HESARAGHATTA" },
  { value: "HIMACHALPRADESH", label: "HIMACHALPRADESH" },
  { value: "HIMATNAGAR", label: "HIMATNAGAR" },
  { value: "HIMMATSAR", label: "HIMMATSAR" },
  { value: "HINDALGA", label: "HINDALGA" },
  { value: "HINDAUN", label: "HINDAUN" },
  { value: "HINDOLI", label: "HINDOLI" },
  { value: "HINDUMALKOT(7B)", label: "HINDUMALKOT(7B)" },
  { value: "HINDUPUR", label: "HINDUPUR" },
  { value: "HINGANGHAT", label: "HINGANGHAT" },
  { value: "HINGNA", label: "HINGNA" },
  { value: "HINGOLI", label: "HINGOLI" },
  { value: "HINJAWADI", label: "HINJAWADI" },
  { value: "HIREKERUR", label: "HIREKERUR" },
  { value: "HIRESHITTA BAAD", label: "HIRESHITTA BAAD" },
  { value: "HISAR", label: "HISAR" },
  { value: "HMTPinjore(CT)", label: "HMTPinjore(CT)" },
  { value: "HNCITY", label: "HNCITY" },
  { value: "HODAL", label: "HODAL" },
  { value: "HOJAI", label: "HOJAI" },
  { value: "HOLALKERE", label: "HOLALKERE" },
  { value: "HOLEALUR", label: "HOLEALUR" },
  { value: "HOMBAL", label: "HOMBAL" },
  { value: "HONDA", label: "HONDA" },
  { value: "HONGAHALLI", label: "HONGAHALLI" },
  { value: "HONNAVAR", label: "HONNAVAR" },
  { value: "HOOGHLY", label: "HOOGHLY" },
  { value: "HOOMGARH", label: "HOOMGARH" },
  { value: "HOSADURGA", label: "HOSADURGA" },
  { value: "HOSANAGARA", label: "HOSANAGARA" },
  { value: "HOSAPETE", label: "HOSAPETE" },
  { value: "HOSARITTI", label: "HOSARITTI" },
  { value: "HOSHANGABAD", label: "HOSHANGABAD" },
  { value: "HOSHIARPUR", label: "HOSHIARPUR" },
  { value: "HOSKOTE", label: "HOSKOTE" },
  { value: "HOSPET", label: "HOSPET" },
  { value: "HOSUR", label: "HOSUR" },
  { value: "HOWLY", label: "HOWLY" },
  { value: "HOWRAGHAT", label: "HOWRAGHAT" },
  { value: "HOWRAH", label: "HOWRAH" },
  { value: "HUBBALLI", label: "HUBBALLI" },
  { value: "HUDA", label: "HUDA" },
  { value: "HUDKESHWAR", label: "HUDKESHWAR" },
  { value: "HULKOTI", label: "HULKOTI" },
  { value: "HUNGUND", label: "HUNGUND" },
  { value: "HUNNUR", label: "HUNNUR" },
  { value: "HUNSUR", label: "HUNSUR" },
  { value: "HUPARI", label: "HUPARI" },
  { value: "HUSNABAD", label: "HUSNABAD" },
  { value: "HUTBAYISLAND", label: "HUTBAYISLAND" },
  { value: "HUZURABAD", label: "HUZURABAD" },
  { value: "HYDERABAD", label: "HYDERABAD" },
  { value: "HYDERABAD(MALKAPET)", label: "HYDERABAD(MALKAPET)" },
  { value: "HYDERABAD(NARSINGI)", label: "HYDERABAD(NARSINGI)" },
  { value: "HYDERABADCITY", label: "HYDERABADCITY" },
  { value: "Habibpur(CT)", label: "Habibpur(CT)" },
  { value: "Habra(M)", label: "Habra(M)" },
  { value: "HafizGanj(CT)", label: "HafizGanj(CT)" },
  { value: "Hafizpur(CT)", label: "Hafizpur(CT)" },
  { value: "Haflong(TC)", label: "Haflong(TC)" },
  { value: "Hajan(MC)", label: "Hajan(MC)" },
  { value: "Hallaur(CT)", label: "Hallaur(CT)" },
  { value: "Hamirpur(NPP)", label: "Hamirpur(NPP)" },
  { value: "Hamren(TC)", label: "Hamren(TC)" },
  { value: "Hanamkonda", label: "Hanamkonda" },
  { value: "Handia(NP)", label: "Handia(NP)" },
  { value: "Handiaya(NP)", label: "Handiaya(NP)" },
  { value: "Hanumana(NP)", label: "Hanumana(NP)" },
  { value: "Hanumanthampatti(TP)", label: "Hanumanthampatti(TP)" },
  { value: "Harduaganj(NP)", label: "Harduaganj(NP)" },
  { value: "Hargaon(NP)", label: "Hargaon(NP)" },
  { value: "Hariharpur(CT)", label: "Hariharpur(CT)" },
  { value: "Hariharpur(NP)", label: "Hariharpur(NP)" },
  { value: "HaripurKalan(CT)", label: "HaripurKalan(CT)" },
  { value: "Harishpur(CT)", label: "Harishpur(CT)" },
  { value: "Hariyawan(CT)", label: "Hariyawan(CT)" },
  { value: "Harpalpur(CT)", label: "Harpalpur(CT)" },
  { value: "Harpalpur(NP)", label: "Harpalpur(NP)" },
  { value: "Harraiya(NP)", label: "Harraiya(NP)" },
  { value: "HarsewakpurNo.2(CT)", label: "HarsewakpurNo.2(CT)" },
  { value: "Hasangarh(CT)", label: "Hasangarh(CT)" },
  { value: "Hasanpur(NPP)", label: "Hasanpur(NPP)" },
  { value: "Hasayan(NP)", label: "Hasayan(NP)" },
  { value: "HatSaraiya(CT)", label: "HatSaraiya(CT)" },
  { value: "Hata(NP)", label: "Hata(NP)" },
  { value: "Hatgachha(CT)", label: "Hatgachha(CT)" },
  { value: "Hathin(MC)", label: "Hathin(MC)" },
  { value: "Hatsimla(CT)", label: "Hatsimla(CT)" },
  { value: "Hatti(CT)", label: "Hatti(CT)" },
  { value: "HattiGoldMines(NAC)", label: "HattiGoldMines(NAC)" },
  { value: "Hazaribag", label: "Hazaribag" },
  { value: "Hebbagodi(CT)", label: "Hebbagodi(CT)" },
  { value: "Heirok(NP)", label: "Heirok(NP)" },
  { value: "Herbertpur(NP)", label: "Herbertpur(NP)" },
  { value: "Highways(TP)", label: "Highways(TP)" },
  { value: "HindalcoIndustriesLtd.(Renukoot)(ITS)", label: "HindalcoIndustriesLtd.(Renukoot)(ITS)" },
  { value: "Hindoria(NP)", label: "Hindoria(NP)" },
  { value: "Hinganghat(MCl)", label: "Hinganghat(MCl)" },
  { value: "Hinkal(CT)", label: "Hinkal(CT)" },
  { value: "Hirapur(CT)", label: "Hirapur(CT)" },
  { value: "Hirdepur(CT)", label: "Hirdepur(CT)" },
  { value: "Hiriyur(TMC)", label: "Hiriyur(TMC)" },
  { value: "Hirmi(CT)", label: "Hirmi(CT)" },
  { value: "Hubli-Dharwad(MCorp.)", label: "Hubli-Dharwad(MCorp.)" },
  { value: "Hussainabad(NP)", label: "Hussainabad(NP)" },
  { value: "Hussainpur(CT)", label: "Hussainpur(CT)" },
  { value: "Hyderabad(NP)", label: "Hyderabad(NP)" },
  { value: "Hyderabad ", label: "Hyderabad " },
  { value: "IBRAHIMPATNAM", label: "IBRAHIMPATNAM" },
  { value: "ICHALKARANJI", label: "ICHALKARANJI" },
  { value: "ICHCHAPURAM", label: "ICHCHAPURAM" },
  { value: "ICHHAWAR", label: "ICHHAWAR" },
  { value: "IDAR", label: "IDAR" },
  { value: "IDUKKI", label: "IDUKKI" },
  { value: "IGATPURI", label: "IGATPURI" },
  { value: "IGLAS", label: "IGLAS" },
  { value: "IKAUNA", label: "IKAUNA" },
  { value: "ILAYANGUDI", label: "ILAYANGUDI" },
  { value: "ILKAL", label: "ILKAL" },
  { value: "ILLAMBAZAR", label: "ILLAMBAZAR" },
  { value: "ILLUPUR", label: "ILLUPUR" },
  { value: "IMPHAL", label: "IMPHAL" },
  { value: "INAYATNAGAR", label: "INAYATNAGAR" },
  { value: "INDALWAI", label: "INDALWAI" },
  { value: "INDAPUR", label: "INDAPUR" },
  { value: "INDERGARH", label: "INDERGARH" },
  { value: "INDORA", label: "INDORA" },
  { value: "INDORE", label: "INDORE" },
  { value: "INDOREMOFFUSIL", label: "INDOREMOFFUSIL" },
  { value: "INDRA COLONY", label: "INDRA COLONY" },
  { value: "INDRI", label: "INDRI" },
  { value: "INDUSTRIAL AREA", label: "INDUSTRIAL AREA" },
  { value: "INGORIYA", label: "INGORIYA" },
  { value: "IRINJALAKUDA", label: "IRINJALAKUDA" },
  { value: "IRITTY", label: "IRITTY" },
  { value: "ISASANI", label: "ISASANI" },
  { value: "ISLAMPUR", label: "ISLAMPUR" },
  { value: "ISMAILBAD", label: "ISMAILBAD" },
  { value: "ISRANA", label: "ISRANA" },
  { value: "ITANAGAR", label: "ITANAGAR" },
  { value: "ITARSI", label: "ITARSI" },
  { value: "ITAUNJA", label: "ITAUNJA" },
  { value: "ITAWA", label: "ITAWA" },
  { value: "IYYAPPANTHANGAL", label: "IYYAPPANTHANGAL" },
  { value: "Ibrahimpur(CT)", label: "Ibrahimpur(CT)" },
  { value: "Ichgam(CT)", label: "Ichgam(CT)" },
  { value: "Ichhawar(NP)", label: "Ichhawar(NP)" },
  { value: "Iduvai(CT)", label: "Iduvai(CT)" },
  { value: "IffcoCensusVillage(CT)", label: "IffcoCensusVillage(CT)" },
  { value: "Iglas(NP)", label: "Iglas(NP)" },
  { value: "Ikauna(NP)", label: "Ikauna(NP)" },
  { value: "IltifatganjBazar(NP)", label: "IltifatganjBazar(NP)" },
  { value: "Imphal East", label: "Imphal East" },
  { value: "Imphal West", label: "Imphal West" },
  { value: "InamManiyachi(CT)", label: "InamManiyachi(CT)" },
  { value: "Indergarh(NP)", label: "Indergarh(NP)" },
  { value: "Injambakkam(CT)", label: "Injambakkam(CT)" },
  { value: "Iravadanallur(CT)", label: "Iravadanallur(CT)" },
  { value: "Irugur(TP)", label: "Irugur(TP)" },
  { value: "Isagarh(NP)", label: "Isagarh(NP)" },
  { value: "IsapurBanger(CT)", label: "IsapurBanger(CT)" },
  { value: "Islamnagar(NP)", label: "Islamnagar(NP)" },
  { value: "Islampur(CT)", label: "Islampur(CT)" },
  { value: "Islampur(NP)", label: "Islampur(NP)" },
  { value: "Isri(CT)", label: "Isri(CT)" },
  { value: "Itanagar", label: "Itanagar" },
  { value: "Itarsi(M)", label: "Itarsi(M)" },
  { value: "Itaunja(NP)", label: "Itaunja(NP)" },
  { value: "Itwa(CT)", label: "Itwa(CT)" },
  { value: "JABALPUR", label: "JABALPUR" },
  { value: "JADUPUR", label: "JADUPUR" },
  { value: "JAFRABAD", label: "JAFRABAD" },
  { value: "JAGADHRI", label: "JAGADHRI" },
  { value: "JAGATPUR", label: "JAGATPUR" },
  { value: "JAGATSINGHAPUR", label: "JAGATSINGHAPUR" },
  { value: "JAGATSINGHPUR", label: "JAGATSINGHPUR" },
  { value: "JAGDALPUR", label: "JAGDALPUR" },
  { value: "JAGDISHPUR", label: "JAGDISHPUR" },
  { value: "JAGGAIAHPET", label: "JAGGAIAHPET" },
  { value: "JAGGAMPETA", label: "JAGGAMPETA" },
  { value: "JAGIROAD", label: "JAGIROAD" },
  { value: "JAGNER", label: "JAGNER" },
  { value: "JAGRAON", label: "JAGRAON" },
  { value: "JAGTIAL", label: "JAGTIAL" },
  { value: "JAGULI", label: "JAGULI" },
  { value: "JAHANABAD", label: "JAHANABAD" },
  { value: "JAHAZPUR", label: "JAHAZPUR" },
  { value: "JAIGAD", label: "JAIGAD" },
  { value: "JAIGAON", label: "JAIGAON" },
  { value: "JAIPUR", label: "JAIPUR" },
  { value: "JAISALMER", label: "JAISALMER" },
  { value: "JAISINGHPUR", label: "JAISINGHPUR" },
  { value: "JAITARAN", label: "JAITARAN" },
  { value: "JAITO", label: "JAITO" },
  { value: "JAITPUR", label: "JAITPUR" },
  { value: "JAITPURKALAN", label: "JAITPURKALAN" },
  { value: "JAITSAR", label: "JAITSAR" },
  { value: "JAJAPUR", label: "JAJAPUR" },
  { value: "JAJPUR", label: "JAJPUR" },
  { value: "JAKHALMANDI", label: "JAKHALMANDI" },
  { value: "JAKHAON", label: "JAKHAON" },
  { value: "JALALABAD", label: "JALALABAD" },
  { value: "JALALPUR", label: "JALALPUR" },
  { value: "JALANDHAR", label: "JALANDHAR" },
  { value: "JALAUN", label: "JALAUN" },
  { value: "JALESWAR", label: "JALESWAR" },
  { value: "JALGAON", label: "JALGAON" },
  { value: "JALLIWADA", label: "JALLIWADA" },
  { value: "JALNA", label: "JALNA" },
  { value: "JALOR", label: "JALOR" },
  { value: "JALORE", label: "JALORE" },
  { value: "JALPAIGURI", label: "JALPAIGURI" },
  { value: "JALUKIE", label: "JALUKIE" },
  { value: "JAMALPUR", label: "JAMALPUR" },
  { value: "JAMBUSAR", label: "JAMBUSAR" },
  { value: "JAMDOBA", label: "JAMDOBA" },
  { value: "JAMJODHPUR", label: "JAMJODHPUR" },
  { value: "JAMKHANDI", label: "JAMKHANDI" },
  { value: "JAMKHED", label: "JAMKHED" },
  { value: "JAMMALAMADUGU", label: "JAMMALAMADUGU" },
  { value: "JAMMIKUNTA", label: "JAMMIKUNTA" },
  { value: "JAMMU", label: "JAMMU" },
  { value: "JAMNAGAR", label: "JAMNAGAR" },
  { value: "JAMNI", label: "JAMNI" },
  { value: "JAMSHEDPUR", label: "JAMSHEDPUR" },
  { value: "JAMTARA", label: "JAMTARA" },
  { value: "JAMUHA", label: "JAMUHA" },
  { value: "JAMUI", label: "JAMUI" },
  { value: "JAMWARAMGARH", label: "JAMWARAMGARH" },
  { value: "JAN MIRI BOR GAON", label: "JAN MIRI BOR GAON" },
  { value: "JANDIALAGURU", label: "JANDIALAGURU" },
  { value: "JANDIALAMANJKI", label: "JANDIALAMANJKI" },
  { value: "JANGALPARA", label: "JANGALPARA" },
  { value: "JANGAON", label: "JANGAON" },
  { value: "JANGAREDDIGUDEM", label: "JANGAREDDIGUDEM" },
  { value: "JANGIPUR", label: "JANGIPUR" },
  { value: "JANGLHAKEEMNO2", label: "JANGLHAKEEMNO2" },
  { value: "JANJGIR", label: "JANJGIR" },
  { value: "JANJGIR-CHAMPA", label: "JANJGIR-CHAMPA" },
  { value: "JANJGIRCHAMPA", label: "JANJGIRCHAMPA" },
  { value: "JANPUR", label: "JANPUR" },
  { value: "JAORA", label: "JAORA" },
  { value: "JARWAL", label: "JARWAL" },
  { value: "JASANA", label: "JASANA" },
  { value: "JASDAN", label: "JASDAN" },
  { value: "JASPUR", label: "JASPUR" },
  { value: "JASSUR", label: "JASSUR" },
  { value: "JASWANTEHSIL", label: "JASWANTEHSIL" },
  { value: "JATH", label: "JATH" },
  { value: "JATNI", label: "JATNI" },
  { value: "JATTARI", label: "JATTARI" },
  { value: "JAUNPUR", label: "JAUNPUR" },
  { value: "JAWAD", label: "JAWAD" },
  { value: "JAWAHARNAGAR", label: "JAWAHARNAGAR" },
  { value: "JAWAL", label: "JAWAL" },
  { value: "JAWALAMUKHI", label: "JAWALAMUKHI" },
  { value: "JAWALI", label: "JAWALI" },
  { value: "JAWHAR", label: "JAWHAR" },
  { value: "JAYANKONDAM", label: "JAYANKONDAM" },
  { value: "JAYASHANKAR", label: "JAYASHANKAR" },
  { value: "JEHANABAD", label: "JEHANABAD" },
  { value: "JEJURI", label: "JEJURI" },
  { value: "JETPUR", label: "JETPUR" },
  { value: "JETPUR-PAVI", label: "JETPUR-PAVI" },
  { value: "JEVARGI", label: "JEVARGI" },
  { value: "JEYPORE", label: "JEYPORE" },
  { value: "JHABUA", label: "JHABUA" },
  { value: "JHAJJAR", label: "JHAJJAR" },
  { value: "JHAKRI", label: "JHAKRI" },
  { value: "JHALAWAR", label: "JHALAWAR" },
  { value: "JHALOD", label: "JHALOD" },
  { value: "JHAMBUGHODA", label: "JHAMBUGHODA" },
  { value: "JHANDUTA", label: "JHANDUTA" },
  { value: "JHANGIRABAD", label: "JHANGIRABAD" },
  { value: "JHANJHERI", label: "JHANJHERI" },
  { value: "JHANSI", label: "JHANSI" },
  { value: "JHANSIRLY.SETTL", label: "JHANSIRLY.SETTL" },
  { value: "JHARGRAM", label: "JHARGRAM" },
  { value: "JHARKHAND", label: "JHARKHAND" },
  { value: "JHAROL", label: "JHAROL" },
  { value: "JHARSUGUDA", label: "JHARSUGUDA" },
  { value: "JHINJHAK", label: "JHINJHAK" },
  { value: "JHINJHIPAHARI", label: "JHINJHIPAHARI" },
  { value: "JHOREHAT", label: "JHOREHAT" },
  { value: "JHUMRITELAIYA", label: "JHUMRITELAIYA" },
  { value: "JHUNJHUNU", label: "JHUNJHUNU" },
  { value: "JIND", label: "JIND" },
  { value: "JIRAPUR", label: "JIRAPUR" },
  { value: "JIRIBAM", label: "JIRIBAM" },
  { value: "JOBAT", label: "JOBAT" },
  { value: "JOBNER", label: "JOBNER" },
  { value: "JODHAN", label: "JODHAN" },
  { value: "JODHPUR", label: "JODHPUR" },
  { value: "JOGBANI", label: "JOGBANI" },
  { value: "JOGINDERNAGAR", label: "JOGINDERNAGAR" },
  { value: "JOGIPET", label: "JOGIPET" },
  { value: "JOLARPET", label: "JOLARPET" },
  { value: "JONAI", label: "JONAI" },
  { value: "JORETHANG", label: "JORETHANG" },
  { value: "JORHAT", label: "JORHAT" },
  { value: "JOSHIMATH", label: "JOSHIMATH" },
  { value: "JOURAKHURD", label: "JOURAKHURD" },
  { value: "JOURIAN", label: "JOURIAN" },
  { value: "JOWAI", label: "JOWAI" },
  { value: "JOYA", label: "JOYA" },
  { value: "JOYPUR", label: "JOYPUR" },
  { value: "JPNAGAR", label: "JPNAGAR" },
  { value: "JUBBAL", label: "JUBBAL" },
  { value: "JUGAULI", label: "JUGAULI" },
  { value: "JUKKAL", label: "JUKKAL" },
  { value: "JULANA", label: "JULANA" },
  { value: "JUNAGADH", label: "JUNAGADH" },
  { value: "JUNGA", label: "JUNGA" },
  { value: "JUNNAR", label: "JUNNAR" },
  { value: "JYOTIKHURIA", label: "JYOTIKHURIA" },
  { value: "Jabera(CT)", label: "Jabera(CT)" },
  { value: "Jafarabad(NP)", label: "Jafarabad(NP)" },
  { value: "Jafrabad(CT)", label: "Jafrabad(CT)" },
  { value: "Jafrabad(M)", label: "Jafrabad(M)" },
  { value: "Jagadishpur(CT)", label: "Jagadishpur(CT)" },
  { value: "Jagannathpur(CT)", label: "Jagannathpur(CT)" },
  { value: "Jagjeetpur(CT)", label: "Jagjeetpur(CT)" },
  { value: "Jagner(NP)", label: "Jagner(NP)" },
  { value: "Jahangirabad(NPP)", label: "Jahangirabad(NPP)" },
  { value: "Jahangirpur(NP)", label: "Jahangirpur(NP)" },
  { value: "Jahazpur(M)", label: "Jahazpur(M)" },
  { value: "Jaintia Hills", label: "Jaintia Hills" },
  { value: "Jais(NPP)", label: "Jais(NPP)" },
  { value: "Jaithara(NP)", label: "Jaithara(NP)" },
  { value: "Jaithari(NP)", label: "Jaithari(NP)" },
  { value: "Jaitpur(CT)", label: "Jaitpur(CT)" },
  { value: "JalaKendua(CT)", label: "JalaKendua(CT)" },
  { value: "JalalPatti(CT)", label: "JalalPatti(CT)" },
  { value: "Jalalabad(NP)", label: "Jalalabad(NP)" },
  { value: "Jalalabad(NPP)", label: "Jalalabad(NPP)" },
  { value: "Jalali(NP)", label: "Jalali(NP)" },
  { value: "Jalalpur(NPP)", label: "Jalalpur(NPP)" },
  { value: "JalalpurDehat(CT)", label: "JalalpurDehat(CT)" },
  { value: "Jalesar(NPP)", label: "Jalesar(NPP)" },
  { value: "Jaluidanga(CT)", label: "Jaluidanga(CT)" },
  { value: "Jalukie(TC)", label: "Jalukie(TC)" },
  { value: "Jamshila(CT)", label: "Jamshila(CT)" },
  { value: "Jamtara(CT)", label: "Jamtara(CT)" },
  { value: "JamwaRamgarh(CT)", label: "JamwaRamgarh(CT)" },
  { value: "Jandli(Part)(113)(CT)", label: "Jandli(Part)(113)(CT)" },
  { value: "Jangalpur(CT)", label: "Jangalpur(CT)" },
  { value: "Jangipur(NP)", label: "Jangipur(NP)" },
  { value: "Janjgir Champa", label: "Janjgir Champa" },
  { value: "JankiNagar(CT)", label: "JankiNagar(CT)" },
  { value: "Jansath(NP)", label: "Jansath(NP)" },
  { value: "JaridihBazar(CT)", label: "JaridihBazar(CT)" },
  { value: "Jarwal(NP)", label: "Jarwal(NP)" },
  { value: "Jasai(CT)", label: "Jasai(CT)" },
  { value: "Jasra(CT)", label: "Jasra(CT)" },
  { value: "Jasrana(NP)", label: "Jasrana(NP)" },
  { value: "Jaswantnagar(NPP)", label: "Jaswantnagar(NPP)" },
  { value: "Jatara(NP)", label: "Jatara(NP)" },
  { value: "Jatragachhi(CT)", label: "Jatragachhi(CT)" },
  { value: "Jawad(NP)", label: "Jawad(NP)" },
  { value: "Jawar(NP)", label: "Jawar(NP)" },
  { value: "Jaynagar(CT)", label: "Jaynagar(CT)" },
  { value: "JaypurBil(CT)", label: "JaypurBil(CT)" },
  { value: "Jaysingpur(MCl)", label: "Jaysingpur(MCl)" },
  { value: "Jemari(J.K.NagarTownship)(CT)", label: "Jemari(J.K.NagarTownship)(CT)" },
  { value: "JeronKhalsa(NP)", label: "JeronKhalsa(NP)" },
  { value: "Jewar(NP)", label: "Jewar(NP)" },
  { value: "Jhabrera(NP)", label: "Jhabrera(NP)" },
  { value: "Jhagarwas(CT)", label: "Jhagarwas(CT)" },
  { value: "JhagraPt.III(CT)", label: "JhagraPt.III(CT)" },
  { value: "Jhalu(NP)", label: "Jhalu(NP)" },
  { value: "JharodaMajraBurari(CT)", label: "JharodaMajraBurari(CT)" },
  { value: "Jhinjhak(NP)", label: "Jhinjhak(NP)" },
  { value: "Jhinjhana(NP)", label: "Jhinjhana(NP)" },
  { value: "Jhinkpani(CT)", label: "Jhinkpani(CT)" },
  { value: "Jhundpura(NP)", label: "Jhundpura(NP)" },
  { value: "Jhusi(NP)", label: "Jhusi(NP)" },
  { value: "JhusiKohna(CT)", label: "JhusiKohna(CT)" },
  { value: "Jillalguda(CT)", label: "Jillalguda(CT)" },
  { value: "Jiran(NP)", label: "Jiran(NP)" },
  { value: "Jirapur(NP)", label: "Jirapur(NP)" },
  { value: "Jiribam(MCl)", label: "Jiribam(MCl)" },
  { value: "Jiwangarh(CT)", label: "Jiwangarh(CT)" },
  { value: "Jiyanpur(NP)", label: "Jiyanpur(NP)" },
  { value: "Jobat(NP)", label: "Jobat(NP)" },
  { value: "Jobner(M)", label: "Jobner(M)" },
  { value: "Jodhan(CT)", label: "Jodhan(CT)" },
  { value: "Joida", label: "Joida" },
  { value: "Jonk(CT)", label: "Jonk(CT)" },
  { value: "Joura(NP)", label: "Joura(NP)" },
  { value: "Jugsalai(M)", label: "Jugsalai(M)" },
  { value: "Jujarsaha(CT)", label: "Jujarsaha(CT)" },
  { value: "Junnar(MCl)", label: "Junnar(MCl)" },
  { value: "Jutogh(CB)", label: "Jutogh(CB)" },
  { value: "Jyotiba Phule nagar", label: "Jyotiba Phule nagar" },
  { value: "KABI", label: "KABI" },
  { value: "KACHCHH", label: "KACHCHH" },
  { value: "KACHNALGOSAIN", label: "KACHNALGOSAIN" },
  { value: "KADABA", label: "KADABA" },
  { value: "KADAMBAGACHI", label: "KADAMBAGACHI" },
  { value: "KADAMTAL", label: "KADAMTAL" },
  { value: "KADANA", label: "KADANA" },
  { value: "KADANNAPPALLY", label: "KADANNAPPALLY" },
  { value: "KADAPA", label: "KADAPA" },
  { value: "KADEGAON", label: "KADEGAON" },
  { value: "KADI", label: "KADI" },
  { value: "KADIRI", label: "KADIRI" },
  { value: "KADIRVEDU", label: "KADIRVEDU" },
  { value: "KADKOL", label: "KADKOL" },
  { value: "KADMA", label: "KADMA" },
  { value: "KADMATISLAND", label: "KADMATISLAND" },
  { value: "KADTHAL", label: "KADTHAL" },
  { value: "KADUR", label: "KADUR" },
  { value: "KAGAROL", label: "KAGAROL" },
  { value: "KAGAZNAGAR", label: "KAGAZNAGAR" },
  { value: "KAHALGAON", label: "KAHALGAON" },
  { value: "KAHNUWAN", label: "KAHNUWAN" },
  { value: "KAIKALURU", label: "KAIKALURU" },
  { value: "KAILASAHAR", label: "KAILASAHAR" },
  { value: "KAILASHAHAR", label: "KAILASHAHAR" },
  { value: "KAIMGANJ", label: "KAIMGANJ" },
  { value: "KAIMUR", label: "KAIMUR" },
  { value: "KAIMUR BHABUA", label: "KAIMUR BHABUA" },
  { value: "KAIPAMANGALAM", label: "KAIPAMANGALAM" },
  { value: "KAISERGANJ", label: "KAISERGANJ" },
  { value: "KAITHAL", label: "KAITHAL" },
  { value: "KAKANPUR", label: "KAKANPUR" },
  { value: "KAKARMATA", label: "KAKARMATA" },
  { value: "KAKCHING", label: "KAKCHING" },
  { value: "KAKINADA", label: "KAKINADA" },
  { value: "KAKKALAPALLERURAL", label: "KAKKALAPALLERURAL" },
  { value: "KAKKATTIL", label: "KAKKATTIL" },
  { value: "KAKORI", label: "KAKORI" },
  { value: "KAKRI", label: "KAKRI" },
  { value: "KALAAMB", label: "KALAAMB" },
  { value: "KALABARI", label: "KALABARI" },
  { value: "KALABURAGI", label: "KALABURAGI" },
  { value: "KALADGI", label: "KALADGI" },
  { value: "KALAHANDI", label: "KALAHANDI" },
  { value: "KALAIGAON", label: "KALAIGAON" },
  { value: "KALAIN", label: "KALAIN" },
  { value: "KALAKOTE", label: "KALAKOTE" },
  { value: "KALAMESHWAR", label: "KALAMESHWAR" },
  { value: "KALANAUR", label: "KALANAUR" },
  { value: "KALANAUR(YAMUNANAGAR)", label: "KALANAUR(YAMUNANAGAR)" },
  { value: "KALANIVOIPATTI", label: "KALANIVOIPATTI" },
  { value: "KALANJOOR", label: "KALANJOOR" },
  { value: "KALAPATHAR", label: "KALAPATHAR" },
  { value: "KALASANGHIAN", label: "KALASANGHIAN" },
  { value: "KALAVAD", label: "KALAVAD" },
  { value: "KALAYAT", label: "KALAYAT" },
  { value: "KALGACHIA", label: "KALGACHIA" },
  { value: "KALIABOR", label: "KALIABOR" },
  { value: "KALIKADAVU", label: "KALIKADAVU" },
  { value: "KALIMPONG", label: "KALIMPONG" },
  { value: "KALKA", label: "KALKA" },
  { value: "KALLACHI", label: "KALLACHI" },
  { value: "KALLAKURICHI", label: "KALLAKURICHI" },
  { value: "KALLAM", label: "KALLAM" },
  { value: "KALLAMBALAM", label: "KALLAMBALAM" },
  { value: "KALLUMUTTY", label: "KALLUMUTTY" },
  { value: "KALNA", label: "KALNA" },
  { value: "KALOL", label: "KALOL" },
  { value: "KALPAKKAM", label: "KALPAKKAM" },
  { value: "KALPETTA", label: "KALPETTA" },
  { value: "KALWAKURTHY", label: "KALWAKURTHY" },
  { value: "KALWAN", label: "KALWAN" },
  { value: "KALWAR", label: "KALWAR" },
  { value: "KALWARI", label: "KALWARI" },
  { value: "KALYAN", label: "KALYAN" },
  { value: "KALYANADURGAM", label: "KALYANADURGAM" },
  { value: "KALYANI", label: "KALYANI" },
  { value: "KAMAKHYANAGAR", label: "KAMAKHYANAGAR" },
  { value: "KAMALPUR", label: "KAMALPUR" },
  { value: "KAMARBANDHA", label: "KAMARBANDHA" },
  { value: "KAMAREDDY", label: "KAMAREDDY" },
  { value: "KAMARPUKUR", label: "KAMARPUKUR" },
  { value: "KAMATAGI", label: "KAMATAGI" },
  { value: "KAMAYAGOUNDANPATTI", label: "KAMAYAGOUNDANPATTI" },
  { value: "KAMPIL", label: "KAMPIL" },
  { value: "KAMPURTOWN", label: "KAMPURTOWN" },
  { value: "KAMRAJNAGAR", label: "KAMRAJNAGAR" },
  { value: "KAMREJ", label: "KAMREJ" },
  { value: "KAMRUP", label: "KAMRUP" },
  { value: "KAMRUP METROPOLITAN", label: "KAMRUP METROPOLITAN" },
  { value: "KAMSHET", label: "KAMSHET" },
  { value: "KANAKAPURA", label: "KANAKAPURA" },
  { value: "KANCHANPUR", label: "KANCHANPUR" },
  { value: "KANCHIKACHERLA", label: "KANCHIKACHERLA" },
  { value: "KANCHIPURAM", label: "KANCHIPURAM" },
  { value: "KANDAGHAT", label: "KANDAGHAT" },
  { value: "KANDHAMAL", label: "KANDHAMAL" },
  { value: "KANDI", label: "KANDI" },
  { value: "KANDLA", label: "KANDLA" },
  { value: "KANDRI", label: "KANDRI" },
  { value: "KANDUKUR", label: "KANDUKUR" },
  { value: "KANGAN", label: "KANGAN" },
  { value: "KANGEYAM", label: "KANGEYAM" },
  { value: "KANGRA", label: "KANGRA" },
  { value: "KANHAN", label: "KANHAN" },
  { value: "KANHANGAD", label: "KANHANGAD" },
  { value: "KANIGIRI", label: "KANIGIRI" },
  { value: "KANINA", label: "KANINA" },
  { value: "KANJIRAPALLY", label: "KANJIRAPALLY" },
  { value: "KANJIRAPPALLY", label: "KANJIRAPPALLY" },
  { value: "KANKAVLI", label: "KANKAVLI" },
  { value: "KANKE", label: "KANKE" },
  { value: "KANKER", label: "KANKER" },
  { value: "KANKHAL", label: "KANKHAL" },
  { value: "KANKROLI", label: "KANKROLI" },
  { value: "KANNAD", label: "KANNAD" },
  { value: "KANNANENTHAL", label: "KANNANENTHAL" },
  { value: "KANNAUJ", label: "KANNAUJ" },
  { value: "KANNIYAKUMARI", label: "KANNIYAKUMARI" },
  { value: "KANNOD", label: "KANNOD" },
  { value: "KANNUR", label: "KANNUR" },
  { value: "KANODAR", label: "KANODAR" },
  { value: "KANORE", label: "KANORE" },
  { value: "KANOTA", label: "KANOTA" },
  { value: "KANPUR", label: "KANPUR" },
  { value: "KANPUR DEHAT", label: "KANPUR DEHAT" },
  { value: "KANPUR NAGAR", label: "KANPUR NAGAR" },
  { value: "KANSAD", label: "KANSAD" },
  { value: "KANSAPUR", label: "KANSAPUR" },
  { value: "KANSHIRAM NAGAR", label: "KANSHIRAM NAGAR" },
  { value: "KANTABAJI", label: "KANTABAJI" },
  { value: "KANTH", label: "KANTH" },
  { value: "KANYAKUMARI", label: "KANYAKUMARI" },
  { value: "KAPADVANJ", label: "KAPADVANJ" },
  { value: "KAPASAN", label: "KAPASAN" },
  { value: "KAPRADA", label: "KAPRADA" },
  { value: "KAPREN", label: "KAPREN" },
  { value: "KAPTANGANJ", label: "KAPTANGANJ" },
  { value: "KAPURTHALA", label: "KAPURTHALA" },
  { value: "KARAD", label: "KARAD" },
  { value: "KARAICHUTHUPUDUR", label: "KARAICHUTHUPUDUR" },
  { value: "KARAIKAL", label: "KARAIKAL" },
  { value: "KARAIKUDI", label: "KARAIKUDI" },
  { value: "KARAMADAI", label: "KARAMADAI" },
  { value: "KARANJA", label: "KARANJA" },
  { value: "KARANJETURFSATARA", label: "KARANJETURFSATARA" },
  { value: "KARANJIA", label: "KARANJIA" },
  { value: "KARANPRAYAG", label: "KARANPRAYAG" },
  { value: "KARANPUR", label: "KARANPUR" },
  { value: "KARAULI", label: "KARAULI" },
  { value: "KARAVALIMADAPUR", label: "KARAVALIMADAPUR" },
  { value: "KARBI ANGLONG", label: "KARBI ANGLONG" },
  { value: "KARBIANGLONG", label: "KARBIANGLONG" },
  { value: "KARCHANA", label: "KARCHANA" },
  { value: "KARDHAN", label: "KARDHAN" },
  { value: "KARELI", label: "KARELI" },
  { value: "KAREPALLI", label: "KAREPALLI" },
  { value: "KARERA", label: "KARERA" },
  { value: "KARGAINA", label: "KARGAINA" },
  { value: "KARGIL", label: "KARGIL" },
  { value: "KARHAL", label: "KARHAL" },
  { value: "KARIM NAGAR", label: "KARIM NAGAR" },
  { value: "KARIMANNOOR", label: "KARIMANNOOR" },
  { value: "KARIMGANJ", label: "KARIMGANJ" },
  { value: "KARIMNAGAR", label: "KARIMNAGAR" },
  { value: "KARIMPUR", label: "KARIMPUR" },
  { value: "KARIWALI", label: "KARIWALI" },
  { value: "KARJAN", label: "KARJAN" },
  { value: "KARJAT", label: "KARJAT" },
  { value: "KARJAT(AHMEDNAGAR)", label: "KARJAT(AHMEDNAGAR)" },
  { value: "KARKALA", label: "KARKALA" },
  { value: "KARLI", label: "KARLI" },
  { value: "KARMA", label: "KARMA" },
  { value: "KARMAD", label: "KARMAD" },
  { value: "KARMALA", label: "KARMALA" },
  { value: "KARNAL", label: "KARNAL" },
  { value: "KARNAPRAYAG", label: "KARNAPRAYAG" },
  { value: "KARSOG", label: "KARSOG" },
  { value: "KARTARPUR", label: "KARTARPUR" },
  { value: "KARUKACHAL", label: "KARUKACHAL" },
  { value: "KARUMATHAMPATTI", label: "KARUMATHAMPATTI" },
  { value: "KARUNAGAPPALLI", label: "KARUNAGAPPALLI" },
  { value: "KARUNGAL", label: "KARUNGAL" },
  { value: "KARUNGAPALLY", label: "KARUNGAPALLY" },
  { value: "KARUR", label: "KARUR" },
  { value: "KARWAR", label: "KARWAR" },
  { value: "KARWI", label: "KARWI" },
  { value: "KASAL", label: "KASAL" },
  { value: "KASARA", label: "KASARA" },
  { value: "KASARAGOD", label: "KASARAGOD" },
  { value: "KASAULI", label: "KASAULI" },
  { value: "KASDOL", label: "KASDOL" },
  { value: "KASGANJ", label: "KASGANJ" },
  { value: "KASHIPUR", label: "KASHIPUR" },
  { value: "KASIABAZAAR", label: "KASIABAZAAR" },
  { value: "KASIMPURPOWERHOUSECOLONY", label: "KASIMPURPOWERHOUSECOLONY" },
  { value: "KASUMPTI", label: "KASUMPTI" },
  { value: "KATAGERI", label: "KATAGERI" },
  { value: "KATAGISHAHAPUR", label: "KATAGISHAHAPUR" },
  { value: "KATAI", label: "KATAI" },
  { value: "KATAKA", label: "KATAKA" },
  { value: "KATARAM", label: "KATARAM" },
  { value: "KATERA", label: "KATERA" },
  { value: "KATGHORA", label: "KATGHORA" },
  { value: "KATHAURA", label: "KATHAURA" },
  { value: "KATHGHARIYA", label: "KATHGHARIYA" },
  { value: "KATHGODAM", label: "KATHGODAM" },
  { value: "KATHLAL", label: "KATHLAL" },
  { value: "KATHUA", label: "KATHUA" },
  { value: "KATHUNANGAL", label: "KATHUNANGAL" },
  { value: "KATHURA", label: "KATHURA" },
  { value: "KATIGARA", label: "KATIGARA" },
  { value: "KATIHAR", label: "KATIHAR" },
  { value: "KATLIA", label: "KATLIA" },
  { value: "KATLICHERRA", label: "KATLICHERRA" },
  { value: "KATNI", label: "KATNI" },
  { value: "KATOL", label: "KATOL" },
  { value: "KATRA", label: "KATRA" },
  { value: "KATRAS", label: "KATRAS" },
  { value: "KATTA", label: "KATTA" },
  { value: "KATTAKKADA", label: "KATTAKKADA" },
  { value: "KATTAPANNA", label: "KATTAPANNA" },
  { value: "KATTAPPANA", label: "KATTAPPANA" },
  { value: "KATTUMANNARKOIL", label: "KATTUMANNARKOIL" },
  { value: "KATWA", label: "KATWA" },
  { value: "KAULAKHA", label: "KAULAKHA" },
  { value: "KAUSHAMBI", label: "KAUSHAMBI" },
  { value: "KAVALI", label: "KAVALI" },
  { value: "KAVANT", label: "KAVANT" },
  { value: "KAVATHEMAHANKAL", label: "KAVATHEMAHANKAL" },
  { value: "KAVILTALI", label: "KAVILTALI" },
  { value: "KAWARDHA", label: "KAWARDHA" },
  { value: "KAYAKUCHI", label: "KAYAKUCHI" },
  { value: "KAYAMKULAM", label: "KAYAMKULAM" },
  { value: "KAYATHAR", label: "KAYATHAR" },
  { value: "KAZIRANGA", label: "KAZIRANGA" },
  { value: "KEELAKARAI", label: "KEELAKARAI" },
  { value: "KEERANUR", label: "KEERANUR" },
  { value: "KEESARA", label: "KEESARA" },
  { value: "KEEZHAPAVUR", label: "KEEZHAPAVUR" },
  { value: "KEKRI", label: "KEKRI" },
  { value: "KELAKHERA", label: "KELAKHERA" },
  { value: "KELAMBAKKAM", label: "KELAMBAKKAM" },
  { value: "KELWA", label: "KELWA" },
  { value: "KENDRAPARA", label: "KENDRAPARA" },
  { value: "KENDUJHAR", label: "KENDUJHAR" },
  { value: "KEONJHAR", label: "KEONJHAR" },
  { value: "KEOTA", label: "KEOTA" },
  { value: "KERUR", label: "KERUR" },
  { value: "KESARIYA", label: "KESARIYA" },
  { value: "KESHARIPUR", label: "KESHARIPUR" },
  { value: "KESHOD", label: "KESHOD" },
  { value: "KESHPUR", label: "KESHPUR" },
  { value: "KESRISINGHPUR", label: "KESRISINGHPUR" },
  { value: "KETHUN", label: "KETHUN" },
  { value: "KEVADIA", label: "KEVADIA" },
  { value: "KHACHROD", label: "KHACHROD" },
  { value: "KHADIA", label: "KHADIA" },
  { value: "KHADKI", label: "KHADKI" },
  { value: "KHADURSAHIB", label: "KHADURSAHIB" },
  { value: "KHAGA", label: "KHAGA" },
  { value: "KHAGARIA", label: "KHAGARIA" },
  { value: "KHAGAUL", label: "KHAGAUL" },
  { value: "KHAILSANA", label: "KHAILSANA" },
  { value: "KHAIR", label: "KHAIR" },
  { value: "KHAIRAGARH", label: "KHAIRAGARH" },
  { value: "KHAIRI", label: "KHAIRI" },
  { value: "KHAIRTHAL", label: "KHAIRTHAL" },
  { value: "KHAJUWALA", label: "KHAJUWALA" },
  { value: "KHALARI", label: "KHALARI" },
  { value: "KHALILABAD", label: "KHALILABAD" },
  { value: "KHALINI", label: "KHALINI" },
  { value: "KHALIYA", label: "KHALIYA" },
  { value: "KHAMANON", label: "KHAMANON" },
  { value: "KHAMARI", label: "KHAMARI" },
  { value: "KHAMARIYA", label: "KHAMARIYA" },
  { value: "KHAMBHALIA", label: "KHAMBHALIA" },
  { value: "KHAMBHAT", label: "KHAMBHAT" },
  { value: "KHAMGAON", label: "KHAMGAON" },
  { value: "KHAMMAM", label: "KHAMMAM" },
  { value: "KHANAKUL", label: "KHANAKUL" },
  { value: "KHANAPUR", label: "KHANAPUR" },
  { value: "KHANDALA", label: "KHANDALA" },
  { value: "KHANDAR", label: "KHANDAR" },
  { value: "KHANDAULI", label: "KHANDAULI" },
  { value: "KHANDBARA", label: "KHANDBARA" },
  { value: "KHANDELA", label: "KHANDELA" },
  { value: "KHANDWA", label: "KHANDWA" },
  { value: "KHANIADHANA", label: "KHANIADHANA" },
  { value: "KHANJARPUR", label: "KHANJARPUR" },
  { value: "KHANNA", label: "KHANNA" },
  { value: "KHANPUR", label: "KHANPUR" },
  { value: "KHANPURDHANI", label: "KHANPURDHANI" },
  { value: "KHANSAHIB", label: "KHANSAHIB" },
  { value: "KHANVEL", label: "KHANVEL" },
  { value: "KHARAGHODA", label: "KHARAGHODA" },
  { value: "KHARAGPUR", label: "KHARAGPUR" },
  { value: "KHARAKMAF", label: "KHARAKMAF" },
  { value: "KHARAN", label: "KHARAN" },
  { value: "KHARAR", label: "KHARAR" },
  { value: "KHARBAO", label: "KHARBAO" },
  { value: "KHARDI", label: "KHARDI" },
  { value: "KHAREPATAN", label: "KHAREPATAN" },
  { value: "KHARGHAR", label: "KHARGHAR" },
  { value: "KHARGONE", label: "KHARGONE" },
  { value: "KHARIAR", label: "KHARIAR" },
  { value: "KHARKHODA", label: "KHARKHODA" },
  { value: "KHARORA", label: "KHARORA" },
  { value: "KHARSIA", label: "KHARSIA" },
  { value: "KHARUPETIA", label: "KHARUPETIA" },
  { value: "KHASA", label: "KHASA" },
  { value: "KHASDIPILA", label: "KHASDIPILA" },
  { value: "KHATAULI", label: "KHATAULI" },
  { value: "KHATEGAON", label: "KHATEGAON" },
  { value: "KHATIMA", label: "KHATIMA" },
  { value: "KHATKHATI", label: "KHATKHATI" },
  { value: "KHATRA", label: "KHATRA" },
  { value: "KHED", label: "KHED" },
  { value: "KHEDA", label: "KHEDA" },
  { value: "KHEDBRAHMA", label: "KHEDBRAHMA" },
  { value: "KHEJROLI", label: "KHEJROLI" },
  { value: "KHEJURI", label: "KHEJURI" },
  { value: "KHEKRA", label: "KHEKRA" },
  { value: "KHERALU", label: "KHERALU" },
  { value: "KHERGAM", label: "KHERGAM" },
  { value: "KHERI", label: "KHERI" },
  { value: "KHERLI", label: "KHERLI" },
  { value: "KHERWARACHHAONI", label: "KHERWARACHHAONI" },
  { value: "KHETASARAI", label: "KHETASARAI" },
  { value: "KHETRI", label: "KHETRI" },
  { value: "KHIRAIJURI", label: "KHIRAIJURI" },
  { value: "KHLIEHRIAT", label: "KHLIEHRIAT" },
  { value: "KHOPOLI", label: "KHOPOLI" },
  { value: "KHORDA", label: "KHORDA" },
  { value: "KHORDHA", label: "KHORDHA" },
  { value: "KHORIBARI", label: "KHORIBARI" },
  { value: "KHORLIM", label: "KHORLIM" },
  { value: "KHOTHRAN", label: "KHOTHRAN" },
  { value: "KHOWAI", label: "KHOWAI" },
  { value: "KHOWANG", label: "KHOWANG" },
  { value: "KHUNTI", label: "KHUNTI" },
  { value: "KHURJA", label: "KHURJA" },
  { value: "KHUTAR", label: "KHUTAR" },
  { value: "KICHHA", label: "KICHHA" },
  { value: "KILIMANOOR", label: "KILIMANOOR" },
  { value: "KILLA-PARDI", label: "KILLA-PARDI" },
  { value: "KILLIANWALI", label: "KILLIANWALI" },
  { value: "KIM", label: "KIM" },
  { value: "KINATHUKADAVU", label: "KINATHUKADAVU" },
  { value: "KINNAUR", label: "KINNAUR" },
  { value: "KINWAT", label: "KINWAT" },
  { value: "KIRAOLI", label: "KIRAOLI" },
  { value: "KISHANGANJ", label: "KISHANGANJ" },
  { value: "KISHANGARH", label: "KISHANGARH" },
  { value: "KISHTWAR", label: "KISHTWAR" },
  { value: "KITHAUR", label: "KITHAUR" },
  { value: "KITTUR", label: "KITTUR" },
  { value: "KIYAMGEI", label: "KIYAMGEI" },
  { value: "KOCHI", label: "KOCHI" },
  { value: "KODAD", label: "KODAD" },
  { value: "KODAIKANAL", label: "KODAIKANAL" },
  { value: "KODAIROAD", label: "KODAIROAD" },
  { value: "KODAKARA", label: "KODAKARA" },
  { value: "KODALLA", label: "KODALLA" },
  { value: "KODANGAL", label: "KODANGAL" },
  { value: "KODERMA", label: "KODERMA" },
  { value: "KODINAR", label: "KODINAR" },
  { value: "KODIYAL", label: "KODIYAL" },
  { value: "KODUMUDI", label: "KODUMUDI" },
  { value: "KODUNGALLUR", label: "KODUNGALLUR" },
  { value: "KODUVALLY", label: "KODUVALLY" },
  { value: "KOHARA", label: "KOHARA" },
  { value: "KOHIMA", label: "KOHIMA" },
  { value: "KOIRIPUR", label: "KOIRIPUR" },
  { value: "KOKERNAG", label: "KOKERNAG" },
  { value: "KOKRAJHAR", label: "KOKRAJHAR" },
  { value: "KOLAD", label: "KOLAD" },
  { value: "KOLAGHAT", label: "KOLAGHAT" },
  { value: "KOLAR", label: "KOLAR" },
  { value: "KOLASIB", label: "KOLASIB" },
  { value: "KOLAYAT", label: "KOLAYAT" },
  { value: "KOLENCHERY", label: "KOLENCHERY" },
  { value: "KOLHAPUR", label: "KOLHAPUR" },
  { value: "KOLKATA", label: "KOLKATA" },
  { value: "KOLLAM", label: "KOLLAM" },
  { value: "KOLLAPUR", label: "KOLLAPUR" },
  { value: "KOLLEGAL", label: "KOLLEGAL" },
  { value: "KOLLEGALA", label: "KOLLEGALA" },
  { value: "KOLLIDAM", label: "KOLLIDAM" },
  { value: "KOLUMAM", label: "KOLUMAM" },
  { value: "KOMPALLY", label: "KOMPALLY" },
  { value: "KONAJE", label: "KONAJE" },
  { value: "KONCH", label: "KONCH" },
  { value: "KONDAGAON", label: "KONDAGAON" },
  { value: "KONDAMALLEPALLY", label: "KONDAMALLEPALLY" },
  { value: "KONDHALI", label: "KONDHALI" },
  { value: "KONDLI", label: "KONDLI" },
  { value: "KONDOTTY", label: "KONDOTTY" },
  { value: "KONGAON", label: "KONGAON" },
  { value: "KONNI", label: "KONNI" },
  { value: "KONNUR", label: "KONNUR" },
  { value: "KOORGALLY", label: "KOORGALLY" },
  { value: "KOOTHATTUKULAM", label: "KOOTHATTUKULAM" },
  { value: "KOOTTANAD", label: "KOOTTANAD" },
  { value: "KOPARGAON", label: "KOPARGAON" },
  { value: "KOPPA", label: "KOPPA" },
  { value: "KOPPAL", label: "KOPPAL" },
  { value: "KOPPAM", label: "KOPPAM" },
  { value: "KOPPARURAL", label: "KOPPARURAL" },
  { value: "KORAON", label: "KORAON" },
  { value: "KORAPUT", label: "KORAPUT" },
  { value: "KORBA", label: "KORBA" },
  { value: "KOREADISTRICT", label: "KOREADISTRICT" },
  { value: "KOREGAONBHIMA", label: "KOREGAONBHIMA" },
  { value: "KORIANWALI", label: "KORIANWALI" },
  { value: "KORIYA", label: "KORIYA" },
  { value: "KORPANA", label: "KORPANA" },
  { value: "KORUKONDA", label: "KORUKONDA" },
  { value: "KORUTLA", label: "KORUTLA" },
  { value: "KOSAMBA", label: "KOSAMBA" },
  { value: "KOSGI", label: "KOSGI" },
  { value: "KOSI", label: "KOSI" },
  { value: "KOSLI", label: "KOSLI" },
  { value: "KOTA", label: "KOTA" },
  { value: "KOTAGIRI", label: "KOTAGIRI" },
  { value: "KOTAPADU", label: "KOTAPADU" },
  { value: "KOTAWALI", label: "KOTAWALI" },
  { value: "KOTDWAR", label: "KOTDWAR" },
  { value: "KOTHAGUDEM", label: "KOTHAGUDEM" },
  { value: "KOTHAGUDEM COLLS", label: "KOTHAGUDEM COLLS" },
  { value: "KOTHAKOTA", label: "KOTHAKOTA" },
  { value: "KOTHAMANGALAM", label: "KOTHAMANGALAM" },
  { value: "KOTHAVALASA", label: "KOTHAVALASA" },
  { value: "KOTISEKHAN", label: "KOTISEKHAN" },
  { value: "KOTKAPURA", label: "KOTKAPURA" },
  { value: "KOTKASIM", label: "KOTKASIM" },
  { value: "KOTKHAI", label: "KOTKHAI" },
  { value: "KOTLAMAHINGIRAN", label: "KOTLAMAHINGIRAN" },
  { value: "KOTMA", label: "KOTMA" },
  { value: "KOTPUTLI", label: "KOTPUTLI" },
  { value: "KOTTAKKAL", label: "KOTTAKKAL" },
  { value: "KOTTARAKKARA", label: "KOTTARAKKARA" },
  { value: "KOTTAYAM", label: "KOTTAYAM" },
  { value: "KOTTUR", label: "KOTTUR" },
  { value: "KOTULPUR", label: "KOTULPUR" },
  { value: "KOUNDAMPALAYAM", label: "KOUNDAMPALAYAM" },
  { value: "KOVAIPUDUR", label: "KOVAIPUDUR" },
  { value: "KOVILAMBAKKAM", label: "KOVILAMBAKKAM" },
  { value: "KOVILPATTI", label: "KOVILPATTI" },
  { value: "KOVVURU", label: "KOVVURU" },
  { value: "KOYILANDY", label: "KOYILANDY" },
  { value: "KOZHENCHERRY", label: "KOZHENCHERRY" },
  { value: "KOZHIKODE", label: "KOZHIKODE" },
  { value: "KRALPORA", label: "KRALPORA" },
  { value: "KRISHNA", label: "KRISHNA" },
  { value: "KRISHNAGIRI", label: "KRISHNAGIRI" },
  { value: "KRISHNANAGAR", label: "KRISHNANAGAR" },
  { value: "KRISHNARAJANAGARA", label: "KRISHNARAJANAGARA" },
  { value: "KRISHNARAJPETE", label: "KRISHNARAJPETE" },
  { value: "KRISHNARAYAPURAM", label: "KRISHNARAYAPURAM" },
  { value: "KSTPP JHALAWAR", label: "KSTPP JHALAWAR" },
  { value: "KSWU CAMPUS TORVI", label: "KSWU CAMPUS TORVI" },
  { value: "KUBERPUR", label: "KUBERPUR" },
  { value: "KUCHAMANCITY", label: "KUCHAMANCITY" },
  { value: "KUCHINDA", label: "KUCHINDA" },
  { value: "KUDAL", label: "KUDAL" },
  { value: "KUDAPPANAKUNNU", label: "KUDAPPANAKUNNU" },
  { value: "KUDAVASAL", label: "KUDAVASAL" },
  { value: "KUDITRE", label: "KUDITRE" },
  { value: "KUDUR", label: "KUDUR" },
  { value: "KUKARWADA", label: "KUKARWADA" },
  { value: "KUKSHI", label: "KUKSHI" },
  { value: "KULASEKHARAM", label: "KULASEKHARAM" },
  { value: "KULGAM", label: "KULGAM" },
  { value: "KULGERI", label: "KULGERI" },
  { value: "KULITHALAI", label: "KULITHALAI" },
  { value: "KULLU", label: "KULLU" },
  { value: "KULPAHAR", label: "KULPAHAR" },
  { value: "KULRI", label: "KULRI" },
  { value: "KUMARGHAT", label: "KUMARGHAT" },
  { value: "KUMARHATTI", label: "KUMARHATTI" },
  { value: "KUMARSAIN", label: "KUMARSAIN" },
  { value: "KUMBAKONAM", label: "KUMBAKONAM" },
  { value: "KUMILY", label: "KUMILY" },
  { value: "KUMTA", label: "KUMTA" },
  { value: "KUND", label: "KUND" },
  { value: "KUNDA", label: "KUNDA" },
  { value: "KUNDAPURA", label: "KUNDAPURA" },
  { value: "KUNDARA", label: "KUNDARA" },
  { value: "KUNDARKI", label: "KUNDARKI" },
  { value: "KUNDELI", label: "KUNDELI" },
  { value: "KUNDLI", label: "KUNDLI" },
  { value: "KUNDRATHUR", label: "KUNDRATHUR" },
  { value: "KUNIGAL", label: "KUNIGAL" },
  { value: "KUNIHAR", label: "KUNIHAR" },
  { value: "KUNNAMANGALAM", label: "KUNNAMANGALAM" },
  { value: "KUNNAMKULAM", label: "KUNNAMKULAM" },
  { value: "KUNWARGAON", label: "KUNWARGAON" },
  { value: "KUPWARA", label: "KUPWARA" },
  { value: "KURALI", label: "KURALI" },
  { value: "KURARARURAL", label: "KURARARURAL" },
  { value: "KURAWALI", label: "KURAWALI" },
  { value: "KURDUVADI", label: "KURDUVADI" },
  { value: "KURKHEDA", label: "KURKHEDA" },
  { value: "KURNOOL", label: "KURNOOL" },
  { value: "KURSEONG", label: "KURSEONG" },
  { value: "KURSI", label: "KURSI" },
  { value: "KURTHOUL", label: "KURTHOUL" },
  { value: "KURUD", label: "KURUD" },
  { value: "KURUKSHETRA", label: "KURUKSHETRA" },
  { value: "KURUMBAPATTI", label: "KURUMBAPATTI" },
  { value: "KURUNDWAD", label: "KURUNDWAD" },
  { value: "KURUNGKUMEY", label: "KURUNGKUMEY" },
  { value: "KURUPAM", label: "KURUPAM" },
  { value: "KURUVATTOOR", label: "KURUVATTOOR" },
  { value: "KURWAI", label: "KURWAI" },
  { value: "KUSHALGARH", label: "KUSHALGARH" },
  { value: "KUSHALNAGAR", label: "KUSHALNAGAR" },
  { value: "KUSHINAGAR", label: "KUSHINAGAR" },
  { value: "KUTHALAM", label: "KUTHALAM" },
  { value: "KUTHUPARAMBA", label: "KUTHUPARAMBA" },
  { value: "KUTTIADY", label: "KUTTIADY" },
  { value: "KYMORE", label: "KYMORE" },
  { value: "Kabnur(CT)", label: "Kabnur(CT)" },
  { value: "Kabrai(NP)", label: "Kabrai(NP)" },
  { value: "Kachhla(NP)", label: "Kachhla(NP)" },
  { value: "Kachigam(CT)", label: "Kachigam(CT)" },
  { value: "Kachnar(CT)", label: "Kachnar(CT)" },
  { value: "KachujanGaon(CT)", label: "KachujanGaon(CT)" },
  { value: "Kadambur(TP)", label: "Kadambur(TP)" },
  { value: "Kadi Mehsana", label: "Kadi Mehsana" },
  { value: "Kadipur(NP)", label: "Kadipur(NP)" },
  { value: "Kadirur(CT)", label: "Kadirur(CT)" },
  { value: "KadmaNo-II(CT)", label: "KadmaNo-II(CT)" },
  { value: "Kadwad(CT)", label: "Kadwad(CT)" },
  { value: "Kaijuri(CT)", label: "Kaijuri(CT)" },
  { value: "Kailaras(NP)", label: "Kailaras(NP)" },
  { value: "Kailashpur(CT)", label: "Kailashpur(CT)" },
  { value: "Kaimganj(NPP)", label: "Kaimganj(NPP)" },
  { value: "Kainoor(CT)", label: "Kainoor(CT)" },
  { value: "Kairana(NPP)", label: "Kairana(NPP)" },
  { value: "Kakarhati(NP)", label: "Kakarhati(NP)" },
  { value: "Kakati(CT)", label: "Kakati(CT)" },
  { value: "Kakaya(CT)", label: "Kakaya(CT)" },
  { value: "Kakching(MCl)", label: "Kakching(MCl)" },
  { value: "Kakkalur(CT)", label: "Kakkalur(CT)" },
  { value: "Kakkanad(CT)", label: "Kakkanad(CT)" },
  { value: "Kakkodi(CT)", label: "Kakkodi(CT)" },
  { value: "Kakod(NP)", label: "Kakod(NP)" },
  { value: "Kakori(NP)", label: "Kakori(NP)" },
  { value: "Kakrala(NPP)", label: "Kakrala(NPP)" },
  { value: "Kaladhungi(NP)", label: "Kaladhungi(NP)" },
  { value: "Kalaikunda(CT)", label: "Kalaikunda(CT)" },
  { value: "Kalamassery(M)", label: "Kalamassery(M)" },
  { value: "Kalanaur(MC)", label: "Kalanaur(MC)" },
  { value: "Kalapatti(TP)", label: "Kalapatti(TP)" },
  { value: "Kalaria(CT)", label: "Kalaria(CT)" },
  { value: "Kalher(CT)", label: "Kalher(CT)" },
  { value: "KalliPashchim(CT)", label: "KalliPashchim(CT)" },
  { value: "Kalliasseri(CT)", label: "Kalliasseri(CT)" },
  { value: "Kallipur(CT)", label: "Kallipur(CT)" },
  { value: "Kalliyoor(CT)", label: "Kalliyoor(CT)" },
  { value: "Kalmath(CT)", label: "Kalmath(CT)" },
  { value: "Kalpi(NPP)", label: "Kalpi(NPP)" },
  { value: "Kalugumalai(TP)", label: "Kalugumalai(TP)" },
  { value: "Kalundre(CT)", label: "Kalundre(CT)" },
  { value: "Kamalganj(NP)", label: "Kamalganj(NP)" },
  { value: "Kamareddy(M)", label: "Kamareddy(M)" },
  { value: "Kambe(CT)", label: "Kambe(CT)" },
  { value: "Kampil(NP)", label: "Kampil(NP)" },
  { value: "KampurTown(TC)", label: "KampurTown(TC)" },
  { value: "Kamranga(CT)", label: "Kamranga(CT)" },
  { value: "Kanad(NP)", label: "Kanad(NP)" },
  { value: "Kanadukathan(TP)", label: "Kanadukathan(TP)" },
  { value: "Kanakkampalayam(CT)", label: "Kanakkampalayam(CT)" },
  { value: "Kanapaka(CT)", label: "Kanapaka(CT)" },
  { value: "Kandanur(TP)", label: "Kandanur(TP)" },
  { value: "Kandari(CT)", label: "Kandari(CT)" },
  { value: "Kandharpur(CT)", label: "Kandharpur(CT)" },
  { value: "Kandhla", label: "Kandhla" },
  { value: "Kandhla(NPP)", label: "Kandhla(NPP)" },
  { value: "Kandra(CT)", label: "Kandra(CT)" },
  { value: "Kandwa(CT)", label: "Kandwa(CT)" },
  { value: "Kangeyanallur(CT)", label: "Kangeyanallur(CT)" },
  { value: "Kangpokpi(CT)", label: "Kangpokpi(CT)" },
  { value: "Kangrali(BK)(CT)", label: "Kangrali(BK)(CT)" },
  { value: "Kangrali(KH)(CT)", label: "Kangrali(KH)(CT)" },
  { value: "Kanhan(Pipri)(CT)", label: "Kanhan(Pipri)(CT)" },
  { value: "Kanina(MC)", label: "Kanina(MC)" },
  { value: "Kaniyur(CT)", label: "Kaniyur(CT)" },
  { value: "Kaniyur(TP)", label: "Kaniyur(TP)" },
  { value: "Kannankurichi(TP)", label: "Kannankurichi(TP)" },
  { value: "Kannauj(NPP)", label: "Kannauj(NPP)" },
  { value: "Kanota(CT)", label: "Kanota(CT)" },
  { value: "Kantaberia(CT)", label: "Kantaberia(CT)" },
  { value: "Kantaphod(NP)", label: "Kantaphod(NP)" },
  { value: "Kanuru(CT)", label: "Kanuru(CT)" },
  { value: "Kanwat(CT)", label: "Kanwat(CT)" },
  { value: "Kanwla(110)(CT)", label: "Kanwla(110)(CT)" },
  { value: "KapasHera(CT)", label: "KapasHera(CT)" },
  { value: "Kaptanganj(NP)", label: "Kaptanganj(NP)" },
  { value: "Kapuria(CT)", label: "Kapuria(CT)" },
  { value: "Karaipudur(CT)", label: "Karaipudur(CT)" },
  { value: "Karakulam(CT)", label: "Karakulam(CT)" },
  { value: "Karanpur(CT)", label: "Karanpur(CT)" },
  { value: "Karari(NP)", label: "Karari(NP)" },
  { value: "KarawalNagar(CT)", label: "KarawalNagar(CT)" },
  { value: "Kareli(CT)", label: "Kareli(CT)" },
  { value: "Karera(NP)", label: "Karera(NP)" },
  { value: "Kari(NP)", label: "Kari(NP)" },
  { value: "Karmeta(CT)", label: "Karmeta(CT)" },
  { value: "Karnawal(NP)", label: "Karnawal(NP)" },
  { value: "Karumathampatti(TP)", label: "Karumathampatti(TP)" },
  { value: "Karvad(CT)", label: "Karvad(CT)" },
  { value: "Kasargod", label: "Kasargod" },
  { value: "Kasba(NP)", label: "Kasba(NP)" },
  { value: "KasbaBonli(CT)", label: "KasbaBonli(CT)" },
  { value: "KasbaKhanpur(CT)", label: "KasbaKhanpur(CT)" },
  { value: "KasbaSultanpur(CT)", label: "KasbaSultanpur(CT)" },
  { value: "Kashirampur(CT)", label: "Kashirampur(CT)" },
  { value: "KasimBazar(CT)", label: "KasimBazar(CT)" },
  { value: "Kataiya(NP)", label: "Kataiya(NP)" },
  { value: "KatgharLalganj(NP)", label: "KatgharLalganj(NP)" },
  { value: "Kathanian(CT)", label: "Kathanian(CT)" },
  { value: "Katigora", label: "Katigora" },
  { value: "Katpadi(TP)", label: "Katpadi(TP)" },
  { value: "Katra(NP)", label: "Katra(NP)" },
  { value: "KatraMedniganj(NP)", label: "KatraMedniganj(NP)" },
  { value: "KatriPiperKhera(CT)", label: "KatriPiperKhera(CT)" },
  { value: "Kattathurai(CT)", label: "Kattathurai(CT)" },
  { value: "Kattuputhur(TP)", label: "Kattuputhur(TP)" },
  { value: "Kauriaganj(NP)", label: "Kauriaganj(NP)" },
  { value: "Kawardha ", label: "Kawardha " },
  { value: "Kedarnath(NP)", label: "Kedarnath(NP)" },
  { value: "Kelambakkam ", label: "Kelambakkam " },
  { value: "Kemri(NP)", label: "Kemri(NP)" },
  { value: "Kendua(CT)", label: "Kendua(CT)" },
  { value: "Kenjar(CT)", label: "Kenjar(CT)" },
  { value: "Kerakat(NP)", label: "Kerakat(NP)" },
  { value: "Keshoraipatan(M)", label: "Keshoraipatan(M)" },
  { value: "Kesrisinghpur(M)", label: "Kesrisinghpur(M)" },
  { value: "Kewalpur(CT)", label: "Kewalpur(CT)" },
  { value: "Khadda(NP)", label: "Khadda(NP)" },
  { value: "KhadkiBk(CT)", label: "KhadkiBk(CT)" },
  { value: "Khagrabari(CT)", label: "Khagrabari(CT)" },
  { value: "Khailar(CT)", label: "Khailar(CT)" },
  { value: "Khair(NPP)", label: "Khair(NPP)" },
  { value: "Khairabad(CT)", label: "Khairabad(CT)" },
  { value: "Khairabad(NPP)", label: "Khairabad(NPP)" },
  { value: "Khajuraho(NP)", label: "Khajuraho(NP)" },
  { value: "Khamanon(NP)", label: "Khamanon(NP)" },
  { value: "Khambra(CT)", label: "Khambra(CT)" },
  { value: "KhanapuramHaveli(CT)", label: "KhanapuramHaveli(CT)" },
  { value: "Khanauri(NP)", label: "Khanauri(NP)" },
  { value: "Khanpur(CT)", label: "Khanpur(CT)" },
  { value: "Khanpur(NP)", label: "Khanpur(NP)" },
  { value: "Khanupur(CT)", label: "Khanupur(CT)" },
  { value: "Khapar(CT)", label: "Khapar(CT)" },
  { value: "Kharela(NP)", label: "Kharela(NP)" },
  { value: "Khargapur(NP)", label: "Khargapur(NP)" },
  { value: "Khargone West nimar", label: "Khargone West nimar" },
  { value: "Khargupur(NP)", label: "Khargupur(NP)" },
  { value: "Kharia(P)(CT)", label: "Kharia(P)(CT)" },
  { value: "KharimalaKhagrabari(CT)", label: "KharimalaKhagrabari(CT)" },
  { value: "Kharkhoda(NP)", label: "Kharkhoda(NP)" },
  { value: "Khatauli(NPP)", label: "Khatauli(NPP)" },
  { value: "KhatauliRural(CT)", label: "KhatauliRural(CT)" },
  { value: "Khategaon(NP)", label: "Khategaon(NP)" },
  { value: "Khatyari(CT)", label: "Khatyari(CT)" },
  { value: "KheraKalan(CT)", label: "KheraKalan(CT)" },
  { value: "Kherli(M)", label: "Kherli(M)" },
  { value: "KherliHafizpur(CT)", label: "KherliHafizpur(CT)" },
  { value: "KherwaraChhaoni(CT)", label: "KherwaraChhaoni(CT)" },
  { value: "Khetri(M)", label: "Khetri(M)" },
  { value: "Khongapani(NP)", label: "Khongapani(NP)" },
  { value: "Khongman(CT)", label: "Khongman(CT)" },
  { value: "Khoni(CT)", label: "Khoni(CT)" },
  { value: "Khonsa(NT)", label: "Khonsa(NT)" },
  { value: "Khora(CT)", label: "Khora(CT)" },
  { value: "Khrew(MC)", label: "Khrew(MC)" },
  { value: "Khudaganj(NP)", label: "Khudaganj(NP)" },
  { value: "Khurai(M)", label: "Khurai(M)" },
  { value: "Khurja(NPP)", label: "Khurja(NPP)" },
  { value: "KhurjaRural(CT)", label: "KhurjaRural(CT)" },
  { value: "Khusrupur(NP)", label: "Khusrupur(NP)" },
  { value: "Khutar(NP)", label: "Khutar(NP)" },
  { value: "Kiphire", label: "Kiphire" },
  { value: "Kiphire(TC)", label: "Kiphire(TC)" },
  { value: "KirariSulemanNagar(CT)", label: "KirariSulemanNagar(CT)" },
  { value: "Kiratpur(NPP)", label: "Kiratpur(NPP)" },
  { value: "Kiriburu(CT)", label: "Kiriburu(CT)" },
  { value: "Kirtinagar(NP)", label: "Kirtinagar(NP)" },
  { value: "Kishangarh(CT)", label: "Kishangarh(CT)" },
  { value: "Kishangarh(MCl)", label: "Kishangarh(MCl)" },
  { value: "Kishni(NP)", label: "Kishni(NP)" },
  { value: "Kishunpur(NP)", label: "Kishunpur(NP)" },
  { value: "Kithaur(NP)", label: "Kithaur(NP)" },
  { value: "Kodagu", label: "Kodagu" },
  { value: "Kodugu ", label: "Kodugu " },
  { value: "Kolar(M)", label: "Kolar(M)" },
  { value: "Kolaras(NP)", label: "Kolaras(NP)" },
  { value: "Kolasib(NT)", label: "Kolasib(NT)" },
  { value: "Kolayat(CT)", label: "Kolayat(CT)" },
  { value: "Kolazhy(CT)", label: "Kolazhy(CT)" },
  { value: "Komaralingam(TP)", label: "Komaralingam(TP)" },
  { value: "Kombai(TP)", label: "Kombai(TP)" },
  { value: "Kon(CT)", label: "Kon(CT)" },
  { value: "KonappanaAgrahara(CT)", label: "KonappanaAgrahara(CT)" },
  { value: "Konch(NPP)", label: "Konch(NPP)" },
  { value: "Kondalampatti(CT)", label: "Kondalampatti(CT)" },
  { value: "Kondappanaickenpatti(CT)", label: "Kondappanaickenpatti(CT)" },
  { value: "Kondumal(CT)", label: "Kondumal(CT)" },
  { value: "Kondur(CT)", label: "Kondur(CT)" },
  { value: "Konerikuppam(CT)", label: "Konerikuppam(CT)" },
  { value: "Kooraikundu(CT)", label: "Kooraikundu(CT)" },
  { value: "Kopaganj(NP)", label: "Kopaganj(NP)" },
  { value: "KoraJahanabad(NP)", label: "KoraJahanabad(NP)" },
  { value: "Koradi(CT)", label: "Koradi(CT)" },
  { value: "Koraon(NP)", label: "Koraon(NP)" },
  { value: "Korwa(CT)", label: "Korwa(CT)" },
  { value: "Kosi Kotwan", label: "Kosi Kotwan" },
  { value: "Kosmi(CT)", label: "Kosmi(CT)" },
  { value: "Kota(CT)", label: "Kota(CT)" },
  { value: "Kotar(NP)", label: "Kotar(NP)" },
  { value: "Kotba(NP)", label: "Kotba(NP)" },
  { value: "Kothapet(CT)", label: "Kothapet(CT)" },
  { value: "Kothavalasa(CT)", label: "Kothavalasa(CT)" },
  { value: "Kothri(NP)", label: "Kothri(NP)" },
  { value: "Kotma(M)", label: "Kotma(M)" },
  { value: "Kotra(NP)", label: "Kotra(NP)" },
  { value: "Kottaiyur(TP)", label: "Kottaiyur(TP)" },
  { value: "Kottamkara(CT)", label: "Kottamkara(CT)" },
  { value: "Kottivakkam(CT)", label: "Kottivakkam(CT)" },
  { value: "Kotwa(CT)", label: "Kotwa(CT)" },
  { value: "Kovur(CT)", label: "Kovur(CT)" },
  { value: "Kovvur", label: "Kovvur" },
  { value: "KralPora(CT)", label: "KralPora(CT)" },
  { value: "Krishnapur(CT)", label: "Krishnapur(CT)" },
  { value: "Kuchanur(TP)", label: "Kuchanur(TP)" },
  { value: "Kuchera(M)", label: "Kuchera(M)" },
  { value: "Kuda(CT)", label: "Kuda(CT)" },
  { value: "Kudremukh(NAC)", label: "Kudremukh(NAC)" },
  { value: "Kudus(CT)", label: "Kudus(CT)" },
  { value: "Kukdeshwar(NP)", label: "Kukdeshwar(NP)" },
  { value: "Kukra(CT)", label: "Kukra(CT)" },
  { value: "Kukudakhandi(CT)", label: "Kukudakhandi(CT)" },
  { value: "Kulathur(CT)", label: "Kulathur(CT)" },
  { value: "Kuldanga(CT)", label: "Kuldanga(CT)" },
  { value: "Kulihanda(CT)", label: "Kulihanda(CT)" },
  { value: "KumarKaibartaGaon(CT)", label: "KumarKaibartaGaon(CT)" },
  { value: "Kumbhraj(NP)", label: "Kumbhraj(NP)" },
  { value: "Kumher(M)", label: "Kumher(M)" },
  { value: "Kunda(NP)", label: "Kunda(NP)" },
  { value: "Kundalwadi(MCl)", label: "Kundalwadi(MCl)" },
  { value: "Kunnam", label: "Kunnam" },
  { value: "Kunnamangalam(CT)", label: "Kunnamangalam(CT)" },
  { value: "Kurali(MCl)", label: "Kurali(MCl)" },
  { value: "Kurekuppa(CT)", label: "Kurekuppa(CT)" },
  { value: "KuriBhagtasani(CT)", label: "KuriBhagtasani(CT)" },
  { value: "Kurichi(M)", label: "Kurichi(M)" },
  { value: "Kurkheda(CT)", label: "Kurkheda(CT)" },
  { value: "Kurpania(CT)", label: "Kurpania(CT)" },
  { value: "Kursath(NP)", label: "Kursath(NP)" },
  { value: "KurthiJafarpur(CT)", label: "KurthiJafarpur(CT)" },
  { value: "Kurul(CT)", label: "Kurul(CT)" },
  { value: "Kurung Kumey", label: "Kurung Kumey" },
  { value: "Kurwai(NP)", label: "Kurwai(NP)" },
  { value: "Kusadanga(CT)", label: "Kusadanga(CT)" },
  { value: "Kushalgarh(M)", label: "Kushalgarh(M)" },
  { value: "Kushalnagar ", label: "Kushalnagar " },
  { value: "Kushtagi(TMC)", label: "Kushtagi(TMC)" },
  { value: "Kusmara(NP)", label: "Kusmara(NP)" },
  { value: "Kusmi(NP)", label: "Kusmi(NP)" },
  { value: "Kuttikkattoor(CT)", label: "Kuttikkattoor(CT)" },
  { value: "Kuwarbav(CT)", label: "Kuwarbav(CT)" },
  { value: "LADAKH", label: "LADAKH" },
  { value: "LADNUN", label: "LADNUN" },
  { value: "LADWA", label: "LADWA" },
  { value: "LAHAR", label: "LAHAR" },
  { value: "LAHARIGHAT", label: "LAHARIGHAT" },
  { value: "LAHARPUR", label: "LAHARPUR" },
  { value: "LAHARTARABOULIA", label: "LAHARTARABOULIA" },
  { value: "LAHUL SPITI", label: "LAHUL SPITI" },
  { value: "LAJPUR", label: "LAJPUR" },
  { value: "LAKHIMPUR", label: "LAKHIMPUR" },
  { value: "LAKHIMPURKHERI", label: "LAKHIMPURKHERI" },
  { value: "LAKHIPUR", label: "LAKHIPUR" },
  { value: "LAKHISARAI", label: "LAKHISARAI" },
  { value: "LAKHNADON", label: "LAKHNADON" },
  { value: "LAKKIDI", label: "LAKKIDI" },
  { value: "LAKKUNDI", label: "LAKKUNDI" },
  { value: "LAKSAR", label: "LAKSAR" },
  { value: "LAKSHETTIPET", label: "LAKSHETTIPET" },
  { value: "LALA", label: "LALA" },
  { value: "LALGANJ", label: "LALGANJ" },
  { value: "LALGANJ(RAIBAREILLY)", label: "LALGANJ(RAIBAREILLY)" },
  { value: "LALGARH", label: "LALGARH" },
  { value: "LALGARHJATTAN", label: "LALGARHJATTAN" },
  { value: "LALGUDI", label: "LALGUDI" },
  { value: "LALITPUR", label: "LALITPUR" },
  { value: "LALKUAN", label: "LALKUAN" },
  { value: "LALRU", label: "LALRU" },
  { value: "LALSAR", label: "LALSAR" },
  { value: "LALSOT", label: "LALSOT" },
  { value: "LAMBHUA", label: "LAMBHUA" },
  { value: "LAMSHANG", label: "LAMSHANG" },
  { value: "LANJA", label: "LANJA" },
  { value: "LANKA", label: "LANKA" },
  { value: "LASALGAON", label: "LASALGAON" },
  { value: "LASUDIAMORI", label: "LASUDIAMORI" },
  { value: "LATEHAR", label: "LATEHAR" },
  { value: "LATERI", label: "LATERI" },
  { value: "LATUR", label: "LATUR" },
  { value: "LAVANA", label: "LAVANA" },
  { value: "LAVKUSHNAGAR", label: "LAVKUSHNAGAR" },
  { value: "LAWARNP", label: "LAWARNP" },
  { value: "LAWNGTLAI", label: "LAWNGTLAI" },
  { value: "LAXMANGARH", label: "LAXMANGARH" },
  { value: "LAXMESHWAR", label: "LAXMESHWAR" },
  { value: "LEH", label: "LEH" },
  { value: "LEH LADAKH", label: "LEH LADAKH" },
  { value: "LIBASPUR", label: "LIBASPUR" },
  { value: "LIDHORAKHAS", label: "LIDHORAKHAS" },
  { value: "LILONGCHAJING", label: "LILONGCHAJING" },
  { value: "LIMBASI", label: "LIMBASI" },
  { value: "LIMDI", label: "LIMDI" },
  { value: "LIMKHEDA", label: "LIMKHEDA" },
  { value: "LINGAMPET", label: "LINGAMPET" },
  { value: "LINGSUGUR", label: "LINGSUGUR" },
  { value: "LOHAGHAT", label: "LOHAGHAT" },
  { value: "LOHARA", label: "LOHARA" },
  { value: "LOHARDAGA", label: "LOHARDAGA" },
  { value: "LOHARGHAT", label: "LOHARGHAT" },
  { value: "LOHARI", label: "LOHARI" },
  { value: "LOHARIASALMALLA", label: "LOHARIASALMALLA" },
  { value: "LOHARU", label: "LOHARU" },
  { value: "LOHIANKHAS", label: "LOHIANKHAS" },
  { value: "LOKAPUR", label: "LOKAPUR" },
  { value: "LONAND", label: "LONAND" },
  { value: "LONAVALA", label: "LONAVALA" },
  { value: "LONI", label: "LONI" },
  { value: "LONKOTDA", label: "LONKOTDA" },
  { value: "LORMI", label: "LORMI" },
  { value: "LOSAL", label: "LOSAL" },
  { value: "LOWERMUTHI", label: "LOWERMUTHI" },
  { value: "LOWERSUBANSIRI", label: "LOWERSUBANSIRI" },
  { value: "LUCKNOW", label: "LUCKNOW" },
  { value: "LUDHIANA", label: "LUDHIANA" },
  { value: "LUDHIANAMOFFUSIL", label: "LUDHIANAMOFFUSIL" },
  { value: "LUMDING", label: "LUMDING" },
  { value: "LUNAWADA", label: "LUNAWADA" },
  { value: "LUNGLEI", label: "LUNGLEI" },
  { value: "LUNI", label: "LUNI" },
  { value: "LUNKARANSAR", label: "LUNKARANSAR" },
  { value: "LUWANGSANGBAM", label: "LUWANGSANGBAM" },
  { value: "LachhimanPatti(CT)", label: "LachhimanPatti(CT)" },
  { value: "Lagda(CT)", label: "Lagda(CT)" },
  { value: "Lahar(NP)", label: "Lahar(NP)" },
  { value: "Laharpur(NPP)", label: "Laharpur(NPP)" },
  { value: "Lahsari(CT)", label: "Lahsari(CT)" },
  { value: "LaiphamSiphai(CT)", label: "LaiphamSiphai(CT)" },
  { value: "Lakheri(M)", label: "Lakheri(M)" },
  { value: "Lakhna(NP)", label: "Lakhna(NP)" },
  { value: "Laksar(NP)", label: "Laksar(NP)" },
  { value: "Lakshadweep", label: "Lakshadweep" },
  { value: "LalGopalganjNindaura(NP)", label: "LalGopalganjNindaura(NP)" },
  { value: "Lalhapur(CT)", label: "Lalhapur(CT)" },
  { value: "Lalsot(M)", label: "Lalsot(M)" },
  { value: "Lamjaotongba(CT)", label: "Lamjaotongba(CT)" },
  { value: "Landhaura(NP)", label: "Landhaura(NP)" },
  { value: "Lanja(CT)", label: "Lanja(CT)" },
  { value: "Lansdowne(CB)", label: "Lansdowne(CB)" },
  { value: "Lar(NP)", label: "Lar(NP)" },
  { value: "Lateri(NP)", label: "Lateri(NP)" },
  { value: "Lathi(M)", label: "Lathi(M)" },
  { value: "Lawan(NP)", label: "Lawan(NP)" },
  { value: "Lawsohtun(CT)", label: "Lawsohtun(CT)" },
  { value: "LedwaMahua(CT)", label: "LedwaMahua(CT)" },
  { value: "Lengpui(NT)", label: "Lengpui(NT)" },
  { value: "Lerhupur(CT)", label: "Lerhupur(CT)" },
  { value: "LidoTown(CT)", label: "LidoTown(CT)" },
  { value: "Lilia(CT)", label: "Lilia(CT)" },
  { value: "Limbodi(CT)", label: "Limbodi(CT)" },
  { value: "Lohaghat(NP)", label: "Lohaghat(NP)" },
  { value: "Lohara(CT)", label: "Lohara(CT)" },
  { value: "Loharda(NP)", label: "Loharda(NP)" },
  { value: "Lohit", label: "Lohit" },
  { value: "Lohta(CT)", label: "Lohta(CT)" },
  { value: "Longding", label: "Longding" },
  { value: "Longleng", label: "Longleng" },
  { value: "Longleng(TC)", label: "Longleng(TC)" },
  { value: "LoniaKarbal(CT)", label: "LoniaKarbal(CT)" },
  { value: "Losal(M)", label: "Losal(M)" },
  { value: "Lower Dibang Valley", label: "Lower Dibang Valley" },
  { value: "Lower Subansiri", label: "Lower Subansiri" },
  { value: "MAABIRASINIDHAM", label: "MAABIRASINIDHAM" },
  { value: "MACHALISAHAR", label: "MACHALISAHAR" },
  { value: "MACHERLA", label: "MACHERLA" },
  { value: "MACHHALISHAHAR", label: "MACHHALISHAHAR" },
  { value: "MACHHE", label: "MACHHE" },
  { value: "MACHHIWARA", label: "MACHHIWARA" },
  { value: "MACHI", label: "MACHI" },
  { value: "MACHILIPATNAM", label: "MACHILIPATNAM" },
  { value: "MADAGADIPET", label: "MADAGADIPET" },
  { value: "MADANA", label: "MADANA" },
  { value: "MADANAPALLE", label: "MADANAPALLE" },
  { value: "MADANAYAKAHALLI", label: "MADANAYAKAHALLI" },
  { value: "MADANGANJ", label: "MADANGANJ" },
  { value: "MADANRYTING", label: "MADANRYTING" },
  { value: "MADANTHYAR", label: "MADANTHYAR" },
  { value: "MADATHUKULAM", label: "MADATHUKULAM" },
  { value: "MADDUR", label: "MADDUR" },
  { value: "MADGAON", label: "MADGAON" },
  { value: "MADHAVARAM", label: "MADHAVARAM" },
  { value: "MADHEPURA", label: "MADHEPURA" },
  { value: "MADHI", label: "MADHI" },
  { value: "MADHIRA", label: "MADHIRA" },
  { value: "MADHOGANJ", label: "MADHOGANJ" },
  { value: "MADHOGARH", label: "MADHOGARH" },
  { value: "MADHPUR", label: "MADHPUR" },
  { value: "MADHUBANI", label: "MADHUBANI" },
  { value: "MADHUPUR", label: "MADHUPUR" },
  { value: "MADHURAWADA", label: "MADHURAWADA" },
  { value: "MADHYAMGRAM", label: "MADHYAMGRAM" },
  { value: "MADIKERI", label: "MADIKERI" },
  { value: "MADIPAKKAM", label: "MADIPAKKAM" },
  { value: "MADLAUDA", label: "MADLAUDA" },
  { value: "MADURAI", label: "MADURAI" },
  { value: "MADURANTHAKAM", label: "MADURANTHAKAM" },
  { value: "MAGADI", label: "MAGADI" },
  { value: "MAGAM", label: "MAGAM" },
  { value: "MAGARLOD", label: "MAGARLOD" },
  { value: "MAHAARAJPUR", label: "MAHAARAJPUR" },
  { value: "MAHABUB NAGAR", label: "MAHABUB NAGAR" },
  { value: "MAHABUBABAD", label: "MAHABUBABAD" },
  { value: "MAHAD", label: "MAHAD" },
  { value: "MAHAGAMA", label: "MAHAGAMA" },
  { value: "MAHAJAN", label: "MAHAJAN" },
  { value: "MAHALINGPUR", label: "MAHALINGPUR" },
  { value: "MAHANAD", label: "MAHANAD" },
  { value: "MAHANPUR", label: "MAHANPUR" },
  { value: "MAHARAJGANJ", label: "MAHARAJGANJ" },
  { value: "MAHARAJGANJ(RAIBAREILLY)", label: "MAHARAJGANJ(RAIBAREILLY)" },
  { value: "MAHASAMUND", label: "MAHASAMUND" },
  { value: "MAHBUBNAGAR", label: "MAHBUBNAGAR" },
  { value: "MAHE", label: "MAHE" },
  { value: "MAHEMDAVAD", label: "MAHEMDAVAD" },
  { value: "MAHENDRAGARH", label: "MAHENDRAGARH" },
  { value: "MAHESANA", label: "MAHESANA" },
  { value: "MAHESHKHUNT", label: "MAHESHKHUNT" },
  { value: "MAHESHPUR", label: "MAHESHPUR" },
  { value: "MAHESHWAR", label: "MAHESHWAR" },
  { value: "MAHESHWARAM", label: "MAHESHWARAM" },
  { value: "MAHESHWARI", label: "MAHESHWARI" },
  { value: "MAHIDPUR", label: "MAHIDPUR" },
  { value: "MAHILPUR", label: "MAHILPUR" },
  { value: "MAHISAGAR", label: "MAHISAGAR" },
  { value: "MAHISHADAL", label: "MAHISHADAL" },
  { value: "MAHOBA", label: "MAHOBA" },
  { value: "MAHOLI", label: "MAHOLI" },
  { value: "MAHRAJGANJ", label: "MAHRAJGANJ" },
  { value: "MAHRAUNI", label: "MAHRAUNI" },
  { value: "MAHUA", label: "MAHUA" },
  { value: "MAHUAKHERAGANJ", label: "MAHUAKHERAGANJ" },
  { value: "MAHUDA", label: "MAHUDA" },
  { value: "MAHUDHA", label: "MAHUDHA" },
  { value: "MAHUKALAN", label: "MAHUKALAN" },
  { value: "MAHUVA", label: "MAHUVA" },
  { value: "MAHWA", label: "MAHWA" },
  { value: "MAIDANGARHI", label: "MAIDANGARHI" },
  { value: "MAIGALGANJ", label: "MAIGALGANJ" },
  { value: "MAIHAR", label: "MAIHAR" },
  { value: "MAIJHAULIKHETAL", label: "MAIJHAULIKHETAL" },
  { value: "MAINAMOJPUR", label: "MAINAMOJPUR" },
  { value: "MAINPURI", label: "MAINPURI" },
  { value: "MAIRANG", label: "MAIRANG" },
  { value: "MAJGAON", label: "MAJGAON" },
  { value: "MAJHARAPIPAREHATMALI", label: "MAJHARAPIPAREHATMALI" },
  { value: "MAJHAULI", label: "MAJHAULI" },
  { value: "MAJHAULIRAJ", label: "MAJHAULIRAJ" },
  { value: "MAJHOLI", label: "MAJHOLI" },
  { value: "MAJITHA", label: "MAJITHA" },
  { value: "MAJULI", label: "MAJULI" },
  { value: "MAKARDAH", label: "MAKARDAH" },
  { value: "MAKDONE", label: "MAKDONE" },
  { value: "MAKKHANPUR", label: "MAKKHANPUR" },
  { value: "MAKRANA", label: "MAKRANA" },
  { value: "MAKRONIYA", label: "MAKRONIYA" },
  { value: "MAKTAMPUR", label: "MAKTAMPUR" },
  { value: "MALAKHERA", label: "MALAKHERA" },
  { value: "MALANCHA", label: "MALANCHA" },
  { value: "MALAPPURAM", label: "MALAPPURAM" },
  { value: "MALAUDH", label: "MALAUDH" },
  { value: "MALBAZAR", label: "MALBAZAR" },
  { value: "MALDA", label: "MALDA" },
  { value: "MALEBENNUR", label: "MALEBENNUR" },
  { value: "MALEGAON", label: "MALEGAON" },
  { value: "MALERKOTLA", label: "MALERKOTLA" },
  { value: "MALGUND", label: "MALGUND" },
  { value: "MALHARA", label: "MALHARA" },
  { value: "MALHIPUR", label: "MALHIPUR" },
  { value: "MALIHABAD", label: "MALIHABAD" },
  { value: "MALIKIPURAM", label: "MALIKIPURAM" },
  { value: "MALIYAGUDA", label: "MALIYAGUDA" },
  { value: "MALKANGIRI", label: "MALKANGIRI" },
  { value: "MALKAPUR", label: "MALKAPUR" },
  { value: "MALLANWALAKHAS", label: "MALLANWALAKHAS" },
  { value: "MALLAPPALLY", label: "MALLAPPALLY" },
  { value: "MALLASAMUDRAM", label: "MALLASAMUDRAM" },
  { value: "MALLUR", label: "MALLUR" },
  { value: "MALOUT", label: "MALOUT" },
  { value: "MALPURA", label: "MALPURA" },
  { value: "MALUR", label: "MALUR" },
  { value: "MALVAN", label: "MALVAN" },
  { value: "MAMIDALAPADU", label: "MAMIDALAPADU" },
  { value: "MAMIT", label: "MAMIT" },
  { value: "MANACHANALLUR", label: "MANACHANALLUR" },
  { value: "MANAKSAR", label: "MANAKSAR" },
  { value: "MANALI", label: "MANALI" },
  { value: "MANAMADURAI", label: "MANAMADURAI" },
  { value: "MANANTHAVADY", label: "MANANTHAVADY" },
  { value: "MANAPPARAI", label: "MANAPPARAI" },
  { value: "MANASA", label: "MANASA" },
  { value: "MANATHVADY", label: "MANATHVADY" },
  { value: "MANAVADAR", label: "MANAVADAR" },
  { value: "MANAWAR", label: "MANAWAR" },
  { value: "MANCHAR", label: "MANCHAR" },
  { value: "MANCHENAHALLI", label: "MANCHENAHALLI" },
  { value: "MANCHERIAL", label: "MANCHERIAL" },
  { value: "MANDAL", label: "MANDAL" },
  { value: "MANDALGARH", label: "MANDALGARH" },
  { value: "MANDANGAD", label: "MANDANGAD" },
  { value: "MANDAPETA", label: "MANDAPETA" },
  { value: "MANDAR", label: "MANDAR" },
  { value: "MANDI", label: "MANDI" },
  { value: "MANDI HOUSE", label: "MANDI HOUSE" },
  { value: "MANDIA", label: "MANDIA" },
  { value: "MANDIDEEP", label: "MANDIDEEP" },
  { value: "MANDIDHANAURA", label: "MANDIDHANAURA" },
  { value: "MANDIGOBINDGARH", label: "MANDIGOBINDGARH" },
  { value: "MANDLA", label: "MANDLA" },
  { value: "MANDRAYAL", label: "MANDRAYAL" },
  { value: "MANDSAUR", label: "MANDSAUR" },
  { value: "MANDURI", label: "MANDURI" },
  { value: "MANDVI", label: "MANDVI" },
  { value: "MANDYA", label: "MANDYA" },
  { value: "MANEGAON", label: "MANEGAON" },
  { value: "MANENDRAGARH", label: "MANENDRAGARH" },
  { value: "MANESAR", label: "MANESAR" },
  { value: "MANGALAGIRI", label: "MANGALAGIRI" },
  { value: "MANGALAPURAM", label: "MANGALAPURAM" },
  { value: "MANGALDOI", label: "MANGALDOI" },
  { value: "MANGALURU", label: "MANGALURU" },
  { value: "MANGALWAD", label: "MANGALWAD" },
  { value: "MANGALWEDHA", label: "MANGALWEDHA" },
  { value: "MANGAN", label: "MANGAN" },
  { value: "MANGAON", label: "MANGAON" },
  { value: "MANGASAMUDRAMRURAL", label: "MANGASAMUDRAMRURAL" },
  { value: "MANGO", label: "MANGO" },
  { value: "MANGPUCINCHONAPLANTATION", label: "MANGPUCINCHONAPLANTATION" },
  { value: "MANGROL", label: "MANGROL" },
  { value: "MANICKAPURAM", label: "MANICKAPURAM" },
  { value: "MANIPAL", label: "MANIPAL" },
  { value: "MANIPUR", label: "MANIPUR" },
  { value: "MANJAKOTE", label: "MANJAKOTE" },
  { value: "MANJANADE", label: "MANJANADE" },
  { value: "MANJERI", label: "MANJERI" },
  { value: "MANJHANPUR", label: "MANJHANPUR" },
  { value: "MANJHIAON", label: "MANJHIAON" },
  { value: "MANJOOR", label: "MANJOOR" },
  { value: "MANJRI", label: "MANJRI" },
  { value: "MANKAPUR", label: "MANKAPUR" },
  { value: "MANMAD", label: "MANMAD" },
  { value: "MANNANTHALA", label: "MANNANTHALA" },
  { value: "MANNARGUDI", label: "MANNARGUDI" },
  { value: "MANNARKKAD", label: "MANNARKKAD" },
  { value: "MANNUTHY", label: "MANNUTHY" },
  { value: "MANOHARPUR", label: "MANOHARPUR" },
  { value: "MANOHARTHANA", label: "MANOHARTHANA" },
  { value: "MANOR", label: "MANOR" },
  { value: "MANPUR", label: "MANPUR" },
  { value: "MANSA", label: "MANSA" },
  { value: "MANSAR", label: "MANSAR" },
  { value: "MANSURCHAK", label: "MANSURCHAK" },
  { value: "MANTHANI", label: "MANTHANI" },
  { value: "MANU", label: "MANU" },
  { value: "MANUGURU", label: "MANUGURU" },
  { value: "MANVI", label: "MANVI" },
  { value: "MAPUSA", label: "MAPUSA" },
  { value: "MARANDA", label: "MARANDA" },
  { value: "MARATHAKKARA", label: "MARATHAKKARA" },
  { value: "MARCEL", label: "MARCEL" },
  { value: "MAREGAON", label: "MAREGAON" },
  { value: "MARGHERITA", label: "MARGHERITA" },
  { value: "MARH", label: "MARH" },
  { value: "MARIAHU", label: "MARIAHU" },
  { value: "MARIANI", label: "MARIANI" },
  { value: "MARIGAON", label: "MARIGAON" },
  { value: "MARIPEDA", label: "MARIPEDA" },
  { value: "MARKANDA", label: "MARKANDA" },
  { value: "MARKAPUR", label: "MARKAPUR" },
  { value: "MARTHANDAM", label: "MARTHANDAM" },
  { value: "MARUADIHRLY.SETTLEMENT", label: "MARUADIHRLY.SETTLEMENT" },
  { value: "MARWARJUNCTION", label: "MARWARJUNCTION" },
  { value: "MASALA", label: "MASALA" },
  { value: "MASAURHI", label: "MASAURHI" },
  { value: "MASINAICKENPATTI", label: "MASINAICKENPATTI" },
  { value: "MASOODPUR", label: "MASOODPUR" },
  { value: "MASTI", label: "MASTI" },
  { value: "MASUDA", label: "MASUDA" },
  { value: "MASUR", label: "MASUR" },
  { value: "MATAINA", label: "MATAINA" },
  { value: "MATHABHANGA", label: "MATHABHANGA" },
  { value: "MATHERISHEKHAN", label: "MATHERISHEKHAN" },
  { value: "MATHIGODU", label: "MATHIGODU" },
  { value: "MATHUR", label: "MATHUR" },
  { value: "MATHURA", label: "MATHURA" },
  { value: "MATHURAPUR", label: "MATHURAPUR" },
  { value: "MATI", label: "MATI" },
  { value: "MATILIRATHAN", label: "MATILIRATHAN" },
  { value: "MATTAN", label: "MATTAN" },
  { value: "MATTANNUR", label: "MATTANNUR" },
  { value: "MAU", label: "MAU" },
  { value: "MAUDA", label: "MAUDA" },
  { value: "MAUDAHA", label: "MAUDAHA" },
  { value: "MAUGANJ", label: "MAUGANJ" },
  { value: "MAUR", label: "MAUR" },
  { value: "MAURANIPUR", label: "MAURANIPUR" },
  { value: "MAVELIKARA", label: "MAVELIKARA" },
  { value: "MAVLI", label: "MAVLI" },
  { value: "MAVOOR", label: "MAVOOR" },
  { value: "MAWANA", label: "MAWANA" },
  { value: "MAWBLEI", label: "MAWBLEI" },
  { value: "MAWKYRWAT", label: "MAWKYRWAT" },
  { value: "MAWLAI-MAWÏONG", label: "MAWLAI-MAWÏONG" },
  { value: "MAWNGAP", label: "MAWNGAP" },
  { value: "MAYABUNDER", label: "MAYABUNDER" },
  { value: "MAYANG", label: "MAYANG" },
  { value: "MAYANI", label: "MAYANI" },
  { value: "MAYAR", label: "MAYAR" },
  { value: "MAYILADUTHURAI", label: "MAYILADUTHURAI" },
  { value: "MAYNAGURI", label: "MAYNAGURI" },
  { value: "MAYURBHANJ", label: "MAYURBHANJ" },
  { value: "MAZBAT", label: "MAZBAT" },
  { value: "MECHERI", label: "MECHERI" },
  { value: "MED", label: "MED" },
  { value: "MEDAK", label: "MEDAK" },
  { value: "MEDCHAL", label: "MEDCHAL" },
  { value: "MEDHA", label: "MEDHA" },
  { value: "MEDININAGAR", label: "MEDININAGAR" },
  { value: "MEDO", label: "MEDO" },
  { value: "MEENANGADI", label: "MEENANGADI" },
  { value: "MEERGANJ", label: "MEERGANJ" },
  { value: "MEERUT", label: "MEERUT" },
  { value: "MEGHAHATUBURU", label: "MEGHAHATUBURU" },
  { value: "MEGHNAGAR", label: "MEGHNAGAR" },
  { value: "MEHAM", label: "MEHAM" },
  { value: "MEHANDIPUR", label: "MEHANDIPUR" },
  { value: "MEHARAGAON", label: "MEHARAGAON" },
  { value: "MEHARBAN", label: "MEHARBAN" },
  { value: "MEHATPUR", label: "MEHATPUR" },
  { value: "MEHMEDABAD", label: "MEHMEDABAD" },
  { value: "MEHNA", label: "MEHNA" },
  { value: "MEHNAR", label: "MEHNAR" },
  { value: "MEHRONI", label: "MEHRONI" },
  { value: "MEHSANA", label: "MEHSANA" },
  { value: "MEHTA", label: "MEHTA" },
  { value: "MEJATEHSIL", label: "MEJATEHSIL" },
  { value: "MEJIA", label: "MEJIA" },
  { value: "MELAMADAI", label: "MELAMADAI" },
  { value: "MELLI", label: "MELLI" },
  { value: "MELUR", label: "MELUR" },
  { value: "MEMARI", label: "MEMARI" },
  { value: "MENDARDA", label: "MENDARDA" },
  { value: "MENDHAR", label: "MENDHAR" },
  { value: "MENHDAWAL", label: "MENHDAWAL" },
  { value: "MERAPANI", label: "MERAPANI" },
  { value: "MERTA", label: "MERTA" },
  { value: "METODA", label: "METODA" },
  { value: "METPALLY", label: "METPALLY" },
  { value: "METTUPALAYAM", label: "METTUPALAYAM" },
  { value: "METTUR", label: "METTUR" },
  { value: "MEWAT", label: "MEWAT" },
  { value: "MHASALA", label: "MHASALA" },
  { value: "MHASWAD", label: "MHASWAD" },
  { value: "MHOW", label: "MHOW" },
  { value: "MIDNAPORE", label: "MIDNAPORE" },
  { value: "MIHINPURWA", label: "MIHINPURWA" },
  { value: "MILAK", label: "MILAK" },
  { value: "MINJUR", label: "MINJUR" },
  { value: "MIRABHAYANDAR", label: "MIRABHAYANDAR" },
  { value: "MIRAJ", label: "MIRAJ" },
  { value: "MIRIK", label: "MIRIK" },
  { value: "MIRPUR", label: "MIRPUR" },
  { value: "MIRYALAGUDA", label: "MIRYALAGUDA" },
  { value: "MIRZAPUR", label: "MIRZAPUR" },
  { value: "MIRZAWALA", label: "MIRZAWALA" },
  { value: "MISRIKHR", label: "MISRIKHR" },
  { value: "MITHAPUR", label: "MITHAPUR" },
  { value: "MODASA", label: "MODASA" },
  { value: "MODINAGAR", label: "MODINAGAR" },
  { value: "MOGA", label: "MOGA" },
  { value: "MOHALI", label: "MOHALI" },
  { value: "MOHANA", label: "MOHANA" },
  { value: "MOHANBARI", label: "MOHANBARI" },
  { value: "MOHANIA", label: "MOHANIA" },
  { value: "MOHANLALGANJ", label: "MOHANLALGANJ" },
  { value: "MOHANNAGAR", label: "MOHANNAGAR" },
  { value: "MOHANPUR", label: "MOHANPUR" },
  { value: "MOHANPURA", label: "MOHANPURA" },
  { value: "MOHNA", label: "MOHNA" },
  { value: "MOIDE", label: "MOIDE" },
  { value: "MOINABAD", label: "MOINABAD" },
  { value: "MOIRANG", label: "MOIRANG" },
  { value: "MOKAMA", label: "MOKAMA" },
  { value: "MOKANDAPALLI", label: "MOKANDAPALLI" },
  { value: "MOKOKCHUNG", label: "MOKOKCHUNG" },
  { value: "MOMINPET", label: "MOMINPET" },
  { value: "MON", label: "MON" },
  { value: "MOOCHIKKAL", label: "MOOCHIKKAL" },
  { value: "MOODBIDRI", label: "MOODBIDRI" },
  { value: "MOODUSHEDDE", label: "MOODUSHEDDE" },
  { value: "MOONAK", label: "MOONAK" },
  { value: "MOONDA KOTEE TEA GARDEN", label: "MOONDA KOTEE TEA GARDEN" },
  { value: "MOORANG", label: "MOORANG" },
  { value: "MOOSANAGAR", label: "MOOSANAGAR" },
  { value: "MORA", label: "MORA" },
  { value: "MORADABAD", label: "MORADABAD" },
  { value: "MORADABADPAHARI", label: "MORADABADPAHARI" },
  { value: "MORAN", label: "MORAN" },
  { value: "MORANHAT", label: "MORANHAT" },
  { value: "MORAR", label: "MORAR" },
  { value: "MORASA", label: "MORASA" },
  { value: "MORAYUR", label: "MORAYUR" },
  { value: "MORBI", label: "MORBI" },
  { value: "MORENA", label: "MORENA" },
  { value: "MORGAON", label: "MORGAON" },
  { value: "MORIGAON", label: "MORIGAON" },
  { value: "MORINDA", label: "MORINDA" },
  { value: "MORTAD", label: "MORTAD" },
  { value: "MORVA HADAF", label: "MORVA HADAF" },
  { value: "MOTH", label: "MOTH" },
  { value: "MOTHRURAL", label: "MOTHRURAL" },
  { value: "MOTIHARI", label: "MOTIHARI" },
  { value: "MOTIKHAVDI", label: "MOTIKHAVDI" },
  { value: "MOUDA", label: "MOUDA" },
  { value: "MOVVA", label: "MOVVA" },
  { value: "MOYNA", label: "MOYNA" },
  { value: "MT", label: "MT" },
  { value: "MUBARAKPUR", label: "MUBARAKPUR" },
  { value: "MUDBIDRI", label: "MUDBIDRI" },
  { value: "MUDHAL", label: "MUDHAL" },
  { value: "MUDHOL", label: "MUDHOL" },
  { value: "MUDIGERE", label: "MUDIGERE" },
  { value: "MUGHALSARAI", label: "MUGHALSARAI" },
  { value: "MUKALMUA", label: "MUKALMUA" },
  { value: "MUKERIAN", label: "MUKERIAN" },
  { value: "MUKLAWA", label: "MUKLAWA" },
  { value: "MUKTSAR", label: "MUKTSAR" },
  { value: "MUKUNDGARH", label: "MUKUNDGARH" },
  { value: "MUKUNDPUR", label: "MUKUNDPUR" },
  { value: "MUL", label: "MUL" },
  { value: "MULANUR", label: "MULANUR" },
  { value: "MULBAGAL", label: "MULBAGAL" },
  { value: "MULCHERA", label: "MULCHERA" },
  { value: "MULGUND", label: "MULGUND" },
  { value: "MULKI", label: "MULKI" },
  { value: "MULLANA", label: "MULLANA" },
  { value: "MULLANPURDAKHA", label: "MULLANPURDAKHA" },
  { value: "MULLANPURGARIBDASS", label: "MULLANPURGARIBDASS" },
  { value: "MULUGU", label: "MULUGU" },
  { value: "MUMBAI", label: "MUMBAI" },
  { value: "MUMBRA", label: "MUMBRA" },
  { value: "MUNDARGI", label: "MUNDARGI" },
  { value: "MUNDAWAR", label: "MUNDAWAR" },
  { value: "MUNDERABAZAR", label: "MUNDERABAZAR" },
  { value: "MUNDIA", label: "MUNDIA" },
  { value: "MUNDKA", label: "MUNDKA" },
  { value: "MUNDRA", label: "MUNDRA" },
  { value: "MUNGELI", label: "MUNGELI" },
  { value: "MUNGER", label: "MUNGER" },
  { value: "MUNGRABADSHAHPUR", label: "MUNGRABADSHAHPUR" },
  { value: "MUNNAR", label: "MUNNAR" },
  { value: "MURADNAGAR", label: "MURADNAGAR" },
  { value: "MURATGANJ", label: "MURATGANJ" },
  { value: "MURBAD", label: "MURBAD" },
  { value: "MURDESHWAR", label: "MURDESHWAR" },
  { value: "MURI", label: "MURI" },
  { value: "MURI GANGA", label: "MURI GANGA" },
  { value: "MURSHIDABAD", label: "MURSHIDABAD" },
  { value: "MURTHAL", label: "MURTHAL" },
  { value: "MURTIZAPUR", label: "MURTIZAPUR" },
  { value: "MURUD", label: "MURUD" },
  { value: "MURUGAMPALAYAM", label: "MURUGAMPALAYAM" },
  { value: "MURUKAMBATTU", label: "MURUKAMBATTU" },
  { value: "MUSHALPUR", label: "MUSHALPUR" },
  { value: "MUSIRI", label: "MUSIRI" },
  { value: "MUSSOORIE", label: "MUSSOORIE" },
  { value: "MUSTABAD", label: "MUSTABAD" },
  { value: "MUVAL", label: "MUVAL" },
  { value: "MUVATTUPUZHA", label: "MUVATTUPUZHA" },
  { value: "MUZAFFARNAGAR", label: "MUZAFFARNAGAR" },
  { value: "MUZAFFARPUR", label: "MUZAFFARPUR" },
  { value: "MYLAVARAM", label: "MYLAVARAM" },
  { value: "MYLLIEM", label: "MYLLIEM" },
  { value: "MYSORE", label: "MYSORE" },
  { value: "MYSURU", label: "MYSURU" },
  { value: "Machalpur(NP)", label: "Machalpur(NP)" },
  { value: "Madai(CT)", label: "Madai(CT)" },
  { value: "Madambakkam(TP)", label: "Madambakkam(TP)" },
  { value: "MadanpurRampur(CT)", label: "MadanpurRampur(CT)" },
  { value: "Madhapar(CT)", label: "Madhapar(CT)" },
  { value: "Madhawgdha(CT)", label: "Madhawgdha(CT)" },
  { value: "Madhogarh(NP)", label: "Madhogarh(NP)" },
  { value: "Madhupur(CT)", label: "Madhupur(CT)" },
  { value: "Madiya(CT)", label: "Madiya(CT)" },
  { value: "Maduravoyal(M)", label: "Maduravoyal(M)" },
  { value: "Magam(MC)", label: "Magam(MC)" },
  { value: "Magarlod(NP)", label: "Magarlod(NP)" },
  { value: "Magdalla(INA)", label: "Magdalla(INA)" },
  { value: "Maghar(NP)", label: "Maghar(NP)" },
  { value: "Mahabalipuram ", label: "Mahabalipuram " },
  { value: "Mahaban(NP)", label: "Mahaban(NP)" },
  { value: "Mahabuababad", label: "Mahabuababad" },
  { value: "Mahapoli(CT)", label: "Mahapoli(CT)" },
  { value: "Maharajganj(NP)", label: "Maharajganj(NP)" },
  { value: "MaheshMundi(CT)", label: "MaheshMundi(CT)" },
  { value: "Maheshtala(M)", label: "Maheshtala(M)" },
  { value: "MahewaPattiPashchimUparhar(CT)", label: "MahewaPattiPashchimUparhar(CT)" },
  { value: "Mahiari(CT)", label: "Mahiari(CT)" },
  { value: "Mahimapur(CT)", label: "Mahimapur(CT)" },
  { value: "Mahindale(CT)", label: "Mahindale(CT)" },
  { value: "Mahlidih(CT)", label: "Mahlidih(CT)" },
  { value: "Mahmudabad(NPP)", label: "Mahmudabad(NPP)" },
  { value: "Maholi(NP)", label: "Maholi(NP)" },
  { value: "Maholiya(CT)", label: "Maholiya(CT)" },
  { value: "Mahona(NP)", label: "Mahona(NP)" },
  { value: "Mahrajganj(NP)", label: "Mahrajganj(NP)" },
  { value: "Mahroni(NP)", label: "Mahroni(NP)" },
  { value: "MahroniRural(CT)", label: "MahroniRural(CT)" },
  { value: "MahulKhasOrMahul(CT)", label: "MahulKhasOrMahul(CT)" },
  { value: "Mahura(CT)", label: "Mahura(CT)" },
  { value: "Mailani(NP)", label: "Mailani(NP)" },
  { value: "Maindargi(MCl)", label: "Maindargi(MCl)" },
  { value: "Mairang(TC)", label: "Mairang(TC)" },
  { value: "Mairwa(NP)", label: "Mairwa(NP)" },
  { value: "Majaragollappatti(CT)", label: "Majaragollappatti(CT)" },
  { value: "MakhalTala(CT)", label: "MakhalTala(CT)" },
  { value: "Makhdumpur(NP)", label: "Makhdumpur(NP)" },
  { value: "Makhu(NP)", label: "Makhu(NP)" },
  { value: "Malanpur(CT)", label: "Malanpur(CT)" },
  { value: "Malhargarh(NP)", label: "Malhargarh(NP)" },
  { value: "Malicherla(CT)", label: "Malicherla(CT)" },
  { value: "Malihabad(NP)", label: "Malihabad(NP)" },
  { value: "Malikpur(CT)", label: "Malikpur(CT)" },
  { value: "Malkapur(CT)", label: "Malkapur(CT)" },
  { value: "Malkera(CT)", label: "Malkera(CT)" },
  { value: "Mallamooppampatti(CT)", label: "Mallamooppampatti(CT)" },
  { value: "MallikBagan(CT)", label: "MallikBagan(CT)" },
  { value: "Mallikpur(CT)", label: "Mallikpur(CT)" },
  { value: "Malsisar(CT)", label: "Malsisar(CT)" },
  { value: "Malumichampatti(CT)", label: "Malumichampatti(CT)" },
  { value: "Mammit", label: "Mammit" },
  { value: "Mamsapuram(TP)", label: "Mamsapuram(TP)" },
  { value: "Mamun(CT)", label: "Mamun(CT)" },
  { value: "Manakkody(CT)", label: "Manakkody(CT)" },
  { value: "Manapakkam(CT)", label: "Manapakkam(CT)" },
  { value: "Manasa(NP)", label: "Manasa(NP)" },
  { value: "Mandalgarh(M)", label: "Mandalgarh(M)" },
  { value: "Mandav(NP)", label: "Mandav(NP)" },
  { value: "Mandawa(M)", label: "Mandawa(M)" },
  { value: "Mandawar(CT)", label: "Mandawar(CT)" },
  { value: "Mandawar(NP)", label: "Mandawar(NP)" },
  { value: "Mandideep(M)", label: "Mandideep(M)" },
  { value: "Mandoli(CT)", label: "Mandoli(CT)" },
  { value: "Maner(NP)", label: "Maner(NP)" },
  { value: "Manethi(28)(CT)", label: "Manethi(28)(CT)" },
  { value: "Mangadu(TP)", label: "Mangadu(TP)" },
  { value: "Mangalam(CT)", label: "Mangalam(CT)" },
  { value: "Mangalore", label: "Mangalore" },
  { value: "Manglaur(NPP)", label: "Manglaur(NPP)" },
  { value: "ManglayaSadak(CT)", label: "ManglayaSadak(CT)" },
  { value: "Manihari(NP)", label: "Manihari(NP)" },
  { value: "Manikpur(NP)", label: "Manikpur(NP)" },
  { value: "ManikpurSarhat(NP)", label: "ManikpurSarhat(NP)" },
  { value: "Maniyar(NP)", label: "Maniyar(NP)" },
  { value: "Manjhanpur(NP)", label: "Manjhanpur(NP)" },
  { value: "ManjoorGarhi(CT)", label: "ManjoorGarhi(CT)" },
  { value: "Mannarai(CT)", label: "Mannarai(CT)" },
  { value: "Manoharpur(CT)", label: "Manoharpur(CT)" },
  { value: "Manwal(CT)", label: "Manwal(CT)" },
  { value: "Mappilaiurani(CT)", label: "Mappilaiurani(CT)" },
  { value: "Maradu(CT)", label: "Maradu(CT)" },
  { value: "MaraiKalan(CT)", label: "MaraiKalan(CT)" },
  { value: "Maramangalathupatti(CT)", label: "Maramangalathupatti(CT)" },
  { value: "Marehra(NPP)", label: "Marehra(NPP)" },
  { value: "Marhi(CT)", label: "Marhi(CT)" },
  { value: "Mariahu(NP)", label: "Mariahu(NP)" },
  { value: "Markayankottai(TP)", label: "Markayankottai(TP)" },
  { value: "Marowa(CT)", label: "Marowa(CT)" },
  { value: "Maruadih(CT)", label: "Maruadih(CT)" },
  { value: "Marutharode(CT)", label: "Marutharode(CT)" },
  { value: "Masaurhi(NagarParishad)", label: "Masaurhi(NagarParishad)" },
  { value: "Masila(CT)", label: "Masila(CT)" },
  { value: "Maswasi(NP)", label: "Maswasi(NP)" },
  { value: "Mataundh(NP)", label: "Mataundh(NP)" },
  { value: "Matheran(MCl)", label: "Matheran(MCl)" },
  { value: "Mathurapur(CT)", label: "Mathurapur(CT)" },
  { value: "Mattan(MC)", label: "Mattan(MC)" },
  { value: "Mau(NP)", label: "Mau(NP)" },
  { value: "MauAima(NP)", label: "MauAima(NP)" },
  { value: "Maudaha(NPP)", label: "Maudaha(NPP)" },
  { value: "Mauganj(NP)", label: "Mauganj(NP)" },
  { value: "Maurawan(NP)", label: "Maurawan(NP)" },
  { value: "Mawana(NPP)", label: "Mawana(NPP)" },
  { value: "Mawpat(CT)", label: "Mawpat(CT)" },
  { value: "MayangImphal(MCl)", label: "MayangImphal(MCl)" },
  { value: "Medziphema(TC)", label: "Medziphema(TC)" },
  { value: "Meenambakkam(TP)", label: "Meenambakkam(TP)" },
  { value: "Meerpet(CT)", label: "Meerpet(CT)" },
  { value: "Mehgaon(NP)", label: "Mehgaon(NP)" },
  { value: "Mehnagar(NP)", label: "Mehnagar(NP)" },
  { value: "Mehsi(NP)", label: "Mehsi(NP)" },
  { value: "MehuWalaMafi(CT)", label: "MehuWalaMafi(CT)" },
  { value: "Melachokkanathapuram(TP)", label: "Melachokkanathapuram(TP)" },
  { value: "Mendu(NP)", label: "Mendu(NP)" },
  { value: "Meru(CT)", label: "Meru(CT)" },
  { value: "Mettamalai(CT)", label: "Mettamalai(CT)" },
  { value: "Mettur(M)", label: "Mettur(M)" },
  { value: "MharalBk(CT)", label: "MharalBk(CT)" },
  { value: "Mhaswad(MCl)", label: "Mhaswad(MCl)" },
  { value: "Middha(CT)", label: "Middha(CT)" },
  { value: "Mihona(NP)", label: "Mihona(NP)" },
  { value: "Milavittan(CT)", label: "Milavittan(CT)" },
  { value: "Minjur(TP)", label: "Minjur(TP)" },
  { value: "Miranpur(NP)", label: "Miranpur(NP)" },
  { value: "Mirganj(NP)", label: "Mirganj(NP)" },
  { value: "Mirzapur(CT)", label: "Mirzapur(CT)" },
  { value: "Misrikh-cum-Neemsar(NPP)", label: "Misrikh-cum-Neemsar(NPP)" },
  { value: "Modinagar(NPP)", label: "Modinagar(NPP)" },
  { value: "Mohammadabad(NP)", label: "Mohammadabad(NP)" },
  { value: "Mohammadabad(NPP)", label: "Mohammadabad(NPP)" },
  { value: "Mohammadi(NPP)", label: "Mohammadi(NPP)" },
  { value: "Mohan(NP)", label: "Mohan(NP)" },
  { value: "Mohanpur(CT)", label: "Mohanpur(CT)" },
  { value: "Mohanpur(NP)", label: "Mohanpur(NP)" },
  { value: "Mohenpur(CT)", label: "Mohenpur(CT)" },
  { value: "Mohgaon(NP)", label: "Mohgaon(NP)" },
  { value: "Mohiuddinpur(CT)", label: "Mohiuddinpur(CT)" },
  { value: "Mohmaiki(CT)", label: "Mohmaiki(CT)" },
  { value: "MohpadaAliasWasambe(CT)", label: "MohpadaAliasWasambe(CT)" },
  { value: "Mokokchung(MC)", label: "Mokokchung(MC)" },
  { value: "MolarBand(CT)", label: "MolarBand(CT)" },
  { value: "Mopperipalayam(TP)", label: "Mopperipalayam(TP)" },
  { value: "Moreh(ST)", label: "Moreh(ST)" },
  { value: "Motipur(NP)", label: "Motipur(NP)" },
  { value: "MoujeAnjanvel(CT)", label: "MoujeAnjanvel(CT)" },
  { value: "MountAbu(M)", label: "MountAbu(M)" },
  { value: "Mubarakpur(CT)", label: "Mubarakpur(CT)" },
  { value: "Mubarakpur(NPP)", label: "Mubarakpur(NPP)" },
  { value: "Mudki(NP)", label: "Mudki(NP)" },
  { value: "Mugalivakkam(CT)", label: "Mugalivakkam(CT)" },
  { value: "Mughalsarai(NPP)", label: "Mughalsarai(NPP)" },
  { value: "Muhammadabad(NP)", label: "Muhammadabad(NP)" },
  { value: "Mukhani(CT)", label: "Mukhani(CT)" },
  { value: "Mukhed(MCl)", label: "Mukhed(MCl)" },
  { value: "MukrampurKhema(CT)", label: "MukrampurKhema(CT)" },
  { value: "Mul(MCl)", label: "Mul(MCl)" },
  { value: "Mulavukad(CT)", label: "Mulavukad(CT)" },
  { value: "Multai(M)", label: "Multai(M)" },
  { value: "Mulur(CT)", label: "Mulur(CT)" },
  { value: "MunderaBazar(NP)", label: "MunderaBazar(NP)" },
  { value: "Mundwa(M)", label: "Mundwa(M)" },
  { value: "Mungaoli(NP)", label: "Mungaoli(NP)" },
  { value: "MuniKiReti(NP)", label: "MuniKiReti(NP)" },
  { value: "Murgathaul(CT)", label: "Murgathaul(CT)" },
  { value: "Murmadi(CT)", label: "Murmadi(CT)" },
  { value: "Mursan(NP)", label: "Mursan(NP)" },
  { value: "Murum(MCl)", label: "Murum(MCl)" },
  { value: "Musafirkhana(NP)", label: "Musafirkhana(NP)" },
  { value: "Musiri(TP)", label: "Musiri(TP)" },
  { value: "Mussoorie(NPP)", label: "Mussoorie(NPP)" },
  { value: "Mustafabad(CT)", label: "Mustafabad(CT)" },
  { value: "Muthanampalayam(CT)", label: "Muthanampalayam(CT)" },
  { value: "Muthangi(CT)", label: "Muthangi(CT)" },
  { value: "Muttayyapuram(CT)", label: "Muttayyapuram(CT)" },
  { value: "N.F.LTWP", label: "N.F.LTWP" },
  { value: "NABARANGAPUR", label: "NABARANGAPUR" },
  { value: "NABARANGPUR", label: "NABARANGPUR" },
  { value: "NABHA", label: "NABHA" },
  { value: "NADAPURAM", label: "NADAPURAM" },
  { value: "NADAUN", label: "NADAUN" },
  { value: "NADIA", label: "NADIA" },
  { value: "NADIAD(GJ)", label: "NADIAD(GJ)" },
  { value: "NADOTI", label: "NADOTI" },
  { value: "NAGAMANGALA", label: "NAGAMANGALA" },
  { value: "NAGANAKULAM", label: "NAGANAKULAM" },
  { value: "NAGAON", label: "NAGAON" },
  { value: "NAGAPATTINAM", label: "NAGAPATTINAM" },
  { value: "NAGAPUR", label: "NAGAPUR" },
  { value: "NAGAR", label: "NAGAR" },
  { value: "NAGAR KURNOOL", label: "NAGAR KURNOOL" },
  { value: "NAGARBERA", label: "NAGARBERA" },
  { value: "NAGARI", label: "NAGARI" },
  { value: "NAGARKURNOOL", label: "NAGARKURNOOL" },
  { value: "NAGAUR", label: "NAGAUR" },
  { value: "NAGBHIR", label: "NAGBHIR" },
  { value: "NAGDA", label: "NAGDA" },
  { value: "NAGERCOIL", label: "NAGERCOIL" },
  { value: "NAGINA", label: "NAGINA" },
  { value: "NAGINIMORAHQ", label: "NAGINIMORAHQ" },
  { value: "NAGOTHANE", label: "NAGOTHANE" },
  { value: "NAGPUR", label: "NAGPUR" },
  { value: "NAGRA (41)", label: "NAGRA (41)" },
  { value: "NAGRAKATA", label: "NAGRAKATA" },
  { value: "NAGRI", label: "NAGRI" },
  { value: "NAGROTA", label: "NAGROTA" },
  { value: "NAGROTABAGWAN", label: "NAGROTABAGWAN" },
  { value: "NAHAN", label: "NAHAN" },
  { value: "NAIDUPETA", label: "NAIDUPETA" },
  { value: "NAIGARHI", label: "NAIGARHI" },
  { value: "NAIHATI", label: "NAIHATI" },
  { value: "NAINITAL", label: "NAINITAL" },
  { value: "NAINPUR", label: "NAINPUR" },
  { value: "NAINWA", label: "NAINWA" },
  { value: "NAIPALAPUR", label: "NAIPALAPUR" },
  { value: "NAJIBABAD", label: "NAJIBABAD" },
  { value: "NAKASHIPARA", label: "NAKASHIPARA" },
  { value: "NAKHATRANA", label: "NAKHATRANA" },
  { value: "NAKKAPALLI", label: "NAKKAPALLI" },
  { value: "NAKODAR", label: "NAKODAR" },
  { value: "NAKUR", label: "NAKUR" },
  { value: "NALAGARH", label: "NALAGARH" },
  { value: "NALANDA", label: "NALANDA" },
  { value: "NALASOPARAEAST", label: "NALASOPARAEAST" },
  { value: "NALBARI", label: "NALBARI" },
  { value: "NALCHHA", label: "NALCHHA" },
  { value: "NALGONDA", label: "NALGONDA" },
  { value: "NALIYA", label: "NALIYA" },
  { value: "NALWADI", label: "NALWADI" },
  { value: "NAMAKKAL", label: "NAMAKKAL" },
  { value: "NAMBIYUR", label: "NAMBIYUR" },
  { value: "NAMCHI", label: "NAMCHI" },
  { value: "NAMRUP", label: "NAMRUP" },
  { value: "NAMSAI", label: "NAMSAI" },
  { value: "NANAKMATTA", label: "NANAKMATTA" },
  { value: "NANAPONDHA", label: "NANAPONDHA" },
  { value: "NANDAFATA", label: "NANDAFATA" },
  { value: "NANDAKUMAR", label: "NANDAKUMAR" },
  { value: "NANDAPRAYAG", label: "NANDAPRAYAG" },
  { value: "NANDASAN", label: "NANDASAN" },
  { value: "NANDED", label: "NANDED" },
  { value: "NANDELAV", label: "NANDELAV" },
  { value: "NANDGAON", label: "NANDGAON" },
  { value: "NANDIGAMA", label: "NANDIGAMA" },
  { value: "NANDIPET", label: "NANDIPET" },
  { value: "NANDRI", label: "NANDRI" },
  { value: "NANDURBAR", label: "NANDURBAR" },
  { value: "NANDYALA", label: "NANDYALA" },
  { value: "NANGAL", label: "NANGAL" },
  { value: "NANGALCHAUDHARY", label: "NANGALCHAUDHARY" },
  { value: "NANGLOI", label: "NANGLOI" },
  { value: "NANGUNERI", label: "NANGUNERI" },
  { value: "NANJANGUD", label: "NANJANGUD" },
  { value: "NANKWADA", label: "NANKWADA" },
  { value: "NANMINDA", label: "NANMINDA" },
  { value: "NANNGLI", label: "NANNGLI" },
  { value: "NANPARA", label: "NANPARA" },
  { value: "NAPASAR", label: "NAPASAR" },
  { value: "NAPOKLU", label: "NAPOKLU" },
  { value: "NARAINGARH", label: "NARAINGARH" },
  { value: "NARANAPURAM", label: "NARANAPURAM" },
  { value: "NARASANNAPETA", label: "NARASANNAPETA" },
  { value: "NARASARAOPETA", label: "NARASARAOPETA" },
  { value: "NARASIMHARAJAPURA", label: "NARASIMHARAJAPURA" },
  { value: "NARAVI", label: "NARAVI" },
  { value: "NARAYANGAON", label: "NARAYANGAON" },
  { value: "NARAYANGARH", label: "NARAYANGARH" },
  { value: "NARAYANKHED(CT)", label: "NARAYANKHED(CT)" },
  { value: "NARAYANPET", label: "NARAYANPET" },
  { value: "NARAYANPUR", label: "NARAYANPUR" },
  { value: "NAREGAL", label: "NAREGAL" },
  { value: "NARENDRANAGAR", label: "NARENDRANAGAR" },
  { value: "NARENDRAPUR", label: "NARENDRAPUR" },
  { value: "NARGUND", label: "NARGUND" },
  { value: "NARIANGARH", label: "NARIANGARH" },
  { value: "NARKATIAGANJ", label: "NARKATIAGANJ" },
  { value: "NARKHED", label: "NARKHED" },
  { value: "NARMADA", label: "NARMADA" },
  { value: "NARMADAPURAM", label: "NARMADAPURAM" },
  { value: "NARNAUL", label: "NARNAUL" },
  { value: "NARNAUND", label: "NARNAUND" },
  { value: "NARORA", label: "NARORA" },
  { value: "NARSAPUR", label: "NARSAPUR" },
  { value: "NARSINGARH", label: "NARSINGARH" },
  { value: "NARSINGHPUR", label: "NARSINGHPUR" },
  { value: "NARSIPATNAM", label: "NARSIPATNAM" },
  { value: "NARWAL", label: "NARWAL" },
  { value: "NARWANA", label: "NARWANA" },
  { value: "NASHIK", label: "NASHIK" },
  { value: "NASIRABAD", label: "NASIRABAD" },
  { value: "NASRAPUR", label: "NASRAPUR" },
  { value: "NASRULLAGANJ", label: "NASRULLAGANJ" },
  { value: "NASVADI", label: "NASVADI" },
  { value: "NATEPUTE", label: "NATEPUTE" },
  { value: "NATHAM", label: "NATHAM" },
  { value: "NATHDWARA", label: "NATHDWARA" },
  { value: "NATHUAWALA", label: "NATHUAWALA" },
  { value: "NATRAMPALLI", label: "NATRAMPALLI" },
  { value: "NATTAKOM", label: "NATTAKOM" },
  { value: "NATTHANPUR", label: "NATTHANPUR" },
  { value: "NAUGACHHIA", label: "NAUGACHHIA" },
  { value: "NAUGARH", label: "NAUGARH" },
  { value: "NAUJHEEL", label: "NAUJHEEL" },
  { value: "NAUSHERA", label: "NAUSHERA" },
  { value: "NAUTANWA", label: "NAUTANWA" },
  { value: "NAVIMUMBAI", label: "NAVIMUMBAI" },
  { value: "NAVIPET", label: "NAVIPET" },
  { value: "NAVSARI", label: "NAVSARI" },
  { value: "NAWABGANJ", label: "NAWABGANJ" },
  { value: "NAWADA", label: "NAWADA" },
  { value: "NAWALGARH", label: "NAWALGARH" },
  { value: "NAWANSHAHR", label: "NAWANSHAHR" },
  { value: "NAXALBARI", label: "NAXALBARI" },
  { value: "NAYABAZAR NOTIFIED BAZAR AREA", label: "NAYABAZAR NOTIFIED BAZAR AREA" },
  { value: "NAYAGAON", label: "NAYAGAON" },
  { value: "NAYAGARH", label: "NAYAGARH" },
  { value: "NAZARETH", label: "NAZARETH" },
  { value: "NAZIRA", label: "NAZIRA" },
  { value: "NDMC(Part)", label: "NDMC(Part)" },
  { value: "NEAMATPUR", label: "NEAMATPUR" },
  { value: "NEDUMANGAD", label: "NEDUMANGAD" },
  { value: "NEEDAMANGALAM", label: "NEEDAMANGALAM" },
  { value: "NEEMKATHANA", label: "NEEMKATHANA" },
  { value: "NEEMRANA", label: "NEEMRANA" },
  { value: "NEEMUCH", label: "NEEMUCH" },
  { value: "Neil Island", label: "Neil Island" },
  { value: "NELAKONDAPALLY", label: "NELAKONDAPALLY" },
  { value: "NELAMANGALATOWN", label: "NELAMANGALATOWN" },
  { value: "NELLIKUZHI", label: "NELLIKUZHI" },
  { value: "NELLORE", label: "NELLORE" },
  { value: "NELYADI", label: "NELYADI" },
  { value: "NENMANIKKARA", label: "NENMANIKKARA" },
  { value: "NEORIAHUSAINPUR", label: "NEORIAHUSAINPUR" },
  { value: "NEPANAGAR", label: "NEPANAGAR" },
  { value: "NER", label: "NER" },
  { value: "NERAL", label: "NERAL" },
  { value: "NERKUNDRAM", label: "NERKUNDRAM" },
  { value: "NERUPPERICHAL", label: "NERUPPERICHAL" },
  { value: "NERWA", label: "NERWA" },
  { value: "NESARI", label: "NESARI" },
  { value: "NETHAUR", label: "NETHAUR" },
  { value: "NETRANG", label: "NETRANG" },
  { value: "NEW DELHI", label: "NEW DELHI" },
  { value: "NEWARI", label: "NEWARI" },
  { value: "NEWASA", label: "NEWASA" },
  { value: "NEWDELHI", label: "NEWDELHI" },
  { value: "NEWEGARA", label: "NEWEGARA" },
  { value: "NEWGRAINMANDI", label: "NEWGRAINMANDI" },
  { value: "NEWTEHRI", label: "NEWTEHRI" },
  { value: "NEYKKARAPATTI", label: "NEYKKARAPATTI" },
  { value: "NEYVELI", label: "NEYVELI" },
  { value: "NEYYATTINKARA", label: "NEYYATTINKARA" },
  { value: "NHAVE", label: "NHAVE" },
  { value: "NICOBAR", label: "NICOBAR" },
  { value: "NIDADAVOLE", label: "NIDADAVOLE" },
  { value: "NIDHOLIKALAN", label: "NIDHOLIKALAN" },
  { value: "NIGDI", label: "NIGDI" },
  { value: "NIGOHA", label: "NIGOHA" },
  { value: "NIHALSINGHWALA", label: "NIHALSINGHWALA" },
  { value: "NILAKOTTAI", label: "NILAKOTTAI" },
  { value: "NILAMBUR", label: "NILAMBUR" },
  { value: "NILAMEL", label: "NILAMEL" },
  { value: "NILGIRIS", label: "NILGIRIS" },
  { value: "NILOKHERI", label: "NILOKHERI" },
  { value: "NIMAPADA", label: "NIMAPADA" },
  { value: "NIMBAHERA", label: "NIMBAHERA" },
  { value: "NIPHAD", label: "NIPHAD" },
  { value: "NIRGUNDI", label: "NIRGUNDI" },
  { value: "NIRJULIVILLAGE", label: "NIRJULIVILLAGE" },
  { value: "NIRMAL", label: "NIRMAL" },
  { value: "NIRMAND", label: "NIRMAND" },
  { value: "NIVI", label: "NIVI" },
  { value: "NIWAI", label: "NIWAI" },
  { value: "NIWARI", label: "NIWARI" },
  { value: "NIWAS", label: "NIWAS" },
  { value: "NIZAMABAD", label: "NIZAMABAD" },
  { value: "NIZAMPUR", label: "NIZAMPUR" },
  { value: "NIZAMPURA", label: "NIZAMPURA" },
  { value: "NOAMUNDI", label: "NOAMUNDI" },
  { value: "NOHAR", label: "NOHAR" },
  { value: "NOIDA", label: "NOIDA" },
  { value: "NOKHA", label: "NOKHA" },
  { value: "NONGKSEH", label: "NONGKSEH" },
  { value: "NONGPOH", label: "NONGPOH" },
  { value: "NONGSTOIN", label: "NONGSTOIN" },
  { value: "NOONMATI", label: "NOONMATI" },
  { value: "NOORPUR", label: "NOORPUR" },
  { value: "NORTH 24 PARGANAS", label: "NORTH 24 PARGANAS" },
  { value: "NORTH AND MIDDLE ANDAMAN", label: "NORTH AND MIDDLE ANDAMAN" },
  { value: "NORTH DELHI", label: "NORTH DELHI" },
  { value: "NORTH DINAJPUR", label: "NORTH DINAJPUR" },
  { value: "NORTH EAST DELHI", label: "NORTH EAST DELHI" },
  { value: "NORTH GOA", label: "NORTH GOA" },
  { value: "NORTH SIKKIM", label: "NORTH SIKKIM" },
  { value: "NORTH WEST DELHI", label: "NORTH WEST DELHI" },
  { value: "NORTH24PARGANAS", label: "NORTH24PARGANAS" },
  { value: "NORTHKOTTACHERY", label: "NORTHKOTTACHERY" },
  { value: "NORTHLAKHIMPUR", label: "NORTHLAKHIMPUR" },
  { value: "NORTHTRIPURA", label: "NORTHTRIPURA" },
  { value: "NUA", label: "NUA" },
  { value: "NUAPADA", label: "NUAPADA" },
  { value: "NUH", label: "NUH" },
  { value: "NUMALIGARH", label: "NUMALIGARH" },
  { value: "NURPUR", label: "NURPUR" },
  { value: "NUZIVIDU", label: "NUZIVIDU" },
  { value: "Nabghara(CT)", label: "Nabghara(CT)" },
  { value: "Nabinagar(NP)", label: "Nabinagar(NP)" },
  { value: "Nachane(CT)", label: "Nachane(CT)" },
  { value: "Nadbai(M)", label: "Nadbai(M)" },
  { value: "NadgaonTarfBirwadi(CT)", label: "NadgaonTarfBirwadi(CT)" },
  { value: "Nadiad(M+OG)", label: "Nadiad(M+OG)" },
  { value: "Nadigaon(NP)", label: "Nadigaon(NP)" },
  { value: "Naduvannur(CT)", label: "Naduvannur(CT)" },
  { value: "NagalaImarti(CT)", label: "NagalaImarti(CT)" },
  { value: "Nagam(CT)", label: "Nagam(CT)" },
  { value: "Nagamangalam(CT)", label: "Nagamangalam(CT)" },
  { value: "Nagapattinam(M)", label: "Nagapattinam(M)" },
  { value: "Nagardeole(CT)", label: "Nagardeole(CT)" },
  { value: "Nagercoil(M)", label: "Nagercoil(M)" },
  { value: "Nagina(NPP)", label: "Nagina(NPP)" },
  { value: "Nagla(CT)", label: "Nagla(CT)" },
  { value: "Nagram(NP)", label: "Nagram(NP)" },
  { value: "Nagri(NP)", label: "Nagri(NP)" },
  { value: "NagriKalan(CT)", label: "NagriKalan(CT)" },
  { value: "Nahira(CT)", label: "Nahira(CT)" },
  { value: "NaiBazar(NP)", label: "NaiBazar(NP)" },
  { value: "Nainana-Brahman(CT)", label: "Nainana-Brahman(CT)" },
  { value: "NainanaJat(CT)", label: "NainanaJat(CT)" },
  { value: "Nainital(CB)", label: "Nainital(CB)" },
  { value: "Nainital(NPP)", label: "Nainital(NPP)" },
  { value: "Nainwa(M)", label: "Nainwa(M)" },
  { value: "Najibabad(NPP)", label: "Najibabad(NPP)" },
  { value: "NakhulaGrant(CT)", label: "NakhulaGrant(CT)" },
  { value: "Nakoda(CT)", label: "Nakoda(CT)" },
  { value: "Nakur(NPP)", label: "Nakur(NPP)" },
  { value: "Naldurg(MCl)", label: "Naldurg(MCl)" },
  { value: "Nalkheda(NP)", label: "Nalkheda(NP)" },
  { value: "Nambol(MCI)(Majorpart)", label: "Nambol(MCI)(Majorpart)" },
  { value: "Nanauta(NP)", label: "Nanauta(NP)" },
  { value: "NandgaonPode(CT)", label: "NandgaonPode(CT)" },
  { value: "Nandura(MCl+OG)", label: "Nandura(MCl+OG)" },
  { value: "Nanhera(104)(CT)", label: "Nanhera(104)(CT)" },
  { value: "Nanjikottai(CT)", label: "Nanjikottai(CT)" },
  { value: "Nanpara(NPP)", label: "Nanpara(NPP)" },
  { value: "Nanpur(CT)", label: "Nanpur(CT)" },
  { value: "NaoriyaPakhanglakpa(CT)", label: "NaoriyaPakhanglakpa(CT)" },
  { value: "Naraini(NP)", label: "Naraini(NP)" },
  { value: "Naranammalpuram(TP)", label: "Naranammalpuram(TP)" },
  { value: "Narasingapuram(CT)", label: "Narasingapuram(CT)" },
  { value: "Narauli(NP)", label: "Narauli(NP)" },
  { value: "Narayanapuram(CT)", label: "Narayanapuram(CT)" },
  { value: "Narayangarh(NP)", label: "Narayangarh(NP)" },
  { value: "Narayanpur", label: "Narayanpur" },
  { value: "Nari(CT)", label: "Nari(CT)" },
  { value: "Nari(P)(CT)", label: "Nari(P)(CT)" },
  { value: "Narkanda(NP)", label: "Narkanda(NP)" },
  { value: "NarotMehra(CT)", label: "NarotMehra(CT)" },
  { value: "Narsala(CT)", label: "Narsala(CT)" },
  { value: "Narsingarh(CT)", label: "Narsingarh(CT)" },
  { value: "Narsinghgarh(M)", label: "Narsinghgarh(M)" },
  { value: "Narsingi(CT)", label: "Narsingi(CT)" },
  { value: "Narwar(NP)", label: "Narwar(NP)" },
  { value: "Nasaratpur(CT)", label: "Nasaratpur(CT)" },
  { value: "Naspur(CT)", label: "Naspur(CT)" },
  { value: "Nasrullaganj(NP)", label: "Nasrullaganj(NP)" },
  { value: "Nathampannai(CT)", label: "Nathampannai(CT)" },
  { value: "Nathdwara(M)", label: "Nathdwara(M)" },
  { value: "Natrampalli(TP)", label: "Natrampalli(TP)" },
  { value: "Nattapettai(CT)", label: "Nattapettai(CT)" },
  { value: "Nattarasankottai(TP)", label: "Nattarasankottai(TP)" },
  { value: "Naubatpur(NP)", label: "Naubatpur(NP)" },
  { value: "Naugachhia(NP)", label: "Naugachhia(NP)" },
  { value: "NaugawanSadat(NP)", label: "NaugawanSadat(NP)" },
  { value: "Nautanwa(NPP)", label: "Nautanwa(NPP)" },
  { value: "Navi Mumbai", label: "Navi Mumbai" },
  { value: "Nawa city", label: "Nawa city" },
  { value: "Nawabganj(NP)", label: "Nawabganj(NP)" },
  { value: "Nawabganj(NPP)", label: "Nawabganj(NPP)" },
  { value: "Nawagarh(NP)", label: "Nawagarh(NP)" },
  { value: "Nawalgarh(M)", label: "Nawalgarh(M)" },
  { value: "Nazarathpettai(CT)", label: "Nazarathpettai(CT)" },
  { value: "NebSarai(CT)", label: "NebSarai(CT)" },
  { value: "Neelagiri(CT)", label: "Neelagiri(CT)" },
  { value: "Neelankarai(CT)", label: "Neelankarai(CT)" },
  { value: "Neemrana(CT)", label: "Neemrana(CT)" },
  { value: "Nehon(CT)", label: "Nehon(CT)" },
  { value: "Nellimarla(CT)", label: "Nellimarla(CT)" },
  { value: "Nerkuppai(TP)", label: "Nerkuppai(TP)" },
  { value: "New Chandigarh ", label: "New Chandigarh " },
  { value: "New Mahe", label: "New Mahe" },
  { value: "NewBongaigaonRly.Col.(CT)", label: "NewBongaigaonRly.Col.(CT)" },
  { value: "NewMahe(CT)", label: "NewMahe(CT)" },
  { value: "NewaTalai(CT)", label: "NewaTalai(CT)" },
  { value: "Nibra(CT)", label: "Nibra(CT)" },
  { value: "Nichlaul(NP)", label: "Nichlaul(NP)" },
  { value: "NimbhoreBudruk(CT)", label: "NimbhoreBudruk(CT)" },
  { value: "Ningthoukhong(MCl)", label: "Ningthoukhong(MCl)" },
  { value: "Nirmali(NP)", label: "Nirmali(NP)" },
  { value: "Nissing(MC)", label: "Nissing(MC)" },
  { value: "Nithari(CT)", label: "Nithari(CT)" },
  { value: "Niwari(NP)", label: "Niwari(NP)" },
  { value: "Niz-Bahjani(CT)", label: "Niz-Bahjani(CT)" },
  { value: "Niz-Mankata(CT)", label: "Niz-Mankata(CT)" },
  { value: "Nizamabad(NP)", label: "Nizamabad(NP)" },
  { value: "Nohsa(CT)", label: "Nohsa(CT)" },
  { value: "Nokha(M)", label: "Nokha(M)" },
  { value: "Nongmynsong(CT)", label: "Nongmynsong(CT)" },
  { value: "Nongthymmai(CT)", label: "Nongthymmai(CT)" },
  { value: "Noorpur(NPP)", label: "Noorpur(NPP)" },
  { value: "North Cachar hills", label: "North Cachar hills" },
  { value: "North Dinajpur uttar", label: "North Dinajpur uttar" },
  { value: "North Paravur", label: "North Paravur" },
  { value: "North Tripura", label: "North Tripura" },
  { value: "NorthDumDum(M)", label: "NorthDumDum(M)" },
  { value: "NorthVanlaiphai(NT)", label: "NorthVanlaiphai(NT)" },
  { value: "NowGam(CT)", label: "NowGam(CT)" },
  { value: "Nowbasata(CT)", label: "Nowbasata(CT)" },
  { value: "Nowgong(M)", label: "Nowgong(M)" },
  { value: "Nowrozabad(Khodargama)(NP)", label: "Nowrozabad(Khodargama)(NP)" },
  { value: "Nurmahal(MCl)", label: "Nurmahal(MCl)" },
  { value: "Nurpur(CT)", label: "Nurpur(CT)" },
  { value: "Nyotini(NP)", label: "Nyotini(NP)" },
  { value: "OACHIRA", label: "OACHIRA" },
  { value: "OBAIDULLAGANJ", label: "OBAIDULLAGANJ" },
  { value: "OBEDULLAGANJ", label: "OBEDULLAGANJ" },
  { value: "ODDANCHATRAM", label: "ODDANCHATRAM" },
  { value: "OJHAR", label: "OJHAR" },
  { value: "OKHLA", label: "OKHLA" },
  { value: "OKNINO.II", label: "OKNINO.II" },
  { value: "OLLUR", label: "OLLUR" },
  { value: "OLPAD", label: "OLPAD" },
  { value: "OMALUR", label: "OMALUR" },
  { value: "OMERGA", label: "OMERGA" },
  { value: "ONGOLE", label: "ONGOLE" },
  { value: "ONI", label: "ONI" },
  { value: "OODLABARI", label: "OODLABARI" },
  { value: "OORGAUMPET", label: "OORGAUMPET" },
  { value: "OOTY", label: "OOTY" },
  { value: "ORAI", label: "ORAI" },
  { value: "ORANRURAL", label: "ORANRURAL" },
  { value: "ORDINANCEFACTORYITARSI", label: "ORDINANCEFACTORYITARSI" },
  { value: "ORMANJHI", label: "ORMANJHI" },
  { value: "OROS", label: "OROS" },
  { value: "OSIAN", label: "OSIAN" },
  { value: "OSMANABAD", label: "OSMANABAD" },
  { value: "OTTAPALAM", label: "OTTAPALAM" },
  { value: "OTUR", label: "OTUR" },
  { value: "Obra(NP)", label: "Obra(NP)" },
  { value: "Odaipatti(TP)", label: "Odaipatti(TP)" },
  { value: "OelDhakwa(NP)", label: "OelDhakwa(NP)" },
  { value: "Olavanna(CT)", label: "Olavanna(CT)" },
  { value: "Orchha(NP)", label: "Orchha(NP)" },
  { value: "Owle(CT)", label: "Owle(CT)" },
  { value: "P.N.Patti(TP)", label: "P.N.Patti(TP)" },
  { value: "PABAL", label: "PABAL" },
  { value: "PACHORE", label: "PACHORE" },
  { value: "PACHPADRA", label: "PACHPADRA" },
  { value: "PACHWAD", label: "PACHWAD" },
  { value: "PADAMPUR", label: "PADAMPUR" },
  { value: "PADANTHAL", label: "PADANTHAL" },
  { value: "PADANTHALUMOODU", label: "PADANTHALUMOODU" },
  { value: "PADAPPAI", label: "PADAPPAI" },
  { value: "PADARATHPUR", label: "PADARATHPUR" },
  { value: "PADARI", label: "PADARI" },
  { value: "PADERU", label: "PADERU" },
  { value: "PADGHA", label: "PADGHA" },
  { value: "PADRA", label: "PADRA" },
  { value: "PADRAUNA", label: "PADRAUNA" },
  { value: "PADRI", label: "PADRI" },
  { value: "PADUBIDRI", label: "PADUBIDRI" },
  { value: "PAHASU", label: "PAHASU" },
  { value: "PAHSAIYADRAZA", label: "PAHSAIYADRAZA" },
  { value: "PAITHAN", label: "PAITHAN" },
  { value: "PAKUR", label: "PAKUR" },
  { value: "PAKWARA", label: "PAKWARA" },
  { value: "PALA", label: "PALA" },
  { value: "PALACODE", label: "PALACODE" },
  { value: "PALAKKAD", label: "PALAKKAD" },
  { value: "PALAKONDA", label: "PALAKONDA" },
  { value: "PALAKURTHY", label: "PALAKURTHY" },
  { value: "PALAMANER", label: "PALAMANER" },
  { value: "PALAMAU", label: "PALAMAU" },
  { value: "PALAMPUR", label: "PALAMPUR" },
  { value: "PALAMU", label: "PALAMU" },
  { value: "PALANA", label: "PALANA" },
  { value: "PALANGANAMGUDI", label: "PALANGANAMGUDI" },
  { value: "PALANGARAI", label: "PALANGARAI" },
  { value: "PALANI", label: "PALANI" },
  { value: "PALANPUR", label: "PALANPUR" },
  { value: "PALASA", label: "PALASA" },
  { value: "PALASAN", label: "PALASAN" },
  { value: "PALAYAM", label: "PALAYAM" },
  { value: "PALEJ", label: "PALEJ" },
  { value: "PALGHAR", label: "PALGHAR" },
  { value: "PALI", label: "PALI" },
  { value: "PALIAKALAN", label: "PALIAKALAN" },
  { value: "PALISSERY", label: "PALISSERY" },
  { value: "PALITANA", label: "PALITANA" },
  { value: "PALIYA", label: "PALIYA" },
  { value: "PALLADAM", label: "PALLADAM" },
  { value: "PALLAHARA", label: "PALLAHARA" },
  { value: "PALLAPALAYAM", label: "PALLAPALAYAM" },
  { value: "PALLAVARAM", label: "PALLAVARAM" },
  { value: "PALLICHAL", label: "PALLICHAL" },
  { value: "PALLIKONDA", label: "PALLIKONDA" },
  { value: "PALLIPURAM", label: "PALLIPURAM" },
  { value: "PALSANA", label: "PALSANA" },
  { value: "PALUS", label: "PALUS" },
  { value: "PALWAL", label: "PALWAL" },
  { value: "PALWANCHA", label: "PALWANCHA" },
  { value: "PAMARRU", label: "PAMARRU" },
  { value: "PANAGARH", label: "PANAGARH" },
  { value: "PANAJI", label: "PANAJI" },
  { value: "PANANGAD", label: "PANANGAD" },
  { value: "PANBOLI", label: "PANBOLI" },
  { value: "PANCH MAHALS", label: "PANCH MAHALS" },
  { value: "PANCHARI", label: "PANCHARI" },
  { value: "PANCHGAON", label: "PANCHGAON" },
  { value: "PANCHGRAM", label: "PANCHGRAM" },
  { value: "PANCHKULA", label: "PANCHKULA" },
  { value: "PANCHLA", label: "PANCHLA" },
  { value: "PANCHSHEELNAGAR", label: "PANCHSHEELNAGAR" },
  { value: "PANDALAM", label: "PANDALAM" },
  { value: "PANDALUR", label: "PANDALUR" },
  { value: "PANDARIYA", label: "PANDARIYA" },
  { value: "PANDAVAPURA", label: "PANDAVAPURA" },
  { value: "PANDHARKAWADA", label: "PANDHARKAWADA" },
  { value: "PANDHARPUR", label: "PANDHARPUR" },
  { value: "PANDHURNA", label: "PANDHURNA" },
  { value: "PANDIKKAD", label: "PANDIKKAD" },
  { value: "PANDUA", label: "PANDUA" },
  { value: "PANDUTARFA(BODHANURBAN)", label: "PANDUTARFA(BODHANURBAN)" },
  { value: "PANEY PHENSANG", label: "PANEY PHENSANG" },
  { value: "PANIKOILI", label: "PANIKOILI" },
  { value: "PANIPAT", label: "PANIPAT" },
  { value: "PANJOKHARA", label: "PANJOKHARA" },
  { value: "PANNA", label: "PANNA" },
  { value: "PANOOR", label: "PANOOR" },
  { value: "PANRUTI", label: "PANRUTI" },
  { value: "PANSKURA", label: "PANSKURA" },
  { value: "PANVEL", label: "PANVEL" },
  { value: "PANWARI", label: "PANWARI" },
  { value: "PAONTASAHIB", label: "PAONTASAHIB" },
  { value: "PAOTA", label: "PAOTA" },
  { value: "PAPROLA", label: "PAPROLA" },
  { value: "PAPUMPARE", label: "PAPUMPARE" },
  { value: "PARADEEP", label: "PARADEEP" },
  { value: "PARAKKAD", label: "PARAKKAD" },
  { value: "PARALAKHEMUNDI", label: "PARALAKHEMUNDI" },
  { value: "PARAMAKUDI", label: "PARAMAKUDI" },
  { value: "PARAMATHI", label: "PARAMATHI" },
  { value: "PARANDA", label: "PARANDA" },
  { value: "PARANGIPETTAI", label: "PARANGIPETTAI" },
  { value: "PARAPPANANGADI", label: "PARAPPANANGADI" },
  { value: "PARASIA", label: "PARASIA" },
  { value: "PARASSALA", label: "PARASSALA" },
  { value: "PARATWADA", label: "PARATWADA" },
  { value: "PARAVUR", label: "PARAVUR" },
  { value: "PARBATSAR", label: "PARBATSAR" },
  { value: "PARBHANI", label: "PARBHANI" },
  { value: "PARDI [KAUSADI]", label: "PARDI [KAUSADI]" },
  { value: "PARDIKANDE", label: "PARDIKANDE" },
  { value: "PARDISANDHPOR", label: "PARDISANDHPOR" },
  { value: "PARGAON", label: "PARGAON" },
  { value: "PARIGI", label: "PARIGI" },
  { value: "PARIPPALLY", label: "PARIPPALLY" },
  { value: "PARKAL", label: "PARKAL" },
  { value: "PARSHIVNI", label: "PARSHIVNI" },
  { value: "PARSONA", label: "PARSONA" },
  { value: "PARVADA", label: "PARVADA" },
  { value: "PARVATHIPURAM", label: "PARVATHIPURAM" },
  { value: "PARWANOO", label: "PARWANOO" },
  { value: "PASCHIMGOPINATHPUR", label: "PASCHIMGOPINATHPUR" },
  { value: "PASHAN", label: "PASHAN" },
  { value: "PASIGHAT", label: "PASIGHAT" },
  { value: "PASUMPON", label: "PASUMPON" },
  { value: "PAT", label: "PAT" },
  { value: "PATAN", label: "PATAN" },
  { value: "PATASHPUR", label: "PATASHPUR" },
  { value: "PATAUDI", label: "PATAUDI" },
  { value: "PATDI", label: "PATDI" },
  { value: "PATHALGAON", label: "PATHALGAON" },
  { value: "PATHANAMTHITTA", label: "PATHANAMTHITTA" },
  { value: "PATHANAPURAM", label: "PATHANAPURAM" },
  { value: "PATHANKOT", label: "PATHANKOT" },
  { value: "PATHAPATNAM", label: "PATHAPATNAM" },
  { value: "PATHARDI", label: "PATHARDI" },
  { value: "PATHARKANDI", label: "PATHARKANDI" },
  { value: "PATHIRAPPALLY", label: "PATHIRAPPALLY" },
  { value: "PATHSALA", label: "PATHSALA" },
  { value: "PATIALA", label: "PATIALA" },
  { value: "PATIYALI", label: "PATIYALI" },
  { value: "PATLA", label: "PATLA" },
  { value: "PATNA", label: "PATNA" },
  { value: "PATPARGANJ", label: "PATPARGANJ" },
  { value: "PATRAN", label: "PATRAN" },
  { value: "PATRATU", label: "PATRATU" },
  { value: "PATRODIH", label: "PATRODIH" },
  { value: "PATTAMBI", label: "PATTAMBI" },
  { value: "PATTAMUNDAI", label: "PATTAMUNDAI" },
  { value: "PATTI", label: "PATTI" },
  { value: "PATTIKONDA", label: "PATTIKONDA" },
  { value: "PATTUKKOTTAI", label: "PATTUKKOTTAI" },
  { value: "PAURI", label: "PAURI" },
  { value: "PAURI GARHWAL", label: "PAURI GARHWAL" },
  { value: "PAURIGARHWAL", label: "PAURIGARHWAL" },
  { value: "PAVITHIRAM", label: "PAVITHIRAM" },
  { value: "PAWAI", label: "PAWAI" },
  { value: "PAWANI", label: "PAWANI" },
  { value: "PAYAGPUR", label: "PAYAGPUR" },
  { value: "PAYAL", label: "PAYAL" },
  { value: "PAYYANUR", label: "PAYYANUR" },
  { value: "PAZHAYANGADI", label: "PAZHAYANGADI" },
  { value: "PEDDAPALLI", label: "PEDDAPALLI" },
  { value: "PEDDAPURAM", label: "PEDDAPURAM" },
  { value: "PEDONG", label: "PEDONG" },
  { value: "PEHOWA", label: "PEHOWA" },
  { value: "PEN", label: "PEN" },
  { value: "PENDRA", label: "PENDRA" },
  { value: "PENDURTHI", label: "PENDURTHI" },
  { value: "PENNAGARAM", label: "PENNAGARAM" },
  { value: "PEPPEGANJ", label: "PEPPEGANJ" },
  { value: "PERAMBAKKAM", label: "PERAMBAKKAM" },
  { value: "PERAMBALUR", label: "PERAMBALUR" },
  { value: "PERAMBRA", label: "PERAMBRA" },
  { value: "PERAVOOR", label: "PERAVOOR" },
  { value: "PEREMBRA", label: "PEREMBRA" },
  { value: "PEREN", label: "PEREN" },
  { value: "PERESANDRA", label: "PERESANDRA" },
  { value: "PERINTHALMANNA", label: "PERINTHALMANNA" },
  { value: "PERIYAKULAM", label: "PERIYAKULAM" },
  { value: "PERIYANAICKENPALAYAM", label: "PERIYANAICKENPALAYAM" },
  { value: "PERIYANEGAMAM", label: "PERIYANEGAMAM" },
  { value: "PERNAMBUT", label: "PERNAMBUT" },
  { value: "PERNEM", label: "PERNEM" },
  { value: "PERUMANALLUR", label: "PERUMANALLUR" },
  { value: "PERUMANNA", label: "PERUMANNA" },
  { value: "PERUMBAVOOR", label: "PERUMBAVOOR" },
  { value: "PERUNDURAI", label: "PERUNDURAI" },
  { value: "PERUVAYAL", label: "PERUVAYAL" },
  { value: "PETLAD", label: "PETLAD" },
  { value: "PETLAWAD", label: "PETLAWAD" },
  { value: "PHAGI", label: "PHAGI" },
  { value: "PHAGWARA", label: "PHAGWARA" },
  { value: "PHALI", label: "PHALI" },
  { value: "PHALODI", label: "PHALODI" },
  { value: "PHALTAN", label: "PHALTAN" },
  { value: "PHAPHUNDA", label: "PHAPHUNDA" },
  { value: "PHEK", label: "PHEK" },
  { value: "PHILLAUR", label: "PHILLAUR" },
  { value: "PHINTER", label: "PHINTER" },
  { value: "PHODONG", label: "PHODONG" },
  { value: "PHOOLPUR", label: "PHOOLPUR" },
  { value: "PHOONKIYA", label: "PHOONKIYA" },
  { value: "PHUENTSHOLING", label: "PHUENTSHOLING" },
  { value: "PHULBANI", label: "PHULBANI" },
  { value: "PHULERA", label: "PHULERA" },
  { value: "PHULIA", label: "PHULIA" },
  { value: "PHULWARISHARIF", label: "PHULWARISHARIF" },
  { value: "PHUNCHOG RAI ", label: "PHUNCHOG RAI " },
  { value: "PHUSRO", label: "PHUSRO" },
  { value: "PICHHORE", label: "PICHHORE" },
  { value: "PIDUGURALLA", label: "PIDUGURALLA" },
  { value: "PILAKHNA", label: "PILAKHNA" },
  { value: "PILANI", label: "PILANI" },
  { value: "PILERU", label: "PILERU" },
  { value: "PILIBANGA", label: "PILIBANGA" },
  { value: "PILIBHIT", label: "PILIBHIT" },
  { value: "PILKHUWA", label: "PILKHUWA" },
  { value: "PIMPALGAONBASWANT", label: "PIMPALGAONBASWANT" },
  { value: "PIMPRI-CHINCHWAD", label: "PIMPRI-CHINCHWAD" },
  { value: "PINANGWAN", label: "PINANGWAN" },
  { value: "PINDRA", label: "PINDRA" },
  { value: "PINDWARA", label: "PINDWARA" },
  { value: "PINJORE", label: "PINJORE" },
  { value: "PIPALKOTI", label: "PIPALKOTI" },
  { value: "PIPARCITY", label: "PIPARCITY" },
  { value: "PIPARI", label: "PIPARI" },
  { value: "PIPARIYA", label: "PIPARIYA" },
  { value: "PIPILI", label: "PIPILI" },
  { value: "PIPLIAMANDI", label: "PIPLIAMANDI" },
  { value: "PIPLIYAKUMAR", label: "PIPLIYAKUMAR" },
  { value: "PIRANGUT", label: "PIRANGUT" },
  { value: "PIRANKALIYAR", label: "PIRANKALIYAR" },
  { value: "PIRANWADI", label: "PIRANWADI" },
  { value: "PIRAVOM", label: "PIRAVOM" },
  { value: "PIRAWA", label: "PIRAWA" },
  { value: "PIRIYAPATNA", label: "PIRIYAPATNA" },
  { value: "PIRO", label: "PIRO" },
  { value: "PISANGAN", label: "PISANGAN" },
  { value: "PITHAMPUR", label: "PITHAMPUR" },
  { value: "PITHAPURAM", label: "PITHAPURAM" },
  { value: "PITHORA", label: "PITHORA" },
  { value: "PITHORAGARH", label: "PITHORAGARH" },
  { value: "POCHAMPALLI", label: "POCHAMPALLI" },
  { value: "POHIR", label: "POHIR" },
  { value: "POKHRAN", label: "POKHRAN" },
  { value: "POLAYKALAN", label: "POLAYKALAN" },
  { value: "POLEM", label: "POLEM" },
  { value: "POLLACHI", label: "POLLACHI" },
  { value: "POLUR", label: "POLUR" },
  { value: "PONDA", label: "PONDA" },
  { value: "PONDICHERRY", label: "PONDICHERRY" },
  { value: "PONNAMARAVATHI", label: "PONNAMARAVATHI" },
  { value: "PONNANI", label: "PONNANI" },
  { value: "PONNERI", label: "PONNERI" },
  { value: "PONNUR", label: "PONNUR" },
  { value: "POONCH", label: "POONCH" },
  { value: "POOTHKHAS", label: "POOTHKHAS" },
  { value: "POR", label: "POR" },
  { value: "PORBANDAR", label: "PORBANDAR" },
  { value: "POROMPAT", label: "POROMPAT" },
  { value: "PORT BLAIR", label: "PORT BLAIR" },
  { value: "PORTBLAIR", label: "PORTBLAIR" },
  { value: "PORVORIM", label: "PORVORIM" },
  { value: "POYNAD", label: "POYNAD" },
  { value: "PRAKASAM", label: "PRAKASAM" },
  { value: "PRATAPGARH", label: "PRATAPGARH" },
  { value: "PRATAPGHAR", label: "PRATAPGHAR" },
  { value: "PRATAPNAGAR", label: "PRATAPNAGAR" },
  { value: "PRATAPPURA", label: "PRATAPPURA" },
  { value: "PRAYAGRAJ", label: "PRAYAGRAJ" },
  { value: "PRAYAGRAJCHHEOKI", label: "PRAYAGRAJCHHEOKI" },
  { value: "PRODDATUR", label: "PRODDATUR" },
  { value: "PUDUCHERRY", label: "PUDUCHERRY" },
  { value: "PUDUKKOTTAI", label: "PUDUKKOTTAI" },
  { value: "PUKHRAYAN", label: "PUKHRAYAN" },
  { value: "PULGAON", label: "PULGAON" },
  { value: "PULIVENDULA", label: "PULIVENDULA" },
  { value: "PULIYANKUDI", label: "PULIYANKUDI" },
  { value: "PULPEHLADPUR", label: "PULPEHLADPUR" },
  { value: "PULWAMA", label: "PULWAMA" },
  { value: "PUNALUR", label: "PUNALUR" },
  { value: "PUNDRI", label: "PUNDRI" },
  { value: "PUNE", label: "PUNE" },
  { value: "PUNHANA", label: "PUNHANA" },
  { value: "PUNJAIPUGALUR", label: "PUNJAIPUGALUR" },
  { value: "PUNJAIPULIAMPATTI", label: "PUNJAIPULIAMPATTI" },
  { value: "PURAMUFTI", label: "PURAMUFTI" },
  { value: "PURANABAZAR", label: "PURANABAZAR" },
  { value: "PURANDARPUR", label: "PURANDARPUR" },
  { value: "PURANPUR", label: "PURANPUR" },
  { value: "PURBIKARGAHIA", label: "PURBIKARGAHIA" },
  { value: "PURDILNAGAR", label: "PURDILNAGAR" },
  { value: "PURI", label: "PURI" },
  { value: "PURNIA", label: "PURNIA" },
  { value: "PUROLA", label: "PUROLA" },
  { value: "PURSURA", label: "PURSURA" },
  { value: "PURULIA", label: "PURULIA" },
  { value: "PURWA", label: "PURWA" },
  { value: "PUSAD", label: "PUSAD" },
  { value: "PUSHPRAJGARH", label: "PUSHPRAJGARH" },
  { value: "PUTHOOR", label: "PUTHOOR" },
  { value: "PUTHUKKAD", label: "PUTHUKKAD" },
  { value: "PUTTAPRTHI", label: "PUTTAPRTHI" },
  { value: "PUTTUR", label: "PUTTUR" },
  { value: "PYALA", label: "PYALA" },
  { value: "PYNTHORUMKHRAH", label: "PYNTHORUMKHRAH" },
  { value: "PYNURSLA", label: "PYNURSLA" },
  { value: "Pachal", label: "Pachal" },
  { value: "Pachgaon(CT)", label: "Pachgaon(CT)" },
  { value: "Pachperwa(NP)", label: "Pachperwa(NP)" },
  { value: "PadaliGujar(CT)", label: "PadaliGujar(CT)" },
  { value: "Padikkasuvaithanpatti(CT)", label: "Padikkasuvaithanpatti(CT)" },
  { value: "Padoli(CT)", label: "Padoli(CT)" },
  { value: "Pahalgam(MC)", label: "Pahalgam(MC)" },
  { value: "Paharpur(CT)", label: "Paharpur(CT)" },
  { value: "Pahasu(NP)", label: "Pahasu(NP)" },
  { value: "Paintepur(NP)", label: "Paintepur(NP)" },
  { value: "PakriyaNaugwanMustqil(CT)", label: "PakriyaNaugwanMustqil(CT)" },
  { value: "Palamedu(TP)", label: "Palamedu(TP)" },
  { value: "PalaniChettipatti(TP)", label: "PalaniChettipatti(TP)" },
  { value: "Palasbari(MB)", label: "Palasbari(MB)" },
  { value: "Palashban(CT)", label: "Palashban(CT)" },
  { value: "Palavakkam(CT)", label: "Palavakkam(CT)" },
  { value: "Palda(CT)", label: "Palda(CT)" },
  { value: "Palera(NP)", label: "Palera(NP)" },
  { value: "Palghar(MCl)", label: "Palghar(MCl)" },
  { value: "Palhni(CT)", label: "Palhni(CT)" },
  { value: "Pali(CT)", label: "Pali(CT)" },
  { value: "Pali(NP)", label: "Pali(NP)" },
  { value: "PaliKhera(CT)", label: "PaliKhera(CT)" },
  { value: "Palidevad(CT)", label: "Palidevad(CT)" },
  { value: "Palladam(M)", label: "Palladam(M)" },
  { value: "Pallanthurai(CT)", label: "Pallanthurai(CT)" },
  { value: "Pallapatti(CT)", label: "Pallapatti(CT)" },
  { value: "Pallathur(TP)", label: "Pallathur(TP)" },
  { value: "Pallikkunnu(CT)", label: "Pallikkunnu(CT)" },
  { value: "Pallipalayam(M)", label: "Pallipalayam(M)" },
  { value: "PallipalayamAgraharam(CT)", label: "PallipalayamAgraharam(CT)" },
  { value: "Panch Mahal", label: "Panch Mahal" },
  { value: "Panchkula(MCl)", label: "Panchkula(MCl)" },
  { value: "Panchkula ", label: "Panchkula " },
  { value: "Panchpara(CT)", label: "Panchpara(CT)" },
  { value: "Pandharpur(MCl)", label: "Pandharpur(MCl)" },
  { value: "Pankhedi(CT)", label: "Pankhedi(CT)" },
  { value: "Pannaipuram(TP)", label: "Pannaipuram(TP)" },
  { value: "Panoli(INA)", label: "Panoli(INA)" },
  { value: "Pantheeramkavu(CT)", label: "Pantheeramkavu(CT)" },
  { value: "Panuria(CT)", label: "Panuria(CT)" },
  { value: "Papampeta(CT)", label: "Papampeta(CT)" },
  { value: "Pappankurichi(CT)", label: "Pappankurichi(CT)" },
  { value: "Papum Pare", label: "Papum Pare" },
  { value: "Para(CT)", label: "Para(CT)" },
  { value: "Paraniputhur(CT)", label: "Paraniputhur(CT)" },
  { value: "Parappukkara(CT)", label: "Parappukkara(CT)" },
  { value: "Parasi(CT)", label: "Parasi(CT)" },
  { value: "Paratdih(CT)", label: "Paratdih(CT)" },
  { value: "PardiParnera(CT)", label: "PardiParnera(CT)" },
  { value: "Parichha(CT)", label: "Parichha(CT)" },
  { value: "Parikshitgarh(NP)", label: "Parikshitgarh(NP)" },
  { value: "Parmanandpur(CT)", label: "Parmanandpur(CT)" },
  { value: "Parsadepur(NP)", label: "Parsadepur(NP)" },
  { value: "PartapSinghwala(CT)", label: "PartapSinghwala(CT)" },
  { value: "Parvathipuram(M)", label: "Parvathipuram(M)" },
  { value: "Pasan(M)", label: "Pasan(M)" },
  { value: "PaschimJitpur(CT)", label: "PaschimJitpur(CT)" },
  { value: "Patan(NP)", label: "Patan(NP)" },
  { value: "Pathanamthitta ", label: "Pathanamthitta " },
  { value: "Pathardi(MCl)", label: "Pathardi(MCl)" },
  { value: "Patharia(NP)", label: "Patharia(NP)" },
  { value: "Pathariya(NP)", label: "Pathariya(NP)" },
  { value: "Patholi(CT)", label: "Patholi(CT)" },
  { value: "Pathsala(TC)", label: "Pathsala(TC)" },
  { value: "Patiyali(NP)", label: "Patiyali(NP)" },
  { value: "Pattanam(CT)", label: "Pattanam(CT)" },
  { value: "Patti(MCl)", label: "Patti(MCl)" },
  { value: "Pattinamkattan(CT)", label: "Pattinamkattan(CT)" },
  { value: "Pauni(MCl)", label: "Pauni(MCl)" },
  { value: "Pauri(NPP)", label: "Pauri(NPP)" },
  { value: "Pavali(CT)", label: "Pavali(CT)" },
  { value: "Pawai(NP)", label: "Pawai(NP)" },
  { value: "PedaBoddepalle(CT)", label: "PedaBoddepalle(CT)" },
  { value: "Pennathur(TP)", label: "Pennathur(TP)" },
  { value: "Periapattinam(CT)", label: "Periapattinam(CT)" },
  { value: "PeriyaNegamam(TP)", label: "PeriyaNegamam(TP)" },
  { value: "Periyakulam(M)", label: "Periyakulam(M)" },
  { value: "Periyar", label: "Periyar" },
  { value: "Pfutsero(TC)", label: "Pfutsero(TC)" },
  { value: "Phalauda(NP)", label: "Phalauda(NP)" },
  { value: "Phek(TC)", label: "Phek(TC)" },
  { value: "Phulera(M)", label: "Phulera(M)" },
  { value: "Phulwaria(CT)", label: "Phulwaria(CT)" },
  { value: "Phuphkalan(NP)", label: "Phuphkalan(NP)" },
  { value: "Pichhore(NP)", label: "Pichhore(NP)" },
  { value: "Pimpalgaon(CT)", label: "Pimpalgaon(CT)" },
  { value: "Pinahat(NP)", label: "Pinahat(NP)" },
  { value: "Pindwara(M)", label: "Pindwara(M)" },
  { value: "Pinjore(MC)", label: "Pinjore(MC)" },
  { value: "Pipalrawan(NP)", label: "Pipalrawan(NP)" },
  { value: "PipalsanaChaudhari(CT)", label: "PipalsanaChaudhari(CT)" },
  { value: "PiparaDand(CT)", label: "PiparaDand(CT)" },
  { value: "Pipariya(NP)", label: "Pipariya(NP)" },
  { value: "Pipraich(NP)", label: "Pipraich(NP)" },
  { value: "Pirangut(CT)", label: "Pirangut(CT)" },
  { value: "Pirawa(M)", label: "Pirawa(M)" },
  { value: "Pirayiri(CT)", label: "Pirayiri(CT)" },
  { value: "Piro(NP)", label: "Piro(NP)" },
  { value: "Podara(CT)", label: "Podara(CT)" },
  { value: "Poladpur(CT)", label: "Poladpur(CT)" },
  { value: "PoothKalan(CT)", label: "PoothKalan(CT)" },
  { value: "Porsa(M)", label: "Porsa(M)" },
  { value: "Porur(TP)", label: "Porur(TP)" },
  { value: "Pothatturpettai(TP)", label: "Pothatturpettai(TP)" },
  { value: "Powayan(NP)", label: "Powayan(NP)" },
  { value: "Pratitnagar(CT)", label: "Pratitnagar(CT)" },
  { value: "Prayagraj Allahabad", label: "Prayagraj Allahabad" },
  { value: "PremchakUrfBaheri(CT)", label: "PremchakUrfBaheri(CT)" },
  { value: "Prithvipur(NP)", label: "Prithvipur(NP)" },
  { value: "Prothrapur(CT)", label: "Prothrapur(CT)" },
  { value: "PudupalayamAgraharam(CT)", label: "PudupalayamAgraharam(CT)" },
  { value: "Pudupatti(TP)", label: "Pudupatti(TP)" },
  { value: "Puduvayal(TP)", label: "Puduvayal(TP)" },
  { value: "Pukhrayan(NPP)", label: "Pukhrayan(NPP)" },
  { value: "Pulgaon(MCl)", label: "Pulgaon(MCl)" },
  { value: "Puliyur(TP)", label: "Puliyur(TP)" },
  { value: "Punjab", label: "Punjab" },
  { value: "PunjaiThottakurichi(TP)", label: "PunjaiThottakurichi(TP)" },
  { value: "PuraPandey(CT)", label: "PuraPandey(CT)" },
  { value: "Puranattukara(CT)", label: "Puranattukara(CT)" },
  { value: "PureTiwari(CT)", label: "PureTiwari(CT)" },
  { value: "Purne(CT)", label: "Purne(CT)" },
  { value: "Purquazi(NP)", label: "Purquazi(NP)" },
  { value: "Purwa(NP)", label: "Purwa(NP)" },
  { value: "Pushkar(M)", label: "Pushkar(M)" },
  { value: "Puthagaram(CT)", label: "Puthagaram(CT)" },
  { value: "Puthuppariyaram(CT)", label: "Puthuppariyaram(CT)" },
  { value: "PuthurAgraharam(CT)", label: "PuthurAgraharam(CT)" },
  { value: "Puzhakkal(CT)", label: "Puzhakkal(CT)" },
  { value: "Puzhathi(CT)", label: "Puzhathi(CT)" },
  { value: "QAIMOH", label: "QAIMOH" },
  { value: "QAZIGUND", label: "QAZIGUND" },
  { value: "QUAID-E-MILLATNAGAR", label: "QUAID-E-MILLATNAGAR" },
  { value: "QUARSI", label: "QUARSI" },
  { value: "QUEPEM", label: "QUEPEM" },
  { value: "QUEULA", label: "QUEULA" },
  { value: "QUILANDAY", label: "QUILANDAY" },
  { value: "RABKAVIBANHATTI", label: "RABKAVIBANHATTI" },
  { value: "RADAUR", label: "RADAUR" },
  { value: "RADHAKRISHNAPUR", label: "RADHAKRISHNAPUR" },
  { value: "RADHAKUND", label: "RADHAKUND" },
  { value: "RADHANPUR", label: "RADHANPUR" },
  { value: "RAEBARELI", label: "RAEBARELI" },
  { value: "RAGHABPURP", label: "RAGHABPURP" },
  { value: "RAGHUNATHGANJ", label: "RAGHUNATHGANJ" },
  { value: "RAHA", label: "RAHA" },
  { value: "RAHURI", label: "RAHURI" },
  { value: "RAICHUR", label: "RAICHUR" },
  { value: "RAIGAD", label: "RAIGAD" },
  { value: "RAIGANJ", label: "RAIGANJ" },
  { value: "RAIGARH", label: "RAIGARH" },
  { value: "RAIKOT", label: "RAIKOT" },
  { value: "RAIL", label: "RAIL" },
  { value: "RAILMAGRA", label: "RAILMAGRA" },
  { value: "RAILWAYCOLONY", label: "RAILWAYCOLONY" },
  { value: "RAIPUR", label: "RAIPUR" },
  { value: "RAIPURRANI", label: "RAIPURRANI" },
  { value: "RAIRANGPUR", label: "RAIRANGPUR" },
  { value: "RAISEN", label: "RAISEN" },
  { value: "RAISINGHNAGAR", label: "RAISINGHNAGAR" },
  { value: "RAIWALA", label: "RAIWALA" },
  { value: "RAJAKKAD", label: "RAJAKKAD" },
  { value: "RAJALDESAR", label: "RAJALDESAR" },
  { value: "RAJAM", label: "RAJAM" },
  { value: "RAJAMAHENDRAVARAM", label: "RAJAMAHENDRAVARAM" },
  { value: "RAJAMPET", label: "RAJAMPET" },
  { value: "RAJANUKUNTE", label: "RAJANUKUNTE" },
  { value: "RAJAPALAYAM", label: "RAJAPALAYAM" },
  { value: "RAJAPUR", label: "RAJAPUR" },
  { value: "RAJARHAT", label: "RAJARHAT" },
  { value: "RAJASUNAKHALA", label: "RAJASUNAKHALA" },
  { value: "RAJAURI", label: "RAJAURI" },
  { value: "RAJDHANWAR", label: "RAJDHANWAR" },
  { value: "RAJGAD", label: "RAJGAD" },
  { value: "RAJGANJ", label: "RAJGANJ" },
  { value: "RAJGARH", label: "RAJGARH" },
  { value: "RAJGIR", label: "RAJGIR" },
  { value: "RAJGURUNAGAR", label: "RAJGURUNAGAR" },
  { value: "RAJIM", label: "RAJIM" },
  { value: "RAJIYASAR", label: "RAJIYASAR" },
  { value: "RAJKOT", label: "RAJKOT" },
  { value: "RAJNANDGAON", label: "RAJNANDGAON" },
  { value: "RAJOD", label: "RAJOD" },
  { value: "RAJOUND", label: "RAJOUND" },
  { value: "RAJOURI", label: "RAJOURI" },
  { value: "RAJPARDI", label: "RAJPARDI" },
  { value: "RAJPIPLA", label: "RAJPIPLA" },
  { value: "RAJPURA", label: "RAJPURA" },
  { value: "RAJPURKHADAR", label: "RAJPURKHADAR" },
  { value: "RAJSAMAND", label: "RAJSAMAND" },
  { value: "RAJULA", label: "RAJULA" },
  { value: "RAJURA", label: "RAJURA" },
  { value: "RAKRI", label: "RAKRI" },
  { value: "RALEGAON", label: "RALEGAON" },
  { value: "RAMAGUNDAM", label: "RAMAGUNDAM" },
  { value: "RAMANAGAR", label: "RAMANAGAR" },
  { value: "RAMANAGARA", label: "RAMANAGARA" },
  { value: "RAMANATHAPURAM", label: "RAMANATHAPURAM" },
  { value: "RAMANATTUKARA", label: "RAMANATTUKARA" },
  { value: "RAMAPUR", label: "RAMAPUR" },
  { value: "RAMAYAMPET", label: "RAMAYAMPET" },
  { value: "RAMBAN", label: "RAMBAN" },
  { value: "RAMDASPUURFNAGAL", label: "RAMDASPUURFNAGAL" },
  { value: "RAMESWARAM", label: "RAMESWARAM" },
  { value: "RAMGANJMANDI", label: "RAMGANJMANDI" },
  { value: "RAMGARH", label: "RAMGARH" },
  { value: "RAMJIBANPUR", label: "RAMJIBANPUR" },
  { value: "RAMKRISHNANAGAR", label: "RAMKRISHNANAGAR" },
  { value: "RAMNAGAR", label: "RAMNAGAR" },
  { value: "RAMPACHODAVARAM", label: "RAMPACHODAVARAM" },
  { value: "RAMPUR", label: "RAMPUR" },
  { value: "RAMPURAPHUL", label: "RAMPURAPHUL" },
  { value: "RAMPURBUSHAHR", label: "RAMPURBUSHAHR" },
  { value: "RAMPURHAT", label: "RAMPURHAT" },
  { value: "RAMSANEHIGHAT", label: "RAMSANEHIGHAT" },
  { value: "RAMSHEHAR", label: "RAMSHEHAR" },
  { value: "RAMSINGHPUR", label: "RAMSINGHPUR" },
  { value: "RAMTEK", label: "RAMTEK" },
  { value: "RANAGHAT", label: "RANAGHAT" },
  { value: "RANBIRSINGHPURA", label: "RANBIRSINGHPURA" },
  { value: "RANCHI", label: "RANCHI" },
  { value: "RANEBENNUR", label: "RANEBENNUR" },
  { value: "RANGAPAHAR", label: "RANGAPAHAR" },
  { value: "RANGAREDDY", label: "RANGAREDDY" },
  { value: "RANGAT", label: "RANGAT" },
  { value: "RANGIA", label: "RANGIA" },
  { value: "RANIA", label: "RANIA" },
  { value: "RANIBANDH", label: "RANIBANDH" },
  { value: "RANIGANJ", label: "RANIGANJ" },
  { value: "RANIGAON", label: "RANIGAON" },
  { value: "RANIKHET", label: "RANIKHET" },
  { value: "RANIPET", label: "RANIPET" },
  { value: "RANIWARA", label: "RANIWARA" },
  { value: "RANNI", label: "RANNI" },
  { value: "RANPUR", label: "RANPUR" },
  { value: "RAPAR", label: "RAPAR" },
  { value: "RASHMI", label: "RASHMI" },
  { value: "RASINA", label: "RASINA" },
  { value: "RASIPURAM", label: "RASIPURAM" },
  { value: "RASULABAD", label: "RASULABAD" },
  { value: "RASULPUR", label: "RASULPUR" },
  { value: "RATANGARH", label: "RATANGARH" },
  { value: "RATANNAGAR", label: "RATANNAGAR" },
  { value: "RATH", label: "RATH" },
  { value: "RATIA", label: "RATIA" },
  { value: "RATLAM", label: "RATLAM" },
  { value: "RATNAGIRI", label: "RATNAGIRI" },
  { value: "RATTIHALLI", label: "RATTIHALLI" },
  { value: "RAVAPAR", label: "RAVAPAR" },
  { value: "RAVER", label: "RAVER" },
  { value: "RAVULAPALEM", label: "RAVULAPALEM" },
  { value: "RAWATBHATA", label: "RAWATBHATA" },
  { value: "RAWATSAR", label: "RAWATSAR" },
  { value: "RAXAUL", label: "RAXAUL" },
  { value: "RAYA", label: "RAYA" },
  { value: "RAYACHOTY", label: "RAYACHOTY" },
  { value: "RAYAGADA", label: "RAYAGADA" },
  { value: "RAYYA", label: "RAYYA" },
  { value: "REASI", label: "REASI" },
  { value: "RECKONGPEO", label: "RECKONGPEO" },
  { value: "REDHILLS", label: "REDHILLS" },
  { value: "REENGUS", label: "REENGUS" },
  { value: "REES", label: "REES" },
  { value: "REHAN", label: "REHAN" },
  { value: "RENUKOOT", label: "RENUKOOT" },
  { value: "RENUKOT", label: "RENUKOT" },
  { value: "RENWAL", label: "RENWAL" },
  { value: "RENWALMANJI", label: "RENWALMANJI" },
  { value: "REPALLE", label: "REPALLE" },
  { value: "REVDAR", label: "REVDAR" },
  { value: "REWA", label: "REWA" },
  { value: "REWALSAR", label: "REWALSAR" },
  { value: "REWARI", label: "REWARI" },
  { value: "RIDMALSAR", label: "RIDMALSAR" },
  { value: "RISHABHDEV", label: "RISHABHDEV" },
  { value: "RISHIKESH", label: "RISHIKESH" },
  { value: "RISHRA", label: "RISHRA" },
  { value: "RISIABAZAAR", label: "RISIABAZAAR" },
  { value: "RISIABAZAR", label: "RISIABAZAR" },
  { value: "RLY.SETTLEMENTROZA", label: "RLY.SETTLEMENTROZA" },
  { value: "ROBERTSGANJ", label: "ROBERTSGANJ" },
  { value: "RODAYAN", label: "RODAYAN" },
  { value: "ROHA", label: "ROHA" },
  { value: "ROHINI", label: "ROHINI" },
  { value: "ROHRU", label: "ROHRU" },
  { value: "ROHTA", label: "ROHTA" },
  { value: "ROHTAK", label: "ROHTAK" },
  { value: "ROHTAS", label: "ROHTAS" },
  { value: "ROING", label: "ROING" },
  { value: "RONA", label: "RONA" },
  { value: "ROORKEE", label: "ROORKEE" },
  { value: "ROPAR", label: "ROPAR" },
  { value: "ROSERA", label: "ROSERA" },
  { value: "ROURKELA", label: "ROURKELA" },
  { value: "ROWTA", label: "ROWTA" },
  { value: "RUDAULI", label: "RUDAULI" },
  { value: "RUDRAPRAYAG", label: "RUDRAPRAYAG" },
  { value: "RUDRAPUR", label: "RUDRAPUR" },
  { value: "RUKSIN", label: "RUKSIN" },
  { value: "RUNKATA", label: "RUNKATA" },
  { value: "RUPAIDIHA", label: "RUPAIDIHA" },
  { value: "RUPNAGAR", label: "RUPNAGAR" },
  { value: "RUPNARAYANPUR", label: "RUPNARAYANPUR" },
  { value: "Rabupura(NP)", label: "Rabupura(NP)" },
  { value: "Radaur(CT)", label: "Radaur(CT)" },
  { value: "Radhakishorenagar(CT)", label: "Radhakishorenagar(CT)" },
  { value: "Radhanagar(CT)", label: "Radhanagar(CT)" },
  { value: "Raghogarh-Vijaypur(M)", label: "Raghogarh-Vijaypur(M)" },
  { value: "Raghunathchak(CT)", label: "Raghunathchak(CT)" },
  { value: "Raha(TC)", label: "Raha(TC)" },
  { value: "Rahanal(CT)", label: "Rahanal(CT)" },
  { value: "Rahatgarh(NP)", label: "Rahatgarh(NP)" },
  { value: "Raipur rani", label: "Raipur rani" },
  { value: "Raipur(CT)", label: "Raipur(CT)" },
  { value: "RaipurRani(CT)", label: "RaipurRani(CT)" },
  { value: "RaipurRasulpur(CT)", label: "RaipurRasulpur(CT)" },
  { value: "RajaKaRampur(NP)", label: "RajaKaRampur(NP)" },
  { value: "Rajakhedi(CT)", label: "Rajakhedi(CT)" },
  { value: "Rajakhera(M)", label: "Rajakhera(M)" },
  { value: "Rajaldesar(M)", label: "Rajaldesar(M)" },
  { value: "Rajapur(NP)", label: "Rajapur(NP)" },
  { value: "Rajauli(NP)", label: "Rajauli(NP)" },
  { value: "Rajgarh(M)", label: "Rajgarh(M)" },
  { value: "Rajnagar(NP)", label: "Rajnagar(NP)" },
  { value: "RajopattiurfKotaBazar(CT)", label: "RajopattiurfKotaBazar(CT)" },
  { value: "RajpurSonarpur(M)", label: "RajpurSonarpur(M)" },
  { value: "Rajur(CT)", label: "Rajur(CT)" },
  { value: "Rajura(MCl)", label: "Rajura(MCl)" },
  { value: "Ramachandrapuram(M)", label: "Ramachandrapuram(M)" },
  { value: "Ramanattukara(CT)", label: "Ramanattukara(CT)" },
  { value: "Ramapuram(CT)", label: "Ramapuram(CT)" },
  { value: "Ramban(MC)", label: "Ramban(MC)" },
  { value: "Ramchandrapur(CT)", label: "Ramchandrapur(CT)" },
  { value: "Ramdas(MCl)", label: "Ramdas(MCl)" },
  { value: "Ramgarh(CT)", label: "Ramgarh(CT)" },
  { value: "Ramgarh(M)", label: "Ramgarh(M)" },
  { value: "RamgarhPanjoopur(CT)", label: "RamgarhPanjoopur(CT)" },
  { value: "Ramkola(NP)", label: "Ramkola(NP)" },
  { value: "Ramnagar(NP)", label: "Ramnagar(NP)" },
  { value: "Ramnagar(NPP)", label: "Ramnagar(NPP)" },
  { value: "Rampur(CT)", label: "Rampur(CT)" },
  { value: "RampurKarkhana(NP)", label: "RampurKarkhana(NP)" },
  { value: "RampurManiharan(NP)", label: "RampurManiharan(NP)" },
  { value: "RampurNaikin(NP)", label: "RampurNaikin(NP)" },
  { value: "Rampura(132)(CT)", label: "Rampura(132)(CT)" },
  { value: "Rampura(NP)", label: "Rampura(NP)" },
  { value: "Ranapur(NP)", label: "Ranapur(NP)" },
  { value: "Ranga Reddy", label: "Ranga Reddy" },
  { value: "Rangabhita(CT)", label: "Rangabhita(CT)" },
  { value: "Rangapara(TC)", label: "Rangapara(TC)" },
  { value: "Rangareddi", label: "Rangareddi" },
  { value: "Ranipur(NP)", label: "Ranipur(NP)" },
  { value: "Raniyan(CT)", label: "Raniyan(CT)" },
  { value: "Ranpur(CT)", label: "Ranpur(CT)" },
  { value: "RashidpurGarhi(CT)", label: "RashidpurGarhi(CT)" },
  { value: "Rasikpur(CT)", label: "Rasikpur(CT)" },
  { value: "Rasra(NPP)", label: "Rasra(NPP)" },
  { value: "Ratangarh(NP)", label: "Ratangarh(NP)" },
  { value: "Ratannagar(M)", label: "Ratannagar(M)" },
  { value: "Ratanpura(CT)", label: "Ratanpura(CT)" },
  { value: "Rathian(CT)", label: "Rathian(CT)" },
  { value: "Ratibati(CT)", label: "Ratibati(CT)" },
  { value: "Ratnapur(CT)", label: "Ratnapur(CT)" },
  { value: "RawaliMahdood(CT)", label: "RawaliMahdood(CT)" },
  { value: "Rawan(CT)", label: "Rawan(CT)" },
  { value: "Reengus(M)", label: "Reengus(M)" },
  { value: "Rehti(NP)", label: "Rehti(NP)" },
  { value: "RelianceComplex(INA)", label: "RelianceComplex(INA)" },
  { value: "Remuna(NAC)", label: "Remuna(NAC)" },
  { value: "Renukoot(NP+OG)", label: "Renukoot(NP+OG)" },
  { value: "Reoti(NP)", label: "Reoti(NP)" },
  { value: "Revelganj(NP)", label: "Revelganj(NP)" },
  { value: "Ri Bhoi", label: "Ri Bhoi" },
  { value: "Richha(NP)", label: "Richha(NP)" },
  { value: "Risama(CT)", label: "Risama(CT)" },
  { value: "Rishikesh(CT)", label: "Rishikesh(CT)" },
  { value: "Rishra(CT)", label: "Rishra(CT)" },
  { value: "Rithora(NP)", label: "Rithora(NP)" },
  { value: "Rori(CT)", label: "Rori(CT)" },
  { value: "Rosalpatti(CT)", label: "Rosalpatti(CT)" },
  { value: "Rudauli(NPP)", label: "Rudauli(NPP)" },
  { value: "Rudraprayag(NPP)", label: "Rudraprayag(NPP)" },
  { value: "Rudrapur(NP)", label: "Rudrapur(NP)" },
  { value: "Runkata(CT)", label: "Runkata(CT)" },
  { value: "Rura(NP)", label: "Rura(NP)" },
  { value: "RurkiKasba(CT)", label: "RurkiKasba(CT)" },
  { value: "RustamnagarSahaspur(CT)", label: "RustamnagarSahaspur(CT)" },
  { value: "SAABO", label: "SAABO" },
  { value: "SABALGARH", label: "SABALGARH" },
  { value: "SABANG", label: "SABANG" },
  { value: "SABARKANTHA", label: "SABARKANTHA" },
  { value: "SABBAVARAM", label: "SABBAVARAM" },
  { value: "SABLA", label: "SABLA" },
  { value: "SABROOM", label: "SABROOM" },
  { value: "SADABAD", label: "SADABAD" },
  { value: "SADALPUR", label: "SADALPUR" },
  { value: "SADAR", label: "SADAR" },
  { value: "SADASHIVNAGAR", label: "SADASHIVNAGAR" },
  { value: "SADASHIVPET", label: "SADASHIVPET" },
  { value: "SADATPUR", label: "SADATPUR" },
  { value: "SADHAURA", label: "SADHAURA" },
  { value: "SADHLI", label: "SADHLI" },
  { value: "SADIYA", label: "SADIYA" },
  { value: "SADRUDEENNAGAR", label: "SADRUDEENNAGAR" },
  { value: "SADULPUR", label: "SADULPUR" },
  { value: "SADULSHAHAR", label: "SADULSHAHAR" },
  { value: "SAFDARGANJ", label: "SAFDARGANJ" },
  { value: "SAFIDON", label: "SAFIDON" },
  { value: "SAGAR", label: "SAGAR" },
  { value: "SAGARA", label: "SAGARA" },
  { value: "SAGOLBAND", label: "SAGOLBAND" },
  { value: "SAGWARA", label: "SAGWARA" },
  { value: "SAHA", label: "SAHA" },
  { value: "SAHARANPUR", label: "SAHARANPUR" },
  { value: "SAHARSA", label: "SAHARSA" },
  { value: "SAHASWAN", label: "SAHASWAN" },
  { value: "SAHAURFPIPALGAON", label: "SAHAURFPIPALGAON" },
  { value: "SAHAWAR", label: "SAHAWAR" },
  { value: "SAHEBGANJ", label: "SAHEBGANJ" },
  { value: "SAHIBABAD", label: "SAHIBABAD" },
  { value: "SAHIBGANJ", label: "SAHIBGANJ" },
  { value: "SAHIBZADAAJITSINGHNAGAR", label: "SAHIBZADAAJITSINGHNAGAR" },
  { value: "SAHNEWAL", label: "SAHNEWAL" },
  { value: "SAIDPUR", label: "SAIDPUR" },
  { value: "SAIDPURA", label: "SAIDPURA" },
  { value: "SAINTHIA", label: "SAINTHIA" },
  { value: "SAIYADULAJAIB", label: "SAIYADULAJAIB" },
  { value: "SAKALDIHA", label: "SAKALDIHA" },
  { value: "SAKARRA", label: "SAKARRA" },
  { value: "SAKHARPA", label: "SAKHARPA" },
  { value: "SAKIT", label: "SAKIT" },
  { value: "SAKLESHPURA", label: "SAKLESHPURA" },
  { value: "SAKOLI", label: "SAKOLI" },
  { value: "SAKTI", label: "SAKTI" },
  { value: "SAKURI", label: "SAKURI" },
  { value: "SALAMPUR", label: "SALAMPUR" },
  { value: "SALASAR", label: "SALASAR" },
  { value: "SALASI", label: "SALASI" },
  { value: "SALBARI", label: "SALBARI" },
  { value: "SALEM", label: "SALEM" },
  { value: "SALEMPUR", label: "SALEMPUR" },
  { value: "SALHAWAS", label: "SALHAWAS" },
  { value: "SALIPUR", label: "SALIPUR" },
  { value: "SALKIA", label: "SALKIA" },
  { value: "SALON", label: "SALON" },
  { value: "SALOONI", label: "SALOONI" },
  { value: "SALUMBAR", label: "SALUMBAR" },
  { value: "SALUR", label: "SALUR" },
  { value: "SALVAV", label: "SALVAV" },
  { value: "SAMALKHA", label: "SAMALKHA" },
  { value: "SAMANA", label: "SAMANA" },
  { value: "SAMANGAON", label: "SAMANGAON" },
  { value: "SAMARIYA", label: "SAMARIYA" },
  { value: "SAMASTIPUR", label: "SAMASTIPUR" },
  { value: "SAMBA", label: "SAMBA" },
  { value: "SAMBALPUR", label: "SAMBALPUR" },
  { value: "SAMBHAL", label: "SAMBHAL" },
  { value: "SAMBHAR", label: "SAMBHAR" },
  { value: "SAMI", label: "SAMI" },
  { value: "SAMIRVADI", label: "SAMIRVADI" },
  { value: "SAMPLA", label: "SAMPLA" },
  { value: "SAMRALA", label: "SAMRALA" },
  { value: "SAMUROU", label: "SAMUROU" },
  { value: "SANAWAD", label: "SANAWAD" },
  { value: "SANCHORE", label: "SANCHORE" },
  { value: "SANDILA", label: "SANDILA" },
  { value: "SANGAGIRI", label: "SANGAGIRI" },
  { value: "SANGAMESHWAR", label: "SANGAMESHWAR" },
  { value: "SANGAMNER", label: "SANGAMNER" },
  { value: "SANGAREDDY", label: "SANGAREDDY" },
  { value: "SANGARIA", label: "SANGARIA" },
  { value: "SANGLA", label: "SANGLA" },
  { value: "SANGLI", label: "SANGLI" },
  { value: "SANGOD", label: "SANGOD" },
  { value: "SANGOLA", label: "SANGOLA" },
  { value: "SANGRUR", label: "SANGRUR" },
  { value: "SANGVI", label: "SANGVI" },
  { value: "SANJAULI", label: "SANJAULI" },
  { value: "SANKARANKOIL", label: "SANKARANKOIL" },
  { value: "SANKARAPURAM", label: "SANKARAPURAM" },
  { value: "SANKH", label: "SANKH" },
  { value: "SANKHEDA", label: "SANKHEDA" },
  { value: "SANOLIKHURD", label: "SANOLIKHURD" },
  { value: "SANSARPUR", label: "SANSARPUR" },
  { value: "SANT KABIR NAGAR", label: "SANT KABIR NAGAR" },
  { value: "SANT RAVIDAS NAGAR", label: "SANT RAVIDAS NAGAR" },
  { value: "SANTALPUR", label: "SANTALPUR" },
  { value: "SANTEJ", label: "SANTEJ" },
  { value: "SANTHEBENNUR", label: "SANTHEBENNUR" },
  { value: "SANTIBAZAR", label: "SANTIBAZAR" },
  { value: "SANTINIKETAN", label: "SANTINIKETAN" },
  { value: "SANTKABIRNAGAR", label: "SANTKABIRNAGAR" },
  { value: "SANTRAMPUR", label: "SANTRAMPUR" },
  { value: "SANVARDEM", label: "SANVARDEM" },
  { value: "SANWER", label: "SANWER" },
  { value: "SANYASIGUNDU", label: "SANYASIGUNDU" },
  { value: "SAONER", label: "SAONER" },
  { value: "SAPHALE", label: "SAPHALE" },
  { value: "SAPOTARA", label: "SAPOTARA" },
  { value: "SARAHAN", label: "SARAHAN" },
  { value: "SARAIKELA", label: "SARAIKELA" },
  { value: "SARAIMEER", label: "SARAIMEER" },
  { value: "SARAIPALI", label: "SARAIPALI" },
  { value: "SARAN", label: "SARAN" },
  { value: "SARANG", label: "SARANG" },
  { value: "SARANGARH", label: "SARANGARH" },
  { value: "SARAYMOHANA", label: "SARAYMOHANA" },
  { value: "SARDARGARH", label: "SARDARGARH" },
  { value: "SARDARSHAHAR", label: "SARDARSHAHAR" },
  { value: "SARDHANA", label: "SARDHANA" },
  { value: "SARDHAR", label: "SARDHAR" },
  { value: "SARDULGARH", label: "SARDULGARH" },
  { value: "SARHALI", label: "SARHALI" },
  { value: "SARIGAM", label: "SARIGAM" },
  { value: "SARIMPUR", label: "SARIMPUR" },
  { value: "SARJAPURA", label: "SARJAPURA" },
  { value: "SARKAGHAT", label: "SARKAGHAT" },
  { value: "SARNI", label: "SARNI" },
  { value: "SAROLI", label: "SAROLI" },
  { value: "SARSIWA", label: "SARSIWA" },
  { value: "SARTHEBARI", label: "SARTHEBARI" },
  { value: "SARUPATHAR", label: "SARUPATHAR" },
  { value: "SARWAR", label: "SARWAR" },
  { value: "SASARAM", label: "SASARAM" },
  { value: "SASTHAMCOTTA", label: "SASTHAMCOTTA" },
  { value: "SASWAD", label: "SASWAD" },
  { value: "SATAKHA", label: "SATAKHA" },
  { value: "SATANA", label: "SATANA" },
  { value: "SATARA", label: "SATARA" },
  { value: "SATARI", label: "SATARI" },
  { value: "SATHUPALLY", label: "SATHUPALLY" },
  { value: "SATHYAMANGALAM", label: "SATHYAMANGALAM" },
  { value: "SATLASANA", label: "SATLASANA" },
  { value: "SATNA", label: "SATNA" },
  { value: "SATNALI", label: "SATNALI" },
  { value: "SATTARI", label: "SATTARI" },
  { value: "SATTUR", label: "SATTUR" },
  { value: "SATYAMANGALA", label: "SATYAMANGALA" },
  { value: "SAUSAR", label: "SAUSAR" },
  { value: "SAVADATTIYALLAMMA", label: "SAVADATTIYALLAMMA" },
  { value: "SAVANUR", label: "SAVANUR" },
  { value: "SAVARKUNDLA", label: "SAVARKUNDLA" },
  { value: "SAVLI", label: "SAVLI" },
  { value: "SAWAI MADHOPUR", label: "SAWAI MADHOPUR" },
  { value: "SAWAIJPUR", label: "SAWAIJPUR" },
  { value: "SAWAIMADHOPUR", label: "SAWAIMADHOPUR" },
  { value: "SAWALI", label: "SAWALI" },
  { value: "SAWANTWADI", label: "SAWANTWADI" },
  { value: "SAYAN", label: "SAYAN" },
  { value: "SAYLA", label: "SAYLA" },
  { value: "SEAFORTH", label: "SEAFORTH" },
  { value: "SEARGOVARDHANDAFI", label: "SEARGOVARDHANDAFI" },
  { value: "SECUNDERABAD", label: "SECUNDERABAD" },
  { value: "SEHORE", label: "SEHORE" },
  { value: "SEKKALAI", label: "SEKKALAI" },
  { value: "SELAKUI", label: "SELAKUI" },
  { value: "SELAMBA", label: "SELAMBA" },
  { value: "SELATHAMPATTY", label: "SELATHAMPATTY" },
  { value: "SEMARI", label: "SEMARI" },
  { value: "SEMARIYA", label: "SEMARIYA" },
  { value: "SEMILIGUDA", label: "SEMILIGUDA" },
  { value: "SEMRAUTA", label: "SEMRAUTA" },
  { value: "SENAPATI", label: "SENAPATI" },
  { value: "SENDHWA", label: "SENDHWA" },
  { value: "SEONI", label: "SEONI" },
  { value: "SEONIMALWA", label: "SEONIMALWA" },
  { value: "SERAI KELA KHARSAWAN", label: "SERAI KELA KHARSAWAN" },
  { value: "SERAMPORE", label: "SERAMPORE" },
  { value: "SERCHHIP", label: "SERCHHIP" },
  { value: "SEWRI", label: "SEWRI" },
  { value: "SEYDUNGANALLUR", label: "SEYDUNGANALLUR" },
  { value: "SHABAD", label: "SHABAD" },
  { value: "SHADNAGAR", label: "SHADNAGAR" },
  { value: "SHAH-E-ALAM", label: "SHAH-E-ALAM" },
  { value: "SHAHABAD", label: "SHAHABAD" },
  { value: "SHAHABADMARKANDA", label: "SHAHABADMARKANDA" },
  { value: "SHAHADA", label: "SHAHADA" },
  { value: "SHAHAPUR", label: "SHAHAPUR" },
  { value: "SHAHBADDAULATPUR", label: "SHAHBADDAULATPUR" },
  { value: "SHAHBUDINPUR", label: "SHAHBUDINPUR" },
  { value: "SHAHDARA", label: "SHAHDARA" },
  { value: "SHAHDOL", label: "SHAHDOL" },
  { value: "SHAHJAHANPUR", label: "SHAHJAHANPUR" },
  { value: "SHAHKOT", label: "SHAHKOT" },
  { value: "SHAHPUR", label: "SHAHPUR" },
  { value: "SHAHPURA", label: "SHAHPURA" },
  { value: "SHAHPURBEGU", label: "SHAHPURBEGU" },
  { value: "SHAHUWADI", label: "SHAHUWADI" },
  { value: "SHAHZADPUR", label: "SHAHZADPUR" },
  { value: "SHAJAPUR", label: "SHAJAPUR" },
  { value: "SHAKARPUR", label: "SHAKARPUR" },
  { value: "SHAMCHAURASI", label: "SHAMCHAURASI" },
  { value: "SHAMIRPET", label: "SHAMIRPET" },
  { value: "SHAMLI", label: "SHAMLI" },
  { value: "SHAMSHABAD", label: "SHAMSHABAD" },
  { value: "SHANIVARASANTHE", label: "SHANIVARASANTHE" },
  { value: "SHANKARGARH", label: "SHANKARGARH" },
  { value: "SHANKARPALLE", label: "SHANKARPALLE" },
  { value: "SHANKHESHWAR", label: "SHANKHESHWAR" },
  { value: "SHANTIPUKHURI", label: "SHANTIPUKHURI" },
  { value: "SHAPAR", label: "SHAPAR" },
  { value: "SHASTRINAGAR", label: "SHASTRINAGAR" },
  { value: "SHEIKHPURA", label: "SHEIKHPURA" },
  { value: "SHENKOTTAI", label: "SHENKOTTAI" },
  { value: "SHEO", label: "SHEO" },
  { value: "SHEOGANJ", label: "SHEOGANJ" },
  { value: "SHEOHAR", label: "SHEOHAR" },
  { value: "SHEOPUR", label: "SHEOPUR" },
  { value: "SHEORAPHULI", label: "SHEORAPHULI" },
  { value: "SHERGARH", label: "SHERGARH" },
  { value: "SHIGGAON", label: "SHIGGAON" },
  { value: "SHIHORI", label: "SHIHORI" },
  { value: "SHIKARIPURA", label: "SHIKARIPURA" },
  { value: "SHIKOHABAD", label: "SHIKOHABAD" },
  { value: "SHIKRAPUR", label: "SHIKRAPUR" },
  { value: "SHILLAI", label: "SHILLAI" },
  { value: "SHILLONG", label: "SHILLONG" },
  { value: "SHILOWRI", label: "SHILOWRI" },
  { value: "SHILPHATA", label: "SHILPHATA" },
  { value: "SHIMLA", label: "SHIMLA" },
  { value: "SHIRAHATTI", label: "SHIRAHATTI" },
  { value: "SHIRALA", label: "SHIRALA" },
  { value: "SHIRDI", label: "SHIRDI" },
  { value: "SHIRPUR", label: "SHIRPUR" },
  { value: "SHIRUR", label: "SHIRUR" },
  { value: "SHIRWAL", label: "SHIRWAL" },
  { value: "SHIVAJINAGAR", label: "SHIVAJINAGAR" },
  { value: "SHIVAMOGGA", label: "SHIVAMOGGA" },
  { value: "SHIVANGAON", label: "SHIVANGAON" },
  { value: "SHIVANI", label: "SHIVANI" },
  { value: "SHIVARAJPUR", label: "SHIVARAJPUR" },
  { value: "SHIVPUR", label: "SHIVPUR" },
  { value: "SHIVPURI", label: "SHIVPURI" },
  { value: "SHIVRINARAYAN", label: "SHIVRINARAYAN" },
  { value: "SHOGHI", label: "SHOGHI" },
  { value: "SHOLAVANDAN", label: "SHOLAVANDAN" },
  { value: "SHOLINGHUR", label: "SHOLINGHUR" },
  { value: "SHOPIAN", label: "SHOPIAN" },
  { value: "SHORANUR", label: "SHORANUR" },
  { value: "SHRAVASTI", label: "SHRAVASTI" },
  { value: "SHRAWASTI", label: "SHRAWASTI" },
  { value: "SHREEMAHAVEERJI", label: "SHREEMAHAVEERJI" },
  { value: "SHRIBANSHIDHARNAGAR", label: "SHRIBANSHIDHARNAGAR" },
  { value: "SHRIDUNGARGARH", label: "SHRIDUNGARGARH" },
  { value: "SHRIGONDA", label: "SHRIGONDA" },
  { value: "SHRIMADHOPUR", label: "SHRIMADHOPUR" },
  { value: "SHRIRAMPUR", label: "SHRIRAMPUR" },
  { value: "SHUJALPUR", label: "SHUJALPUR" },
  { value: "SHYAMGARH", label: "SHYAMGARH" },
  { value: "SHYAMPUR", label: "SHYAMPUR" },
  { value: "SHYAMSUNDARPUR", label: "SHYAMSUNDARPUR" },
  { value: "SIAHA", label: "SIAHA" },
  { value: "SIBSAGAR", label: "SIBSAGAR" },
  { value: "SIDDAPUR", label: "SIDDAPUR" },
  { value: "SIDDAPURA", label: "SIDDAPURA" },
  { value: "SIDDHARTHNAGAR", label: "SIDDHARTHNAGAR" },
  { value: "SIDDHPUR", label: "SIDDHPUR" },
  { value: "SIDDIPET", label: "SIDDIPET" },
  { value: "SIDHAULI", label: "SIDHAULI" },
  { value: "SIDHAUR", label: "SIDHAUR" },
  { value: "SIDHI", label: "SIDHI" },
  { value: "SIDHRA", label: "SIDHRA" },
  { value: "SIDHWANBET", label: "SIDHWANBET" },
  { value: "SIDLAGHATTA", label: "SIDLAGHATTA" },
  { value: "SIDRAUL", label: "SIDRAUL" },
  { value: "SIDSAR", label: "SIDSAR" },
  { value: "SIHOR", label: "SIHOR" },
  { value: "SIHORA", label: "SIHORA" },
  { value: "SIKANDRA", label: "SIKANDRA" },
  { value: "SIKANDRABAD", label: "SIKANDRABAD" },
  { value: "SIKANDRARAO", label: "SIKANDRARAO" },
  { value: "SIKAR", label: "SIKAR" },
  { value: "SIKRAI", label: "SIKRAI" },
  { value: "SILAPATHAR", label: "SILAPATHAR" },
  { value: "SILCHAR", label: "SILCHAR" },
  { value: "SILIGURI", label: "SILIGURI" },
  { value: "SILLOD", label: "SILLOD" },
  { value: "SILVASSA", label: "SILVASSA" },
  { value: "SILWANI", label: "SILWANI" },
  { value: "SIMALWARA", label: "SIMALWARA" },
  { value: "SIMDEGA", label: "SIMDEGA" },
  { value: "SIMGA", label: "SIMGA" },
  { value: "SIMLA", label: "SIMLA" },
  { value: "SIMLAGURI", label: "SIMLAGURI" },
  { value: "SIMLAPAL", label: "SIMLAPAL" },
  { value: "SIMROL", label: "SIMROL" },
  { value: "SINDEWAHI", label: "SINDEWAHI" },
  { value: "SINDHANUR", label: "SINDHANUR" },
  { value: "SINDHUDURG", label: "SINDHUDURG" },
  { value: "SINDIMEGHE", label: "SINDIMEGHE" },
  { value: "SINDRANI", label: "SINDRANI" },
  { value: "SINGAPERUMALKOIL", label: "SINGAPERUMALKOIL" },
  { value: "SINGARAYAKONDA", label: "SINGARAYAKONDA" },
  { value: "SINGARWA", label: "SINGARWA" },
  { value: "SINGBEL", label: "SINGBEL" },
  { value: "SINGHANA", label: "SINGHANA" },
  { value: "SINGHBHUM(ST)", label: "SINGHBHUM(ST)" },
  { value: "SINGOLI", label: "SINGOLI" },
  { value: "SINGRAULI", label: "SINGRAULI" },
  { value: "SINGUR", label: "SINGUR" },
  { value: "SINNAR", label: "SINNAR" },
  { value: "SINOR", label: "SINOR" },
  { value: "SIPAJHAR", label: "SIPAJHAR" },
  { value: "SIRA", label: "SIRA" },
  { value: "SIRASPUR", label: "SIRASPUR" },
  { value: "SIRATHU", label: "SIRATHU" },
  { value: "SIRAULIGAUSPUR", label: "SIRAULIGAUSPUR" },
  { value: "SIRCILLA", label: "SIRCILLA" },
  { value: "SIRHIND", label: "SIRHIND" },
  { value: "SIRKALI", label: "SIRKALI" },
  { value: "SIRMATHURA", label: "SIRMATHURA" },
  { value: "SIRMAUR", label: "SIRMAUR" },
  { value: "SIROHI", label: "SIROHI" },
  { value: "SIRONCHA", label: "SIRONCHA" },
  { value: "SIRONJ", label: "SIRONJ" },
  { value: "SIRSA", label: "SIRSA" },
  { value: "SIRSAGANJ", label: "SIRSAGANJ" },
  { value: "SIRSI", label: "SIRSI" },
  { value: "SIRUGUPPA", label: "SIRUGUPPA" },
  { value: "SIRUMUGAI", label: "SIRUMUGAI" },
  { value: "SISWABAZAR", label: "SISWABAZAR" },
  { value: "SITAI", label: "SITAI" },
  { value: "SITAMARHI", label: "SITAMARHI" },
  { value: "SITAMAU", label: "SITAMAU" },
  { value: "SITAPUR", label: "SITAPUR" },
  { value: "SITARGANJ", label: "SITARGANJ" },
  { value: "SITONG FOREST", label: "SITONG FOREST" },
  { value: "SIVAGANGA", label: "SIVAGANGA" },
  { value: "SIVAGNANAPURAM", label: "SIVAGNANAPURAM" },
  { value: "SIVAKASI", label: "SIVAKASI" },
  { value: "SIVASAGAR", label: "SIVASAGAR" },
  { value: "SIWALKHAS", label: "SIWALKHAS" },
  { value: "SIWAN", label: "SIWAN" },
  { value: "SIWANA", label: "SIWANA" },
  { value: "SIWANI", label: "SIWANI" },
  { value: "SIYANA", label: "SIYANA" },
  { value: "SLEEMANABAD", label: "SLEEMANABAD" },
  { value: "SODEPUR", label: "SODEPUR" },
  { value: "SOHANA", label: "SOHANA" },
  { value: "SOHELA", label: "SOHELA" },
  { value: "SOHNA", label: "SOHNA" },
  { value: "SOJAT", label: "SOJAT" },
  { value: "SOJITRA", label: "SOJITRA" },
  { value: "SOLAN", label: "SOLAN" },
  { value: "SOLAPUR", label: "SOLAPUR" },
  { value: "SOMESHWAR", label: "SOMESHWAR" },
  { value: "SOMPETA", label: "SOMPETA" },
  { value: "SOMWARPET", label: "SOMWARPET" },
  { value: "SONADA", label: "SONADA" },
  { value: "SONAI", label: "SONAI" },
  { value: "SONAMARG", label: "SONAMARG" },
  { value: "SONAMUKHI", label: "SONAMUKHI" },
  { value: "SONAPUR", label: "SONAPUR" },
  { value: "SONARI", label: "SONARI" },
  { value: "SONBHADRA", label: "SONBHADRA" },
  { value: "SONEPUR", label: "SONEPUR" },
  { value: "SONGADH", label: "SONGADH" },
  { value: "SONIPAT", label: "SONIPAT" },
  { value: "SONKATCH", label: "SONKATCH" },
  { value: "SONKH", label: "SONKH" },
  { value: "SONTOLI", label: "SONTOLI" },
  { value: "SOOTEA", label: "SOOTEA" },
  { value: "SOPORE", label: "SOPORE" },
  { value: "SORABA", label: "SORABA" },
  { value: "SORAON", label: "SORAON" },
  { value: "SORO", label: "SORO" },
  { value: "SOUTH 24 PARGANAS", label: "SOUTH 24 PARGANAS" },
  { value: "SOUTH ANDAMAN", label: "SOUTH ANDAMAN" },
  { value: "SOUTH DELHI", label: "SOUTH DELHI" },
  { value: "SOUTH DINAJPUR", label: "SOUTH DINAJPUR" },
  { value: "SOUTH GOA", label: "SOUTH GOA" },
  { value: "SOUTH SIKKIM", label: "SOUTH SIKKIM" },
  { value: "SOUTH WEST DELHI", label: "SOUTH WEST DELHI" },
  { value: "SOUTH24PARGANAS", label: "SOUTH24PARGANAS" },
  { value: "SOUTHNALLUR", label: "SOUTHNALLUR" },
  { value: "SREEKANDAPURAM", label: "SREEKANDAPURAM" },
  { value: "SREEKARIYAM", label: "SREEKARIYAM" },
  { value: "SRI GANGANAGAR", label: "SRI GANGANAGAR" },
  { value: "SRIGANGANAGAR", label: "SRIGANGANAGAR" },
  { value: "SRIKAKULAM", label: "SRIKAKULAM" },
  { value: "SRIKALAHASTI", label: "SRIKALAHASTI" },
  { value: "SRIKALI", label: "SRIKALI" },
  { value: "SRIMUKTSARSAHIB", label: "SRIMUKTSARSAHIB" },
  { value: "SRINAGAR", label: "SRINAGAR" },
  { value: "SRINGERI", label: "SRINGERI" },
  { value: "SRINIVASPUR", label: "SRINIVASPUR" },
  { value: "SRIPERUMBUDUR", label: "SRIPERUMBUDUR" },
  { value: "SRIRAMNAGAR", label: "SRIRAMNAGAR" },
  { value: "SRIVIJAYAPURAM", label: "SRIVIJAYAPURAM" },
  { value: "SRIVIJAYNAGAR", label: "SRIVIJAYNAGAR" },
  { value: "SRIVILLIPUTHUR", label: "SRIVILLIPUTHUR" },
  { value: "SRUNGAVARAPUKOTA", label: "SRUNGAVARAPUKOTA" },
  { value: "STN. JADCHERLA", label: "STN. JADCHERLA" },
  { value: "STNDM", label: "STNDM" },
  { value: "SUAR", label: "SUAR" },
  { value: "SUBATHU", label: "SUBATHU" },
  { value: "SUDHAR", label: "SUDHAR" },
  { value: "SUDI", label: "SUDI" },
  { value: "SUFFIPIND", label: "SUFFIPIND" },
  { value: "SUJANGARH", label: "SUJANGARH" },
  { value: "SUJANPUR", label: "SUJANPUR" },
  { value: "SULEBHAVI", label: "SULEBHAVI" },
  { value: "SULLURUPETA", label: "SULLURUPETA" },
  { value: "SULTANBATHERY", label: "SULTANBATHERY" },
  { value: "SULTANGANJ", label: "SULTANGANJ" },
  { value: "SULTANPUR", label: "SULTANPUR" },
  { value: "SULTANPURLODHI", label: "SULTANPURLODHI" },
  { value: "SULTANPURMAJRA", label: "SULTANPURMAJRA" },
  { value: "SULUR", label: "SULUR" },
  { value: "SUMBAL", label: "SUMBAL" },
  { value: "SUMERPUR", label: "SUMERPUR" },
  { value: "SUMMERHILL", label: "SUMMERHILL" },
  { value: "SUNAMUDHAMSINGHWALA", label: "SUNAMUDHAMSINGHWALA" },
  { value: "SUNDARA", label: "SUNDARA" },
  { value: "SUNDARBANI", label: "SUNDARBANI" },
  { value: "SUNDARGARH", label: "SUNDARGARH" },
  { value: "SUNDARKHED", label: "SUNDARKHED" },
  { value: "SUNDARNAGAR", label: "SUNDARNAGAR" },
  { value: "SUNDERBANI", label: "SUNDERBANI" },
  { value: "SUNDERGARH", label: "SUNDERGARH" },
  { value: "SUNDERNAGAR", label: "SUNDERNAGAR" },
  { value: "SUNGUVARCHATRAM", label: "SUNGUVARCHATRAM" },
  { value: "SUNTIKOPPA", label: "SUNTIKOPPA" },
  { value: "SUPA", label: "SUPA" },
  { value: "SUPAUL", label: "SUPAUL" },
  { value: "SUPEDI", label: "SUPEDI" },
  { value: "SURAJPUR", label: "SURAJPUR" },
  { value: "SURANKOT", label: "SURANKOT" },
  { value: "SURAT", label: "SURAT" },
  { value: "SURATGARH", label: "SURATGARH" },
  { value: "SURATHKAL", label: "SURATHKAL" },
  { value: "SURENDRA NAGAR", label: "SURENDRA NAGAR" },
  { value: "SURENDRANAGAR", label: "SURENDRANAGAR" },
  { value: "SURGUJA", label: "SURGUJA" },
  { value: "SURI", label: "SURI" },
  { value: "SUROTH", label: "SUROTH" },
  { value: "SURYAPET", label: "SURYAPET" },
  { value: "SUTHALIA", label: "SUTHALIA" },
  { value: "SUWASRA", label: "SUWASRA" },
  { value: "SWARAJDWEEP", label: "SWARAJDWEEP" },
  { value: "SWAROOPGANJ", label: "SWAROOPGANJ" },
  { value: "SWARUPNAGAR", label: "SWARUPNAGAR" },
  { value: "Sabalgarh(M)", label: "Sabalgarh(M)" },
  { value: "Sachin(CT)", label: "Sachin(CT)" },
  { value: "Sachin(INA)", label: "Sachin(INA)" },
  { value: "Sadabad(NP)", label: "Sadabad(NP)" },
  { value: "Sadashivapet", label: "Sadashivapet" },
  { value: "Sadat(NP)", label: "Sadat(NP)" },
  { value: "Sadatmasaura(CT)", label: "Sadatmasaura(CT)" },
  { value: "Sadigachhi(CT)", label: "Sadigachhi(CT)" },
  { value: "Sadri(M)", label: "Sadri(M)" },
  { value: "SafaPora(CT)", label: "SafaPora(CT)" },
  { value: "Safipur(NP)", label: "Safipur(NP)" },
  { value: "Sagalee(NT)", label: "Sagalee(NT)" },
  { value: "Sagwara(M)", label: "Sagwara(M)" },
  { value: "Sahanpur(NP)", label: "Sahanpur(NP)" },
  { value: "Sahaspur(NP)", label: "Sahaspur(NP)" },
  { value: "Sahaswan(NPP)", label: "Sahaswan(NPP)" },
  { value: "Sahatwar(NP)", label: "Sahatwar(NP)" },
  { value: "Sahawar(NP)", label: "Sahawar(NP)" },
  { value: "Sahebganj(CT)", label: "Sahebganj(CT)" },
  { value: "Sahpau(NP)", label: "Sahpau(NP)" },
  { value: "Saidabad(CT)", label: "Saidabad(CT)" },
  { value: "Saidhari(CT)", label: "Saidhari(CT)" },
  { value: "Saidpur(NP)", label: "Saidpur(NP)" },
  { value: "SaidpurKhajuria(CT)", label: "SaidpurKhajuria(CT)" },
  { value: "Saiha", label: "Saiha" },
  { value: "SaijniNankar(CT)", label: "SaijniNankar(CT)" },
  { value: "Sainthal(NP)", label: "Sainthal(NP)" },
  { value: "Sakhanu(NP)", label: "Sakhanu(NP)" },
  { value: "Sakkarakottai(CT)", label: "Sakkarakottai(CT)" },
  { value: "Sakoli(CT)", label: "Sakoli(CT)" },
  { value: "Saktasanala(CT)", label: "Saktasanala(CT)" },
  { value: "Salakati(CT)", label: "Salakati(CT)" },
  { value: "Salap(CT)", label: "Salap(CT)" },
  { value: "Salarpur(CT)", label: "Salarpur(CT)" },
  { value: "SalarpurKhadar(CT)", label: "SalarpurKhadar(CT)" },
  { value: "Salempur(NP)", label: "Salempur(NP)" },
  { value: "SalempurRajputan(CT)", label: "SalempurRajputan(CT)" },
  { value: "Salon(NP)", label: "Salon(NP)" },
  { value: "Salumbar(M)", label: "Salumbar(M)" },
  { value: "Salur(M)", label: "Salur(M)" },
  { value: "Samalapuram(TP)", label: "Samalapuram(TP)" },
  { value: "Samanatham(CT)", label: "Samanatham(CT)" },
  { value: "Sambhal(NPP)", label: "Sambhal(NPP)" },
  { value: "Samdhan(NP)", label: "Samdhan(NP)" },
  { value: "Samthar(NPP)", label: "Samthar(NPP)" },
  { value: "Samurou(NP)(Minorpart)", label: "Samurou(NP)(Minorpart)" },
  { value: "Sanchi(NP)", label: "Sanchi(NP)" },
  { value: "Sangareddy ", label: "Sangareddy " },
  { value: "Sangaria(M)", label: "Sangaria(M)" },
  { value: "Sankaramanallur(TP)", label: "Sankaramanallur(TP)" },
  { value: "Sankaraperi(CT)", label: "Sankaraperi(CT)" },
  { value: "Sankrailjala(CT)", label: "Sankrailjala(CT)" },
  { value: "Santokhgarh(NP)", label: "Santokhgarh(NP)" },
  { value: "Santpur(Rural)(CT)", label: "Santpur(Rural)(CT)" },
  { value: "Saragaon(NP)", label: "Saragaon(NP)" },
  { value: "SaraiAbdulmalik(CT)", label: "SaraiAbdulmalik(CT)" },
  { value: "SaraiAquil(NP)", label: "SaraiAquil(NP)" },
  { value: "SaraiKhas(CT)", label: "SaraiKhas(CT)" },
  { value: "SaraiLahurUrfLahurpur(CT)", label: "SaraiLahurUrfLahurpur(CT)" },
  { value: "Saraswathipuram", label: "Saraswathipuram" },
  { value: "Saravanampatti(TP)", label: "Saravanampatti(TP)" },
  { value: "Sarcarsamakulam(TP)", label: "Sarcarsamakulam(TP)" },
  { value: "Sardargarh(CT)", label: "Sardargarh(CT)" },
  { value: "Sardarpur(NP)", label: "Sardarpur(NP)" },
  { value: "Sardarshahar(M)", label: "Sardarshahar(M)" },
  { value: "Sardhana(NPP)", label: "Sardhana(NPP)" },
  { value: "Sardulgarh(NP)", label: "Sardulgarh(NP)" },
  { value: "Sarila(NP)", label: "Sarila(NP)" },
  { value: "Sarna(CT)", label: "Sarna(CT)" },
  { value: "Sarni(M)", label: "Sarni(M)" },
  { value: "Sarsaul(CT)", label: "Sarsaul(CT)" },
  { value: "Sarsawa(NPP)", label: "Sarsawa(NPP)" },
  { value: "Sarsawan(CT)", label: "Sarsawan(CT)" },
  { value: "SarupatharBengali(CT)", label: "SarupatharBengali(CT)" },
  { value: "Sarwar(M)", label: "Sarwar(M)" },
  { value: "Sarwat(CT)", label: "Sarwat(CT)" },
  { value: "Sasauli(CT)", label: "Sasauli(CT)" },
  { value: "Sasni(NP)", label: "Sasni(NP)" },
  { value: "Sasti(CT)", label: "Sasti(CT)" },
  { value: "Satai(NP)", label: "Satai(NP)" },
  { value: "Satiyava(CT)", label: "Satiyava(CT)" },
  { value: "Satlapur(CT)", label: "Satlapur(CT)" },
  { value: "Satpokhari(CT)", label: "Satpokhari(CT)" },
  { value: "Satrikh(NP)", label: "Satrikh(NP)" },
  { value: "SatrodKalan(153)(CT)", label: "SatrodKalan(153)(CT)" },
  { value: "SatrodKhas(154)(CT)", label: "SatrodKhas(154)(CT)" },
  { value: "SatrodKhurd(155)(CT)", label: "SatrodKhurd(155)(CT)" },
  { value: "Satyewala(CT)", label: "Satyewala(CT)" },
  { value: "Saurikh(NP)", label: "Saurikh(NP)" },
  { value: "Savda(MCl)", label: "Savda(MCl)" },
  { value: "Sawa(CT)", label: "Sawa(CT)" },
  { value: "Sawangi(Meghe)(CT)", label: "Sawangi(Meghe)(CT)" },
  { value: "Sayalgudi(TP)", label: "Sayalgudi(TP)" },
  { value: "Secunderabad(CB)", label: "Secunderabad(CB)" },
  { value: "SeerHamdan(MC)", label: "SeerHamdan(MC)" },
  { value: "SekmaiBazar(NP)", label: "SekmaiBazar(NP)" },
  { value: "Semari(CT)", label: "Semari(CT)" },
  { value: "Sembianallur(CT)", label: "Sembianallur(CT)" },
  { value: "Semmipalayam(CT)", label: "Semmipalayam(CT)" },
  { value: "Sendurai", label: "Sendurai" },
  { value: "Seohara(NPP)", label: "Seohara(NPP)" },
  { value: "Seondha(NP)", label: "Seondha(NP)" },
  { value: "Seoni(NP)", label: "Seoni(NP)" },
  { value: "Sepahijala", label: "Sepahijala" },
  { value: "Seppa", label: "Seppa" },
  { value: "Seraikela Kharsawan", label: "Seraikela Kharsawan" },
  { value: "Sewai(CT)", label: "Sewai(CT)" },
  { value: "Sewarhi(NP)", label: "Sewarhi(NP)" },
  { value: "Shafipur(CT)", label: "Shafipur(CT)" },
  { value: "Shahabad(NP)", label: "Shahabad(NP)" },
  { value: "Shahabad(NPP)", label: "Shahabad(NPP)" },
  { value: "Shahgarh(NP)", label: "Shahgarh(NP)" },
  { value: "Shahi(NP)", label: "Shahi(NP)" },
  { value: "Shahjahanpur(CT)", label: "Shahjahanpur(CT)" },
  { value: "Shahjangi(CT)", label: "Shahjangi(CT)" },
  { value: "Shahpur(CT)", label: "Shahpur(CT)" },
  { value: "Shahpur(NP)", label: "Shahpur(NP)" },
  { value: "Shaktigarh(NP)", label: "Shaktigarh(NP)" },
  { value: "Shamshabad(CT)", label: "Shamshabad(CT)" },
  { value: "Shamshabad(NP)", label: "Shamshabad(NP)" },
  { value: "Shangus(MC)", label: "Shangus(MC)" },
  { value: "Shankargarh(NP)", label: "Shankargarh(NP)" },
  { value: "Shelar(CT)", label: "Shelar(CT)" },
  { value: "Sheoganj(M)", label: "Sheoganj(M)" },
  { value: "Shergarh(NP)", label: "Shergarh(NP)" },
  { value: "Sherkot(NPP)", label: "Sherkot(NPP)" },
  { value: "Shikarpur(NPP)", label: "Shikarpur(NPP)" },
  { value: "Shimoga", label: "Shimoga" },
  { value: "Shirdi(NP)", label: "Shirdi(NP)" },
  { value: "Shirgaon(CT)", label: "Shirgaon(CT)" },
  { value: "Shishgarh(NP)", label: "Shishgarh(NP)" },
  { value: "Shivar(CT)", label: "Shivar(CT)" },
  { value: "Shivdaspur(CT)", label: "Shivdaspur(CT)" },
  { value: "Shivli(NP)", label: "Shivli(NP)" },
  { value: "Shivrinarayan(NP)", label: "Shivrinarayan(NP)" },
  { value: "Shohratgarh(NP)", label: "Shohratgarh(NP)" },
  { value: "Shrigonda(MCl)", label: "Shrigonda(MCl)" },
  { value: "Shrivardhan(MCl)", label: "Shrivardhan(MCl)" },
  { value: "Shuvararah(CT)", label: "Shuvararah(CT)" },
  { value: "SibdangaBadarpur(CT)", label: "SibdangaBadarpur(CT)" },
  { value: "Sidhpura(NP)", label: "Sidhpura(NP)" },
  { value: "Sikanderpur(NP)", label: "Sikanderpur(NP)" },
  { value: "Sikandra(NP)", label: "Sikandra(NP)" },
  { value: "Sikandrabad(NPP)", label: "Sikandrabad(NPP)" },
  { value: "Sikka(M)", label: "Sikka(M)" },
  { value: "Sikkarayapuram(CT)", label: "Sikkarayapuram(CT)" },
  { value: "SikriKalan(CT)", label: "SikriKalan(CT)" },
  { value: "Sillod(MCl)", label: "Sillod(MCl)" },
  { value: "Silwani(NP)", label: "Silwani(NP)" },
  { value: "Simaluguri(TC)", label: "Simaluguri(TC)" },
  { value: "Simlapal(CT)", label: "Simlapal(CT)" },
  { value: "Sindhawali(CT)", label: "Sindhawali(CT)" },
  { value: "Sindi(MCl)", label: "Sindi(MCl)" },
  { value: "SingahiBhiraura(NP)", label: "SingahiBhiraura(NP)" },
  { value: "Singapur(CT)", label: "Singapur(CT)" },
  { value: "Singarbil(CT)", label: "Singarbil(CT)" },
  { value: "Singoli(NP)", label: "Singoli(NP)" },
  { value: "Singrauli(MCorp.)", label: "Singrauli(MCorp.)" },
  { value: "SingtamTeaGarden(CT)", label: "SingtamTeaGarden(CT)" },
  { value: "Sinhasa(CT)", label: "Sinhasa(CT)" },
  { value: "Sini(CT)", label: "Sini(CT)" },
  { value: "Sirauli(NP)", label: "Sirauli(NP)" },
  { value: "SironchaRy.(CT)", label: "SironchaRy.(CT)" },
  { value: "Sironj(M)", label: "Sironj(M)" },
  { value: "Sirsa(NP)", label: "Sirsa(NP)" },
  { value: "Sirsaganj(NPP)", label: "Sirsaganj(NPP)" },
  { value: "Sirsi(NP)", label: "Sirsi(NP)" },
  { value: "Sirsia(CT)", label: "Sirsia(CT)" },
  { value: "Sisauli(NP)", label: "Sisauli(NP)" },
  { value: "SiswaBazar(NP)", label: "SiswaBazar(NP)" },
  { value: "Sitamau(NP)", label: "Sitamau(NP)" },
  { value: "Sitarganj(NPP)", label: "Sitarganj(NPP)" },
  { value: "Sithurajapuram(CT)", label: "Sithurajapuram(CT)" },
  { value: "Sivaganga(M)", label: "Sivaganga(M)" },
  { value: "Sivasagar Sibsagar", label: "Sivasagar Sibsagar" },
  { value: "Siwani(MC)", label: "Siwani(MC)" },
  { value: "Sohana(CT)", label: "Sohana(CT)" },
  { value: "Somayampalayam(CT)", label: "Somayampalayam(CT)" },
  { value: "Songadh(M)", label: "Songadh(M)" },
  { value: "Sonitpur", label: "Sonitpur" },
  { value: "Soorapattu(CT)", label: "Soorapattu(CT)" },
  { value: "Soraon(CT)", label: "Soraon(CT)" },
  { value: "Soron(NPP)", label: "Soron(NPP)" },
  { value: "South Dinajpur dakshin", label: "South Dinajpur dakshin" },
  { value: "South Garo Hills", label: "South Garo Hills" },
  { value: "South Tripura", label: "South Tripura" },
  { value: "SouthDumDum(M)", label: "SouthDumDum(M)" },
  { value: "Spituk(CT)", label: "Spituk(CT)" },
  { value: "Subeha(NP)", label: "Subeha(NP)" },
  { value: "Suhagi(CT)", label: "Suhagi(CT)" },
  { value: "Sujavalpur(CT)", label: "Sujavalpur(CT)" },
  { value: "Sulanggari(CT)", label: "Sulanggari(CT)" },
  { value: "Suleeswaranpatti(TP)", label: "Suleeswaranpatti(TP)" },
  { value: "Sultanpur(NP)", label: "Sultanpur(NP)" },
  { value: "Sumbal(MC)", label: "Sumbal(MC)" },
  { value: "SumerganjMandi(CT)", label: "SumerganjMandi(CT)" },
  { value: "Sumerpur(M)", label: "Sumerpur(M)" },
  { value: "Sumerpur(NP)", label: "Sumerpur(NP)" },
  { value: "Sunabeda(NAC).", label: "Sunabeda(NAC)." },
  { value: "SunariKalan(101)(CT)", label: "SunariKalan(101)(CT)" },
  { value: "Sunhaira(CT)", label: "Sunhaira(CT)" },
  { value: "Surajgarh(M)", label: "Surajgarh(M)" },
  { value: "Suranga(CT)", label: "Suranga(CT)" },
  { value: "Suriyawan(NP)", label: "Suriyawan(NP)" },
  { value: "Susner(NP)", label: "Susner(NP)" },
  { value: "Susuwahi(CT)", label: "Susuwahi(CT)" },
  { value: "Suthaliya(NP)", label: "Suthaliya(NP)" },
  { value: "SuthanaBarsola(CT)", label: "SuthanaBarsola(CT)" },
  { value: "Suzabad(CT)", label: "Suzabad(CT)" },
  { value: "Swamibagh(NP)", label: "Swamibagh(NP)" },
  { value: "SwroopNagar(CT)", label: "SwroopNagar(CT)" },
  { value: "TABO", label: "TABO" },
  { value: "TADA", label: "TADA" },
  { value: "TADALI", label: "TADALI" },
  { value: "TADEPALLIGUDEM", label: "TADEPALLIGUDEM" },
  { value: "TADIPATRI", label: "TADIPATRI" },
  { value: "TADONG", label: "TADONG" },
  { value: "TAJPUR", label: "TAJPUR" },
  { value: "TAKAGACHH", label: "TAKAGACHH" },
  { value: "TALA", label: "TALA" },
  { value: "TALAJA", label: "TALAJA" },
  { value: "TALALA", label: "TALALA" },
  { value: "TALASARI", label: "TALASARI" },
  { value: "TALCHER", label: "TALCHER" },
  { value: "TALDANGRA", label: "TALDANGRA" },
  { value: "TALEGAONDABHADE", label: "TALEGAONDABHADE" },
  { value: "TALERE", label: "TALERE" },
  { value: "TALIPARAMBA", label: "TALIPARAMBA" },
  { value: "TALOD", label: "TALOD" },
  { value: "TALODA", label: "TALODA" },
  { value: "TALWANDIBHAI", label: "TALWANDIBHAI" },
  { value: "TALWANDISABO", label: "TALWANDISABO" },
  { value: "TALWARA", label: "TALWARA" },
  { value: "TALWARAJHEEL", label: "TALWARAJHEEL" },
  { value: "TAMBAUR", label: "TAMBAUR" },
  { value: "TAMBAUR-CUM-AHMADABAD", label: "TAMBAUR-CUM-AHMADABAD" },
  { value: "TAMILNADU", label: "TAMILNADU" },
  { value: "TAMKHURIRAJ", label: "TAMKHURIRAJ" },
  { value: "TAMLUK", label: "TAMLUK" },
  { value: "TAMULPUR", label: "TAMULPUR" },
  { value: "TANAKPUR", label: "TANAKPUR" },
  { value: "TANDA", label: "TANDA" },
  { value: "TANDA(FAIZABAD)", label: "TANDA(FAIZABAD)" },
  { value: "TANDUR", label: "TANDUR" },
  { value: "TANGI", label: "TANGI" },
  { value: "TANGLA", label: "TANGLA" },
  { value: "TANKARA", label: "TANKARA" },
  { value: "TANUKU", label: "TANUKU" },
  { value: "TAPA", label: "TAPA" },
  { value: "TAPI", label: "TAPI" },
  { value: "TAPIN", label: "TAPIN" },
  { value: "TAPUKARA", label: "TAPUKARA" },
  { value: "TARAGARH", label: "TARAGARH" },
  { value: "TARANA", label: "TARANA" },
  { value: "TARANAGAR", label: "TARANAGAR" },
  { value: "TARAPUR", label: "TARAPUR" },
  { value: "TARICHARKALAN", label: "TARICHARKALAN" },
  { value: "TARKESHWAR", label: "TARKESHWAR" },
  { value: "TARN TARAN", label: "TARN TARAN" },
  { value: "TARNTARAN", label: "TARNTARAN" },
  { value: "TARSALI", label: "TARSALI" },
  { value: "TARSIKKA", label: "TARSIKKA" },
  { value: "TASGAON", label: "TASGAON" },
  { value: "TATIPAKA", label: "TATIPAKA" },
  { value: "TATIRIRURAL", label: "TATIRIRURAL" },
  { value: "TAURU", label: "TAURU" },
  { value: "TAWANG", label: "TAWANG" },
  { value: "TEEGALAPAHAD", label: "TEEGALAPAHAD" },
  { value: "TEHATTA", label: "TEHATTA" },
  { value: "TEHRI", label: "TEHRI" },
  { value: "TEHRI GARHWAL", label: "TEHRI GARHWAL" },
  { value: "TEKADI", label: "TEKADI" },
  { value: "TEKAL", label: "TEKAL" },
  { value: "TEKARI", label: "TEKARI" },
  { value: "TEKKALI", label: "TEKKALI" },
  { value: "TELIAMURA", label: "TELIAMURA" },
  { value: "TEMBHURNI", label: "TEMBHURNI" },
  { value: "TENALI", label: "TENALI" },
  { value: "TENDUKHEDA", label: "TENDUKHEDA" },
  { value: "TENGAGHAT", label: "TENGAGHAT" },
  { value: "TENGAKHAT", label: "TENGAKHAT" },
  { value: "TENKASI", label: "TENKASI" },
  { value: "TENU", label: "TENU" },
  { value: "TEOK", label: "TEOK" },
  { value: "TERDAL", label: "TERDAL" },
  { value: "TEZPUR", label: "TEZPUR" },
  { value: "THAGARAPUVALASA", label: "THAGARAPUVALASA" },
  { value: "THAKURDWARA", label: "THAKURDWARA" },
  { value: "THALAIVASAL", label: "THALAIVASAL" },
  { value: "THALASSERY", label: "THALASSERY" },
  { value: "THALAYOLAPARAMBU", label: "THALAYOLAPARAMBU" },
  { value: "THALLADA", label: "THALLADA" },
  { value: "THAMARASSERY", label: "THAMARASSERY" },
  { value: "THAMMAMPATTI", label: "THAMMAMPATTI" },
  { value: "THANABHAWAN", label: "THANABHAWAN" },
  { value: "THANACHHAPPAR", label: "THANACHHAPPAR" },
  { value: "THANAGAZI", label: "THANAGAZI" },
  { value: "THANAMANDI", label: "THANAMANDI" },
  { value: "THANE", label: "THANE" },
  { value: "THANEWEST", label: "THANEWEST" },
  { value: "THANGARH", label: "THANGARH" },
  { value: "THANJAVUR", label: "THANJAVUR" },
  { value: "THARA", label: "THARA" },
  { value: "THARAD", label: "THARAD" },
  { value: "THARAMANGALAM", label: "THARAMANGALAM" },
  { value: "THARYAL", label: "THARYAL" },
  { value: "THASRA", label: "THASRA" },
  { value: "THELLAR", label: "THELLAR" },
  { value: "THENHIPALAM", label: "THENHIPALAM" },
  { value: "THENI", label: "THENI" },
  { value: "THEOG", label: "THEOG" },
  { value: "THIKRI", label: "THIKRI" },
  { value: "THIMMAPUR", label: "THIMMAPUR" },
  { value: "THIRIYANIZAWATKHAN", label: "THIRIYANIZAWATKHAN" },
  { value: "THIRTHAHALLI", label: "THIRTHAHALLI" },
  { value: "THIRUCHENDUR", label: "THIRUCHENDUR" },
  { value: "THIRUKOILURE", label: "THIRUKOILURE" },
  { value: "THIRUMAZHISAI", label: "THIRUMAZHISAI" },
  { value: "THIRUMULLAIVOYAL", label: "THIRUMULLAIVOYAL" },
  { value: "THIRUTTANI", label: "THIRUTTANI" },
  { value: "THIRUVAIYARU", label: "THIRUVAIYARU" },
  { value: "THIRUVAIYURU", label: "THIRUVAIYURU" },
  { value: "THIRUVALLA", label: "THIRUVALLA" },
  { value: "THIRUVALLUR", label: "THIRUVALLUR" },
  { value: "THIRUVANANTHAPURAM", label: "THIRUVANANTHAPURAM" },
  { value: "THIRUVARUR", label: "THIRUVARUR" },
  { value: "THIRUVATTARU", label: "THIRUVATTARU" },
  { value: "THISAYANVILAI", label: "THISAYANVILAI" },
  { value: "THODUPUZHA", label: "THODUPUZHA" },
  { value: "THOKOTTU", label: "THOKOTTU" },
  { value: "THOKUR", label: "THOKUR" },
  { value: "THONDAMUTHUR", label: "THONDAMUTHUR" },
  { value: "THONDI", label: "THONDI" },
  { value: "THOOTHUKUDI", label: "THOOTHUKUDI" },
  { value: "THOPPUR", label: "THOPPUR" },
  { value: "THORRUR", label: "THORRUR" },
  { value: "THOTTIYAM", label: "THOTTIYAM" },
  { value: "THOUBAL", label: "THOUBAL" },
  { value: "THRIPPUNITHURA", label: "THRIPPUNITHURA" },
  { value: "THRISSUR", label: "THRISSUR" },
  { value: "THRITHALLORE", label: "THRITHALLORE" },
  { value: "THRUTHURAIPOONDI", label: "THRUTHURAIPOONDI" },
  { value: "THUCKALAY", label: "THUCKALAY" },
  { value: "THULLURU", label: "THULLURU" },
  { value: "THURAIYUR", label: "THURAIYUR" },
  { value: "TIBBI", label: "TIBBI" },
  { value: "TIBI", label: "TIBI" },
  { value: "TIBRI", label: "TIBRI" },
  { value: "TIGAON", label: "TIGAON" },
  { value: "TIHU", label: "TIHU" },
  { value: "TIJARA", label: "TIJARA" },
  { value: "TIKAITGANJ", label: "TIKAITGANJ" },
  { value: "TIKAMGARH", label: "TIKAMGARH" },
  { value: "TILAKVADA", label: "TILAKVADA" },
  { value: "TILAWALI", label: "TILAWALI" },
  { value: "TILDA", label: "TILDA" },
  { value: "TILOI", label: "TILOI" },
  { value: "TINDIVANAM", label: "TINDIVANAM" },
  { value: "TINSUKIA", label: "TINSUKIA" },
  { value: "TIPTUR", label: "TIPTUR" },
  { value: "TIRORA", label: "TIRORA" },
  { value: "TIRTOL", label: "TIRTOL" },
  { value: "TIRUCHENGODE", label: "TIRUCHENGODE" },
  { value: "TIRUCHIRAPPALLI", label: "TIRUCHIRAPPALLI" },
  { value: "TIRUKAZHUKUNDRAM", label: "TIRUKAZHUKUNDRAM" },
  { value: "TIRUMAKUDALUNARASIPURA", label: "TIRUMAKUDALUNARASIPURA" },
  { value: "TIRUMALAGIRI", label: "TIRUMALAGIRI" },
  { value: "TIRUMANGALAM", label: "TIRUMANGALAM" },
  { value: "TIRUMAYAM", label: "TIRUMAYAM" },
  { value: "TIRUNEERMALAI", label: "TIRUNEERMALAI" },
  { value: "TIRUNELVELI", label: "TIRUNELVELI" },
  { value: "TIRUPATHUR", label: "TIRUPATHUR" },
  { value: "TIRUPATI", label: "TIRUPATI" },
  { value: "TIRUPPALAI", label: "TIRUPPALAI" },
  { value: "TIRUPPUR", label: "TIRUPPUR" },
  { value: "TIRUPPUVANAM", label: "TIRUPPUVANAM" },
  { value: "TIRUPUR", label: "TIRUPUR" },
  { value: "TIRUR", label: "TIRUR" },
  { value: "TIRUVALLUR", label: "TIRUVALLUR" },
  { value: "TIRUVANNAMALAI", label: "TIRUVANNAMALAI" },
  { value: "TIRUVARUR", label: "TIRUVARUR" },
  { value: "TITABOR ", label: "TITABOR " },
  { value: "TITILAGARH", label: "TITILAGARH" },
  { value: "TITTAKUDI", label: "TITTAKUDI" },
  { value: "TITWALA", label: "TITWALA" },
  { value: "TIWARI", label: "TIWARI" },
  { value: "TODABHIM", label: "TODABHIM" },
  { value: "TODARAISINGH", label: "TODARAISINGH" },
  { value: "TOHANA", label: "TOHANA" },
  { value: "TONK", label: "TONK" },
  { value: "TOONGA", label: "TOONGA" },
  { value: "TORBAN", label: "TORBAN" },
  { value: "TORPA", label: "TORPA" },
  { value: "TOSHAMRURAL", label: "TOSHAMRURAL" },
  { value: "TOTU", label: "TOTU" },
  { value: "TRICHY", label: "TRICHY" },
  { value: "TRIMBAKESHWAR", label: "TRIMBAKESHWAR" },
  { value: "TRIPRAYAR", label: "TRIPRAYAR" },
  { value: "TRIVANDRUM", label: "TRIVANDRUM" },
  { value: "TSUDIKONG", label: "TSUDIKONG" },
  { value: "TUENSANG", label: "TUENSANG" },
  { value: "TUFANGANJ", label: "TUFANGANJ" },
  { value: "TUKHMIRPUR", label: "TUKHMIRPUR" },
  { value: "TULI", label: "TULI" },
  { value: "TULJAPUR", label: "TULJAPUR" },
  { value: "TULSIPUR", label: "TULSIPUR" },
  { value: "TUMAKURU", label: "TUMAKURU" },
  { value: "TUMINAKATTE", label: "TUMINAKATTE" },
  { value: "TUMMI BADI", label: "TUMMI BADI" },
  { value: "TUMSAR", label: "TUMSAR" },
  { value: "TUNDHUL", label: "TUNDHUL" },
  { value: "TUNDLA", label: "TUNDLA" },
  { value: "TUNDLARLY.COLONY", label: "TUNDLARLY.COLONY" },
  { value: "TUNI", label: "TUNI" },
  { value: "TUPRAN", label: "TUPRAN" },
  { value: "TURA", label: "TURA" },
  { value: "TURAIYUR", label: "TURAIYUR" },
  { value: "TURMI", label: "TURMI" },
  { value: "TUTICORIN", label: "TUTICORIN" },
  { value: "Takhatgarh(M)", label: "Takhatgarh(M)" },
  { value: "TakhlibilarPathar(CT)", label: "TakhlibilarPathar(CT)" },
  { value: "TakyelMapal(CT)", label: "TakyelMapal(CT)" },
  { value: "Talbehat(NP)", label: "Talbehat(NP)" },
  { value: "Taldi(CT)", label: "Taldi(CT)" },
  { value: "Talen(NP)", label: "Talen(NP)" },
  { value: "Talera(CT)", label: "Talera(CT)" },
  { value: "Talgram(NP)", label: "Talgram(NP)" },
  { value: "Taliparamba(M)", label: "Taliparamba(M)" },
  { value: "TalwandiBhai(MCl)", label: "TalwandiBhai(MCl)" },
  { value: "Tamenglong", label: "Tamenglong" },
  { value: "Tamenglong(CT)", label: "Tamenglong(CT)" },
  { value: "Tarapur(CT)", label: "Tarapur(CT)" },
  { value: "TarapurVII(CT)", label: "TarapurVII(CT)" },
  { value: "TatarpurLallu(CT)", label: "TatarpurLallu(CT)" },
  { value: "Tawang", label: "Tawang" },
  { value: "Tehri(NPP)", label: "Tehri(NPP)" },
  { value: "Tekanpur(CT)", label: "Tekanpur(CT)" },
  { value: "Telhara(MCl)", label: "Telhara(MCl)" },
  { value: "Tellapur", label: "Tellapur" },
  { value: "Tendukheda(NP)", label: "Tendukheda(NP)" },
  { value: "Tentulkuli(CT)", label: "Tentulkuli(CT)" },
  { value: "Teonthar(NP)", label: "Teonthar(NP)" },
  { value: "Thakkolam(TP)", label: "Thakkolam(TP)" },
  { value: "Thallapalle(CT)", label: "Thallapalle(CT)" },
  { value: "Thamaraikulam(TP)", label: "Thamaraikulam(TP)" },
  { value: "Thandla(NP)", label: "Thandla(NP)" },
  { value: "Thane(MCorp.)", label: "Thane(MCorp.)" },
  { value: "Thanthoni(M)", label: "Thanthoni(M)" },
  { value: "Tharike(CT)", label: "Tharike(CT)" },
  { value: "Thekkumbhagom(CT)", label: "Thekkumbhagom(CT)" },
  { value: "Thenkarai(TP)", label: "Thenkarai(TP)" },
  { value: "Thennala(CT)", label: "Thennala(CT)" },
  { value: "Thenzawl(NT)", label: "Thenzawl(NT)" },
  { value: "Thevaram(TP)", label: "Thevaram(TP)" },
  { value: "Thindal(CT)", label: "Thindal(CT)" },
  { value: "Thirumuruganpoondi(TP)", label: "Thirumuruganpoondi(TP)" },
  { value: "Thiruparankundram(M)", label: "Thiruparankundram(M)" },
  { value: "Thisayanvilai(TP)", label: "Thisayanvilai(TP)" },
  { value: "Thodupuzha(M)", label: "Thodupuzha(M)" },
  { value: "Thongju(CT)", label: "Thongju(CT)" },
  { value: "ThongkhongLaxmiBazar(NP)", label: "ThongkhongLaxmiBazar(NP)" },
  { value: "Thottada(CT)", label: "Thottada(CT)" },
  { value: "Thottipalayam(CT)", label: "Thottipalayam(CT)" },
  { value: "TikaitNagar(NP)", label: "TikaitNagar(NP)" },
  { value: "Tikri(NP)", label: "Tikri(NP)" },
  { value: "TikriKhurd(CT)", label: "TikriKhurd(CT)" },
  { value: "Tilhar(NPP)", label: "Tilhar(NPP)" },
  { value: "Tilpat(CT)", label: "Tilpat(CT)" },
  { value: "Tilthi(CT)", label: "Tilthi(CT)" },
  { value: "Tindwari(NP)", label: "Tindwari(NP)" },
  { value: "Tinsukia(MB)", label: "Tinsukia(MB)" },
  { value: "Tirap", label: "Tirap" },
  { value: "Tirora(MCl)", label: "Tirora(MCl)" },
  { value: "Tirupathur(TP)", label: "Tirupathur(TP)" },
  { value: "Tirwaganj(NP)", label: "Tirwaganj(NP)" },
  { value: "Titron(NP)", label: "Titron(NP)" },
  { value: "Todabhim(M)", label: "Todabhim(M)" },
  { value: "Todaraisingh(M)", label: "Todaraisingh(M)" },
  { value: "TolaMansaraut(CT)", label: "TolaMansaraut(CT)" },
  { value: "TondiFatehpur(NP)", label: "TondiFatehpur(NP)" },
  { value: "TonkKhurd(NP)", label: "TonkKhurd(NP)" },
  { value: "Trajpar(CT)", label: "Trajpar(CT)" },
  { value: "Trehgam(CT)", label: "Trehgam(CT)" },
  { value: "Trimulgherry", label: "Trimulgherry" },
  { value: "Tseminyu(TC)", label: "Tseminyu(TC)" },
  { value: "Tuensang(TC)", label: "Tuensang(TC)" },
  { value: "Tuli(TC)", label: "Tuli(TC)" },
  { value: "Tuljapur(MCl)", label: "Tuljapur(MCl)" },
  { value: "Tulsipur(NP)", label: "Tulsipur(NP)" },
  { value: "Tumkur", label: "Tumkur" },
  { value: "Tumsar(MCl)", label: "Tumsar(MCl)" },
  { value: "Tundla(46)(CT)", label: "Tundla(46)(CT)" },
  { value: "Tura(M)", label: "Tura(M)" },
  { value: "Tuticorin Thoothukudi", label: "Tuticorin Thoothukudi" },
  { value: "UCHANA", label: "UCHANA" },
  { value: "UDAIPUR", label: "UDAIPUR" },
  { value: "UDAIPURA", label: "UDAIPURA" },
  { value: "UDAIPURWATI", label: "UDAIPURWATI" },
  { value: "UDALA", label: "UDALA" },
  { value: "UDALGURI", label: "UDALGURI" },
  { value: "UDARBOND", label: "UDARBOND" },
  { value: "UDASAR", label: "UDASAR" },
  { value: "UDAYARPALAYAM", label: "UDAYARPALAYAM" },
  { value: "UDAYNARAYANPUR", label: "UDAYNARAYANPUR" },
  { value: "UDGIR", label: "UDGIR" },
  { value: "UDHAM SINGH NAGAR", label: "UDHAM SINGH NAGAR" },
  { value: "UDHAMPUR", label: "UDHAMPUR" },
  { value: "UDHAMSINGHNAGAR", label: "UDHAMSINGHNAGAR" },
  { value: "UDMA", label: "UDMA" },
  { value: "UDUMALAIPETTAI", label: "UDUMALAIPETTAI" },
  { value: "UDUPI", label: "UDUPI" },
  { value: "UJHANI", label: "UJHANI" },
  { value: "UJIRE", label: "UJIRE" },
  { value: "UJJAIN", label: "UJJAIN" },
  { value: "UKHRUL", label: "UKHRUL" },
  { value: "UKLANAMANDI", label: "UKLANAMANDI" },
  { value: "ULHASNAGAR", label: "ULHASNAGAR" },
  { value: "ULUBERIA", label: "ULUBERIA" },
  { value: "ULUNDURPET", label: "ULUNDURPET" },
  { value: "ULWE", label: "ULWE" },
  { value: "UMADI", label: "UMADI" },
  { value: "UMARAHA", label: "UMARAHA" },
  { value: "UMARGAM", label: "UMARGAM" },
  { value: "UMARI", label: "UMARI" },
  { value: "UMARIA", label: "UMARIA" },
  { value: "UMARKHED", label: "UMARKHED" },
  { value: "UMARPADA", label: "UMARPADA" },
  { value: "UMBRAJ", label: "UMBRAJ" },
  { value: "UMIAM", label: "UMIAM" },
  { value: "UMRED", label: "UMRED" },
  { value: "UMRETH", label: "UMRETH" },
  { value: "UMSAW", label: "UMSAW" },
  { value: "UMSNING", label: "UMSNING" },
  { value: "UNA", label: "UNA" },
  { value: "UNCHAHAR", label: "UNCHAHAR" },
  { value: "UNCHEHARA", label: "UNCHEHARA" },
  { value: "UNHEL", label: "UNHEL" },
  { value: "UNIARA", label: "UNIARA" },
  { value: "UNJHA", label: "UNJHA" },
  { value: "UNNAO", label: "UNNAO" },
  { value: "UPLETA", label: "UPLETA" },
  { value: "UPPALA", label: "UPPALA" },
  { value: "UPPERSIANG", label: "UPPERSIANG" },
  { value: "UPPINANGADY", label: "UPPINANGADY" },
  { value: "URALIKANCHAN", label: "URALIKANCHAN" },
  { value: "URAMBU", label: "URAMBU" },
  { value: "URAN", label: "URAN" },
  { value: "URJANAGAR", label: "URJANAGAR" },
  { value: "URULIKANCHAN", label: "URULIKANCHAN" },
  { value: "USAHAIT", label: "USAHAIT" },
  { value: "USGAON", label: "USGAON" },
  { value: "USILAMPATTI", label: "USILAMPATTI" },
  { value: "USKI", label: "USKI" },
  { value: "UTHAMAPALAYAM", label: "UTHAMAPALAYAM" },
  { value: "UTHANGARAI", label: "UTHANGARAI" },
  { value: "UTHIRAMERUR", label: "UTHIRAMERUR" },
  { value: "UTHUKKOTTAI", label: "UTHUKKOTTAI" },
  { value: "UTNUR", label: "UTNUR" },
  { value: "UTRAULA", label: "UTRAULA" },
  { value: "UTTARA KANNADA", label: "UTTARA KANNADA" },
  { value: "UTTARAKHAND", label: "UTTARAKHAND" },
  { value: "UTTARKASHI", label: "UTTARKASHI" },
  { value: "UTTARLAI", label: "UTTARLAI" },
  { value: "UTTARPARA", label: "UTTARPARA" },
  { value: "UTTARPARA KOTRUNG", label: "UTTARPARA KOTRUNG" },
  { value: "UTTUKOTTAI", label: "UTTUKOTTAI" },
  { value: "UVARSAD", label: "UVARSAD" },
  { value: "UVERI", label: "UVERI" },
  { value: "UZHAVARKARAI", label: "UZHAVARKARAI" },
  { value: "Uchgaon(CT)", label: "Uchgaon(CT)" },
  { value: "Udaipura(NP)", label: "Udaipura(NP)" },
  { value: "Udaipurwati(M)", label: "Udaipurwati(M)" },
  { value: "Udayarpalayam(TP)", label: "Udayarpalayam(TP)" },
  { value: "Udiana(CT)", label: "Udiana(CT)" },
  { value: "Udyavara(CT)", label: "Udyavara(CT)" },
  { value: "Ugu(NP)", label: "Ugu(NP)" },
  { value: "Ujalaiwadi(CT)", label: "Ujalaiwadi(CT)" },
  { value: "Ujhani(NPP)", label: "Ujhani(NPP)" },
  { value: "Ujhari(NP)", label: "Ujhari(NP)" },
  { value: "Uliyazhathura(CT)", label: "Uliyazhathura(CT)" },
  { value: "Ullal(TMC)", label: "Ullal(TMC)" },
  { value: "Uluberia(M+OG)", label: "Uluberia(M+OG)" },
  { value: "UmariPr.Akola(CT)", label: "UmariPr.Akola(CT)" },
  { value: "Umarsara(CT)", label: "Umarsara(CT)" },
  { value: "UmbarPadaNandade(CT)", label: "UmbarPadaNandade(CT)" },
  { value: "Umlyngka(CT)", label: "Umlyngka(CT)" },
  { value: "Umrangso(TC)", label: "Umrangso(TC)" },
  { value: "UmriKalan(NP)", label: "UmriKalan(NP)" },
  { value: "UmriPraganeBalapur(CT)", label: "UmriPraganeBalapur(CT)" },
  { value: "UmruKhurd(CT)", label: "UmruKhurd(CT)" },
  { value: "Un(NP)", label: "Un(NP)" },
  { value: "UnchaSiwana(CT)", label: "UnchaSiwana(CT)" },
  { value: "Unhel(NP)", label: "Unhel(NP)" },
  { value: "Uniara(M)", label: "Uniara(M)" },
  { value: "Upper Siang", label: "Upper Siang" },
  { value: "Upper Subansiri", label: "Upper Subansiri" },
  { value: "Uppidamangalam(TP)", label: "Uppidamangalam(TP)" },
  { value: "Urakam(CT)", label: "Urakam(CT)" },
  { value: "Uran(MCl)", label: "Uran(MCl)" },
  { value: "Urapakkam(CT)", label: "Urapakkam(CT)" },
  { value: "Urimari(CT)", label: "Urimari(CT)" },
  { value: "UrmarTanda(MCl)", label: "UrmarTanda(MCl)" },
  { value: "Usawan(NP)", label: "Usawan(NP)" },
  { value: "Utai(NP)", label: "Utai(NP)" },
  { value: "Utraula(NPP)", label: "Utraula(NPP)" },
  { value: "UttarChampamura(CT)", label: "UttarChampamura(CT)" },
  { value: "UttarPirpur(CT)", label: "UttarPirpur(CT)" },
  { value: "V.Pudur(TP)", label: "V.Pudur(TP)" },
  { value: "VADAKARA", label: "VADAKARA" },
  { value: "VADALI", label: "VADALI" },
  { value: "VADALUR", label: "VADALUR" },
  { value: "VADANAPPALLY", label: "VADANAPPALLY" },
  { value: "VADAVATHOOR", label: "VADAVATHOOR" },
  { value: "VADDAKKANKULAM", label: "VADDAKKANKULAM" },
  { value: "VADGAM", label: "VADGAM" },
  { value: "VADIPATTI", label: "VADIPATTI" },
  { value: "VADNAGAR", label: "VADNAGAR" },
  { value: "VADODARA", label: "VADODARA" },
  { value: "VADUJ", label: "VADUJ" },
  { value: "VAGRA", label: "VAGRA" },
  { value: "VAIBHAVWADI", label: "VAIBHAVWADI" },
  { value: "VAIJAPUR", label: "VAIJAPUR" },
  { value: "VAISHALI", label: "VAISHALI" },
  { value: "VALANCHERY", label: "VALANCHERY" },
  { value: "VALIA", label: "VALIA" },
  { value: "VALLAM", label: "VALLAM" },
  { value: "VALLIYUR", label: "VALLIYUR" },
  { value: "VALOD", label: "VALOD" },
  { value: "VALSAD", label: "VALSAD" },
  { value: "VALUDUREDDI", label: "VALUDUREDDI" },
  { value: "VALVADA", label: "VALVADA" },
  { value: "VALVETA", label: "VALVETA" },
  { value: "VANASTHALI", label: "VANASTHALI" },
  { value: "VANDAVASI", label: "VANDAVASI" },
  { value: "VANIYAMBADI", label: "VANIYAMBADI" },
  { value: "VANNATHIPARAI RF", label: "VANNATHIPARAI RF" },
  { value: "VANSDA", label: "VANSDA" },
  { value: "VANTHLI", label: "VANTHLI" },
  { value: "VANTIMAMIDI", label: "VANTIMAMIDI" },
  { value: "VAPI", label: "VAPI" },
  { value: "VARANASI", label: "VARANASI" },
  { value: "VARKALA", label: "VARKALA" },
  { value: "VARNI", label: "VARNI" },
  { value: "VARTEJ", label: "VARTEJ" },
  { value: "VASAI-VIRAR", label: "VASAI-VIRAR" },
  { value: "VASCODAGAMA", label: "VASCODAGAMA" },
  { value: "VASIND", label: "VASIND" },
  { value: "VASO", label: "VASO" },
  { value: "VATAKARA", label: "VATAKARA" },
  { value: "VATIKA", label: "VATIKA" },
  { value: "VATTALAGUNDU", label: "VATTALAGUNDU" },
  { value: "VATTIYOORKAVU", label: "VATTIYOORKAVU" },
  { value: "VAVOL", label: "VAVOL" },
  { value: "VAZHAPADI", label: "VAZHAPADI" },
  { value: "VEERBHADRA", label: "VEERBHADRA" },
  { value: "VELHE", label: "VELHE" },
  { value: "VELLAKOIL", label: "VELLAKOIL" },
  { value: "VELLALORE", label: "VELLALORE" },
  { value: "VELLORE", label: "VELLORE" },
  { value: "VELUTHUR", label: "VELUTHUR" },
  { value: "VEMULAWADA", label: "VEMULAWADA" },
  { value: "VENGAL", label: "VENGAL" },
  { value: "VENGARA", label: "VENGARA" },
  { value: "VENGURLA", label: "VENGURLA" },
  { value: "VENKATACHALAPURAM", label: "VENKATACHALAPURAM" },
  { value: "VENKATAGIRI", label: "VENKATAGIRI" },
  { value: "VENKATAGIRIKOTA", label: "VENKATAGIRIKOTA" },
  { value: "VENKATHUR", label: "VENKATHUR" },
  { value: "VENOOR", label: "VENOOR" },
  { value: "VEPPAMBAATTU", label: "VEPPAMBAATTU" },
  { value: "VEPPILANGULAM PART 1", label: "VEPPILANGULAM PART 1" },
  { value: "VERAVAL", label: "VERAVAL" },
  { value: "VERNA", label: "VERNA" },
  { value: "VETTICHIRA", label: "VETTICHIRA" },
  { value: "VIDISHA", label: "VIDISHA" },
  { value: "VIJAPUR", label: "VIJAPUR" },
  { value: "VIJAYAPURA", label: "VIJAYAPURA" },
  { value: "VIJAYARAGHAVGARH", label: "VIJAYARAGHAVGARH" },
  { value: "VIJAYAWADA", label: "VIJAYAWADA" },
  { value: "VIJAYGARH", label: "VIJAYGARH" },
  { value: "VIJAYPUR", label: "VIJAYPUR" },
  { value: "VIKARABAD", label: "VIKARABAD" },
  { value: "VIKASNAGAR", label: "VIKASNAGAR" },
  { value: "VIKRAMGAD", label: "VIKRAMGAD" },
  { value: "VILATHIKULAM", label: "VILATHIKULAM" },
  { value: "VILEMARKUNDI", label: "VILEMARKUNDI" },
  { value: "VILHOLI", label: "VILHOLI" },
  { value: "VILLANKURICHI", label: "VILLANKURICHI" },
  { value: "VILLUPURAM", label: "VILLUPURAM" },
  { value: "VILUPPURAM", label: "VILUPPURAM" },
  { value: "VINUKONDA", label: "VINUKONDA" },
  { value: "VIRAJPET", label: "VIRAJPET" },
  { value: "VIRALIMALAI", label: "VIRALIMALAI" },
  { value: "VIRAMGAM", label: "VIRAMGAM" },
  { value: "VIRAPANDI", label: "VIRAPANDI" },
  { value: "VIRATNAGAR", label: "VIRATNAGAR" },
  { value: "VIRUDHACHALAM", label: "VIRUDHACHALAM" },
  { value: "VIRUDHUNAGAR", label: "VIRUDHUNAGAR" },
  { value: "VISAKHAPATNAM", label: "VISAKHAPATNAM" },
  { value: "VISAPUR", label: "VISAPUR" },
  { value: "VISAVADAR", label: "VISAVADAR" },
  { value: "VISHARATGANJ", label: "VISHARATGANJ" },
  { value: "VISHRAMPURI", label: "VISHRAMPURI" },
  { value: "VISNAGAR", label: "VISNAGAR" },
  { value: "VISSANNAPETAA", label: "VISSANNAPETAA" },
  { value: "VITA", label: "VITA" },
  { value: "VITLA", label: "VITLA" },
  { value: "VIZIANAGARAM", label: "VIZIANAGARAM" },
  { value: "VODLEMOLCACORA", label: "VODLEMOLCACORA" },
  { value: "VYARA", label: "VYARA" },
  { value: "Vadavalli(TP)", label: "Vadavalli(TP)" },
  { value: "Vadghar(CT)", label: "Vadghar(CT)" },
  { value: "Vadugapatti(TP)", label: "Vadugapatti(TP)" },
  { value: "Vaikom(M)", label: "Vaikom(M)" },
  { value: "Valasaravakkam(M)", label: "Valasaravakkam(M)" },
  { value: "Valavanur(TP)", label: "Valavanur(TP)" },
  { value: "Vandiyur(CT)", label: "Vandiyur(CT)" },
  { value: "Vangani(CT)", label: "Vangani(CT)" },
  { value: "Varangaon(CT)", label: "Varangaon(CT)" },
  { value: "VavdiBujarg(CT)", label: "VavdiBujarg(CT)" },
  { value: "Vazhakkala(CT)", label: "Vazhakkala(CT)" },
  { value: "Vazhayur(CT)", label: "Vazhayur(CT)" },
  { value: "Vedapatti(TP)", label: "Vedapatti(TP)" },
  { value: "Vedasandur", label: "Vedasandur" },
  { value: "Veerakeralam(TP)", label: "Veerakeralam(TP)" },
  { value: "VehicleFactoryAreaJabalpur(CT)", label: "VehicleFactoryAreaJabalpur(CT)" },
  { value: "Velampalayam(M)", label: "Velampalayam(M)" },
  { value: "Velayudampalayam(CT)", label: "Velayudampalayam(CT)" },
  { value: "Vellakinar(TP)", label: "Vellakinar(TP)" },
  { value: "Vengara(CT)", label: "Vengara(CT)" },
  { value: "Veppanthattai", label: "Veppanthattai" },
  { value: "Vidisha(M)", label: "Vidisha(M)" },
  { value: "Vidyavihar(M)", label: "Vidyavihar(M)" },
  { value: "Vijaypur(NP)", label: "Vijaypur(NP)" },
  { value: "Vikramgad(CT)", label: "Vikramgad(CT)" },
  { value: "Vilacheri(CT)", label: "Vilacheri(CT)" },
  { value: "Vilangudi(TP)", label: "Vilangudi(TP)" },
  { value: "Vilathikulam(TP)", label: "Vilathikulam(TP)" },
  { value: "Villupuram ", label: "Villupuram " },
  { value: "Vinukonda(M)", label: "Vinukonda(M)" },
  { value: "Viraganur(CT)", label: "Viraganur(CT)" },
  { value: "Viratnagar(M)", label: "Viratnagar(M)" },
  { value: "Viswanatham(CT)", label: "Viswanatham(CT)" },
  { value: "Vizag", label: "Vizag" },
  { value: "Vrindavan(NPP)", label: "Vrindavan(NPP)" },
  { value: "WADA", label: "WADA" },
  { value: "WADAKKANCHERY", label: "WADAKKANCHERY" },
  { value: "WADGAONROAD", label: "WADGAONROAD" },
  { value: "WADHWAN", label: "WADHWAN" },
  { value: "WADSA", label: "WADSA" },
  { value: "WAGHAPUR", label: "WAGHAPUR" },
  { value: "WAGHODIA", label: "WAGHODIA" },
  { value: "WAI", label: "WAI" },
  { value: "WAIDHAN", label: "WAIDHAN" },
  { value: "WALAJABAD", label: "WALAJABAD" },
  { value: "WALANI", label: "WALANI" },
  { value: "WALUJ", label: "WALUJ" },
  { value: "WALWA", label: "WALWA" },
  { value: "WANAPARTHY", label: "WANAPARTHY" },
  { value: "WANDOOR", label: "WANDOOR" },
  { value: "WANI", label: "WANI" },
  { value: "WANKANER", label: "WANKANER" },
  { value: "WARANANAGAR", label: "WARANANAGAR" },
  { value: "WARANGAL", label: "WARANGAL" },
  { value: "WARDHA", label: "WARDHA" },
  { value: "WARJE", label: "WARJE" },
  { value: "WARORA", label: "WARORA" },
  { value: "WARTHI", label: "WARTHI" },
  { value: "WARUD", label: "WARUD" },
  { value: "WASHIM", label: "WASHIM" },
  { value: "WAYANAD", label: "WAYANAD" },
  { value: "WAZIRPUR", label: "WAZIRPUR" },
  { value: "WEST CHAMPARAN", label: "WEST CHAMPARAN" },
  { value: "WEST DELHI", label: "WEST DELHI" },
  { value: "WEST MIDNAPORE", label: "WEST MIDNAPORE" },
  { value: "WEST SIKKIM", label: "WEST SIKKIM" },
  { value: "WEST SINGHBHUM", label: "WEST SINGHBHUM" },
  { value: "WESTBENGAL", label: "WESTBENGAL" },
  { value: "WESTCHAMPARAN", label: "WESTCHAMPARAN" },
  { value: "WESTDINAJPUR", label: "WESTDINAJPUR" },
  { value: "WESTGODAVARI", label: "WESTGODAVARI" },
  { value: "WESTKAMENG", label: "WESTKAMENG" },
  { value: "WESTSIANG", label: "WESTSIANG" },
  { value: "WILLIAMNAGAR", label: "WILLIAMNAGAR" },
  { value: "WOKHA", label: "WOKHA" },
  { value: "WadgaonKolhati(CT)", label: "WadgaonKolhati(CT)" },
  { value: "Wajegaon(CT)", label: "Wajegaon(CT)" },
  { value: "Walidpur(CT)", label: "Walidpur(CT)" },
  { value: "WalujBk.(CT)", label: "WalujBk.(CT)" },
  { value: "Walwadi(CT)", label: "Walwadi(CT)" },
  { value: "Wangjing(NP)", label: "Wangjing(NP)" },
  { value: "Wangoi(NP)", label: "Wangoi(NP)" },
  { value: "Warangal Rural", label: "Warangal Rural" },
  { value: "Warhapur(NP)", label: "Warhapur(NP)" },
  { value: "Warisaliganj(NP)", label: "Warisaliganj(NP)" },
  { value: "Warora(MCl)", label: "Warora(MCl)" },
  { value: "Warud(CT)", label: "Warud(CT)" },
  { value: "WatraGam(MC)", label: "WatraGam(MC)" },
  { value: "Wazirganj(NP)", label: "Wazirganj(NP)" },
  { value: "Weir(M)", label: "Weir(M)" },
  { value: "West Garo Hills", label: "West Garo Hills" },
  { value: "West Godavari", label: "West Godavari" },
  { value: "West Kameng", label: "West Kameng" },
  { value: "West Khasi Hills", label: "West Khasi Hills" },
  { value: "West Medinipur", label: "West Medinipur" },
  { value: "West Siang", label: "West Siang" },
  { value: "West Tripura", label: "West Tripura" },
  { value: "YADGIR", label: "YADGIR" },
  { value: "YADGIRI", label: "YADGIRI" },
  { value: "YAMUNANAGAR", label: "YAMUNANAGAR" },
  { value: "YANAM", label: "YANAM" },
  { value: "YAVATMAL", label: "YAVATMAL" },
  { value: "YAWAT", label: "YAWAT" },
  { value: "YEDDUMAILARAM", label: "YEDDUMAILARAM" },
  { value: "YELAHANKA", label: "YELAHANKA" },
  { value: "YELESWARAM", label: "YELESWARAM" },
  { value: "YELLANDU", label: "YELLANDU" },
  { value: "YELLAPUR", label: "YELLAPUR" },
  { value: "YELLAREDDY", label: "YELLAREDDY" },
  { value: "YEOLA", label: "YEOLA" },
  { value: "YERCAUD", label: "YERCAUD" },
  { value: "YERKHEDA", label: "YERKHEDA" },
  { value: "Yamuna Nagar", label: "Yamuna Nagar" },
  { value: "Yellur(CT)", label: "Yellur(CT)" },
  { value: "Yewalewadi(CT)", label: "Yewalewadi(CT)" },
  { value: "Yupia", label: "Yupia" },
  { value: "ZADESHWAR", label: "ZADESHWAR" },
  { value: "ZAHEERABAD", label: "ZAHEERABAD" },
  { value: "ZAHIRABAD", label: "ZAHIRABAD" },
  { value: "ZAIDPUR", label: "ZAIDPUR" },
  { value: "ZANKHVAV", label: "ZANKHVAV" },
  { value: "ZARI", label: "ZARI" },
  { value: "ZIRA", label: "ZIRA" },
  { value: "ZIRAKPUR", label: "ZIRAKPUR" },
  { value: "ZIRO", label: "ZIRO" },
  { value: "ZUNHEBOTO", label: "ZUNHEBOTO" },
  { value: "Zadgaon(CT)", label: "Zadgaon(CT)" },
  { value: "Zaidpur(NP)", label: "Zaidpur(NP)" },
  { value: "Zamania(NPP)", label: "Zamania(NPP)" },
  { value: "Zawlnuam(NT)", label: "Zawlnuam(NT)" },
  { value: "ZiauddinPur(CT)", label: "ZiauddinPur(CT)" },
  { value: "Zirakpur ", label: "Zirakpur " },
  { value: "Zotirpada(CT)", label: "Zotirpada(CT)" },
  { value: "Zunhebotto", label: "Zunhebotto" },
  { value: "kuchaman city", label: "kuchaman city" },
  { value: "sultanpur ", label: "sultanpur " }
];
